{
  "searchBox": {
    "placeholder": "Ingrese un número de pieza, número de tipo, título o detalles del documento"
  },
  "customLoginPage": {
    "badRequest": {
      "bad_credentials": "La dirección de correo electrónico o contraseña ingresadas no son correctas.",
      "account_disabled": "User is disabled. Please contact administration.",
      "unknown_error": "An unknown error occurred. Please try again later."
    }
  },
  "common": {
    "b2b_login_disabled": "Por motivos de seguridad, su cuenta de usuario ha sido bloqueada debido a un período prolongado de inactividad. Póngase en contacto con su administrador para reactivar su cuenta.",
    "text_orderTemplate_csv_missing_header": "No se pudo cargar el pedido. Utilice la plantilla de pedidos para cargarlo.",
    "customer_registration": "REGISTRO DE CLIENTE",
    "search_mobile_page_searchText": "Ha buscado",
    "header_quick_order": "PEDIDO\n RÁPIDO",
    "mycompany_user_delete_confMessage": "Are you sure you want to delete the following user account?",
    "text_account_saveCart_edit_success": "El carrito se actualizó exitosamente",
    "additional_soldto_location_description": "Introdúzca la ubicación adicional a la que debería tener acceso (se vende a nr., dirección o código de distribuidor)",
    "mycompany_user_delete_note": "Note: You can not undo this deletion.",
    "text_company_manageUser_page_totalResults": "{0} User(s) Found",
    "closest_equivalent_product_text": "Producto equivalente más cercano",
    "closest_equivalent_product_desc": " Este es el producto equivalente más cercano y puede no coincidir exactamente con el número de pieza buscado. Por favor, revise toda la documentación técnica antes de realizar el pedido para asegurar un ajuste, forma y función adecuados.",
    "header_welcome": "Bienvenido",
    "search_page_totalResults": "artículos encontrados",
    "mycompany_delete_error_message": "Cannot delete as at least one sold to must be linked",
    "mycompany_user_delete_account": "Delete a user account",
    "ppd_freight_greater_than_subtotal_info": "El total (el excluye los cargos básicos) de su carrito es {0} {1}. Puede calificar para flete prepagado si agrega {2} {1} piezas valiosas a su carrito.",
    "text_account_warranty_table_header_dsiplay_status": "Razón del estado del reclamo",
    "search_page_searchText": "Ha buscado",
    "vizseek_search_Invalid_text3": "o",
    "text_product_image": "Imagen del producto",
    "text_part_number": "Número de pieza",
    "text_order_status_partially_delivered": "Entregado parcialmente",
    "register_data-protection": "Aviso de privacidad",
    "loginTitle": "Cliente existente",
    "loginsubTitle": "Inicie sesión",
    "loginremembermecheck": "Recuerda mi inicio de sesión",
    "forgotPassword": "¿Olvidó su contraseña?",
    "userlogin": "Iniciar sesión en su cuenta",
    "loginpara": "Regístrese en Bendix y obtenga disponibilidad de productos, precios, información de pedidos y mucho más.",
    "loginNewUser": "¿Usuario nuevo?",
    "loginregisterBtn": "Registrarse",
    "text_aftermarket_part_number": "Referencia IAM",
    "text_quick_order_form": "Formulario de pedido rápido",
    "text_import_order": "Pedido de importación",
    "text_company_managePermissions_page_firstPage": "&laquo; ",
    "text_company_managePermissions_page_lastPage": "&raquo; ",
    "text_company_manageUser_pageAll_firstPage": "&laquo; ",
    "text_company_administrators_page_firstPage": "&laquo; ",
    "text_company_manageusers_restpassword_breadcrumb": "Actualizar contraseña ",
    "text_company_manageUser_registration_lastPage": "&raquo; ",
    "text_company_manageB2BUserGroup_page_firstPage": "&laquo; ",
    "updatePwd_pwd_invalid": "La contraseña no cumple con los requisitos mínimos. ",
    "text_company_children_page_lastPage": "&raquo; ",
    "text_company_members_page_lastPage": "&raquo; ",
    "text_company_manageUser": "Usuarios    ",
    "text_company_manageUser_pageAll_lastPage": "&raquo; ",
    "text_company_budget_page_firstPage": "&laquo; ",
    "text_company_managers_page_firstPage": "&laquo; ",
    "text_company_customers_page_lastPage": "&raquo; ",
    "text_company_costCenter_page_lastPage": "&raquo; ",
    "text_company_members_page_firstPage": "&laquo; ",
    "text_company_usergroups_page_firstPage": "&laquo; ",
    "text_company_costCenter_page_firstPage": "&laquo; ",
    "text_company_approvers_page_firstPage": "&laquo; ",
    "text_company_children_page_firstPage": "&laquo; ",
    "text_company_manageUsers": "Usuarios    ",
    "text_company_manageusers_label": "Usuarios    ",
    "text_company_approvers_page_lastPage": "&raquo; ",
    "text_company_usergroups_page_lastPage": "&raquo; ",
    "text_company_managers_page_lastPage": "&raquo; ",
    "text_company_permissions_page_firstPage": "&laquo; ",
    "text_company_manageUser_registration_firstPage": "&laquo; ",
    "text_company_manageB2BUserGroup_page_lastPage": "&raquo; ",
    "text_company_usergroup_members": "Usuarios    ",
    "text_company_customers_page_firstPage": "&laquo; ",
    "text_company_manageUser_button_create": "Crear nuevo usuario                              ",
    "text_company_approvers_page_showPageResults": "Mostrar paginado ",
    "text_company_administrators_page_lastPage": "&raquo; ",
    "text_company_budget_page_lastPage": "&raquo; ",
    "text_company_permissions_page_lastPage": "&raquo; ",
    "text_core_form_csvMessage1": "Puede cargar automáticamente la información de su declaración básica utilizando la función de plantilla básica",
    "text_core_form_csvMessage2": "Puede buscar el grupo básico/clase básica a través de este enlace <a href=\"/CoreInfoCenter\" >URL a la búsqueda de Material/grupo básico</a>",
    "checkout_product_not_purchasable": "Lamentablemente, el número de pieza {0} ya no se puede comprar. Elimine este producto antes de proceder al pago",
    "text_core_search_heading": "Si no está seguro del número de material o del grupo central, ingrese la información conocida a continuación en el campo correspondiente. La información proporcionada es de ayuda para completar correctamente la solicitud de devolución básica y para administrar sus devoluciones básicas en consecuencia.",
    "checkout_summary_paymentMethod_savedCards_paymentCard": "Tarjeta de pago",
    "basket_add_to_cart": "Agregar",
    "text_account_order_tracking": "El número de rastreo",
    "basket_save_cart_action_save": "Guardar",
    "quote_save": "Guardar cotización",
    "checkout_orderConfirmation_order_note": "Order Note:",
    "guest_register_submit": "Registrarse",
    "basket_save_cart_validation_description_size": "La descripción del carrito no puede tener más de 255 caracteres.",
    "storelocator_dealer": "Dealers",
    "guest_checkout_existingaccount_register_error": "Ya existe una cuenta con la dirección de correo electrónico {0}.",
    "text_warranty_search_to_date_invalid": "Claim Date To can't be less than the Claim Date From.",
    "basket_information_quantity_adjusted": "Se han modificado  sus artículos para que coincidan con los niveles de stock disponibles",
    "pickup_in_stock": "{0} EN STOCK",
    "text_account_quote_status_display_SELLER_SUBMITTED": "Enviado",
    "checkout_page_DeliveryMethodForOrder_NA_orderNote": "Nota de pedido",
    "aria_pickupinstore_storesloaded": "Tiendas cargadas",
    "text_core_search_CR": "CR#",
    "text_core_search_CRStatus": "Estado de la RC",
    "text_core_search_CreationDate": "Fecha de creación",
    "text_core_search_CoreReturnMonth": "Core Return Mes",
    "text_core_search_BOLStatus": "Número de envío",
    "text_core_search_BOLPDF": "BOL PDF",
    "text_core_search_savedReturn": "Saved (Not Submitted)",
    "text_core_search_noSavedReturn": "SUBMITTED",
    "checkout_error_paymentethod_formentry_sop_invalid_billTo_firstName": "Este valor no es válido para este campo.",
    "text_button_save": "Guardar",
    "address_companyName_invalid": "Ingrese el nombre de la empresa",
    "checkout_error_paymentethod_formentry_sop_missing_card_expirationYear": "Ingrese un año de vencimiento",
    "text_select_you_path_upload": "Ruta del archivo a cargar:",
    "text_reports_detailEmea": "Each line item transaction",
    "checkout_summary_deliveryMode_useThisDeliveryMethod": "Usar este método de entrega",
    "user_request_approval": "Pedir aprobación",
    "mycompany_click_locked_user": "Usuario Bloqueado - Haga clic para activar Usuario",
    "payment_issueNumber_toolong": "El número de emisión es demasiado largo",
    "text_generalInfo_packaging": "Embalaje",
    "text_account_coreReports": "Core Reports",
    "text_currency": "Seleccione la monedat",
    "type_marketType_AftermarketRemanufactured_name": "Posventa (Remanufacturado)",
    "text_quote_yes_button_label": "Sí",
    "text_swithToMobileStore": "Regresar a teléfono móvil",
    "storeDetails_table_telephone": "Teléfono",
    "text_account_consent_template_notFound": "Plantilla de consentimiento no encontrada",
    "text_headertext": "Confirmar",
    "text_account_myPart_updatePersonalDetails": "Plantilla de importación de número de pieza del cliente",
    "checkout_summary_paymentMethod_addPaymentDetails_enterYourCardDetails": "Ingrese los detalles de su tarjeta para el pago",
    "pdp_page_add_to_cart": "Añadir a la cesta",
    "search_nav_facetShowMore_price": "más precios...",
    "text_account_orderDetails_backToOrderHistory": "Regresar a historial de pedidos",
    "text_paymentcard_remove_confirm": "¿Seguro que quiere eliminar esta tarjeta de pago?",
    "mobile_storelocator_title": "Localizador de tiendas",
    "basket_page_totals_total_items_one": "{0} ARTÍCULO",
    "checkout_summary_placeOrder_wrongDateFormatMessage": "El formato de fecha debe ser {0}.",
    "guest_description": "¿Prefiere comprar sin crear una cuenta? <br /> ¡Es rápido y simple!",
    "text_quote_discount_by_percentage": "Descuento por porcentaje",
    "mobile_search_nav_facetValueCount": "{0}",
    "coupon_already_exists_cart": "Ya se ha aplicado un cupón de la misma campaña al carrito.",
    "order_history_order_number": "Pedido #:",
    "text_reports_download": "Descargar informe",
    "checkout_multi_deliveryAddress_remove": "Eliminar",
    "basket_save_cart_on_success": "El carrito {0} se guardó correctamente",
    "text_actions": "Accionestt",
    "text_warranty_submit_date": "Fecha",
    "checkout_summary_paymentMethod_addPaymentDetails_useThesePaymentDetails": "Usar estos detalles de pago",
    "basket_page_totals_netTax": "Impuesto:",
    "import_csv_savedCart_requestedDateEmea": "Opcional: Fecha de entrega solicitada (formato DD/MM/AAAA)",
    "text_orderimport_error_dateformat_message": "dd/mm/aaaa",
    "checkout_page_DeliveryMethodForOrder_EMEA_orderNote": "Order Note",
    "address_prefecture_invalid": "Seleccione una prefectura",
    "address_line2_shipping_page_form": "Dirección línea 2",
    "text_account_order_yourOrder": "Su pedido",
    "text_account_savedCarts_page_showPageResults": "Mostrar paginado",
    "text_storefinder_desktop_page_totalResults": "{0} Tiendas encontradas",
    "text_account_consent_already_withdrawn": "El consentimiento ya está retirado",
    "netPrice_check": "Precio neto",
    "storeFinder_line_text": "o",
    "text_reports_detailNa": "Transacciones de artículos de línea",
    "text_core_search_finder": "Buscador de grupos centrales",
    "text_account_order_back_btn": "Regresar",
    "product_share_share": "Descargas",
    "login_password": "Contraseña*",
    "checkout_page_back_to_cart": "Regresar al carrito",
    "text_warranty_terms_highway_applications": "Estas aplicaciones tienen ciclos de trabajo de frenado de frecuencia normal y operan principalmente en carreteras de superficie dura.",
    "search_nav_applied_facets_emea": "Filtros aplicados",
    "basket_export_user_orders": "Pedidos",
    "text_Shipping_Packaging_content1": "Para todas las preguntas, envíe un correo electrónico a",
    "text_Shipping_Packaging_content2": "Proporcione su número de cuenta junto con el número de devolución básico.",
    "basket_export_user_preferredEmailLanguage": "Idioma de correo electrónico preferido",
    "password_strength_verystrong": "Muy fuerte",
    "text_storefinder_mobile_page_linkNextPage": "Siguiente &raquo;",
    "text_account_consent_notFound": "Consentimiento no encontrado",
    "text_core_search_partnum": "N.º de pieza de Bendix",
    "text_account_orderHistory_page_sort_byCodeDesc": "Order No-Desc",
    "text_account_coworker_orders": "Mostrar pedidos de compañeros de trabajo",
    "basket_page_itemNumber": "Artículo nro.",
    "basket_export_user_country": "País",
    "text_core_submission_pleaseNote": "Atención:",
    "text_account_quote_action_display_ORDER": "Solicitar cotización",
    "text_page_message_underconstruction": "<strong> Información: </strong> Página en construcción, no completamente funcional",
    "text_quickOrder_page_total": "Total",
    "text_account_order_total_includesTax": "El total incluye {0} en impuestos",
    "cart_product_deleteall": "¿Quiere eliminar todos los elementos seleccionados?",
    "checkout_multi_address_added": "Su dirección fue creada.",
    "address_selectPrefecture": "Prefectura",
    "checkout_summary_deliveryAddress_saveAndUseThisAddress": "Guardar y usar esta dirección",
    "text_warranty_submit_primary_complaint": "Queja principal",
    "text_headline_search": "Aquí puede buscar productos",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_phoneNumber": "Ingrese un valor para este campo",
    "text_account_order_order": "Pedido",
    "inverse_check": "Xref",
    "register_company_address_two_invalid": "Ingrese la segunda dirección de la empresat",
    "text_account_myPart_success_uploded": "Todos los números de pieza se han cargado correctamente.",
    "address_lastName_invalid": "Ingrese un apellido",
    "open_qty": "Cantidad abierta**",
    "general_zoom": "Vista ampliada de la imagen",
    "system_error_link_expired_title": "Lo sentimos, este enlace ha expirado",
    "basket_restoration": "Bienvenido de nuevo, {0}: Algunos artículos de su carrito de compras anterior se han restaurado a su carrito de compras actual.",
    "checkout_summary_deliveryAddress_saveAddressInMyAddressBook": "Guardar dirección de envío",
    "text_core_submit_emailAddress_invalid": "Ingrese un correo electrónico válido",
    "basket_page_totals_error_wrongzipcode": "Ingrese un código postal válido",
    "checkout_error_paymentethod_formentry_sop_invalid_billTo_postalCode": "Este valor no es válido para este campo.",
    "text_deliveryMethod": "Método de entregat",
    "cart_product_deletealltext": "¿Desea eliminar los elementos seleccionados?",
    "product_product_salesStatus": "Estado del producto",
    "text_storefinder_desktop_page_linkNextPage": "Siguiente",
    "text_warranty_submit_recall_type": "Recall Type*",
    "core_report_coreparent": "Please Select Core Parent",
    "quote_requote_error": "Error al volver a cotizar.",
    "core_error_reports_emea": "You do not have permission, please <a href",
    "storeFinder_table_view_map": "Ver mapa",
    "order_history_billing_address": "Dirección de facturación",
    "text_account_orderHistory_page_linkNextPage": "Página siguiente",
    "cart_page_deliverydate": "Fecha de entrega",
    "basket_page_totals_total": "Total",
    "login_link_forgottenPwd": "¿Olvidó su contraseña?",
    "checkout_error_paymentethod_formentry_sop_missing_shipTo_city": "Ingrese un valor para este campo",
    "cart_total_poa_EMEA": "Precio a consultar = no pudimos mostrar un precio en este momento. Sin embargo, puede continuar con su pedido. <p> Si necesita asistencia adicional, comuníquese con su  <a target='_blank' href='https://truckservices.knorr-bremse.com/about-us/contacts'> servicio local de atención al cliente de Knorr-Bremse. </a> </ p> ",
    "text_headline_bottombanner": "Banner inferior",
    "import_csv_savedCart_fileCSVRequired": "El archivo importado debe ser un archivo de texto con extensión CSV.",
    "checkout_orderConfirmation_orderStatus": "Estado del pedido: {0}",
    "checkout_multi_hostedOrderPostPage_header_wait": "Espere mientras lo transferimos",
    "text_account_reset": "Reiniciar",
    "mobile_checkout_continue_button": "Continuar",
    "checkout_checkout_single": "Pago individual",
    "core_report_NA_description": "Los informes básicos se publican en línea al comienzo de cada mes para la actividad del mes anterior.",
    "product_grid_expand": "Expandir",
    "text_product": "Productot",
    "text_account_addressBook_addAddress_label": "Agregar dirección para pedidos de emergencia",
    "text_quote_not_cancelable": "La cotización {0} no se puede cancelar",
    "search_nav_done_button": "Listo",
    "text_consent_disclaimer": "cláusula de exención de responsabilidades descargable",
    "quote_create_success": "Cotización creada con éxito.",
    "import_csv_savedCart_uploadFile": "Mantenga el formato de plantilla de pedido si crea su propio archivo para ser subido en su ERP",
    "text_account_close": "Cerrar cuenta",
    "warranty_eligibility_check_date_removed_from_service": "Fecha de retiro del servicio*",
    "text_warranty_document_claim_refund": "Si usted reclama un reembolso de gastos adicionales, deberá adjuntar un comprobante de los mismos; Se rechazará reclamaciones sin pruebas.",
    "payment_nameOnCard_invalid": "Ingrese el nombre que figura en la tarjeta",
    "text_account_warranty_table_header_credit_amount": "Monto acreditado (USD)",
    "price_here_download_files": "Aquí puede descargar los archivos de precios.",
    "basket_page_change_configuration": "Cambiar configuración",
    "text_account_orderHistory_emptyOrderHistory": "Historial de pedido vacío",
    "basket_export_user_title": "Título",
    "popup_cart_title": "Su carrito de compra",
    "text_account_quote_status_display_SELLER_REQUEST": "Solicitado",
    "address_line1_invalid": "Ingrese la dirección en la Línea 1",
    "checkout_multi_deliveryAddress_editAddress": "Editar dirección",
    "import_csv_savedCart_import": "Importar",
    "text_quote_comments_label": "Comentarios",
    "checkout_error_authorization_failed": "Lo sentimos, pero su transacción no se pudo completar en este momento; intente nuevamente más tarde o comuníquese con el servicio al cliente al 555-555-5555",
    "text_storefinder_responsive_page_showAllResults": "Mostrar todo",
    "text_account_saved_cart_detail_list_price": "Precio de lista",
    "product_view_details_name": "Descripción de la piezat",
    "text_Type_here_to_search_address": "Escriba aquí para buscar una dirección",
    "checkout_summary_reviewYourOrder": "Revisión final",
    "checkout_express_error_deliveryAddress": "El pago exprés no está disponible debido a que no tiene una dirección de entrega predeterminada. Establezca una dirección de entrega predeterminada en su cuenta para poder usar el pago exprés la próxima vez.",
    "text_account_order_orderDetails_orderNumber": "Pedido # {0}",
    "text_storefinder_desktop_page_firstPage": "&laquo;",
    "text_warranty_submit_part_information": "Información de la pieza número",
    "productsalesstatus_label_apac_code20": "Non vendable à l'IAM",
    "register_checkPwd_invalid": "Confirme su contraseña",
    "checkout_multi_deliveryMethod_stepHeader": "2 - Seleccione el método de entrega",
    "text_warranty_submit_types_operation": "Tipo de operación",
    "checkout_orderConfirmation_Order_ID": "Pedido #:",
    "checkout_pickup_estimated_total": "Total estimado:",
    "checkout_error_paymentethod_formentry_sop_invalid_card_accountNumber": "El número de tarjeta no es válido.",
    "text_account_quote_action_display_EXPIRED": "Expirado",
    "review_based_on": "({0})",
    "register_company_accessRequesting_invalid": "Elija al menos un acceso",
    "text_account_core_search_showAllResults": "Mostrar todo",
    "storelocator_error_no_results_title": "No se encontraron resultados de tiendas para sus criterios de búsqueda.",
    "register_email_mandatory": "Dirección de correo electrónico de la empresa*",
    "text_account_warranty_table_header_model": "Modelo",
    "text_account_core_table_header_model": "Modelo",
    "payment_month": "Mes",
    "search_back_to_product_list": "Regresar a la lista de productos",
    "text_core_submit_address_addressCompany": "Company*",
    "text_account_order_status_display_open": "Abierto",
    "checkout_multi_deliveryAddress_noExistingAddresses": "No tiene ninguna dirección en su directorio.",
    "text_account_closeAccount_popup_title": "Confirmar cierre de cuenta",
    "checkout_summary_paymentMethod_securityCode_whatIsThis": "(¿Qué es esto?)",
    "order_history_shipping_address": "Dirección de envío",
    "text_core_submission_headerNA_text3": "page.",
    "mobile_checkout_confirmOrder": "Revisión final",
    "text_core_submission_pkgQty": "Cantidad de empaques",
    "text_core_submission_BoxQty": "Cantidad",
    "text_core_submission_palletQty": "Cantidad",
    "order_form_subtotal": "Subtotal",
    "text_core_submission_headerNA_text2": "Para obtener información sobre cómo rellenar este formulario, vaya a la página de",
    "text_core_submission_headerNA_text1": "Por favor, rellene toda la información requerida una vez que su devolución esté <b><u>empaquetada y lista</u></b> para su recogida para asegurar un proceso de devolución de núcleos eficiente.",
    "checkout_error_paymentethod_formentry_sop_invalid_card_expirationMonth": "El mes de vencimiento no es válido.",
    "text_account_online_ordering": "Pedidos Online",
    "address_townCity_invalid": "Ingrese un pueblo / ciudad",
    "text_account_trackOrders": "Rastree sus pedidos",
    "productsalesstatus_label_apac_code10": "Obsolète",
    "text_stores": "Tiendas",
    "warranty_check": "Warrany",
    "text_quickOrder_requested": "Solicitado",
    "productsalesstatus_label_apac_code40": "Vendable à l'IAM - jusqu'à épuisement des stocks",
    "validation_donotcontainName_invalid": "please do not use first name,last name or full name in password.",
    "address_error_sim_invalid": "El número de pieza {0} no se puede enviar a la dirección de entrega ingresada. Cambie la dirección de entrega o elimine este número de pieza.",
    "open_estimated_delivery_date": "Fecha de entrega estimada",
    "login_optional": "(opcional)",
    "text_account_myPart_select_customer": "Seleccione al menos un cliente",
    "text_account_savedCarts_page_sortTitle": "Ordenar por",
    "storeFinder_link": "Buscador de tiendas",
    "storeDetails_table_from": "desde",
    "register_phone": "Número de teléfono (móvil preferiblemente)",
    "basket_export_user_city": "Ciudad",
    "storelocator_distributor": "Distributors",
    "guest_register_description": "Benefíciese de un pago más rápido para su próxima compra y acceda a su historial de pedidos",
    "checkout_checkout_multi_pci": "Pago múltiple con PCI",
    "import_csv_savedCart_uploadStarted": "Subiendo archivo...",
    "text_account_core_search_noRequestFound": "No Results found.",
    "checkout_multi_confirmOrder": "REVISIÓN FINAL",
    "general_month_december": "Diciembre",
    "password_strength_medium": "Mediano",
    "kb_search_result_breadcrumb": "resultados para",
    "text_core_submission_headerEMEA_text3": "Por favor",
    "text_core_submission_headerEMEA_text2": "Cascos Rechazados, por ejemplo pinzas devuletas sin reguladores en su lugar, serán achatarradas sin abono o nuevo aviso.",
    "address_building": "Nombre o número del edificio",
    "text_core_submission_headerEMEA_text4": "para más detalles.",
    "text_core_submission_headerEMEA_text1": "Complete la toda la información necesaria cuidadosamente para garantizar un proceso de devolución eficaz - sólo los formularios completos se podrán procesar!",
    "checkout_summary_deliveryAddress_enterDeliveryAddressButton": "Editar dirección de entrega",
    "productsalesstatus_label_apac_code30": "Vendable à l'IAM",
    "basket_page_quote_discounts_link_percent_off": "{0}% menos",
    "text_account_paymentDetails": "Detalles de pago.",
    "order_totals_savings": "Descuentos:",
    "text_updates": "Actualizaciones",
    "text_account_savedcart_cart_name": "Nombre del carrito",
    "vor_textnextline_warning": "Knorr-Bremse is not liable for late or missed deliveries due to incorrectly entered addresses.",
    "fselect_selected": "selección",
    "text_quote_done_button_label": "Listo",
    "text_warranty_submit_business_type": "Tipo de negocio",
    "registration_error_account_exists_title": "Ya existe una cuenta para esta dirección de correo electrónico.",
    "text_account_profile_updatePersonalDetails_mobile": "Editar",
    "text_account_warranty_table_header_claim_status": "Estado de reclamo",
    "cart_product_configuration_toolong": "El valor es demasiado largo.",
    "search_page_xref_number": "Referencia cruzada",
    "basket_page_viewFuture": "Comprobar disponibilidad de emergencia",
    "checkout_multi_hostedOrderPageError_header": "Detalles del error",
    "review_comment": "Descripción de las comentarios",
    "text_account_orderHistory_seebelow": "See Below",
    "text_checkout_pickup_in_store_address": "Recoger en la tienda - {0}, {1}t",
    "text_iam_partNo": "Nro. de pieza IAM",
    "updatePwd_description": "Ingrese una nueva contraseña.",
    "text_account_order_status": "Estado: {0}",
    "text_select_file_type_upload": "Nota: ¡Se permiten archivos word, xls, xlsx, csv, txt, tif, gif, jpg, pdf y HTML!",
    "file_size_gigabytes": "{0} GB",
    "product_product_partname": "Nombre de la piezat",
    "register_accept_read": "Leer",
    "search_page_linkPreviousPage": "Página anterior",
    "login_new_user": "¿Usuario nuevo?",
    "import_csv_savedCart_noFile": "No se eligió ningún archivo.",
    "register_name_invalid": "Descargas",
    "text_rememberMe_cookie": "Por favor, acepte cookies funcionales para \"Recordar mi inicio de sesión\". Puede cambiar la configuración de cookies",
    "here": "aquí",
    "text_select_all_file_loaded": "All files has been attached successfully",
    "checkout_pickup_simplifyPickup": "Simplifique la ubicación de retiro",
    "basket_page_totalUSD": "Total",
    "review_show_all": "Mostrar todo",
    "checkout_multi_paymentMethod_addPaymentDetails_savePaymentDetailsInAccount": "Guardar estos detalles de pago en mi cuenta",
    "text_select_country": "Seleccione su país e idioma",
    "text_expresscheckout_line3": "utilizar un método de envío predeterminado",
    "text_expresscheckout_line1": "establecer una dirección de entrega predeterminada en su cuenta o cuando pague",
    "text_expresscheckout_line2": "establecer detalles de pago predeterminados cuando finalice la compra",
    "address_regionIso_invalid": "Ingrese una región",
    "text_generalInfo_netWeight": "Peso neto",
    "text_free": "GRATIS",
    "product_grid_itemsText": "artículos",
    "profile_lastName_invalid": "Ingrese un apellido",
    "basket_page_listpriceApac": "List Price(Total)",
    "payment_startDate": "Fecha de inicio (Maestro / Solo / Switch solamente)",
    "address_country_invalid": "Seleccione un país / región",
    "checkout_multi_paymentMethod_createSubscription_billingAddress_noneSelectedMsg": "Ingrese una dirección de facturación o ingrese primero una dirección de entrega para que pueda usarse como dirección de facturación.",
    "address_prefecture": "Nombre de la prefectura",
    "minicart_cart_alt": "Su carrito de compra",
    "text_core_ForkLift": "Fork Lift Required",
    "text_account_update_email_address": "Dirección de correo electrónico",
    "text_account_savedCarts_page_currentPage": "Página {0} de {1}",
    "text_account_order_min_NA": "Pedido mínimo / recargo por urgencia:",
    "text_account_orderHistory_page_totalResultsSingleOrder": "1 pedido",
    "text_core_submit_fax": "Fax",
    "checkout_orderConfirmation_yourItems": "Sus artículos",
    "basket_select_product": "Seleccionar",
    "basket_page_totals_minordercharge": "Cargo mínimo de pedido",
    "text_account_quote_status": "Estado",
    "storelocator_postcode_city_search": "Búsqueda de código postal / ciudad",
    "text_account_savedCarts_page_lastPage": "&raquo;",
    "quote_cart_empty_error": "Carrito perdido o vacío",
    "quick_order_page_ordertype": "Tipo de pedido",
    "text_warranty_terms_pick_delivery": "Camión de recogida y entrega (caja de carga)",
    "text_account_orderHistory_mobile_page_currentPage": "{0} de {1}",
    "profile_currentPassword_invalid": "Ingrese su contraseña actual",
    "text_storefinder_desktop_page_currentPage": "{0} de {1}",
    "register_terms_not_accepted": "Para registrarse, acepte nuestros términos y condiciones.",
    "mini_cart_text_cart": "Carrito",
    "checkout_multi_deliveryMethod_breadcrumb": "OPCIONES DE ENTREGA",
    "text_generalInfo_customsInfo": "Información de aduanas",
    "text_warranty_terms_inter_city": "Camión interurbano",
    "checkout_error_paymentethod_formentry_sop_invalid_billTo_street1": "Este valor no es válido para este campo.",
    "cart_items": "{0} artículostt",
    "login_error_incorrect_password_title": "La dirección de correo electrónico o contraseña ingresadas no son correctas.",
    "checkout_error_paymentethod_formentry_sop_invalid_billTo_street2": "Este valor no es válido para este campo.",
    "text_account_closeAccount_popup_confirm": "¿Seguro que quiere cerrar su cuenta?",
    "text_generalInfo_subjecttochange": "Sujeto a cambios con base en la entrega de almacenes; para obtener más detalles, comuníquese con su servicio local de atención al cliente.",
    "basket_validation_voucherNotValid": "El cupón aplicado en el carrito ya no es válido y se ha eliminado del carrito.",
    "address_city": "Ciudad*",
    "text_warranty_submit_vehicle_manufacturer": "del fabricante del vehículo",
    "search_nav_applied_facets": "Facetas Aplicadas",
    "text_warranty_terms_highway_information": "Aplicaciones en carretera:",
    "text_account_myPart": "Mi pieza",
    "onLine_check": "Compra online",
    "mobile_checkout_items_hide": "Artículos ocultos",
    "text_account_savedCart_delete": "Eliminar carrito",
    "pickup_in_store": "Retirar en la tienda",
    "basket_page_coresurcharge": "Cargo del nucleo",
    "basket_page_coredeposit": "Fianza del Casco",
    "checkout_orderConfirmation_coupon_valid_range": "Válido desde {0} hasta {1}",
    "register_company_industryRole": "Sector en la industria de la empresa",
    "checkout_page_deliveryType_complete_message": "Full delivery chosen: The last date in your cart positions is the expected delivery date for the entire order",
    "text_account_order_discount": "Descuentos en pedido:",
    "text_account_addressBook_page_firstPage": "&laquo;",
    "basket_error_occurred": "Se produjo un error al agregar al carrito",
    "pickup_force_in_stock": "EN STOCK",
    "text_core_submit_address_requestedDate": "Fechas disponibles de recogida: *",
    "text_account_myPart_download_button": "Descargar mis propios números de pieza",
    "checkout_summary_paymentMethod_billingAddress_header": "Dirección de facturación:",
    "product_bookmark_and_share": "Marcar y compartir",
    "basket_page_title_yourPickUpItems": "Sus artículos para ser retirados:",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_street1": "Ingrese un valor para este campo",
    "remember_me": "Recuerda mi inicio de sesión",
    "text_core_submission_return": "Solicitud de devolución del núcleo",
    "text_account_quote_page_sortTitle": "Ordenar por",
    "checkout_paymentMethod_notSelected": "Ingrese los detalles de pago para su pedido.",
    "checkout_orderConfirmation_thankYou": "Gracias por su pedido. Su número de pedido es {0}",
    "text_generalInfo_weight_dimensions": "Peso y dimensiones",
    "text_submit_warranty": "Aplicación de solictud de garantía",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_street2": "Ingrese un valor para este campo",
    "coupon_invalid_code_provided": "El código de cupón ingresado no es válido.",
    "sold_to_popup_text_three": "para más ayuda",
    "text_warranty_submit_vehicle_engine_manufacturers": "Fabricant du moteur",
    "text_showFacet": "Mostrar procesamientot",
    "register_company_address_city_invalid": "Ingrese la ciudad donde se encuentra la empresat",
    "basket_page_coreCharges": "Cargo del nucleo",
    "globle_search_message": "Por favor introduzca al menos 3 caracteres",
    "text_page_ifnotfound": "si no puede encontrar lo que está buscando.",
    "basket_page_message_update_reducedNumberOfItemsAdded_noStock": "<a href",
    "storeDetails_table_openingSpecialDays": "Horarios especiales de apertura",
    "text_reports_creditReconNa": "Detalles del débito/crédito básico de fin de mes",
    "text_warranty_submit_product_not_found": "Producto no encontrado",
    "register_company_accessRequesting": "Solicitud de acceso para",
    "checkout_express_error_paymentInfo": "El pago exprés no está disponible ya que no tiene una información de pago predeterminada. Establezca una información de pago predeterminada en su cuenta para poder usar el pago exprés la próxima vez.",
    "text_account_order_title_deliveryItems": "Artículos para entrega",
    "text_warranty_submit_customer_information": "Referencia e información al cliente",
    "checkout_multi_order_summary": "RESUMEN DEL PEDIDO",
    "core_submit_warranty_crn_number_label": "If checked the system will create the CRM Number",
    "basket_information_obselete_status_true": "Este producto se reemplaza por {0}, ya que ahora está obsoleto.",
    "checkout_multi_sop_useMyDeliveryAddress": "Usar mi dirección de entrega",
    "text_warranty_select_file_wish": "Seleccione el archivo que desea cargar y haga clic en el botón \"Upload\" (Cargar). Se agregará cada archivo cargado al reclamo.",
    "register_company_industryRole_invalid": "Seleccione al menos un sector",
    "tooltip_text": "e.g. max. vehicle size",
    "text_sales_status_description_emea_code_40_anonymous": "Vendable à l'IAM",
    "storeDetails_table_opening_opened": "Abierto",
    "mycompany_search_term": "Término de búsqueda",
    "header_quick_order": "PEDIDO RÁPIDO",
    "text_sales_status": "Estado de ventas",
    "text_account_orderHistory_mobile_page_sort_byOrderNumber": "Número de pedido",
    "basket_page_availability": "Disponibilidad",
    "checkout_error_paymentethod_formentry_sop_invalid_card_issueNumber": "El número de emisión no es válido.",
    "product_view_details_code": "Pieza #t",
    "basket_error_invalid_configuration": "Tiene una configuración de producto no válida. {0} problema(s) deben resolverse antes de pagar.",
    "text_header_connect": "Conectar",
    "text_quote_edit_confirmation_modal_title": "Editar advertencia de cotización",
    "order_quantity": "Cantidad",
    "download_click_on_text": "To do so, click on \"START DOWNLOAD\"",
    "text_storefinder_responsive_page_lastPage": "&raquo;",
    "text_reports_detail": "Detalle completo",
    "address_state": "Provincia / estado",
    "storeFinder_pagination_previous": "Anterior",
    "pdp_page_contact_us": "Comuníquese con nosotros",
    "text_sales_status_description_apac_code_40": "Vendable à l'IAM - jusqu'à épuisement des stocks",
    "login_error_incorrect_password_subtitle": "Si olvidó su contraseña, utilice el enlace de contraseña olvidada.",
    "file_size_megabytes": "{0} MB",
    "text_headline_navigationbar": "Navegue por la barra de navegación",
    "text_account_orderHistory_page_sortTitle": "Ordenar por",
    "basket_page_remove": "Eliminar",
    "text_account_account": "Cuenta",
    "address_line2_shipping_page_form_emea": "Número de calle*",
    "register_dataprotection_acceptNA": "Acepto el",
    "text_quickOrder_order_type": "Tipo de pedido",
    "checkout_multi_pickup_items": "Retirar #{0} - {1} Artículos",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_city": "Ingrese un valor para este campo",
    "text_quote_submit_not_modifiable_message": "Una vez que se envía una solicitud de cotización, no se puede modificar.",
    "updatePwd_checkPwd": "Confirmar contraseña",
    "checkout_multi_paymentMethod_edit": "Editar",
    "order_productDetails": "Detalles del producto",
    "checkout_error_paymentethod_formentry_sop_invalid_card_startYear": "El año de emisión no es válido.",
    "text_account_myPart_upload_button": "Todas las referencias se han cargado correctamente.",
    "checkout_error_paymentethod_formentry_sop_invalid_billTo_city": "Este valor no es válido para este campo.",
    "pickup_location_required": "Ingrese su ubicación para ver los productos disponibles en su área.",
    "text_account_addressBook_yourDefaultAddress": "Esta es su dirección predeterminada",
    "text_account_profile_confirmationUpdated": "Su perfil ha sido actualizado",
    "coWorker_check": "Co-Worker Order",
    "text_pagenotfound_homepage": "inicio",
    "pickup_here_button": "Retire aquí",
    "mobile_checkout_deliveryAddress_use": "Utilizar",
    "checkout_page_summary_final_review_shipping_address": "Dirección de envío",
    "checkout_orderConfirmation_get_coupon": "¡Se ha ganado el siguiente cupón!",
    "checkout_error_paymentethod_formentry_sop_missing_shipTo_postalCode": "Ingrese un valor para este campo",
    "text_account_savedcart_numberofproducts": "Número de productos",
    "text_reports_creditEmea": "Explanation of the month end core debit/credit",
    "checkout_error_paymentethod_formentry_sop_missing_card_cvNumber": "Ingrese un valor para este campo",
    "checkout_multi_deliveryAddress_selectAddressMessage": "Seleccione una dirección existente para su entrega.",
    "checkout_orderConfirmation_copySentToShort": "Se envió una copia de los detalles de su pedido a",
    "checkout_multi_address_updated": "Su dirección fue actualizada",
    "register_pwd_invalid": "La contraseña no cumple con los requisitos mínimos.",
    "text_country_selector_APAC": "Asia Pacific",
    "promotional_box_main_heading": "News & Updates of Products and Services",
    "address_postalcode": "Código postal*",
    "text_checkout_noDeliveryModes": "Revise la dirección de envío. Si aún no lo ha hecho, seleccione primero la dirección de entrega e intente de nuevo.t",
    "text_account_savedcart_save_activecart": "No quiero guardar artículos para más tarde",
    "storeFinder_see_more": "Ver más...",
    "checkout_summary_deliveryAddress_header": "Dirección de entrega",
    "general_find_a_store": "Encontrar una tienda",
    "search_mobile_page_sortTitle": "Ordenar por:",
    "register_email_duplicate": "La dirección de correo electrónico ingresada ya está registrada con una cuenta existente",
    "globle_invalidDateFormat": "¡Formato de fecha inválido!",
    "text_voucher_apply_invalid_error": "Este cupón no es válido.",
    "text_quickOrder_product_not_unique": "Producto no único",
    "text_account_quote_myquotes": "Mis cotizaciones",
    "basket_information_quantity_reducedNumberOfItemsAdded_maxOrderQuantityExceeded": "Lamentablemente, la cantidad que eligió superó la cantidad máxima de pedido para este producto.",
    "text_account_confirmation_password_updated": "Su contraseña ha sido cambiada",
    "general_required_po_checkout_mandatory": "El número de orden de compra del cliente es obligatorio para completar el proceso de pago",
    "search_nav_facetShowLess_brand": "menos marcas...",
    "checkout_page_summary_order_type": "Tipo de pedido",
    "basket_save_cart_name": "Nombre",
    "text_headline_login": "Haga clic aquí para ingresar",
    "checkout_multi_pickupInStore_confirm_and_continue": "Simplemente confirme la información a continuación y continúe con el siguiente paso de pago.",
    "text_cookie_notification_accept": "x",
    "checkout_multi_deliveryMethod_message": "Los artículos se enviarán tan pronto como estén disponibles. <br> Consulte el resumen del pedido para obtener más información.",
    "text_account_quote_remove": "Eliminar",
    "text_quote_comment_label": "Negotiation Comment",
    "text_account_profile_updateEmail_mobile": "Cambiar correo electrónico",
    "basket_page_total": "Total",
    "checkout_checkout_multi_pci-sop": "PCI-SOP",
    "text_account_savedCarts_noSavedCarts": "No se encontraron carritos guardados",
    "account_confirmation_forgotten_password_link_sent": "Se han enviado instrucciones para restablecer la contraseña a su dirección de correo electrónico. Comuníquese con el servicio de atención al cliente si necesita asistencia adicional.",
    "basket_page_shipping_find_store": "Encontrar una tienda",
    "basket_page_totals_grossTax": "Su pedido incluye {0} impuesto.",
    "storeDetails_table_opening": "Horas",
    "checkout_summary_deliveryMode_selectDeliveryMethodForOrder": "Método de envío",
    "account_confirmation_email_sent": "¡Instrucciones enviadas para el restablecimiento de contraseña!",
    "text_account_savedCarts_page_totalResultsSingleOrder": "1 carrito guardado",
    "text_company_manage_units_notapproved": "Su solicitud de registro aún no ha sido aprobada, después de la aprobación recibirá un correo electrónico con más información.",
    "text_account_addressBook_page_sort_byName": "Nombre",
    "DeliveryType_Complete_name": "Livraison complète",
    "text_account_orderHistory_page_totalResults": "de {0} pedidos",
    "checkout_orderConfirmation_copySentTo": "Se envió una copia de los detalles de su pedido a {0}",
    "import_csv_savedCart_filesNote": "Aquí puede subir un archivo que contenga una lista de todos los números de parte que desea pedir. La lista se utilizará para actualizar automáticamente su carrito de compras. Para usar esta función: haga clic en <b> Descargar plantilla de pedido </b>, ingrese su información en el archivo, seleccione su tipo de pedido y haga clic en <b> Subir plantilla de pedido </b>",
    "text_quote_discount_apply_calculation_error": "Se generó un error interno al aplicar el descuento. Inténtelo de nuevo",
    "text_core_submission_wghtApx": "Peso aprox.",
    "breadcrumb_techteam_text": "Equipo técnico",
    "search_nav_categoryNav": "Comprar por categoría",
    "storeFinder_noResults": "No Stores Found",
    "text_pleaseSelect": "título",
    "register_company_address_two": "Dirección 2t",
    "basket_error_entrygroup_remove": "No se puede eliminar el grupo de entrada del carrito # {0} debido a un error.",
    "consent_form_global_error": "Algo salió mal al guardar su consentimiento. Gestione su consentimiento en la página de Gestión de consentimiento.",
    "text_volumePrices": "Precios por volumen disponibles",
    "text_account_warranty_search_page_totalResultsSinglePag": "{0} reclamos",
    "product_bundles": "Compre este artículo en un paquete",
    "order_free": "GRATIS",
    "product_grid_confirmQtys_message": "¡Navegar fuera de esta página resultará en la pérdida de los datos que ha ingresado!",
    "text_headline_myaccount": "Haga clic aquí para ingresar o acceder a su cuenta",
    "text_paymentDetails": "Detalles de pago.t",
    "text_core_submit_firstName": "Nombre",
    "pickup_search_button": "Encontrar tiendas",
    "text_warranty_submit_part_scale": "Escala*",
    "checkout_summary_paymentMethod_addPaymentDetails_billingAddressDiffersFromDeliveryAddress": "Si su dirección de facturación es diferente a su dirección de entrega, utilice este formulario para ingresar su dirección de facturación",
    "popup_cart_empty": "Carrito vacío",
    "register_title": "Título",
    "text_warranty_submit_part_requestedPartAmount": "Monto de la pieza solicitada*",
    "text_account_orderHistory_page_sort_byOrderType": "Order Type-Asc",
    "#text_account_mypart_count_message": "You have requested to upload own part numbers into {0} system.###Your original file showed {1} part numbers; your new file show {2} part numbers.###Once your file is completely uploaded to {3} system, it will replace any existing information from your new uploaded file.###Do you want to continue uploading?",
    "basket_restoration_errorMsg": "Su carrito no pudo ser restaurado.",
    "basket_page_totals_quote_total_original": "Subtotal original:",
    "register_company_phoneNumber": "Número de teléfono",
    "quote_approve": "Aprobar cotización",
    "checkout_error_paymentethod_formentry_sop_missing_card_expirationMonth": "Ingrese un mes de vencimiento",
    "checkout_orderDetails_hide": "[-] Ocultar detalles del pedido",
    "search_meta_title": "Buscar",
    "core_number_not_available": "La pieza introducida no tiene núcleo. Por favor, introduzca un número de pieza diferente o haga clic en la x para cerrar la búsqueda",
    "text_account_order_status_display_processing": "En proceso",
    "text_addToCart_outOfStock": "agotado en líneat",
    "checkout_error_paymentethod_formentry_sop_missing_shipTo_firstName": "Ingrese un valor para este campo",
    "quickorder_page_ordertypes": "Tipo de pedido",
    "storeFinder_pagination_next": "Siguiente",
    "text_account_order_summary": "A continuación, se muestra un resumen de su pedido:",
    "text_warranty_terms_firetruck_home": "Camión de bomberos",
    "checkout_multi_next": "Siguiente &raquo;",
    "text_warranty_submit_labourrequested_no": "No",
    "text_account_paymentDetails_billingAddress": "Dirección de facturación",
    "mini_cart_popup_quantity": "Cantidad:",
    "text_storefinder_mobile_page_totalResults": "{0} Tiendas encontradas",
    "text_warranty_submit_email2": "Dirección de correo electrónico 2",
    "text_warranty_submit_email1": "Dirección de correo electrónico 1",
    "text_account_savedCart_dateSaved": "Fecha guardada",
    "checkout_summary_deliveryMode_noneSelected": "Ninguna selección",
    "checkout_multi_shipment_pickup_location": "Lugar de envío / retiro",
    "checkout_page_summary_final_review_carrierSelection": "Selección de transportista:",
    "quote_create_error": "Error al elaborar la cotización.",
    "payment_cardType_invalid": "Seleccione un tipo de tarjeta",
    "register_remember": "Recuérdame en esta computadora",
    "search_nav_changeLocation": "Cambiar ubicación",
    "text_account_orderHistory_page_sort_byCategory": "Order Category-Asc",
    "product_share_viewMoreServices": "Ver más servicios",
    "basket_validation_couponNotValid": "El cupón aplicado en el carrito ya no es válido y se ha eliminado del carrito.",
    "address_countryIso": "País*",
    "open_total_usd": "Abierto Total dólares de los EE.UU. (United States dollars, USD)",
    "warranty_eligibility_check_vehicle_identification_number": "Número de identificación del vehículo",
    "text_account_addressBook_page_sort_byDateModified": "Fecha modificada",
    "checkout_page_summary_deliveryMode_selectDeliveryMethodForOrder_NA": "Selección de transportista",
    "register_dataprotection_id": "verificación de protección de datos",
    "checkout_error_paymentethod_formentry_sop_invalid_billTo_email": "Este valor no es válido para este campo.",
    "product_average_review_rating": "Calificación promedio de productos {0} / 5",
    "search_nav_facetShowLess_category": "menos categorías...",
    "text_label_loadingmoreresults": "Cargando más resultados...",
    "text_warranty_submit_final_review": "Revisión final",
    "cart_page_customer_reference_apac": "Item Ref No.",
    "warranty_eligibility_check_bendix_part_number": "N.º de pieza de Bendix*",
    "pdp_page_sign_in": "Registrarse",
    "text_coreClass": "Clase principal",
    "pickup_pagination_next": "Siguiente",
    "core_submit_warranty_material_includedyes": "Material de garantía incluido",
    "text_account_savedCart_id": "IDENTIFICACIÓN",
    "text_logout": "Cerrar sesión",
    "register_email": "Dirección de correo electrónico",
    "text_select_customerid_account": "Seleccione ID de cliente para vincularlo con esta nueva cuenta de usuario",
    "text_warranty_submit_claim_ref_number": "Número de Referencia de la reclamación del cliente",
    "forgottenPwd_email_invalid": "Ingrese un correo electrónico válido",
    "text_select_cutomer_id_user_account": "Seleccione el ID de cliente a vincular con esta nueva cuenta de usuario",
    "basket_export_cart_item_quantity": "Cantidad",
    "address_postcodeJP": "Código postal precedido por símbolo postal",
    "text_header_languageandcurrency": "Idioma y moneda",
    "productsalesstatus_label_apac_code40_anonymous": "Vendable à l'IAM",
    "search_mobile_no_results": "No se ha encontrado resultados.",
    "product_grid_futurestock_updatefuture_availability": "Mostrar disponibilidad futura",
    "text_account_savedCarts_ShoopingCart": "Carrito de compras guardado",
    "text_account_profile_myProfile": "Mi perfil",
    "text_quote_cancel_success": "La cotización {0} ha sido cancelada",
    "review_back": "Volver a los comentarios",
    "text_account_orderHistory_page_sort_byDate": "Fecha",
    "text_warranty_eligibility_part_number_error": "Please enter a valid Bendix Part Number",
    "aria_pickupinstore_loading": "Cargando... Por favor espere...",
    "text_account_order_placedBy": "Colocado por: {0}",
    "basket_restoration_restorationError": "Su carrito no pudo ser restaurado.",
    "product_start_bundle": "Comenzar paquete",
    "text_account_orderHistory_orderNumber": "Número de pedido",
    "register_title_invalid": "Seleccione un título",
    "text_cust_part_no": "Referencia propia del Cliente",
    "register_company_name_invalid": "Ingrese el nombre de la empresa",
    "text_account_closeAccount_button": "Cerrar cuenta",
    "text_warranty_search_reset": "Restablecer",
    "checkout_pickup_pickup_in_store": "Recoger en la tienda - {0}, {1}",
    "profile_pwd": "Contraseña",
    "register_company_faxNumber_invalid": "Ingrese el número de fax de la empresat",
    "text_add_row_button": "Añadir fila",
    "import_csv_savedCart_requestedDate": "Fecha de entrega solicitada (formato DD / MM / AAAA)",
    "profile_title": "Título",
    "checkout_multi_cancel": "Cancelar",
    "header_link_logout": "Cerrar sesión",
    "checkout_multi_inStore": "En la tienda",
    "basket_page_title": "Artículo",
    "checkout_multi_deliveryMethod_notprovided": "Debe proporcionar una opción de entrega para ir al siguiente paso.",
    "checkout_error_paymentethod_formentry_sop_missing_shipTo_shippingMethod": "Ingrese un valor para este campo",
    "text_button_menu": "Menú",
    "text_quote_expiration_time_warning": "Nota: Si la fecha de caducidad se configura hoy o antes, se establecerá en {0} días a partir de hoy.",
    "only_bendix_personel": "Sólo para el personal de Knorr-Bremse",
    "text_htcCode": "Código de clasificación arancelaria (Harmonized Tariff Code, HTC)t",
    "warranty_eligibility_check_date_in_service": "Fecha de puesta en servicio*",
    "text_account_addressBook_addressDetails": "Detalles de la dirección",
    "checkout_summary_deliveryAddress_noneSelected": "Ninguna selección",
    "text_button_showall": "Mostrar todo",
    "text_account_addressBook_confirmationUpdated": "Su dirección fue actualizada",
    "review_alias": "Su nombre",
    "test_account_core_reportsinfoEMEA": "If you cannot get a particular core report, please contact your",
    "text_Saved_Billing_Addresses": "Direcciones de facturación guardadas",
    "popup_cart_showing": "Mostrando {0} de {1} artículos",
    "text_warranty_claim_information": "Información solicitud",
    "text_account_savedCart_name": "Nombre",
    "register_termsOfUsage_message": "Términos de uso de la tienda virtual",
    "mycompany_user_delete_confMessage": "¿Está seguro de que desea eliminar la siguiente cuenta de usuario?",
    "text_account_quote_status_display_BUYER_ORDERED": "Ordenado",
    "basket_page_cartId": "Identificación del carrito:",
    "search_nav_facetShowLess_typenumber": "menos...",
    "register_customer_regisration": "REGISTRO DE CLIENTE",
    "text_checkout": "Pagot",
    "mycompany_set_right": "Establecer derechos de usuario",
    "product_overview": "Detalles",
    "mobile_checkout_multi_button_submit": "Enviar",
    "product_volumePrices_column_price": "Precio de cada uno",
    "text_warranty_search_from_date_to_date_invalid": "Claim Date From can't be greater than Claim Date To.",
    "text_account_profile_resetPassword": "Restablecer contraseña",
    "review_show_less": "Mostrar menos",
    "text_software_download_header": "Software Descargar",
    "checkout_pickup_no_delivery_required": "No se requiere entrega para este pedido",
    "pagination_items": "artículos",
    "breadcrumb_quickOrder": "Pedido rápido",
    "checkout_summary_deliveryAddress_editDeliveryAddressButton": "Editar dirección de entrega",
    "register_company_phoneNumber_invalid": "Ingrese el número de teléfono de la empresat",
    "header_changecustomer_id": "Cambiar identificación del cliente",
    "search_spellingSuggestion_prompt": "Quiso decir:",
    "text_account_savedCart_message": "Las promociones y los totales reflejan lo que existía en el momento en que se guardó el carrito. Las promociones y los totales pueden cambiar o dejar de aplicar cuando se restaura el carrito.",
    "text_account_profile_cancel": "Cancelar",
    "text_warranty_submit_requested_cost": "Reembolso de costos solicitado",
    "click_export_download": "Haga clic en “Exportar” para descargar los datos en un archivo de Excel.",
    "basket_confirmation_items_added": "Sus artículos guardados han sido agregados a su carrito.",
    "text_warranty_search_search": "Buscar",
    "checkout_multi_hostedOrderPageError_ERROR_150": "Falla general del sistema. Posible acción: Espere unos minutos y vuelva a hacer el pedido.",
    "pickup_product_availability": "Disponibilidad del producto por ubicación de tienda",
    "text_account_yourAccount": "Mi cuenta",
    "basket_page_cartIdShort": "Identificación:",
    "review_rating_invalid": "Ingrese una calificación",
    "text_account_order_orderNumberShort": "Pedido #: {0}",
    "text_warranty_search_claim_from_date": "Fecha de reclamo desde",
    "text_quickOrder_product_quantity_max": "Cantidad reducida debido a stock insuficiente",
    "checkout_multi_hostedOrderPageError_ERROR_151": "Se recibió la solicitud, pero se agotó el tiempo de espera del servidor. Posible acción: Para evitar duplicar el pedido, no vuelva a enviar la solicitud hasta que se haya comunicado con nuestro equipo de ventas.",
    "text_account_warranty_search_page_linkNextPage": "Página siguiente",
    "checkout_multi_hostedOrderPageError_ERROR_152": "Se recibió la solicitud, pero un servicio no terminó de ejecutarse a tiempo. Posible acción: Para evitar duplicar el pedido, no vuelva a enviar la solicitud hasta que se haya comunicado con nuestro equipo de ventas.",
    "search_meta_description_results": "Resultados de búsqueda para",
    "profile_title_invalid": "Seleccione un título",
    "text_generalInfo_coreInformation": "Información principal",
    "order_history_status_date": "Situación a la fecha:",
    "address_townJP": "Ciudad, pueblo, municipio",
    "checkout_summary_paymentMethod_securityCode_whatIsThis_description": "Los últimos 3 dígitos en la banda de la firma en el reverso de la tarjeta. Para American Express, son los 4 dígitos justo encima del holograma en el frente de la tarjeta.",
    "text_account_order_status_display_created": "Creado",
    "product_product_spec": "Descargas",
    "text_account_quotes_noQuotes": "Sin cotizaciones",
    "checkout_page_replaced": "Sustituido",
    "paymentMethod_paymentDetails_expires": "Caduca {0} / {1}",
    "text_core_submit_coreGroup": "Grupo principal",
    "product_grid_outOfStock": "Agotado",
    "text_materialType": "Tipo de materialtt",
    "storeDetails_table_email": "Email",
    "basket_export_cart_item_sku": "Código de artículo (Stock Keeping Unit, SKU)",
    "text_pagenotfound_or": "o",
    "checkout_error_paymentethod_formentry_sop_invalid_billTo_phoneNumber": "Este valor no es válido para este campo.",
    "text_warranty_submit_enter_product_code": "Please enter product code",
    "cart_product_deletetext": "Do you want to delete the selected item?",
    "text_weight_approx": "Peso aprox. [kg]",
    "basket_page_totals_quote_total_after_discount": "Nuevo subtotal:",
    "pickup_out_of_stock": "AGOTADO",
    "general_unknown_identifier": "Se pasó un identificador desconocido",
    "text_account_addressBook_page_showAllResults": "Mostrar todo",
    "text_core_submit_address_address": "Dirección*",
    "breadcrumbs_core": "Core Submission",
    "text_quantity": "Cantidadt",
    "general_continue_button": "Continuar",
    "quote_approve_error": "Error al aprobar la cotización.",
    "text_account_warranty_search_page_showPageResults": "Mostrar paginado",
    "product_grid_future_tooltip_qty": "CANT.",
    "text_account_savedcart_restore_btn": "Restaurar",
    "text_account_savedcart_cart_id": "IDENTIFICACIÓN",
    "search_nav_facetShowMore": "Ver más",
    "basket_validation_configurationError": "{0} tiene errores de configuración que deben corregirse antes de proceder al pago.",
    "storelocator_search_results_go": "Ir",
    "text_headline_homebanner": "Banner superior",
    "text_cutoff_orderconfirmation_timezone_EMEA": "Cut-off time: {0} must be placed by {1} {2}",
    "text_quote_discount_modal_title": "Descuento {0}",
    "text_warranty_terms_transit_bus": "Autobús de tránsito (autobús urbano)",
    "text_account_savedCart_position": "Posiciones",
    "checkout_multi_items_to_pickup": "Retirar:",
    "pickup_pagination_from": "desde&nbsp;",
    "text_core_CollectionDate": "Collection Date",
    "checkout_multi_paymentMethod_addPaymentDetails_useSavedCard": "Usar una tarjeta guardada",
    "text_account_savedcart_retain_savedcart": "Mantenga una copia de este carrito en la lista guardada",
    "cart_page_ordertypes": "Tipo de pedido",
    "text_warranty_terms_highway_off": "Aplicaciones fuera de carretera:",
    "text_account_quote_page_sort_byName": "Nombre",
    "text_account_warranty_search_page_totalResults": "de {0} reclamos",
    "text_warranty_submit_part_labour_requested": "Mano de obra solicitada*",
    "login_title": "Cliente existente",
    "coupon_general_error": "El canje de cupones ha fallado.",
    "checkout_login_loginAndCheckout": "Iniciar sesión en su cuenta",
    "text_account_orderHistory_mobile_page_currentResults": "{0} - {1} de {2} pedidos",
    "basket_your_shopping_basket": "Su carrito de compra",
    "review_submitted_by": "Enviado por",
    "register_company_address_zip": "Código postal*",
    "guest_confirm_email": "Descargas",
    "checkout_orderDetails_show": "[+] Ver detalles del pedido",
    "text_account_warranty_table_header_ref_number": "Customer Warranty Claim Reference No.",
    "text_headertext_conf": "Confirmar",
    "cart_groups_remove": "eliminar",
    "checkout_multi_deliveryMethod": "OPCIONES DE ENTREGA",
    "popup_cart_customer_price": "Precio del cliente",
    "search_nav_facetShowMore_brand": "más marcas...",
    "review_write_review": "Escribir comentario",
    "product_grid_futurestock_refresh": "Actualización futura",
    "checkout_orderConfirmation_summary": "A continuación, se muestra un resumen de su pedido:",
    "text_account_saveCart_edit_success": "El carrito {0} se actualizó exitosamente",
    "checkout_page_show_all_position_text": "Show / Hide sub items",
    "cart_page_total": "Total",
    "header_link_account": "Mi cuenta",
    "text_account_savedCart_total": "Total",
    "text_account_addressBook_addAddress": "Agregar dirección",
    "text_skipToNavigation": "Ir al menú de navegaciónt",
    "checkout_summary_deliveryMode_items_for_pickup": "{0} artículos para retirar por tienda",
    "guest_pwd": "Contraseña",
    "core_report_date": "Mes, año",
    "basket_add_free_gift": "Agregue su regalo gratis al carrito",
    "checkout_pages_availabilty_final_review": "SIGUIENTE",
    "price_select_all": "Seleccionar todo",
    "text_warranty_submit_part_hourlyLabourRate": "Tarifa de mano de obra por hora",
    "mobile_payment_issueNumber": "Número de emisión (Maestro / Solo / Switch solamente)",
    "address_shipping_page_form": "Dirección*",
    "text_account_warranty_search_empty": "No se encontraron reclamos de garantía. Cambie sus criterios de búsqueda e inténtelo de nuevo.",
    "pdp_unavailableText": "NO DISPONIBLE",
    "paymentMethod_header": "Detalles de pago.",
    "search_nav_refine_button": "Procesar",
    "text_account_profile_updatePersonalDetails": "Datos personales",
    "checkout_summary_paymentMethod_addPaymentDetails_billingAddress": "Dirección de facturación",
    "text_core_search_kbpart": "N.º de pieza Knorr-Bremse",
    "search_nav_facetShowMore_stores": "Mostrar más tiendas",
    "download_must_agree_text": "You must agree to our",
    "product_view_details": "Ver detalles",
    "text_account_order_total": "Total",
    "payment_cardNumber_invalid": "Ingrese un número de tarjeta válido",
    "general_month_july": "Julio",
    "product_grid_selectSize": "Seleccionar",
    "text_headline_description": "Descripciónt",
    "quote_reject": "Rechazar cotización",
    "import_csv_savedCart_chooseFile": "Seleccionar archivo",
    "text_core_submission_NA_text1": "Gracias por enviar su solicitud de devolución de núcleo. Por favor, revise su bandeja de entrada para obtener una copia del formulario de devolución de núcleo enviado.",
    "text_core_submission_NA_text2a": "Incluya una copia del formulario de devolución de núcleo de Bendix junto con su envío.",
    "text_core_submission_NA_text2": "Recordatorio:",
    "text_account_saved_cart_detail_net_price": "Precio neto",
    "text_core_submission_NA_text3": "Todos los envíos deben realizarse <b>PREPAGADOS</b> a la siguiente dirección:",
    "text_core_submission_sucess_text3": "MÉXICO:<br/>Distribuidora Bendix <br/>Río Lerma 108-2<br/>Industrial Tlaxcolpan<br/>Tlalnepantla, Estado de México 54030",
    "search_nav_appliedFilters": "Eliminar",
    "checkout_multi_payment": "Pago:",
    "text_account_gereral_rights": "Derechos generales",
    "checkout_multi_deliveryAddress_selectSuggestedAddress": "Verifique su dirección. <br> Le sugerimos que acepte uno de los siguientes cambios en su dirección:",
    "checkout_multi_secure_checkout": "PAGO SEGURO",
    "checkout_checkout": "Ir al carrito",
    "checkout_multi_hostedOrderPostPage_button_submit": "Enviar",
    "general_month_june": "Junio",
    "text_account_addressBook_manageYourAddresses": "Gestione su directorio",
    "checkout_error_paymentethod_formentry_sop_invalid_shipTo_postalCode": "Este valor no es válido para este campo.",
    "product_detail_quantity": "CANT.",
    "text_status": "Estadott",
    "checkout_multi_deliveryMethod_edit": "Editar",
    "text_generalInfo_packagingInformation": "Información de embalaje",
    "text_headline_profile": "Haga clic aquí para ver su perfil, directorio, detalles de pago o historial de pedidos",
    "storeFinder_search": "Buscar",
    "text_quickOrder_delete_checkboxes": "Eliminar todo",
    "text_account_orderHistory_page_sort_byCategoryDesc": "Order Category-Desc",
    "open_order_category": "Categoría de pedido",
    "basket_added_to_mobile_basket": "Artículo agregado",
    "product_share_sendToFacebook": "Enviar a Facebook",
    "order_form": "Formulario de pedido",
    "text_account_savedCart_edit_title": "Editar carrito guardado",
    "basket_page_totals_estimatedtotal": "Total estimado:",
    "text_warranty_terms_motor_home": "Casa rodante",
    "basket_page_deliveryQty": "Delivery Qty",
    "general_month_april": "Abril",
    "text_iam_for": "Referencias IAM para la&nbsp;",
    "text_quote_edit_warning_message": "¿Está seguro que quiere editar esta cotización aprobada?",
    "checkout_multi_hostedOrderPostPage_header_debug": "Esta página muestra todos los campos API de la página de pedidos alojados (Hosted Order Page, HOP) que serán enviados a la URL de la HOP.  Se puede usar para depurar la HOP cambiando los valores para simular el comportamiento deseado.",
    "text_quote_conteroffer_confirmation_message": "¿Está seguro de que quiere ofrecer esta cotización de proveedor?",
    "quote_state_BUYER_DRAFT": "BORRADOR",
    "text_account_addressBook_page_totalResults": "{0} Address(s) Found",
    "address_province_invalid": "Ingrese una provincia",
    "text_warranty_submit_part_datecode": "Código de fecha.",
    "text_headline_orderitems": "Toda la información sobre los artículos de su pedido.",
    "form_global_already_registered": "La dirección de correo electrónico ingresada ya está registrada con una cuenta existente",
    "homepage_proeuct_categories": "Categorías de producto",
    "search_page_nearbyStores": "Ha buscado tiendas cercanas",
    "text_account_addressBook_page_linkPreviousPage": "Página anterior",
    "text_shippingMethod": "Método de envíot",
    "basket_page_totals_estimatedZip": "Código postal:",
    "text_account_saved_cart_detail_core_charges": "Cargo del nucleo",
    "order_form_currency": "$",
    "basket_page_price": "Precio",
    "basket_export_user_fax": "Fax",
    "storelocator_search_totalResults": "Mostrando {0} tiendas más cercanas",
    "checkout_multi_deliveryMethod_header": "Opciones de entrega",
    "text_unitOfMeasure": "Unidadt",
    "text_marketType": "Tipot",
    "text_account_open_position": "Posiciones abiertas",
    "checkout_estimateDeliveryDate_empty": "ABIERTO",
    "text_generalInfo_countryOrigin": "País de origen",
    "text_user_table_delete_user_account": "Eliminar cuenta de usuario",
    "text_account_orderHistory_total": "Total",
    "product_variants_size": "Tamaño",
    "text_account_quote_duplicate": "Duplicar",
    "text_account_addressBook": "Directorio",
    "text_account_quote_page_linkPreviousPage": "Página anterior",
    "text_warranty_search_from_date_invalid_future": "Claim Date From can't be in future date.",
    "cart_groups_edit": "editar",
    "label_emea_nextday": "Al día siguiente antes de las 12 p.m.",
    "checkout_multi_hostedOrderPageError_globalError": "No se pudo crear la suscripción.  Consulte los detalles del error a continuación.",
    "text_headline_coreAttributes": "Principalt",
    "size_of_freight": "Tamaño dl envío",
    "text_account_quote_page_totalResultsSingleOrder": "1 cotización encontrada",
    "text_warranty_eligibility_mileage_km_error": "Mileage can't be more than 9999999 kilometers",
    "product_variants_colour": "Color",
    "text_account_paymentDetails_setDefaultPaymentDetails": "Establecer detalles de pago predeterminados",
    "checkout_summary_paymentMethod_editPaymentMethod": "Editar método de pago",
    "checkout_multi_deliveryMethod_continue": "Siguiente",
    "register_webshop_accept_invalid": "Debe aceptar los términos y condiciones de la tienda virtual",
    "text_warranty_terms_refuse_hauler": "Camión de basura",
    "checkout_multi_deliveryMethod_stepHeader_done": "2 - Método de entrega",
    "checkout_summary_deliveryMode_selectDeliveryMethod": "Seleccionar método de entrega",
    "checkout_multi_paymentDetails_notprovided": "Debe proporcionar los detalles de pago para ir al siguiente paso.",
    "storeFinder_table_distance": "Distancia",
    "product_price_from": "Desde {0}",
    "basket_page_delivery": "Entrega",
    "checkout_page_summary_final_review_billing_address": "Dirección de facturación",
    "storeFinder_postcode_town": "Código postal / pueblo",
    "search_page_showPageResults": "Mostrar paginado",
    "text_warranty_submit_part_repairTime": "Tiempo de reparación (en horas)",
    "text_core_submit_date": "Fecha",
    "text_search_icon_coreGroup": "Buscar Grupo de Casco",
    "text_add_to_core_form": "Añadir al formulario de casco",
    "general_delete_all_button": "Eliminar",
    "button_label_viewcart": "Ver carrito",
    "checkout_page_summary_final_review_delivery_type": "Tipo de entrega",
    "text_warranty_terms_other_vehicle": "Otros vehículos de uso no típico",
    "basket_page_item": "Artículo (estilo de número)",
    "text_account_closeAccount_popup_action": "Cerrar mi cuenta",
    "review_no_reviews": "Sea el primero en escribir un comentario.",
    "label_emea_forwarder": "Stock",
    "text_core_submission_upgradeonly": "Upgrade Core",
    "text_core_rights_label": "Derechos cascos",
    "open_total_usd_APAC": "Abierto Total dólares de los EE.UU. (United States dollars, USD)",
    "text_account_savedCarts_page_sort_byCode": "IDENTIFICACIÓN",
    "search_nav_facetShowMore_collection": "más colecciones...",
    "checkout_pickup_items_to_pickup": "{0} artículos para retirar",
    "product_grid_formDescription": "Seleccione los artículos a continuación y agréguelos al carrito",
    "basket_page_message_update_pickupinstoreitem": "El artículo para retiro en tienda ha sido actualizado.",
    "profile_firstName_invalid": "Ingrese un nombre",
    "basket_information_merge_successful": "El carrito guardado en su cuenta de usuario y su carrito actual se han fusionado. Haga clic aquí para visitar su carrito:",
    "register_dataprotection_accept": "Acepto elt",
    "basket_page_totals_subtotal": "Subtotal:",
    "order_totals_delivery": "Entrega:",
    "text_generalInfo_coreGroup": "Grupo principal",
    "address_room_invalid": "Ingrese un número de habitación",
    "text_warranty_terms_yard_truck": "Camión de terminal",
    "text_account_consent_consentManagement_general_text": "Para personalizar su experiencia, nos gustaría su consentimiento para recibir sus datos de perfil:",
    "checkout_multi_addressDetails": "Detalles de la dirección",
    "cart_count": "{0}t",
    "partsAvailable": "El pedido será enviado cuando todas las piezas estén disponibles",
    "storeFinder_table_address": "Dirección",
    "address_default": "Establecer como mi dirección predeterminada",
    "address_regionIso": "Estado / provincia*",
    "search_mobile_page_totalResults": "{0} artículos",
    "save_page_continue": "Guardar carrito",
    "text_account_orderHistory_page_sort_byTypeNo": "Type No-Asc",
    "text_account_order_status_display_cancelled": "Cancelado",
    "checkout_login_registerAndCheckout": "Registrarse y pagar",
    "pickup_results_button": "Retirar",
    "basket_export_user_customerID": "Cliente ID",
    "core_report_format": "Formato de archivo",
    "checkout_orderConfirmation_orderNumber": "Su número de pedido es {0}",
    "storeFinder_pagination_stores": "tiendas encontradas",
    "checkout_multi_pickupInStore": "Retirar en la tienda",
    "text_account_savedCarts_page_linkPreviousPage": "Página anterior",
    "text_account_quote_date_placed": "Fecha seleccionada",
    "text_account_profile": "Perfil",
    "text_account_addressBook_addEditAddress": "Agregar / editar dirección",
    "pagination_or": "o",
    "text_account_core_search_showPageResults": "Mostrar paginado",
    "text_warranty_name": "Nombre",
    "text_header_language": "Haga clic aquí para cambiar el idioma",
    "text_quickOrder_page_part_no": "Pieza nro.",
    "text_consent_agree": "y estoy de acuerdo con la recopilación y el procesamiento de los datos personales que proporciono para descargar un documento",
    "review_based_on_one": "Basado en {0} comentarios",
    "import_csv_savedCart_fileConstraint": "Tamaño máximo de archivo:",
    "text_quote_not_submitable": "No se puede enviar la cotización ya que el total es negativo",
    "text_address": "Dirección",
    "text_additional_info": "información adicional:",
    "text_quickorder_limit_character": "Max. 35 characters, no more input!",
    "checkout_error_paymentethod_formentry_sop_invalid_shipTo_phoneNumber": "Este valor no es válido para este campo.",
    "product_variants_type": "Descargas",
    "collection_address_provided": "Si es diferente del anterior, por favor, añadir detalles aplicables para la dirección de recogida de contacto personal:",
    "register_dataprotection_accept_invalid": "Debe aceptar la Política de protección de datos",
    "review_submitted_anonymous": "Anónimo",
    "checkout_error_paymentethod_formentry_sop_missing_shipTo_phoneNumber": "Ingrese un valor para este campo",
    "register_company_soldto": "Predeterminado vendido a",
    "text_quick_order_reset_form": "Restablecer formulario",
    "product_close": "Cerrar",
    "text_account_warranty_table_header_date": "Fecha de reclamo",
    "text_account_warranty_search_page_sort_byDate": "Fecha",
    "search_page_product_document": "Documentos",
    "text_warranty_terms_line_haul": "Remolque/Tractor de transporte en línea",
    "basket_page_min_order_NA": "Pedido mínimo / recargo por urgencia:",
    "header_link_selectSalesarea": "Seleccione un área de ventas",
    "text_warranty_search_to_date_invalid_future": "Claim Date To can't be in future date.",
    "register_webshop": "tienda virtual",
    "order_history_min_order": "Pedido mínimo / recargo por urgencia:",
    "search_nav_facetShowLess_nameForFacet": "menos...",
    "account_error_account_exists_with_email_address_subtitle": "Elija una dirección de correo electrónico alternativa.",
    "text_quote_description_not_applicable": "N/A",
    "register_webshop_accept": "Acepto el",
    "product_product_document": "Documentos",
    "search_placeholder": "Ingrese un número de pieza, número de tipo, título o detalles del documento",
    "text_submit_review_carefully": "Por favor revise cuidadosamente todas las líneas  de la recogida antes de enviar su formulario online. No se puede hacer modificaciones en el formulario , una vez se haya enviado.",
    "quote_save_error": "Error al guardar la cotización.",
    "core_error_submission_emea": "You do not have permission, please <a href",
    "text_account_savedCarts_page_sort_byTotal": "Total",
    "category_navTitle": "Comprar por categoría",
    "search_mobile_page_linkPreviousPage": "&laquo; Anterior",
    "basket_error_checkout_empty_cart": "No puede proceder al pago con el carrito vacío.",
    "text_account_paymentDetails_delete_following": "El siguiente método de pago será eliminado",
    "checkout_summary_paymentMethod_paymentDetails_noneSelected": "Ninguna selección",
    "text_core_submit_month": "Mes de devolución del componente usado",
    "text_core_submit_internalTrackingNumber": "Este es su número de seguimiento interno (opcional)",
    "import_csv_savedCart_importCondition": "*El tipo de pedido debe seleccionarse antes de que se pueda subir el archivo. El formato del archivo debe ser CSV, tamaño máximo del archivo (10 KB).",
    "text_storefinder_responsive_page_sortTitle": "Ordenar por:",
    "basket_export_user_firstName": "Nombre",
    "text_quote_discount_by_amount": "Descuento por cantidad",
    "cart_checkout_error": "Error al proceder al pago.",
    "download_the_document_text": "before you can download the document.",
    "basket_page_productdetails": "Detalles del producto",
    "payment_cardNumber": "Número de tarjeta",
    "popup_cart_showall": "Mostrar todo",
    "text_account_addressBook_back_btn": "Regresar",
    "test_account_core_reportsinfoNA": "Si tiene alguna pregunta sobre sus informes básicos, comuníquese con nosotros a",
    "profile_checkPwd_invalid": "Confirme su contraseña",
    "basket_export_user_zipCode": "Código postal",
    "text_core_submission_package": "Tipo de empaque",
    "quote_reject_initiate_request": "Subtotal mínimo de {0} para enviar una cotización.",
    "payment_cardType_pleaseSelect": "Seleccione un tipo de tarjeta",
    "search_nav_facetShowMore_availableInStores": "más tiendas...",
    "mycompany_user_delete_note": "Nota: no puede deshacer esta eliminación.",
    "login_login": "Iniciar sesión en su cuenta",
    "checkout_multi_paymentMethod_addPaymentDetails_billingAddressDiffersFromDeliveryAddress": "Si su dirección de facturación es diferente a su dirección de entrega, utilice este formulario para ingresar su dirección de facturación",
    "basket_export_user_phone": "Teléfono",
    "text_account_order_netTax": "Impuesto:",
    "text_header_storefinder": "Buscador de tiendas",
    "checkout_pages_change_billing_address": "Cambiar dirección de facturación",
    "import_csv_savedCart_enterContentNote": ", ingrese su información en el archivo y haga clic en",
    "mobile_search_add_refinements": "Procesar",
    "text_account_order_shipping": "Costos de envío:",
    "text_account_quote_status_display_SELLER_DRAFT": "Borrador",
    "text_paymentMethod": "Método de pago.t",
    "text_account_quote_page_totalResults": "de {0} cotizaciones",
    "j_password": "Contraseña",
    "register_company_website_invalid": "Ingrese la dirección del sitio web de la empresat",
    "mobile_checkout_paymentMethod": "Detalles de pago.",
    "basket_error_quantity_invalid_binding": "Cantidad no válida: proporcione un número de cantidad válido para agregar este producto a su carrito",
    "text_account_core_search_lastPage": "&raquo;",
    "text_warranty_submit_duplicate_parts_error": "Please remove duplicate Part Number and submit again.",
    "basket_save_cart_action_cancel": "Cancelar",
    "cart_page_reqdeliveryApac": "Req Departure Date",
    "text_account_quote_page_firstPage": "&laquo;",
    "breadcrumb_login": "Iniciar sesión",
    "order_product_seeDetails": "Ver detalles",
    "text_account_order_placedByText": "Colocado por: Miembro del equipo de servicio al cliente",
    "general_month_october": "Octubre",
    "basket_view_basket": "Ver carrito",
    "text_storefinder_desktop_page_sort_byName": "Por nombre",
    "text_setDefault": "Establecer por defectot",
    "checkout_summary_shippingAddress": "Dirección de envío",
    "text_warranty_submit_replacement_type": "Tipo de reemplazo",
    "register_company_address_street": "Dirección con número de calle*",
    "text_warranty_terms_shuttle_bus": "Autobusete o autobús turístico",
    "order_history_reorder_button": "Volver a pedir",
    "basket_export_user_warranty": "GARANTIE",
    "text_account_kbOrderNumber": "Número de pedido de Knorr Bremse",
    "cart_view": "VER CARRITOtt",
    "popup_cart_quantity": "Cantidad",
    "review_general_error": "Complete todos los campos de comentarios obligatorios",
    "text_storefinder_responsive_page_showPageResults": "Mostrar paginado",
    "text_pagenotfound_error": "Lo sentimos, la página que estaba buscando no se pudo encontrar.",
    "text_button_accept": "Aceptar",
    "text_account_addressBook_page_linkNextPage": "Página siguiente",
    "text_account_order_savings": "Descuentos en pedido:",
    "text_core_address": "Collection Address",
    "text_quote_discount_apply_argument_invalid_error": "La entrada de descuento no es válida. Inténtelo de nuevo",
    "basket_page_per_pc": "(por pieza)",
    "text_address_delete": "Eliminar",
    "core_report_parent": "Matriz básica",
    "text_quickOrder_product_not_found": "Producto no encontrado",
    "text_voucher_release_error": "Error al eliminar el comprobante {0}",
    "basket_save_cart_info_msg": "Su carrito será movido a la lista de carrito guardado.",
    "text_nocategory_found_message": "No se ha encontrado ninguna categoría.",
    "text_account_orderHistory_page_sort_byTypeDesc": "Type No-Desc",
    "basket_page_error_remove": "Product was already removed from your cart.",
    "basket_page_viewFuture_unavailable": "El sistema de inventario futuro no está disponible, intente nuevamente más tarde.",
    "basket_page_totals_delivery": "Entrega:",
    "login_register": "Registrarse",
    "text_account_orderHistory_page_sort_byOpenQty": "Open Qty-Asc",
    "text_quickOrder_page_emea_apac_part_no": "Número de pieza del Knorr Bremse/Número de pieza del cliente",
    "address_province": "Provincia",
    "guest_required_message": "Los campos marcados con asterisco (*) son obligatorios",
    "address_phone_invalid": "Número de teléfono incorrecto",
    "basket_page_shipping_change_store": "Cambiar tienda",
    "pdp_page_quantity": "CANT.",
    "text_storefinder_responsive_page_sort_byName": "Por nombre",
    "text_core_taillift": "Taillift Required?*",
    "checkout_page_summary_change_shipping_address": "Cambiar dirección de envío",
    "static_category_sidenavigation_empty": "No se encontraron subcategorías para \"{0}\"",
    "text_account_paymentDetails_noPaymentInformation": "Sin detalles de pago guardados",
    "text_warranty_vehicle_manufacter": "del fabricante del vehículo",
    "checkout_orderConfirmation_title": "Confirmación del pedido",
    "review_number_of": "de",
    "checkout_error_paymentethod_formentry_sop_invalid_shipTo_country": "Este valor no es válido para este campo.",
    "pdp_availableText": "DISPONIBLE",
    "basket_page_totals_savings": "Ahorros",
    "checkout_multi_breadcrumb": "Pago",
    "address_subarea": "Subárea",
    "basket_page_deliveryDateApac": "Requested Departure Date",
    "document_download_kb_text": "Download a Knorr-Bremse document",
    "text_warranty_same_email_invalid": "Email 1 & 2 cannot be same",
    "sold_to_popup_text_two": "comuníquese con nosotros",
    "order_product": "Producto",
    "text_warranty_submit_part_serialno": "Número de serie.",
    "quick_order_customer_reference": "Customer Item Ref. No.",
    "product_product_typenumber": "Ingrese un número",
    "user_locked_invalid_msg": "Your account has been locked, please contact your company administrator accordingly",
    "user_error_account_invalid_doubleOpt_msg": "Por favor, confirme su registro en el correo electrónico con el enlace de confirmación. Solo entonces se puede procesar su registro y recibirá un correo electrónico con más información.",
    "order_totals_total": "Total:",
    "text_warranty_rights_label": "Derechos de garantía",
    "checkout_multi_deliveryAddress_address": "Dirección",
    "product_image_zoom_out": "Alejar",
    "register_company_faxNumber": "Número de fax",
    "register_checkbox_ordering_label": "Pedidos en línea",
    "text_account_order_receivedPromotions": "Promociones recibidas",
    "quote_edit_done": "Carrito nuevo",
    "text_deliveryAddress": "Dirección de entregatt",
    "basket_page_min_order_qty": "CANT. mínima de pedido",
    "address_companyAddress_shipping_page_form_emea": "Dirección 2t",
    "text_core_submission_upgradegrp": "Actualice el grupo de componentes usados",
    "quote_submit": "Enviar cotización",
    "text_generalInfo_coreClass": "Clase principal",
    "text_quickOrder_page_na_part_no": "Número de pieza de Bendix / Número de pieza del cliente",
    "text_quickOrder_page_qty": "CANT.",
    "text_account_quote_page_showAllResults": "Mostrar todo",
    "register_company_countryState_invalid": "Seleccione un estado*",
    "basket_potential_promotions": "Promociones potenciales",
    "text_consent_button_decline": "Declinar",
    "product_share_email": "Correo electrónico",
    "text_account_consent_withdrawn": "Su consentimiento ha sido retirado",
    "text_account_quote_action_display_SAVE": "Guardar cotización",
    "basket_export_user_email": "Email",
    "popup_cart_core_charges": "Cargo del nucleo",
    "basket_validation_unavailable": "Lamentablemente, se eliminó {0} de su carrito debido a que ya no está disponible.",
    "checkout_multi_paymentMethod_savedCards_paymentCard": "Tarjeta de pago",
    "text_core_submit_coreClass": "Clase principal",
    "text_account_configuration_display": "Ver configuración",
    "text_core_submission_grouponly": "Group",
    "text_core_submission_classonly": "Class",
    "address_companyName": "Nombre de la empresa*",
    "quote_accept_error": "Error al aceptar la cotización.",
    "checkout_error_paymentethod_formentry_sop_invalid_shipTo_state": "Este valor no es válido para este campo.",
    "basket_text_shippingcost": "Costos de envío",
    "text_submit_warranty_error": "Error en el envío de la solicitud de garantía. Vuelva a intentarlo o póngase en contacto con el servicio de atención al cliente.",
    "text_account_orderHistory_page_sort_byPartNo": "Part No-Asc",
    "text_account_warranty_search_page_showAllResults": "Mostrar todo",
    "text_account_warranty_search_page_sort_byOrderNumber": "Warranty Claim Number",
    "text_account_addressBook_page_sort_byDateSaved": "Fecha guardada",
    "breadcrumb_home": "Inicio",
    "storeFinder_use_this_form": "Utilice este formulario para buscar una tienda",
    "text_core_search_or": "OR",
    "register_accept_message": "Aceptar",
    "text_account_orderHistory_page_sort_byTotalDesc": "Total-Desc",
    "search_nav_refinements": "Procesamientos",
    "payment_expiryMonth_invalid": "Seleccione el mes de vencimiento de la tarjeta",
    "text_account_addressBook_updateAddress": "Actualizar dirección",
    "file_size_kilobytes": "{0} KB",
    "checkout_multi_deliveryAddress_continue": "Obtenga disponibilidad y revisión final",
    "product_grid_subtotalText": "Subtotal:",
    "basket_added_to_basket_pdp": "Agregado al carrito",
    "account_confirmation_default_address_changed": "Su dirección predeterminada fue actualizada.",
    "checkout_security_code": "Código de seguridad",
    "text_core_submit_crm_invalid": "Obligatorio",
    "guest_email": "Dirección de correo electrónico",
    "storefinder_location_disabled": "Please enable location services from browser",
    "order_history_customer_po_number": "Número de orden de compra:",
    "product_grid_editSize": "Editar",
    "basket_pickup_product_variant": "{0}: {1}",
    "checkout_multi_saveAddress": "Guardar dirección",
    "text_warranty_submit_product_not_unique": "Product Not Unique",
    "basket_page_number": "Nro.",
    "product_product_details_future_nostock": "Este producto no tiene información de disponibilidad futura.",
    "text_header_loginandaccount": "Inicio de sesión y cuenta",
    "text_warranty_email_one_invalid": "Please correct email id",
    "checkout_error_paymentethod_formentry_sop_missing_card_cardType": "Seleccione un tipo de carrito",
    "checkout_summary_deliveryAddress": "Dirección de entrega",
    "text_viewfullsite": "Ver sitio completo",
    "mycompany_legend": "Leyenda",
    "mobile_search_nav_clearSelections": "Borrar todas las selecciones",
    "register_title_emea": "Título*",
    "category_na_meta_description": "Bendix ABS, ATC, Actuators, Air Disc Brakes, Air Treatment, Compressors, Drum Brakes, Steering Gears, Valves, and Formula Blue Hydraulic Brakes",
    "register_checkbox_inversexref_label": "Búsqueda inversa: de Knorr-Bremse a referencia externa",
    "checkout_multi_deliveryAddress_selectSuggestedAddress_sumbitAsIs": "Enviar con los datos actuales",
    "review_reviews": "Comentarios",
    "core_stackable": "Apilable?",
    "text_account_orderHistory_page_firstPage": "&laquo;",
    "text_core_PackageType": "PackageType",
    "text_account_savedCarts_page_sort_byDateSaved": "Fecha guardada",
    "text_account_profile_updateForm": "Utilice este formulario para actualizar sus datos personales.",
    "text_company_manageUser_page_totalResults": "{0} usuario (s) encontrado",
    "checkout_error_tax_missing": "Lo sentimos, pero su transacción no se pudo completar en este momento; intente nuevamente más tarde o comuníquese con el servicio al cliente al 555-555-5555",
    "password_strength_tooshortpwd": "Demasiado corta",
    "cart_expresscheckout_checkbox": "Me gustaría seleccionar la opción de pago rápidot",
    "text_account_orderHistory_page_showPageResults": "Mostrar paginado",
    "product_grid_yourPrice": "Su precio",
    "checkout_orderConfirmation_Shipping_Address": "Dirección de envío",
    "text_core_submission_crmno": "Número de CRM",
    "basket_page_quote_discounts_link": "Descuento",
    "basket_page_min_order": "Cargo mínimo de pedido:",
    "quick_order_page_qty_validation": "Ingrese las cantidades requeridas",
    "checkout_summary_paymentMethod_paymentDetails_expires": "Caduca {0} / {1}",
    "storeFinder_table_opening": "Horario de apertura",
    "quote_approve_success": "Cotización aprobada con éxito.",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_titleCode": "Ingrese un valor para este campo",
    "storelocator_error_no_results_subtitle": "Verifique que el código postal o nombre de lugar sean válidos.",
    "checkout_pickup_continue_button": "Continuar",
    "basket_validation_noStock": "Lamentablemente, <a href",
    "product_variants_size_guide": "Guía de tamaño",
    "text_account_quote_page_sort_byState": "Estado",
    "text_account_addressBook_page_lastPage": "&raquo;",
    "login_required": "Obligatorio",
    "search_page_showing_text": "",
    "search_page_of_text": "de",
    "search_page_result_text": "solicitudes encontradas",
    "basket_export_cart_item_price": "Precio",
    "quote_cart_comments": "Comentarios del carrito",
    "text_account_warranty_search_page_totalResultsSingleOrder": "1 Claim",
    "text_headline_orders": "Ver sus pedidos",
    "text_account_addressBook_page_totalResultsSinglePag": "{0} Direcciones",
    "popup_cart_quantity_added": "Cantidad agregada",
    "checkout_orderConfirmation_Customer_ID": "Cliente ID:",
    "text_itemPrice": "Precio del artículo",
    "text_address_delete_popup_title": "Eliminar dirección",
    "checkout_orderConfirmation_order_Type": "Tipo de pedido:",
    "text_document_download": "Iniciar descarga de documentos",
    "basket_restoration_success": "{0}",
    "text_core_submission_review_text": "Revise su formulario antes de enviarlo. No podrá editar su formulario una vez enviado.",
    "text_account_openPositions_back": "Volver a posiciones abiertas",
    "text_core_submission_pdfEMEA": "Core Manual (Y059594)",
    "popup_cart_pickup": "Retirar",
    "payment_issueNumber_invalid": "Solo se permiten números para ese campo",
    "text_label_showmoreresults": "Mostrar más resultados...",
    "basket_page_title_yourDeliveryItems_pickup": "Los artículos del pedido que se recogerán aparecerán más adelante en el pago.",
    "search_nav_facetShowMore_colour": "más colores...",
    "text_quote_cancel_confirmation_modal_title": "Cancelar cotización {0}",
    "search_nav_facetShowLess_availableInStores": "menos tiendas...",
    "register_company_address_street_invalid": "Ingrese la dirección de la empresa",
    "text_account_warranty_search_page_currentPage": "Página {0} de {1}",
    "text_core_search_partNumber_EMEA": "Introdúzca ref. Knorr-Bremse #",
    "text_account_core_search_totalResultsSinglePag": "{0} Result(s) found",
    "basket_page_title_yourItems": "Su carrito",
    "search_openPositions_export_line1": "Export :Open Positions -status quo {0}",
    "payment_nameOnCard": "Nombre en la tarjeta",
    "checkout_orderConfirmation_PO_Date": "Orden de compra #:",
    "checkout_multi_deliveryAddress_stepHeader": "1 - Seleccione la dirección de entrega",
    "storeFinder_pagination_from": "desde",
    "text_cutoff_timezone_EMEA": "Nota importante: {0} debe ser realizado por {1} {2}.",
    "search_openPositions_export_line2": "Selection : {0},{1},Orders sent from {2} to {3}",
    "text_account_profile_updateEmail": "Actualice su correo electrónico",
    "text_warranty_search_claim_to_date": "Fecha de reclamación hasta",
    "basket_error_product_removed": "Lo sentimos, se eliminaron uno o más productos de su carrito ya que no están en stock o ya no están disponibles.",
    "text_weight_complete": "Peso completo. [kg]",
    "basket_page_quote_discounts_link_target_as": "Objetivo como {0}",
    "text_account_savedcart_delete_popuptitle": "Eliminar carrito guardado",
    "DeliveryType_Partial_name": "Livraison partielle",
    "file_size_bytes": "{0} Bytes",
    "text_core_packaging_pdf": "Tipo de embalaje",
    "registration_error_generic": "Ha ocurrido un error. Inténtelo de nuevo más tarde.",
    "text_account_addressBook_page_sortTitle": "Ordenar por",
    "storeDetails_table_distance": "Distancia",
    "basket_page_qty": "CANT.",
    "basket_restoration_delivery_changed": "Se restauró {0} en su carrito, pero el método de entrega ha cambiado debido a la baja disponibilidad de stock local.",
    "text_expires": "Expirat",
    "updatePwd_title": "Actualizar contraseña",
    "checkout_orderConfirmation_coupon_valid_from": "Válido desde {0}",
    "payment_expiryYear_invalid": "Seleccione el año de vencimiento de la tarjeta",
    "basket_page_title_yourDeliveryItems": "Sus artículos para ser entregados",
    "saved_cart_total_number_one": "{0} carrito guardado",
    "pdp_validEmailText": "Introduzca un correo electrónico válido",
    "checkout_orderConfirmation_pickupItems": "{0} artículos para retirar en la tienda",
    "text_account_profile_emailNotChanged": "Su correo electrónico no fue actualizado",
    "text_account_quote_cancel": "Cancelar",
    "form_register_empty": "Seleccione su país",
    "order_confirmation_guest_register_description": "Para un pago rápido y fácil acceso a pedidos anteriores",
    "product_variants_select_variant": "Seleccione una variante",
    "text_remove": "Eliminart",
    "address_furtherSubarea": "Número de subárea adicional, número de casa",
    "text_account_orderHistory_mobile_page_linkPreviousPage": "&laquo; Anterior",
    "text_account_savedCart_qty": "CANT.",
    "text_help": "Ayuda",
    "register_company_countryCode_invalid": "Seleccione el país donde se encuentra ubicada la empresa",
    "text_storefinder_desktop_page_showAllResults": "Mostrar todo",
    "text_account_order_orderDetails_billingInformtion": "Información de facturación",
    "text_account_orderHistory_page_showAllResults": "Mostrar todo",
    "text_account_orderHistory_page_sort_byPO": "PO No-Asc",
    "order_history_customer_reference_number": "# de referencia del cliente:",
    "warranty_eligibility_check_mileage_in_service": "Millaje en servicio",
    "checkout_multi_deliveryMethod_selectDeliveryMethodMessage": "Método de envío",
    "text_none": "Ninguno",
    "header_customer_id": "Cliente ID:",
    "warranty_claim_yes": "Sí",
    "mycompany_accessAdditionalRights": "Derechos de usuario adicionales",
    "text_warranty_search_customerID": "Cliente ID",
    "coupon_order_recalculation_error": "Se produjo un error al volver a calcular el pedido.",
    "mobile_checkout_paymentMethod_addOrSelect_card": "Seleccione una tarjeta de pago guardada en su billetera o agregue una nueva tarjeta",
    "updatePwd_pwd": "Nueva contraseña",
    "menu_button_home": "Inicio",
    "storeFinder_orSearchBy": "Or search by:",
    "text_account_order_delivery": "Entrega:",
    "testuser_message_display": "Test User is not allowed to place an order",
    "basket_export_user_lastLogin": "Último inicio de sesión",
    "basket_export_user_currency": "Moneda",
    "text_headline_refinements": "Elija la relevancia o agregue filtros",
    "text_account_profile_updateProfile_mobile": "Actualizar perfil",
    "updatePwd_token_invalid": "El enlace utilizado para acceder a la página de actualización no era válido.",
    "text_user_table_save": "Salvar",
    "address_district_and_street": "Distrito y calle",
    "order_totals_subtotal": "Subtotal:",
    "address_subarea_invalid": "Ingrese una subárea",
    "text_cookie_notification": "Utilizamos cookies para asegurarnos de brindarle la mejor experiencia en nuestro sitio web. Si continúa, está de acuerdo con nuestra declaración de políticas.",
    "checkout_pickup_items_appear_later": "Los artículos del pedido de retiro por tienda aparecerán más adelante en el pago.",
    "checkout_order_type_maxQuantityExceeded": "Puede pedir un máximo de {0} piezas por posición según el tipo de pedido elegido como {1}. Actualice su carrito para continuar.",
    "text_warranty_submit_claim_type": "Tipo de reclamo",
    "text_quote_discount_type_null_error": "El tipo de descuento es nulo.",
    "basket_add_to_basket": "Añadir a la cesta",
    "text_marketTypeNA": "Mercado",
    "text_market": "Mercado",
    "pdp_technicalattribute_guide": "Atributos técnicos",
    "storeFinder_stores_nearto": "Tiendas cerca: {0}",
    "text_account_quote_status_display_SELLERAPPROVER_PENDING": "Aprobación pendiente",
    "text_cutoff_timezone_NA": "Nota importante: Los pedidos de emergencia deben realizarse antes de las 4:00 p.m. EST.",
    "checkout_pickup_items_to_be_delivered": "Artículos para entregar",
    "text_weight_code": "[kg]",
    "text_add_button": "Agregar",
    "b2b_unit_order_block_error_checkout": "No puede realizar un pedido en este momento, contáctenos",
    "text_account_savedCarts_page_firstPage": "&laquo;",
    "text_account_quote_page_sort_byCode": "Identificación de cotización",
    "register_firstName_invalid": "Ingrese un nombre",
    "register_dataprotection_messageNA": "Aviso de privacidad",
    "text_account_orderHistory_page_sort_byPartNoDesc": "Part No-Desc",
    "product_grid_items_selected": "Cantidad seleccionada:",
    "basket_save_cart_description": "Descripción",
    "text_button_new": "Nuevo",
    "user_invalid_msg": "Your account has been locked, please contact your company administrator accordingly",
    "text_account_savedCarts": "Carritos guardados",
    "text_generalInfo_customTarrifNo": "Código del Sistema Armonizado",
    "checkout_checkout_multi_deliveryAddress_viewAddressBook": "Directorio",
    "text_total": "Totalt",
    "core_report_pdf": "PDF",
    "text_account_consent_already_given": "Consentimiento ya otorgado",
    "text_headline_addtocart": "Haga clic para agregar el producto al carrito",
    "text_account_order_orderStatus": "El pedido es {0}",
    "cart_total_poa_NA": "Precio a petición se muestra en su carrito, no hemos podido proporcionarle un precio en este momento, sin embargo, puede continuar con su pedido. <p> Si necesita más ayuda, envíenos un correo electrónico a través de <a target='_blank' href='https://b2bendix.com/contact-us-form'> contacto </a> o llame al 1-800-AIR-BRAKE, opción 1. </p>",
    "text_account_savedCart_numberOfProducts": "Número de productos",
    "text_vmrsCodeRear": "Código VMRS (parte trasera)t",
    "register_company_companyStateCode_invalid": "Ingrese el estado donde se encuentra ubicada la empresa",
    "basket_export_csv_file": "Exportar CSV",
    "profile_firstName": "Nombre",
    "text_warranty_submit_part_otherCost": "Otro costo",
    "text_core_submission_EMEA_text2": "If you have got further questions about your submitted core return request, please contact your local Knorr-Bremse core team.",
    "fselect_pageUploadPartPlaceholder": "Buscar un ID de cliente, nombre de la empresa",
    "mobile_checkout_cart_viewFullCart": "Ver carrito completo",
    "text_core_submission_EMEA_text1": "Thank you for submitting your core return request. You will receive an acknowledgement email with further information.",
    "register_site_companyrole_invalid": "Seleccione el sector en la industria",
    "text_account_savedCart_edit": "Editar",
    "text_media_languages": "Idiomastt",
    "checkout_error_paymentethod_formentry_sop_missing_card_issueNumber": "Ingrese un número de emisión",
    "forgottenPwd_email": "Dirección de correo electrónico",
    "checkout_error_paymentethod_formentry_sop_invalid_shipTo_street2": "Este valor no es válido para este campo.",
    "checkout_summary_paymentMethod_addPaymentDetails_savePaymentDetailsInAccount": "Guardar estos detalles de pago en mi cuenta",
    "product_variants_available": "disponible en línea",
    "checkout_summary_paymentMethod_savedCards_noExistingSavedCards": "No tiene ninguna tarjeta guardada",
    "storeFinder_navigateTo": "Ir a",
    "text_account_online_order_rights": "Pedido para pedidos online",
    "text_user_onlineOrdering_label": "Pedidos en línea",
    "text_user_viewpricesandatp_label": "Ver precio y disponibilidad",
    "text_storefront_true_value": "Cierto",
    "text_storefront_false_value": "Falsa",
    "go_back_to_cart_button_text": "Volver al carrito",
    "continue_to_checkout_button_text": "Continuar con el pago",
    "text_popup_title_Vor": "PEDIDOS URGENTES",
    "text_popup_title_emergency": "PEDIDOS URGENTES",
    "text_emergencyOrder_left_quotes": "\"",
    "text_emergencyOrder_right_quotes": "\"",
    "na_text_emergencyOrder_withoutstock_message1": "La cantidad solicitada para la referencia",
    "na_text_emergencyOrder_withoutstock_message2": "de pieza",
    "na_text_emergencyOrder_withoutstock_message3": "no está disponible en su totalidad. Por lo tanto, el tipo de pedido",
    "na_text_emergencyOrder_withoutstock_message4": "no se enviará hoy.",
    "na_text_emergencyOrder_withoutstock_message5": "Puede continuar con el pago o volver a su carrito y cambiar el tipo de pedido.",
    "na_text_emergencyOrder_withoutstock_message6": "Se seguirá aplicando el cargo por pedido urgente si continúa con el pago.",
    "text_account_quote_action_display_CANCEL": "Cancelar cotización",
    "checkout_error_paymentethod_formentry_sop_invalid_shipTo_street1": "Este valor no es válido para este campo.",
    "import_csv_savedCart_genericError": "Error al subir la plantilla de pedido. Intente nuevamente o comuníquese con el servicio al cliente.",
    "text_headline_marketType": "Tipo de mercadot",
    "text_account_quote_date_updated": "Fecha actualizada",
    "text_account_quote_date_created": "Fecha de creación",
    "checkout_multi_deliveryAddress_useThisAddress": "Usar esta dirección",
    "text_headline_terms": "De acuerdo con los términos y condiciones",
    "checkout_summary_paymentMethod_savedCards_UseThisSavedCard": "Usar estos detalles de pago",
    "address_firstName_invalid": "Ingrese un nombre",
    "basket_export_user_lastName": "Apellido",
    "checkout_pickup_pickup_in_store_title": "RECOGER EN LA TIENDA",
    "review_required": "Los campos marcados con asterisco (*) son obligatorios",
    "basket_validation_movedFromPOSToStore": "Sus artículos se han modificado para que coincidan con los niveles de stock disponibles. Se actualizaron uno o más artículos para retiro en tienda para su envío.",
    "checkout_deliverydate_past": "La fecha de entrega solicitada no puede ser anterior a {0}.",
    "popup_cart_total": "Total",
    "text_account_orderHistory_page_sort_byOrderTypeDesc": "Order Type-Desc",
    "text_account_orderHistory": "Historial de pedido",
    "basket_page_quantity": "Cantidad",
    "text_account_savedCarts_page_sort_byName": "Nombre",
    "text_warranty_submit_parts_disposition": "Disposición de piezas si se rechaza*",
    "checkout_page_summary_final_review_order_type": "Tipo de pedido:",
    "select_collection_address": "Por favor, seleccione una dirección de recogida a continuación:",
    "account_confirmation_signout_title": "Ha cerrado sesión en su cuenta.",
    "basket_page_validation_message": "Los productos se han actualizado / eliminado de su carrito.",
    "profile_checkEmail": "Confirmar nueva dirección de correo electrónico",
    "text_dimension": "Dimensiones (largo x ancho x alto)t",
    "basket_page_emea_orderQty": "Order Qty",
    "basket_page_1_pc_only": "(1 PC solamente)",
    "order_history_subtotal": "Subtotal:",
    "text_user_table_header_Warranty": "Garantía",
    "search_page_xref_name": "Nombre",
    "text_account_order_status_display_completed": "Completado",
    "text_sales_status_description_emea_code_40": "Vendable à l'IAM - jusqu'à épuisement des stocks",
    "basket_page_product": "Producto",
    "fselect_pageCoreReportPlaceholder": "Please Select Core Parent",
    "product_grid_in_stock": "En stock",
    "checkout_error_cart_notcalculated": "Lo sentimos, pero su transacción no se pudo completar en este momento; intente nuevamente más tarde o comuníquese con el servicio al cliente al 555-555-5555",
    "mobile_checkout_deliveryAddress": "Dirección de entrega",
    "text_quote_state_label": "Estado",
    "storeFinder_currentPosition": "Current Position",
    "import_csv_savedCart_uploadTemplate": "Descargar plantilla de pedido",
    "text_generalInfo_vrms": "Códigos VRMS / descripción",
    "cart_page_checkout_no": "No",
    "address_selectState": "Provincia / estado",
    "review_write_title_product": "Escriba un comentario para {0}",
    "basket_page_title_pickupFrom": "Retirar de:",
    "text_account_orderHistory_noOrders": "No se encontraron pedidos",
    "text_quote_name_label": "Nombre",
    "text_enter_partnumber_placeholder": "Introduzca número de la pieza",
    "text_core_TailLift": "Tail Lift Required",
    "storeFinder_table_store": "Tienda",
    "text_consent_and": "y la",
    "login_error_account_not_found_title": "La dirección de correo electrónico o contraseña ingresadas no son correctas.",
    "register_company_companyStateCode_japan": "Prefecture*",
    "account_error_login_please": "Debe iniciar sesión para acceder a esta página. Inicie sesión con sus credenciales a continuación.",
    "checkout_multi_paymentMethod_addPaymentDetails_useThesePaymentDetails": "Usar estos detalles de pago",
    "checkout_multi_sop_globalError": "Se ha producido un error al procesar su solicitud. Posible acción: Espere unos minutos y vuelva a hacer el pedido.",
    "basket_page_na_orderQty": "Cant.",
    "checkout_multi_paymentMethod_savedCards_actions": "Acciones",
    "account_confirmation_profile_updated": "Su perfil ha sido actualizado.",
    "register_company_companyStateCode": "Estado*",
    "text_ExportMyData_label": "Exportar mis datos",
    "product_grid_viewFuture": "Futuro",
    "text_account_quote_page_totalResultsCurrPage": "{0} de {1} cotizaciones",
    "text_account_savedCarts_page_showAllResults": "Mostrar todo",
    "checkout_edit": "Editar",
    "text_quote_code": "Identificación de cotización:",
    "text_account_quote_action_display_CREATE": "Calcular cotización",
    "label_emea_snd": "Samedi matin livraison le lendemain",
    "checkout_error_paymentethod_formentry_sop_invalid_card_cardType": "El tipo de tarjeta no es compatible",
    "core_error_reports_na": "You do not have permission, please <a href",
    "text_myaccount": "&laquo; Mi cuenta",
    "import_csv_savedCart_enterContentNoteEmea": ", ingrese su información en el archivo, seleccione su tipo de pedido y haga clic en",
    "script": "validation messages                                                                             ",
    "checkout_login_guestCheckout": "Eche un vistazo como invitado",
    "text_account_quote_status_display_EXPIRED": "Expirado",
    "text_core_submission_address_emea": "Si la dirección de recogida no se proporciona en la selección anterior, a continuación, por favor, rellene la dirección de recogida en los campos de entrada siguientes:",
    "text_backToMobileStore": "Teléfono móvil",
    "text_account_order_appliedCoupons": "Cupones aplicados:",
    "text_account_warranty_table_header_credit_memo": "Nota de crédito N.º",
    "text_warranty_eligibility_error": "Error in Warranty Eligibility Check. Please try again or contact customer service.",
    "password_strength_minchartext": "La contraseña debe contener al menos %d caracteres, letras mayúsculas y minúsculas, números y un caracter especial",
    "label_emea_collection": "Colección",
    "is_kb_transport_required": "Se requiere el transporte de Knorr-Bremse?",
    "mobile_basket_page_update": "Cantidad actualizada",
    "checkout_paymentMethod_noSecurityCode": "Ingrese el código de seguridad.",
    "address_line1_shipping_page_form_emea": "Dirección*",
    "checkout_summary_deliveryAddress_useForNewAddress": "Utilice este formulario para ingresar una nueva dirección",
    "text_warranty_terms_school_bus": "Autobús escolar",
    "search_nav_facetShowMore_size": "más tamaños...",
    "payment_cardType": "Tipo de tarjeta",
    "product_product_partnumber": "Pieza nro.:",
    "text_account_addressBook_page_currentPage": "Página {0} de {1}",
    "checkout_error_terms_not_accepted": "Acepte nuestros términos y condiciones antes de hacer su pedido.",
    "register_email_invalid": "Ingrese un correo electrónico válido",
    "import_csv_savedCart_fileContentNote": "Para usar esta función: seleccione su tipo de pedido, haga clic en",
    "search_nav_resultsForStore": "Resultados para: {0}",
    "text_select_you_can_upload": "You can only upload max 9 mb",
    "checkout_summary_paymentMethod_securityCode": "Código de seguridad",
    "core_report_csv": "CSV",
    "text_storefinder_desktop_page_showPageResults": "Mostrar paginado",
    "text_quote_expiration_time_label": "Fecha de caducidad",
    "checkout_summary_paymentMethod_addPaymentDetails_useSavedCard": "Usar una tarjeta guardada",
    "text_select_specific_file": "Seleccione el archivo que desea cargar y haga clic en el botón \"Upload\" (Cargar). Se agregará cada archivo cargado al reclamo.",
    "address_city_shipping_page_form": "Ciudad*",
    "text_account_order_consignment_status_processing": "En proceso",
    "text_core_CollectionTime": "Collection Time",
    "text_account_closeAccount_retention_info": "Cuando cierre su cuenta, la información de su perfil se mantendrá durante el período de retención exigido por las leyes y regulaciones de su país / región. Atención al cliente podrá ayudarlo con cualquier historial de pedidos o prueba de necesidades de compra durante este tiempo. <br/> <br/> Al final del período de retención, se eliminará la siguiente información de perfil y ya no será accesible para usted o cualquier otra persona: <br/> <br/> <ul> <li> direcciones de correo electrónico </li> <li> información de contacto </li> <li> detalles de envío </li> <li> preferencias de entrega </ li> <li> configuración de gestión de consentimiento </li> <li> historial de cuenta </li> <li> detalles de pago </li> <li> historial de pedidos </li> </ul>",
    "text_register_caps": "REGISTRARSE",
    "core_report_EMEA_description": "Puede descargar en esta página sus informes básicos de Knorr-Bremse de los 18 meses anteriores.  Las actualizaciones de los informes básicos se proporcionarán en línea a principios del mes siguiente.",
    "basket_page_free": "GRATIS",
    "text_account_quote_status_display_BUYER_DRAFT": "Borrador",
    "checkout_summary_placeOrder_readTermsAndConditions": "Al realizar el pedido, confirmo que he leído y estoy de acuerdo con",
    "text_warranty_submit_part_labourAmount": "Monto de mano de obra (llenado automático)",
    "checkout_multi_paymentMethod_paymentDetails_noneSelected": "Ninguna selección",
    "basket_export_user_website": "Dirección de sitio webt",
    "text_account_order_totalSavings": "Ha ahorrado {0} en su pedido",
    "address_building_and_room": "Nombre del edificio y número de habitación",
    "storelocator_query": "Código postal / pueblo",
    "system_error_page_not_found": "404 página no encontrada",
    "text_account_savedcart_activecart_msg": "Los artículos actuales en el carrito se guardarán como:",
    "text_warranty_print": "Imprimir",
    "product_variants_select_size": "Seleccione un tamaño",
    "login_required_message": "Los campos marcados con asterisco (*) son obligatorios",
    "password_strength_weak": "Débil",
    "text_country_selector_EMEA": "Europe",
    "text_voucher_apply_input_placeholder": "ingrese el código de cupón",
    "text_quote_illegal_state_error_reason": "Tenga en cuenta que la acción {0} que intentó realizar no está permitida para la cotización {1} con el estado {2}. Razón: {3}",
    "register_termsConditions_id": "verificación de términos y condicionest",
    "register_lastName_invalid": "Ingrese un apellido",
    "text_quote_dateformat": "dd/MM/aaaa",
    "pickup_pagination_previous": "Anterior",
    "register_checkPwd": "Confirmar contraseña*",
    "text_account_paymentDetails_paymentCard_default": "Mi tarjeta de pago predeterminada",
    "text_quote_no_button_label": "No",
    "text_core_addinfo": "Addition Info",
    "text_warranty_document_once_claim": "Una vez enviada la solicitud, ya no es posible adjuntar un documento.",
    "text_quote_checkout_confirmation_modal_title": "¿Confirmar, aceptar y pagar cotización {0}?",
    "import_csv_savedCart_fileContentEmea": "Debe ser un número de pieza vendible de Knorr-Bremse",
    "text_account_savedcart_delete_msg": "El siguiente carrito será eliminado",
    "text_account_order_consignment_status_pickedup": "Retirado",
    "storeFinder_store_locator": "Localizador de tiendas",
    "checkout_error_paymentethod_formentry_sop_missing_shipTo_country": "Ingrese un valor para este campo",
    "text_warranty_eligibility_endDateLesser_error_title": "Date Removed from Service should be greater than Date in Service",
    "storeFinder_meta_title": "Stores near",
    "text_account_quote_code": "Identificación de cotización",
    "order_history_customer_ID": "Cliente ID",
    "product_grid_availability": "Disponibilidad",
    "search_mobile_page_showAllResults": "Mostrar todo",
    "checkout_multi_summary_breadcrumb": "Revisión final",
    "checkout_paymentMethod_createSubscription_billingAddress_noneSelected": "Ingrese una dirección de facturación o ingrese primero una dirección de entrega para que pueda usarse como dirección de facturación.",
    "checkout_page_summary_final_review_customerId": "Cliente ID:",
    "text_warranty_submit_button": "Enviar",
    "checkout_multi_deliveryAddress_addressBook": "Directorio",
    "no_of_pacakges": "Número de bultos",
    "text_core_submit_coreLineItems_invalid": "Obligatorio",
    "quote_cart_title": "Este carrito está siendo cotizado",
    "product_grid_averagePriceUnitText": "Precio promedio / unidad",
    "system_error_link_expired_subtitle": "Complete el formulario de contraseña olvidada nuevamente.",
    "price_to_use_feature": "Para utilizar esta función- Seleccione los archivos de precios que desea descargar. A continuación, haga clic en Descargar archivos de precio.",
    "register_company_address_street_emea1": "Dirección*",
    "basket_page_quote_discounts_link_absolute_off": "{0} menos",
    "text_plp_page_impp": "Nro. de pieza IAM",
    "review_rating": "Su calificación",
    "register_companystreet_name_invalid_kbRegisterForm_companyStreetNumber": "Ingrese el número de calle",
    "text_warranty_terms_some_parts": "** Algunas piezas podrían tener garantías extendidas, consulte debajo de la pestaña de Warranty Document (documento de garantía) para obtener información.",
    "general_month_august": "Agosto",
    "text_account_core_search_linkPreviousPage": "Página anterior",
    "checkout_multi_paymentMethod_savedCards_billingAddress": "Dirección de facturación",
    "label_emea_bnd": "Livraison le lendemain avant 9h",
    "checkout_error_paymentethod_formentry_sop_missing_shipTo_street1": "Ingrese un valor para este campo",
    "checkout_error_paymentethod_formentry_sop_missing_shipTo_street2": "Ingrese un valor para este campo",
    "product_variants_only_left": "solo queda {0} en línea",
    "registration_confirmation_message_title": "Gracias por enviar su registro, recibirá un correo electrónico para confirmar su registro.",
    "demo_registration_confirmation_message_title": "Gracias por enviar su registro de demostración, por favor seleccione las demostraciones disponibles a continuación.",
    "basket_page_netpriceApac": "Net Price (Total)",
    "general_continue_shopping": "Seguir comprando",
    "text_quote_conteroffer_possible_checkout_message": "Esta es una cotización de proveedor vinculante. El comprador podría pagar de inmediato.",
    "mobile_checkout_edit_link": "Editar",
    "checkout_orderConfirmation_Total": "Total",
    "checkout_checkout_multi_pci_select": "Seleccione una opción PCI",
    "text_homepage_banner_label": "INNOVACIÓN: EL MODELO DE RECICLAJE PARA BLOQUES DE FRENO EVITA LOS RESIDUOS",
    "length_width_height": "(Largo x ancho x alto)",
    "pdp_page_listprice": "Precio de lista",
    "text_percentage": "%",
    "text_headertext_info": "Información",
    "text_storefinder_desktop_page_sortTitle": "Ordenar por:",
    "text_account_orderHistory_page_sort_byDateDesc": "Date-Desc",
    "register_checkbox_list_label": "Precio de lista",
    "text_account_order_consignment_store_title": "Tienda",
    "quote_state_expired": "Esta cotización ha expirado. Elabore una cotización nueva o edite la cotización expirada.",
    "basket_page_message_update_pickupinstoreitem_toship": "El artículo para retiro en tienda ha sido actualizado para su envío.",
    "search_nav_facetShowLess_price": "menos precios...",
    "search_nav_facetValueCount": "({0})",
    "review_rating_alt": "estrellas",
    "core_report_NA_description_example": "Ejemplo: El 1 de enero puede descargar su informe básico de diciembre, que mostrará toda su actividad de diciembre.",
    "text_headline_breadcrumbs": "Rastros de navegación",
    "text_account_savedcart_restore_popuptitle": "Restaurar carrito guardado",
    "header_mobile_link_login": "Iniciar sesión",
    "orderHistory_page_totalResultsDetails": "{0} de {1} pedidos",
    "mycompany_enter_name_placeholder": "Introduzca un nombre o una dirección de correo electrónico",
    "form_select_none": "Ninguno",
    "text_quote_submit_confirmation_message": "¿Seguro que quiere enviar esta cotización?",
    "text_generalInfo_grossWeight": "Peso bruto",
    "text_account_addressBook_setDefaultDeliveryAddress": "Establecer dirección de entrega predeterminada",
    "basket_restoration_unavailable": "Lamentablemente, {0} ya no está disponible. Anteriormente tenía {2} en su carrito.",
    "updatePwd_token_invalidated": "Su contraseña ya ha sido actualizada.",
    "pagination_view": "Ver",
    "text_voucher_apply_input_label": "Código de cupón",
    "profile_pwd_invalid": "Ingrese su contraseña",
    "register_site_companyrole": "Sector en la industria*",
    "storeDetails_table_features": "Características",
    "text_core_submit_address_addressPhone": "Teléfono",
    "basket_page_customerPrice": "Precio del cliente",
    "register_lastName": "Apellido*",
    "text_account_orderHistory_actions": "Acciones",
    "text_pagenotexist_error": "¡Esta página no existe!",
    "payment_expiryDate": "Fecha de caducidad*",
    "address_zipcode": "Código postal",
    "quote_less_comments": "Ver menos comentarios",
    "checkout_multi_deliveryMethod_noExistingDeliveryMethod": "Actualmente no existe un método de entrega.",
    "quote_cart_checkout_error": "Se modificó la cotización del proveedor, por favor, acepte y pague nuevamente.",
    "text_consent_dpr_pdp": "Aviso de privacidad",
    "customeradmin_check": "Administrador de clientes",
    "registration_error_account_exists_subtitle": "Si olvidó su contraseña, utilice el enlace de contraseña olvidada.",
    "text_core_submit_address_countryISO": "País*",
    "text_account_order_includesTax": "Su pedido incluye {0} impuesto",
    "import_csv_savedCart_title": "Importar pedido",
    "text_warranty_terms_logging_vehicle": "Vehículos madereros o mineros",
    "checkout_multi_purchaseOrderNumber_label_NA": "Nro. de orden de compra del cliente",
    "register_back_login": "Volver a inicio de sesión",
    "checkout_multi_paymentMethod_createSubscription_failedMsg": "No se pudo crear la suscripción. Verifique los valores ingresados.",
    "checkout_pages_availabilty_final_review_NA": "SIGUIENTE",
    "text_warranty_submit_part_description": "Descripción",
    "address_shipping_page_form_na": "Dirección*",
    "text_account_savedCart_description": "Descripción",
    "register_termsConditions": "Confirmo que he leído y estoy de acuerdo con el <a class",
    "text_account_orderHistory_page_totalResultsSinglePag": "{0} Pedidos",
    "text_address_remove_following": "La siguiente dirección se eliminará de su directorio",
    "quote_cancel": "Cancelar cotización",
    "quote_save_cart_error": "Hubo un error interno. Inténtelo de nuevo",
    "checkout_checkout_multi_pci-hop": "PCI-HOP",
    "text_account_quote_manage_items": "Gestionar artículos",
    "basket_received_promotions": "Promociones recibidas",
    "text_quote_validity_message": "Esta cotización es válida hasta {0}",
    "text_account_order_status_display_Error": "Pendiente",
    "text_account_orderHistory_page_sort_byDescription": "Description-Asc",
    "text_warranty_note": "Nota:",
    "core_submit_warranty_material_included": "¿Material de garantía incluido?",
    "text_account_savedCarts_page_totalResultsCurrPage": "{0} de {1} carritos guardados",
    "text_skipToContent": "Ir al contenidot",
    "text_account_customerPONumber": "Número de pedido del cliente",
    "pickup_search_message": "Ingrese un pueblo / ciudad o código postal",
    "text_quote_submit_confirmation_modal_title": "¿Confirmar cotización solicitada {0}?",
    "pickup_pagination_last": "Último",
    "checkout_page_summary_deliveryMode_selectDeliveryMethodForOrder": "Tipo de entrega",
    "checkout_multi_hostedOrderPageError_breadcrumb": "Error",
    "register_webshop_id": "verificación de la tienda virtualt",
    "text_account_order_consignment_status_cancelled": "Cancelado",
    "text_warranty_size": "Tamaño",
    "address_phone": "Número de teléfono",
    "text_headline_footer_navigationbar": "Navegue por la barra de navegación del pie de página",
    "text_warranty_submit_part_otherCostDescription": "Descripciones de otros costos",
    "review_show_more": "Mostrar más",
    "checkout_error_paymentethod_formentry_sop_invalid_billTo_state": "Este valor no es válido para este campo.",
    "text_account_orderHistory_mobile_page_totalResults": "{0} pedidos encontrados",
    "text_warranty_terms_ineterstate_truck": "Camión interestatal",
    "product_related_products": "Productos relacionados",
    "text_account_core_breadcrumbEMEA": "Buscador de grupos centrales",
    "basket_page_orderQty": "Order Qty",
    "text_reports_creditRecon": "Reconciliación",
    "text_quickOrder_product_quantity_invalid": "Cantidad inválida",
    "search_nav_removeAttribute": "Eliminar atributo",
    "checkout_summary_deliveryMode_editDeliveryMethod": "Editar método de entrega",
    "saved_quote_total_number": "Cotizaciones ({0})",
    "text_account_paymentType": "Método de pago",
    "basket_information_quantity_reducedNumberOfItemsAdded_lowStock": "Se ha añadido una cantidad menor de este producto a su carrito debido al stock insuficiente",
    "checkout_orderConfirmation_thankYouForOrder": "¡Gracias por su pedido!",
    "order_history_cumulative_price": "*Cumulative Price for one piece including any Core, Freight and applicable surcharges",
    "order_itemPrice": "Precio del artículo",
    "text_company_manage_units_notActivated": "Su cuenta aún no se ha activado, comuníquese con el administrador de cliente para obtener más información.",
    "text_warranty_upload_file": "Cargar archivos",
    "text_account_table_header_openQty": "Abierto Cantidad",
    "text_headline_weightAndDimension": "Peso y dimensionest",
    "To": "use this feature - Click on <b>Download Order Template</b>, enter your information on the file, select your order type and click on <b>Upload Order Template</b>",
    "mobile_checkout_cart_viewLess": "Ver menos",
    "text_company_users_label": "Los usuarios de la empresa",
    "checkout_error_paymentethod_formentry_sop_invalid_shipTo_lastName": "Este valor no es válido para este campo.",
    "text_reports_summaryNa": "Toda la actividad del grupo central de alto nivel",
    "text_warranty_submit_labourrequested_yes": "Sí",
    "checkout_multi_paymentMethod_addPaymentDetails_generalError": "Se produjo un error al contactar al proveedor de pagos.  Espere unos minutos y vuelva a intentar.  Si el problema persiste, comuníquese con nuestro equipo de ventas.",
    "text_account_order_status_display_cancelling": "Cancelación pendiente",
    "checkout_orderConfirmation_continueShopping": "Seguir comprando",
    "text_core_submission_thank_text": "Gracias, su equipo central de Bendix",
    "core_check": "Principalt",
    "popup_close": "Cerrar",
    "text_warranty_search_claim_ref_no": "N.º de referencia de reclamo del cliente",
    "text_select_you_record_sets": "Conjuntos de registros:",
    "text_breakapplication_name": "Nombre",
    "text_breakapplication_size": "Tamaño",
    "login_email": "Dirección de correo electrónico*",
    "text_quickOrder_form_product_exists": "El código ya existe en el formulario",
    "text_account_savedCart_link": "Guardar carrito",
    "register_terms_condition": "Términos de uso",
    "register_termsOfUsage": "Términos de usot",
    "corePrice_check": "Core Price",
    "text_quote_name_description_invalid": "Ingrese un nombre y una descripción válidos",
    "automatically_generated_by_kb": "Automatically generated by Knorr-Bremse",
    "address_selectProvince": "Provincia",
    "cart_page_estdelivery": "Fecha de entrega estimada",
    "text_weight": "Peso total",
    "text_core_submit_lastName": "Apellido",
    "basket_validation_invalidGroup": "Este grupo está configurado incorrectamente. Edítelo.",
    "import_csv_savedCart_fileContentNoteEmea": "Para usar esta función, haga clic en",
    "address_townJP_invalid": "Ingrese una ciudad, pueblo o municipio",
    "basket_error_date_invalid": "Seleccione una fecha no antes del {0}.",
    "search_mobile_page_linkNextPage": "Siguiente &raquo;",
    "checkout_orderConfirmation_thankYouForOrder_bendix": "Gracias por ordenar con Bendix. A continuación, se muestra el resumen de su pedido.",
    "general_mobile_store": "Tienda móvil",
    "text_filter_by": "Filtrado por",
    "text_account_quotes_page_totalResultsCurrPage": "{0} de {1} cotizaciones",
    "basket_export_user_status": "Estado",
    "search_nav_facetTitle": "Comprar por {0}",
    "basket_page_entry_unknownAction": "Acción de entrada de carrito desconocida",
    "text_account_paymentDetails_managePaymentDetails": "Gestione sus detalles de pago",
    "basket_page_message_update": "La cantidad del producto ha sido actualizada.",
    "sold_to_popup_text_one": "No puede hacer un pedido en este momento,",
    "checkout_summary_paymentMethod_savedCards_selectSavedCardOrEnterNew": "Seleccione los detalles de pago existentes o ingrese detalles de pago nuevos",
    "text_account_core_search_totalResultsSingleOrder": "1 Result found.",
    "text_account_quote_page_totalResultsSinglePag": "{0} cotizaciones encontradas",
    "checkout_summary_paymentMethod_savedCards_billingAddress": "Dirección de facturación",
    "mobile_checkout_deliveryMethod": "Opciones de entrega",
    "cart_page_customer_reference": "Customer Item Ref. No.",
    "account_error_account_not_found": "No se encontró ninguna cuenta para la dirección de correo electrónico ingresada.",
    "address_phoneNumber": "Número de teléfono",
    "basket_save_cart_max_chars": "Caracteres restantes",
    "checkout_error_paymentethod_formentry_sop_invalid_card_cvNumber": "El código de seguridad no es válido.",
    "checkout_multi_paymentMethod_breadcrumb": "Dirección de pago y facturación",
    "text_headline_register": "Haga clic aquí para registrar un nuevo cliente.",
    "basket_save_cart_on_error": "Hubo una irregularidad al guardar el carrito {0}",
    "text_account_warranty_table_header_status": "Estado",
    "basket_export_user_userCreated": "Usuario creado / Fecha de activación",
    "mycompany_click_delete_user": "Haga clic en Eliminar usuario",
    "doubleopt_confirmation_message_title": "Gracias por confirmar su registro, una vez aprobado recibirá un correo electrónico con los detalles de inicio de sesión",
    "product_view_details_typenumber": "Tipo #",
    "j_username": "Iniciar sesión",
    "checkout_orderConfirmation_success": "¡Su orden fue exitosa!",
    "cart_page_checkout": "Pago",
    "text_quickOrder_page_price": "Precio",
    "checkout_order_type_lineEntriesExceeded_emergencyEMEA": "Ha seleccionado {0} pedidos: Puede pedir 2 posiciones con un máximo de 2 piezas por posición. Actualice su carrito para continuar.",
    "quote_not_editable": "Quote ID : {0} is not editable",
    "text_warranty_vehicle_identification_number": "Número de identificación del vehículo*",
    "text_warranty_vehicle_identification_notnumber": "Número de identificación del vehículo",
    "text_checkout_pickup_in_store": "Recoger en la tiendat",
    "text_reports_credit": "Debit/Credit Reconciliation",
    "mobile_checkout_deliveryAddress_selectAddressMessage": "Elija una dirección de entrega de su directorio o agregue una nueva",
    "text_warranty_submit_part_totalCost": "Costo total (llenado automático)",
    "product_share_tweet": "Tuitear esto",
    "checkout_multi_paymentMethod_continue": "Siguiente",
    "resetPwd_title": "Restablecer contraseña",
    "checkout_summary_paymentMethod_savedCards_enterNewPaymentDetails": "Ingresar detalles de pago nuevos",
    "basket_restoration_view_cart": "<a href",
    "checkout_orderConfirmation_thankYouForOrder_emea": "Gracias por ordenar con Sistemas de vehículos comerciales de Knorr-Bremse. A continuación, se muestra el resumen de su pedido.",
    "text_account_order_orderNumberLabel": "Su número de pedido es",
    "basket_cartpage_kb_partNo": "Knorr-Bremse",
    "text_storefinder_responsive_page_firstPage": "&laquo;",
    "text_account_addressBook_saveAddress": "Guardar dirección",
    "warranty_vinError": "El VIN debe tener 17 dígitos.",
    "search_page_showAllResults": "Mostrar todo",
    "text_address_remove_confirm": "¿Seguro que quiere eliminar esta dirección?",
    "text_account_order_consignment_trackingID_notavailable": "No disponible",
    "profile_email_unique": "El correo electrónico que ingresó no está disponible",
    "checkout_summary_edit": "Editar",
    "checkout_page_summary_final_review_order_note": "Order Note:",
    "text_account_orderHistory_page_linkPreviousPage": "Página anterior",
    "text_core_submit_address_addressFax": "Fax",
    "breadcrumb_not_found": "Página no encontrada",
    "label_emea_uk_pksh": "Al día siguiente antes de las 12 p.m.",
    "text_warranty_select_all_files": "All files has been attached successfully",
    "text_core_submit_crm": "Número de CR*",
    "text_core_na_submit_crm": "Número de devolución del núcleo Bendix",
    "text_core_submit_customercrm": "Número de referencia del cliente",
    "text_core_search_crm": "Número de CR",
    "text_core_submit_internalUseOnly": "Sólo para uso interno de Bendix",
    "basket_page_cartHelpMessageMobile": "¿Necesita ayuda? <br /> Llame a nuestro equipo para recibir ayuda personalizada al <a href",
    "choose_delivery_carrier_account_number": "Su número de cuenta de operador",
    "text_account_quote_status_display_SELLERAPPROVER_DRAFT": "Borrador",
    "text_warranty_submit_claim_information": "Información solicitud",
    "basket_page_totals_noNetTax": "*No se incluyen impuestos en el total",
    "checkout_order_type_lineEntriesExceeded_emergencyNA": "Ha seleccionado {0} pedidos: Puede pedir artículos de 2 líneas con un máximo de 2 piezas por línea. Actualice su carrito para continuar.",
    "text_core_submission_clarify": "Etiquete claramente las piezas como \"material de garantía\"",
    "text_core_Stackable_pdf": "Stackable",
    "product_emea_meta_description": "Get detailed information about the selected Knorr-Bremse product including technical attributes, associated documents, service solutions and tools.",
    "text_storefinder_mobile_page_description": "Ingrese su ubicación para ver las tiendas en su área o permita que su dispositivo encuentre tiendas cercanas para usted",
    "text_expresscheckout_header": "Pago exprés",
    "text_storefinder_desktop_page_linkPreviousPage": "Anterior",
    "register_dataprotection_message": "Declaración de protección de datos",
    "text_quote_illegal_state_error": "Tenga en cuenta que la acción {0} que intentó realizar no está permitida para la cotización {1} con el estado {2}",
    "text_account_quote_page_showPageResults": "Mostrar paginado",
    "checkout_orderConfirmation_Order_Date": "Fecha del pedido:",
    "text_account_quote_page_lastPage": "&raquo;",
    "register_pwd": "Contraseña*",
    "review_confirmation_thank_you_subtitle": "Intentamos publicar todos los comentarios en el sitio en 24 horas.",
    "basket_page_totals_total_items": "{0} ARTÍCULOS",
    "updatePwd_pwd_invalidMatch": "\"La contraseña debe cumplir con los requisitos establecidos\".",
    "quote_view": "Ver cotización",
    "basket_error_no_pickup_location": "Seleccione una tienda para las entradas resaltadas en rojo.",
    "basket_cartpage_typeNo": "Número de pieza del cliente",
    "cart_basket_typeNo": "Tipo nro.",
    "search_meta_description_on": "en",
    "text_account_order_consignment_pickUpBy": "Retirar por",
    "download_agree_disclaimer_text": "I agree to the disclaimer",
    "review_write_description": "Ingrese su comentario",
    "basket_information_quantity_noItemsAdded_noStock": "Lo sentimos, no hay stock suficiente para su carrito.",
    "text_account_orderHistory_mobile_page_sort_byDate": "Fecha",
    "text_account_profile_paymentCart_removed": "Tarjeta de pago eliminada con éxito",
    "password_strength_strong": "Fuerte",
    "text_sales_status_description_apac_code_40_anonymous": "Vendable à l'IAM",
    "validation_checkEmail_equals": "La dirección de correo electrónico y la confirmación no coinciden",
    "mobile_checkout_continue_shopping": "Seguir comprando",
    "text_account_savedCarts_page_totalResultsSinglePag": "{0} carritos guardados",
    "register_company_website": "Dirección de sitio webt",
    "text_account_orderHistory_page_sort_byDescriptionDesc": "Description-Desc",
    "basket_items": "Artículos",
    "text_quickOrder_page_product": "Producto",
    "basket_page_cartHelpContent": "¿Necesita ayuda? Contáctenos o llame a servicio al cliente al 1 - ### - ### - ####. Si llama respecto a su carrito de compras, proporcione la identificación del carrito de compras en la parte superior.",
    "vor_text_warning": "Please ensure you have entered the complete address including post code as per the correct mail standard format.",
    "guest_checkout": "¿Nuevo en {0}?",
    "quote_newcart_error": "Se ha producido un error al procesar su solicitud. Intente enviar su solicitud nuevamente.",
    "breadcrumb_quote_edit": "Editar cotización",
    "checkout_summary_paymentMethod_addPaymentDetails_useSavedCard_description": "Los clientes registrados pueden seleccionar una tarjeta guardada previamente",
    "basket_restoration_lowStock": "Lamentablemente, se restauró una cantidad menor de {0} en su carrito debido a la baja disponibilidad de stock. Se agregaron {3} a su carrito, ahora tiene {2}.",
    "text_account_orderHistory_page_sort_byTotal": "Total-Asc",
    "text_account_quote_action_display_EDIT": "Editar cotización",
    "basket_page_poa": "Precio a petición",
    "storeDetails_title": "Detalles de la tienda",
    "order_history_realtime_heading": "La información de esta página es información en tiempo real. La información de entrega actualizada se muestra en color rojo.",
    "text_account_consent_consentManagement": "Gestión de consentimiento",
    "address_room": "Número de habitación",
    "text_guest_customer": "Invitado",
    "checkout_multi_paymentMethod_addPaymentDetails_enterYourCardDetails": "Ingrese los detalles de su tarjeta para el pago",
    "profile_checkPwd": "Confirmar contraseña*",
    "profile_checkEmail_invalid": "Confirme su dirección de correo electrónico",
    "checkout_checkout_flow_select": "Seleccione un modo de pago alternativo",
    "checkout_error_paymentethod_formentry_sop_invalid_shipTo_shippingMethod": "Este valor no es válido para este campo.",
    "basket_page_itemDescription": "Descripción",
    "checkout_multi_hostedOrderPageError_continue": "Continuar",
    "review_see_reviews": "Mostrar comentarios",
    "checkout_information_delivery_method_changed": "Su método de entrega ha sido actualizado en función de su ubicación de entrega.",
    "globle_notLessThanDefault": "The Date must not less than default date",
    "text_account_order_qty": "CANT.",
    "address_regionIso_shipping_form": "Estado / provincia*",
    "text_iconCartRemove": "Eliminar",
    "pdp_page_corecharges": "Cargo del nucleo",
    "basket_page_totals_discounts": "Descuentos en pedido:",
    "checkout_error_paymentethod_formentry_sop_invalid_billTo_lastName": "Este valor no es válido para este campo.",
    "basket_page_entry_action_REMOVE": "Eliminar",
    "register_company_address_city": "Ciudad*",
    "quote_comment_invalid": "El comentario no puede tener más de 255 caracteres.",
    "general_month_february": "Febrero",
    "text_account_profile_changePassword_mobile": "Cambiar contraseña",
    "text_account_viewOrderHistory": "Ver historial de pedidos",
    "saved_cart_total_number": "Carritos guardados ({0})",
    "checkout_error_paymentethod_formentry_invalid": "Verifique que los detalles de su pago sean correctos o proporcione un método de pago diferente.",
    "checkout_multi_sop_remove": "Eliminar",
    "pickup_pagination_page_details": "{0} a {1} de {2}",
    "checkout_error_paymentethod_formentry_sop_invalid_card_startMonth": "El mes de emisión no es válido.",
    "checkout_pickup_store_destinations": "{0} destinos de retiro por tienda",
    "product_product_details_future_title": "Disponibilidad futura",
    "saved_cart_total_description": "Usted tiene",
    "text_account_table_head_order_category": "Order Category",
    "NotBlank_orderHistoryForm_startDate": "Please enter Start Date",
    "review_confirmation_thank_you_title": "Gracias por su comentario",
    "text_core_submit_emailAddress": "Dirección email de confirmación*",
    "text_max_vehicle_size": "p.ej. el tamaño máx.del vehículo",
    "checkout_order_type_lineEntriesExceeded": "Puede solicitar un máximo de {0} líneas según el tipo de pedido seleccionado como {1}. Actualice su carrito para continuar.",
    "core_error_submission_na": "You do not have permission, please <a href",
    "checkout_summary_paymentMethod_savedCards_actions": "Acciones",
    "popup_quick_view_select": "Seleccionar opciones",
    "basket_export_user_core": "Rapports de base",
    "text_delete_savedcart_error": "Error al eliminar el carrito guardado",
    "checkout_summary_placeOrder_readTermsAndConditions_EMEA": "Al realizar el pedido, confirmo que he leído y acepto las <a class",
    "text_storefinder_responsive_page_currentPage": "{0} de {1}",
    "registration_consent_link": "Para ver otras opciones o cambiar su configuración, vaya a la página de gestión de consentimiento en Mi cuenta.",
    "checkout_orderConfirmation_Carrier_Selection": "Selección de transportista:",
    "basket_error_invalid_configuration_edit": "Resolver problemas",
    "checkout_orderConfirmation_coupon_valid_until": "Válido hasta {0}",
    "text_consent_button_more": "Más.",
    "text_warranty_submit_part_add": "Añadir un número de referencia",
    "order_orderItems": "Pedir artículos",
    "register_company_address_street_emea": "Número de calle*",
    "register_company_address_street_emea_lite_user": "Número de calle",
    "text_reports_summary": "Resumen",
    "text_account_savedCart_backToSavedCarts": "Regresar a carritos guardados",
    "text_quickOrder_delivery_date": "Fecha de entrega",
    "text_productDetails": "Detalles del productot",
    "text_account_order_orderBreadcrumb": "Pedido {0}",
    "text_account_quote_page_linkNextPage": "Página siguiente",
    "cart_total_note": "* se pueden agregar costos / cargos de flete",
    "storeFinder_find_a_store": "Encontrar una tienda",
    "text_button_cancel": "Cancelar",
    "please_select_state_text": "Seleccione",
    "text_warranty_terms_charter_bus": "Autobús interestatal o chárter",
    "basket_page_shipping": "Envío",
    "text_core_submit_soldto": "Cliente ID",
    "text_account_order_status_display_error": "Pendiente",
    "quote_reject_error": "Error al rechazar la cotización.",
    "b2b_unit_order_blocked_login": "Comuníquese con servicio al cliente.",
    "order_history_order_type_others": "Others",
    "address_district_invalid": "Ingrese un distrito",
    "text_core_submit_address_address2": "Dirección 2t",
    "checkout_multi_paymentMethod_viewSavedPayments": "Ver pagos guardados",
    "open_total_usd_EMEA": "Open Value - in EUR*",
    "text_warranty_attachement_available": "Adjuntos disponibles",
    "text_warranty_eligibility_success": "Sí, la pieza está cubierta por la garantía",
    "general_month_september": "Septiembre",
    "text_guest_ordererror": "Página de error de pedido como invitado",
    "storeFinder_nearby_stores": "Tiendas cercanas",
    "text_button_use": "Utilizar",
    "text_quote_description_label": "Descripción",
    "text_account_core_search_currentPage": "Página {0} de {1}",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_country": "Ingrese un valor para este campo",
    "checkout_multi_paymentMethod_savedCards_stepHeader": "3 - Seleccione Detalles de pago",
    "text_Saved_Shipping_Addresses": "Direcciones de envío guardadas",
    "text_account_quote_name": "Nombre",
    "text_quote_discount_adjust_total": "Ajuste total",
    "address_title_invalid": "Seleccione un título",
    "basket_added_to_basket": "Agregado al carrito",
    "deliveryMode_select_delivery_type": "Entrega",
    "text_cart": "Carrito",
    "text_account_warranty_search_page_totalResultsCurrPage": "Reclamos {0} de {1}",
    "text_restore_savedcart_error": "Error al restaurar el carrito guardado",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_email": "Ingrese un valor para este campo",
    "text_default": "Por defectot",
    "paymentMethod_billingAddress_header": "Dirección de facturación:",
    "checkout_deliveryAddress_notSelected": "Proporcione una dirección de entrega para su pedido",
    "basket_page_customerprice": "Precio del cliente",
    "quick_order_req": "REQ",
    "text_expresscheckout_info1": "Al establecer con éxito su configuración de esta manera, los usuarios que han iniciado sesión continuarán directamente hacia el paso de revisión final cuando procedan al pago",
    "text_expresscheckout_info2": "Los usuarios que aún no hayan iniciado sesión pueden elegir el pago exprés en el carrito de compras",
    "general_month_march": "Marzo",
    "text_warranty_terms_app_frequency": "Estas aplicaciones tienen ciclos de trabajo de frenado de alta frecuencia, operan en condiciones más severas y pueden usarse en carreteras de superficie dura o en condiciones todo terreno.",
    "text_confirmation_warranty": "Warranty Confirmation",
    "text_account_warranty_search_page_linkPreviousPage": "Página anterior",
    "text_expresscheckout_info3": "La función de pago exprés no está disponible para usuarios invitados",
    "enter_part_number_quick_order": "Ingrese el número de pieza",
    "search_nav_facetShowLess_size": "menos tamaños...",
    "general_month_january": "Enero",
    "order_history_order_date": "Fecha del pedido:",
    "text_countryOfOrigin": "País de origen",
    "text_account_addressBook_page_sort_byCode": "IDENTIFICACIÓN",
    "checkout_orderConfirmation_orderNumberShort": "Pedido # {0}",
    "text_user_registraion_request_label": "Solicitudes de registro",
    "user_rights_approval": "Conjunto de derechos de usuario",
    "basket_page_totals_estimatetaxesbutton": "Impuesto estimado",
    "login_description": "Inicie sesión",
    "text_account_orderHistory_page_totalResultsCurrPage": "{0} de {1} pedidos",
    "warranty_claim_no": "Sí",
    "register_state_placeholder": "Seleccione su estado",
    "text_storefinder_responsive_page_linkNextPage": "Siguiente",
    "checkout_error_paymentethod_formentry_sop_invalid_billTo_country": "Este valor no es válido para este campo.",
    "register_checkbox_priceDownloadAccess_label": "Descargar archivo de precios",
    "storeFinder_table_view_store": "Ver tienda",
    "profile_submit": "Actualizar",
    "quote_submit_success": "Cotización enviada con éxito.",
    "text_storefinder_mobile_page_currentResults": "{0} - {1} de {2} tiendas",
    "checkout_multi_deliveryAddress_noSuggestedAddresses": "No hay sugerencias de dirección",
    "basket_page_itemPrice": "Precio del artículo",
    "search_page_sortTitle": "Ordenar por:",
    "checkout_summary_deliveryMode_number_of_pickup_destinations": "{0} destinos de retiro por tienda",
    "register_termsOfUsage_accept_invalid": "Debe aceptar los términos de uso de la tienda virtual",
    "import_csv_savedCart_downloadTemplate": "Descargar plantilla de pedido",
    "import_csv_core_downloadTemplate": "Descargar plantilla básica",
    "price_download_files": "Descargar sus archivos precio",
    "text_account_order_consignment_status_shipped": "Enviado",
    "text_account_change_email_address": "Cambiar dirección de correo electrónico",
    "search_nav_selectRefinements_title": "Seleccionar procesamientos",
    "text_core_submit_phone": "Teléfono",
    "text_core_submit_personalDetails_phone": "Teléfono",
    "text_core_submit_personalDetails_emailAddress": "Dirección email de confirmación",
    "text_core_submit_address": "Dirección*",
    "text_core_submit_address_country": "País*",
    "text_core_submit_address_selectState": "State / Province*",
    "text_core_submission_wghttotal": "Peso total",
    "checkout_multi_paymentMethod_addPaymentDetails_header": "Detalles de pago.",
    "checkout_summary_deliveryAddress_noExistingAddresses": "No tiene ninguna dirección en su directorio.",
    "text_account_savedCarts_page_linkNextPage": "Página siguiente",
    "checkout_multi_addEditform": "Utilice este formulario para agregar / editar una dirección.",
    "storeDetails_map_link": "Map",
    "basket_page_netprice": "Precio neto",
    "pdp_information_replacedby": "Reemplazado por:",
    "payment_year": "Año",
    "checkout_page_summary_final_review_customer_refrence": "# de referencia del cliente:",
    "checkout_orderConfirmation_Summary_title": "Resumen del pedido",
    "text_warranty_submit_enter_amount": "(ingrese el monto por pieza)",
    "text_account_savedCarts_page_totalResults": "de {0} carritos guardados",
    "text_account_quote_action_display_CHECKOUT": "Aceptar y pagar cotización",
    "text_account_orderHistory_mobile_page_sortTitle": "Ordenar por:",
    "text_quote_dateformat_datepicker_selection": "dd/mm/aa",
    "register_company_b2bUnits_invalid": "Please Select at least one sold to",
    "review_number_reviews": "Comentarios",
    "pickup_pagination_stores": "&nbsp;tiendas encontradas",
    "basket_error_quantity_notNull": "El campo de cantidad no puede estar vacío.",
    "text_account_addressBook_noSavedAddresses": "No se encontraron direcciones guardadas",
    "quote_submit_error": "Error al enviar la cotización.",
    "basket_page_deliveryDate": "Fecha de entrega solicitada",
    "product_share_print": "Imprimir",
    "fselect_noResultFound": "No se ha encontrado resultados.",
    "download_disclaimer_text": "Download Disclaimer",
    "review_submit": "Enviar comentario",
    "pickup_in_store_back_to_results": "Regresar",
    "text_account_warranty_search_page_sortTitle": "Ordenar por",
    "import_csv_savedCart_fileContent": "Debe ser un número de pieza vendible de Bendix",
    "text_myCompanyManage_content": "En esta sección se pueden crear, editar y eliminar todos los usuarios de su empresa",
    "import_csv_savedCart_selectFile": "Seleccione un archivo para subir. El archivo debe ser un archivo de texto con extensión CSV.",
    "basket_error_date_success": "Solicite la fecha de entrega actualizada.",
    "checkout_orderConfirmation_cut-off-time": "Hora límite:",
    "product_grid_future_tooltip_delivery": "Entrega",
    "storeDetails_table_distanceFromCurrentLocation": "{0} from Current Location",
    "search_mobile_page_currentPage": "{0} - {1} de {2} productos",
    "quote_acceptandcheckout": "Aceptar y pagar",
    "pickup_mobile_back_to_cart_page": "Volver a la bolsa de compras",
    "basket_restoration_items_msg": "Los siguientes artículos son:",
    "checkout_pickup_items_to_be_shipped": "Enviar a:",
    "checkout_error_paymentethod_formentry_sop_missing_card_accountNumber": "Ingrese un número de tarjeta",
    "text_minOrderQuantity": "Cantidad mínima por pedidot",
    "checkout_checkout_multi": "Pago múltiple",
    "checkout_multi_paymentMethod_addPaymentDetails_enterDifferentBillingAddress": "Ingrese una dirección de facturación diferente",
    "text_account_consent_cookiesusage": "Uso de cookies",
    "address_postcode_invalid": "Ingrese el código postal",
    "text_headline_addaddress": "Haga clic para agregar una dirección",
    "storeDetails_table_opening_closed": "Cerrado",
    "basket_page_message_remove": "El producto ha sido eliminado de su carrito.",
    "address_line2_invalid": "Ingrese la dirección en la Línea 2",
    "search_Results_NextPage_link": "Siguiente",
    "register_checkbox_admin_label": "Administrador de clientes",
    "register_site_company": "Ingrese la información de su empresa*",
    "text_account_orderHistory_page_sort_byPODesc": "PO No-Desc",
    "warranty_eligibility_check_type_of_operation": "Tipo de operación",
    "text_core_submit_address_zipCode": "Código postal*",
    "popup_done": "Listo",
    "register_termOfUsage_accept_dataProtection": "Debe aceptar la Declaración de protección de datos",
    "cart_page_quantity_label": "CANT.",
    "basket_export_user_username": "Nombre de usuario",
    "text_account_profile_saveUpdates": "Actualizar",
    "checkout_page_summary_deliveryMode_selectDeliveryMethodForOrder_EMEA": "Tipo de entrega",
    "text_core_submission_pdfNA": "Bendix Core Cente",
    "checkout_summary_paymentMethod_savedCards_header": "Seleccionar detalles de pago",
    "text_warranty_document_attachement_all": "Los documentos se pueden adjuntar si están en formato jpg, word o pdf y no superan los 9 MB en total.",
    "product_product_details_future_date": "Fecha de entrega estimada",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_state": "Ingrese un valor para este campo",
    "order_form_total": "Formulario de pedido total",
    "order_history_order_type": "Tipo de pedido:",
    "text_account_warranty_search_page_lastPage": "&raquo;",
    "core_error_generic": "No Results found.",
    "NotBlank_orderHistoryForm_endDate": "Please enter End Date",
    "checkout_summary_paymentMethod_addPaymentDetails_header": "Detalles de pago.",
    "address_required": "Los campos marcados con asterisco (*) son obligatorios",
    "checkout_orderConfirmation_pickupPoints": "{0} destinos para retiros por tienda",
    "text_warranty_eligibility_mileageInService_invalid": "Please enter a valid Mileage in Service",
    "payment_issueNumber": "Número de emisión",
    "quote_newcart_success": "La cotización {0} se guardó exitosamente",
    "text_coreGroup": "Grupo principalt",
    "text_warranty_email_two_invalid": "Please correct email id",
    "review_headline": "Título del comentario",
    "checkout_multi_deliveryAddress_addressSuggestions_addressNotFound": "O mantenga su dirección original:",
    "address_district": "Distrito",
    "checkout_multi_paymentMethod_seeOrderSummaryForMoreInformation": "Consulte el área de resumen de pedidos para obtener más información.",
    "text_account_addressBook_page_sort_byTotal": "Totalt",
    "basket_save_cart_validation_name_notBlank": "El nombre del carrito no puede estar en blanco",
    "text_popupCartTitle": "Su carrito de comprat",
    "basket_page_surcharge": "ReCargo del nucleo",
    "text_account_core_search_firstPage": "&laquo;",
    "text_warranty_eligibility_mileage_mi_error": "Mileage can't be more than 6213711 miles",
    "forgottenPwd_description": "Ingrese la dirección de correo electrónico de su cuenta.  Las instrucciones sobre cómo restablecer su contraseña serán enviadas a esta dirección.",
    "error_account_myPart_template_format": "Cargue los datos en el formato correcto - tome la plantilla de excel de carga",
    "basket_page_needHelp": "¿Necesita ayuda?",
    "checkout_multi_paymentMethod_addPaymentDetails_billingAddress": "Dirección de facturación",
    "text_account_paymentDetails_paymentCard": "Tarjeta de pago",
    "general_delete_button": "Eliminar",
    "text_account_savedCart_savedCartBreadcrumb": "Carrito guardado {0}",
    "text_account_quote_action_display_REJECT": "Rechazar cotización",
    "basket_cartpage_pos": "Punto de venta (Poin of sale, POS)",
    "cart_page_reqdelivery": "Fecha de entrega requerida",
    "text_account_paymentDetails_delete_popup_title": "Eliminar Pago",
    "text_headline_productinfo": "Haga clic para obtener más información sobre la descripción general del producto, comentarios del producto o el método de entrega",
    "text_account_orderHistory_page_sort_byOrderNumber": "Número de pedido",
    "text_reports_summaryEmea": "All activity for the month by group at a high level",
    "text_account_quote_page_currentPage": "Página {0} de {1}",
    "storeFinder_viewMap": "Ver mapa",
    "text_headline_orderinfo": "Toda la información sobre la dirección de entrega, método de entrega y método de pago",
    "checkout_order_purchaseOrderNumber_label_EMEA": "# de referencia del cliente:",
    "search_page_firstPage": "&laquo;",
    "storefinder_searchterm_invalid": "Ingrese el término de búsqueda o el código postal",
    "checkout_pickup_confirm_and_continue": "Simplemente confirme la información a continuación y continúe con el siguiente paso de pago.",
    "text_account_warranty_table_header_reason": "Motivo del rechazo",
    "checkout_multi_paymentMethod_savedCards_selectSavedCardOrEnterNew": "Seleccione los detalles de pago existentes o ingrese detalles de pago nuevos",
    "basket_save_cart": "Guardar carrito",
    "checkout_multi_deliveryAddress_stepHeader_done": "1 - Dirección de entrega",
    "basket_quick_order_error": "No se agregaron {0} productos al carrito, revise los errores en la página de pedidos rápidos",
    "text_component_message_underconstruction": "<strong> Información: </strong> Componente en construcción, no completamente funcional",
    "fork_lift_required": "Carretilla elevadora necesaria? *",
    "text_account_paymentDetails_delete": "Eliminar",
    "text_account_core_search_total": "Totalt",
    "text_copyright": "&copy; 2016 hybris software",
    "text_account_quote_action_display_SUBMIT": "Enviar cotización",
    "text_account_table_header_status": "Estado del pedido",
    "review_comment_invalid": "Ingrese una descripción",
    "pickup_back_to_product_page": "&lt; Volver a la página del producto",
    "text_warranty_submit_quantity_invalid": "Please enter a valid Quantity",
    "text_voucher_apply_button_label": "Aplicar",
    "product_volumePrices_column_qa": "Cantidad",
    "checkout_error_paymentethod_formentry_sop_invalid_card_expirationYear": "El año de vencimiento no es válido.",
    "text_account_manageQuotes_breadcrumb": "Cotizaciones",
    "text_productHierarchy": "Jerarquía del productot",
    "account_confirmation_close_title": "Su cuenta ha sido cerrada.",
    "text_account_order_pickup_location": "Lugar de retiro",
    "text_user_table_unlock_user_account": "Desbloquear cuenta de usuario",
    "basket_export_user_company": "Empresa",
    "text_account_quote_email": "E-Mail",
    "text_account_order_consignment_status_readyforpickup": "Retirar por tienda",
    "download_start_download_button_text": "start download",
    "text_headline_productcategories": "Categorías de producto",
    "import_csv_savedCart_quantity": "Cantidad",
    "text_attn": "ATENCIÓN:",
    "checkout_summary_placeOrder_readTermsAndConditions_close": "Cerrar",
    "profile_lastName": "Apellido",
    "register_firstName": "Nombre*",
    "product_na_meta_description": "Bendix Commercial Vehicle Systems offers a complete line of air compressors, valves, ABS, stability systems, driver assistance systems, air dryers, plus air disc and drum brakes",
    "checkout_pickup_items_at_one_location": "Todos los artículos en su pedido seleccionado para retirar por tiendas están disponibles actualmente en estas tiendas:",
    "open_total_usd_NA": "Abierto Total dólares de los EE.UU. (United States dollars, USD)",
    "mycompany_click_edit_user": "Haga clic para editar los detalles de los usuarios",
    "text_account_quote_status_display_BUYER_SUBMITTED": "Enviado",
    "text_quote_previous_estimated_total_display": "Total estimado anterior",
    "text_warranty_submit_part_nature_defect": "Explicar la naturaleza del defecto *",
    "text_warranty_submit_part_nature_defect_na": "Explicar la naturaleza del defecto *",
    "text_quickOrder_product_not_purchaseable": "El producto no se puede comprar. Ingrese otro código de artículo",
    "register_checkbox_coworker_label": "Mostrar pedidos de compañeros de trabajo",
    "text_headline_findstore": "Encuentre su tienda",
    "quote_name_invalid": "Ingrese un nombre válido",
    "text_account_quote_status_display_CANCELLED": "Cancelado",
    "text_account_orderHistory_page_currentPage": "Página {0} de {1}",
    "text_core_submission_review_emea": "Revise todas sus entradas en este formulario. Una vez que se envíe no se pueden realizar más cambios en la solicitud de devolución.",
    "text_account_orderHistory_page_lastPage": "&raquo;",
    "listPrice_check": "Precio de lista",
    "order_history_total": "Totalt",
    "header_hello": "Hola",
    "quote_requote": "Cotizar de nuevo",
    "text_javascript_disabled": "Se requiere JavaScript para acceder a la página. Por favor, active JavaScript.",
    "basket_page_listprice": "Precio de lista",
    "text_account_savedCart_back_to_saved_cart": "Regresar a carritos guardados",
    "search_nav_facetShowMore_style": "más estilos...",
    "register_company_countryState": "Estado*",
    "checkout_orderConfirmation_Billing_Address": "Dirección de facturación",
    "text_account_quote_total": "Total",
    "checkout_error_paymentethod_formentry_sop_missing_card_startYear": "Ingrese un año de emisión",
    "text_account_core_search_linkNextPage": "Página siguiente",
    "text_consent_dpr": "declaración de protección",
    "product_grid_quantityText": "Cantidad",
    "checkout_summary_deliveryAddress_useThisAddress": "Usar esta dirección",
    "address_regionIso_prefecture": "Prefectura",
    "mobile_checkout_paymentMethod_add_card": "Agregar nueva tarjeta",
    "checkout_multi_paymentMethod_addPaymentDetails_useSavedCard_description": "Los clientes registrados pueden seleccionar una tarjeta guardada previamente",
    "basket_information_quantity_reducedNumberOfItemsAdded_nextDeliveryUnit": "La cantidad ingresada para el número de pieza {1} cambió debido a restricciones de tamaño de paquete.",
    "coupon_not_active_expired": "El código de cupón ingresado ya no es válido.",
    "text_notproduct_found_message": "No se ha encontrado ningún producto.",
    "checkout_multi_paymentMethod_savedCards_noExistingSavedCards": "No tiene ninguna tarjeta guardada",
    "import_csv_savedCart_fileMaxSizeExceeded": "El archivo es demasiado grande.",
    "text_account_orderHistory_page_sort_byCode": "Order No-Asc",
    "pickup_buy_online_message": "Compre sus productos ahora y retírelos más tarde en la tienda.",
    "fselect_pageAddUserPlaceholder": "Buscar un ID de cliente, nombre de la empresa, o dirección",
    "text_account_order_orderPlaced": "Colocado en {0}",
    "text_view": "Vert",
    "text_deviceCode": "Código de dispositivott",
    "text_warranty_view_max_mb": "(máx. 9.00 MB)",
    "quickorder_checkbox_not_selected_text": "Casilla de verificación no seleccionada",
    "text_account_order_unconsignedEntry_status_pending": "Pendiente",
    "text_account_savedcart_to_activecart": "El siguiente carrito guardado será restaurado como carrito activo",
    "text_account_kbpartNumber": "Número de pieza del Bendix/Número de pieza del cliente",
    "text_account_order_warning_storePickUpItems": "Recordatorio: retire sus artículos pronto.",
    "cart_page_checkout_yes": "Sí",
    "text_account_quote_status_display_BUYER_APPROVED": "Aprobado",
    "text_account_core_search_sortTitle": "Ordenar por:",
    "text_warranty_tag_serial_number": "Número de serie de garantía de aire total (Total Air Guarantee, T.A.G.)",
    "checkout_pickup_items_available_at_one_location": "SUS ARTÍCULOS PARA RETIRAR POR TIENDA ESTÁN DISPONIBLES EN UNA UBICACIÓN (no afecta la entrega de pedidos)",
    "basket_restoration_noStock": "Lamentablemente, <a href",
    "quote_create": "Request a Quote",
    "search_page_product_cross_reference_emea": "Referencia cruzada",
    "pickup_mobile_back_to_product_page": "Volver a la página del producto",
    "basket_page_id": "Identificación del artículo",
    "search_page_product": "Producto",
    "search_Results_previousPage_link": "Anterior",
    "search_page_lastPage": "&raquo;",
    "text_expresscheckout_title": "Benefíciese de un pago más rápido al:",
    "basket_error_quantity_invalid": "Proporcione un número positivo para actualizar la cantidad de un artículo.",
    "text_account_order_orderNumber": "Su número de pedido es {0}",
    "text_hideFacet": "Ocultar procesamiento",
    "search_page_linkNextPage": "Página siguiente",
    "text_account_order_orderTotals": "Total del pedido",
    "order_order_totals": "Totales de pedidos",
    "fselect_defaultPlaceholder": "Select some options",
    "product_variants_in_stock": "En stock",
    "register_checkbox_updateMyPart_label": "Descargar/Cargar números de pieza propios",
    "basket_page_shipping_pickup": "Retirar",
    "mobile_checkout_items_show": "Mostrar más artículos",
    "storeDetails_table_distanceFromSource": "{0} desde {1}",
    "text_headline_sortandrefine": "Ordenar y filtrar",
    "text_account_order_subtotal": "Subtotal:",
    "register_company_name": "Nombre de la empresa*",
    "cart_page_shop": "Tienda",
    "checkout_multi_deliveryMethod_deliveryOptions": "Opciones de entrega",
    "label_emea_sand": "SAND",
    "text_page_return": "O puede volver a nuestro.",
    "checkout_summary_deliveryMode_header": "Opciones de entrega",
    "text_headline_categories": "Haga clic aquí en el botón de menú para acceder a las categorías.",
    "search_page_pageSize_title": "Productos por página:",
    "text_core_submission_wghtCode": "(lbs)",
    "mycompany_delete_error_message": "No se puede eliminar ya que al menos uno vendido a debe estar vinculado",
    "basket_export_user_address2": "Dirección 2",
    "basket_export_user_address1": "Dirección 1",
    "checkout_multi_purchaseOrderNumber_label_EMEA": "Nro. de referencia del cliente",
    "search_no_results": "0 artículos encontrados para la palabra clave <strong> {0} </strong>",
    "product_variants_select_style": "Seleccione el estilo primero",
    "text_quote_edit_confirmation_message": "Esta cotización ha sido aprobada. La edición de esta cotización evitará el pago hasta que se aprueben las nuevas ediciones.",
    "checkout_multi_paymentMethod": "Dirección de pago y facturación",
    "text_country_selector_NA": "North America",
    "product_grid_readonly_qty": "CANT.",
    "text_warranty_vehicle_unit_number": "Número de vehículo / unidad",
    "basket_page_shipping_ship": "Enviar",
    "updatePwd_submit": "Actualizar",
    "core_error_b2bunit": "Please Select at least one Core Parent",
    "profile_email": "Nueva dirección de correo electrónico",
    "open_type_number": "Ingrese un número",
    "text_save_cart_title": "Guardar carrito",
    "register_new_customer": "Crear una cuenta",
    "text_header_menu": "Menú",
    "cart_page_requested": "Solicitado",
    "register_company_countryCode": "País*",
    "text_companyRegistrationRequest_heading": "Solicitudes de registro",
    "basket_save_cart_validation_name_charset": "El nombre del carrito solo puede ser alfanumérico",
    "checkout_summary_paymentMethod_addPaymentDetails_paymentCard": "Tarjeta de pago",
    "quick_order_delivery_date": "Fecha de entrega",
    "text_account_addressBook_page_showPageResults": "Mostrar paginado",
    "cart_page_replaced": "Sustituido",
    "product_grid_future_tooltip_error": "Lo sentimos, pero no es posible recuperar los datos de disponibilidad futura en este momento. Inténtelo más tarde.",
    "payment_startDate_invalid": "La fecha de emisión debe preceder a la fecha de vencimiento",
    "basket_page_comment_menu": "Comentario",
    "text_core_submission_memo": "(Número de devolución de cascos)",
    "product_product_details": "Detalles del producto",
    "quote_reject_success": "Cotización rechazada con éxito.",
    "text_account_profile_updatePassword": "Utilice este formulario para actualizar la contraseña de su cuenta",
    "checkout_multi_paymentMethod_savedCards_enterNewPaymentDetails": "Ingrese detalles de pago nuevos",
    "core_submit_warranty_certify_check": "I certify that the cores on this CRM have been removed from trucks and/or heavy-duty vehicles in the territory of Canada.",
    "text_core_submit_address_addressLName": "Apellido",
    "text_account_quote_page_sort_byDate": "Fecha actualizada",
    "text_account_quote_status_display_SELLERAPPROVER_REJECTED": "Rechazado",
    "text_account_quote_status_display_BUYER_REJECTED": "Rechazado",
    "checkout_summary_deliveryAddress_selectExistingAddress": "Seleccionar dirección existente",
    "cart_page_estdeliveryApac": "Est Departure Date",
    "text_subcategories_label": "Categoría",
    "checkout_checkout_multi_pci-ws": "PCI-Predeterminado",
    "mycompany_active_user": "Usuario Activo - pulsar para el bloqueo de usuario",
    "text_storefinder_mobile_page_currentPage": "{0} de {1}",
    "basket_page_quote_discounts": "Descuento de cotización:",
    "basket_export_cart_item_name": "Nombre",
    "text_account_savedcart_numberofpositions": "Number of Positions",
    "warranty_eligibility_check_submit": "Enviar",
    "text_quickOrder_product_code_invalid": "Código de producto inválido",
    "checkout_multi_sop_savePaymentInfo": "Guardar información de pago",
    "search_nav_facetShowLess_style": "menos estilos...",
    "cart_checkout": "PAGOt",
    "text_storefinder_responsive_page_linkPreviousPage": "Anterior",
    "search_nav_facetShowLess": "Ver menos",
    "globle_weekendDate": "¡Fin de semana! Seleccione otra fecha",
    "text_account_core_search_totalResultsCurrPage": "Mostrando {0} de {1} resultados",
    "product_image_zoom_in": "Haga clic para ampliar",
    "text_quote_cancel_button_label": "Cancelar",
    "checkout_multi_deliveryAddress_addAddress": "Agregar nueva dirección",
    "payment_cvn": "Número de verificación de tarjeta",
    "product_variants_out_of_stock": "Agotado",
    "checkout_multi_deliveryAddress": "Lugar de envío / retiro",
    "text_account_core_search_totalResults": "{0} New Result(s) found",
    "storeFinder_findStoresNearMe": "Encontrar tiendas",
    "text_connect": "Conectar",
    "text_account_savedCart_restore": "Restaurar",
    "text_account_warranty_table_header_decision": "Decision",
    "account_confirmation_payment_details_removed": "Sus detalles de pago fueron eliminados.",
    "product_product_details_more": "Más detalles del producto",
    "text_account_profile_createnewuser": "Crear nueva cuenta de usuario",
    "globle_notLessThanToday": "The Date must not less than today's date",
    "checkout_summary_reviewYourOrderMessage": "¡Revise su pedido cuidadosamente!",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_lastName": "Ingrese un valor para este campo",
    "pdp_page_generaltab_soldinmultipleof": "Vendido en múltiplos de",
    "label_emea_b9nd": "B9ND",
    "order_history_status": "Order Status:",
    "checkout_error_payment_not_accepted": "Su pago fue rechazado. Verifique que los detalles de su pago sean correctos.",
    "checkout_pickup_items_simplify_pickup_location": "Me gustaría cambiar mi pedido para retirar todos mis artículos en la misma tienda",
    "text_account_myCore": "Mis básicos",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_postalCode": "Ingrese un valor para este campo",
    "checkout_error_paymentethod_formentry_sop_invalid_shipTo_firstName": "Este valor no es válido para este campo.",
    "text_account_orderHistory_page_sort_byOpenQtyDesc": "Open Qty-Desc",
    "account_confirmation_password_updated": "¡Éxito! Ahora puede ingresar con su nueva contraseña.",
    "login_error_invalidSalesArea": "No tiene autorización para iniciar sesióntt",
    "general_month_november": "Noviembre",
    "register_state_invalid": "Seleccione un estado",
    "text_warranty_dealer_code": "Resultado del código de distribuidor",
    "text_quickOrder_header": "Pedido rápido",
    "text_account_quote_status_display_SELLERAPPROVER_APPROVED": "Aprobado",
    "text_core_submit_address_addressFName": "Nombre",
    "form_empty_select": "Seleccione",
    "text_account_quote_msg3": "Nota: No puede deshacer esta eliminación",
    "text_account_quote_msg4": "Haga clic para modificar la información del usuario",
    "quote_description_invalid": "La descripción no puede tener más de 255 caracteres.",
    "order_history_delivery_type": "Tipo de entrega",
    "text_account_quote_msg1": "Eliminar una cuenta de usuario",
    "checkout_summary_paymentMethod_addPaymentDetails_enterDifferentBillingAddress": "Ingresar una dirección de facturación diferente",
    "text_account_closeAccount_header": "Acerca de cerrar su cuenta",
    "text_account_quote_msg2": "¿Está seguro de que desea eliminar la siguiente cuenta de usuario?",
    "order_total": "Total",
    "text_account_quote_msg5": "Usuario bloqueado: haga clic para activar",
    "Please": "carefully check each request and either edit and approve it, or decline it.",
    "registration_confirmation_message_subtitle": "Revise su bandeja de entrada para verificar su dirección de correo electrónico.",
    "mobile_multi_checkout_selectExistingCard": "Elija entre los detalles de pago existentes",
    "text_account_order_title_storePickUpItems": "Artículos para retirar por tienda",
    "text_quote_discount_rate_null_error": "La tasa de descuento es nula.",
    "address_street": "Nombre de calle con número de calle",
    "checkout_error_paymentethod_formentry_sop_invalid_shipTo_city": "Este valor no es válido para este campo.",
    "login_error_account_not_found_subtitle": "Si olvidó su contraseña, utilice el enlace de contraseña olvidada.",
    "text_storefinder_mobile_page_linkPreviousPage": "&laquo; Anterior",
    "text_headline_vmrs": "Normas del informe de mantenimiento del vehículot",
    "text_account_order_min_EMEA": "Cargo mínimo de pedido:",
    "text_account_addressBook_page_totalResultsCurrPage": "{0} of {1} Direcciones guardadas",
    "text_warranty_submit_requestedPartAmount_invalid": "Please enter a valid Requested Handling Amount",
    "checkout_placeOrder_failed": "Error al realizar el pedido",
    "address_error_formentry_invalid": "Se encontraron errores en la dirección que proporcionó. Verifique los errores que se muestran a continuación y vuelva a enviar su dirección.",
    "checkout_summary_paymentMethod_header": "Detalles de pago.",
    "cart_page_continue": "Seguir comprando",
    "text_account_addressBook_page_totalResultsSingleOrder": "1 Direcciones",
    "text_consent_email": "Ingrese su dirección de correo electrónico",
    "text_account_consent_given": "Su consentimiento ha sido otorgado",
    "text_warranty_submit_part_quantity": "Cantidad*",
    "basket_page_message_update_reducedNumberOfItemsAdded_lowStock": "Se ha cambiado la cantidad ingresada en el número de posición {4} para el número de pieza {5} debido a restricciones de tamaño de paquete.",
    "text_warranty_submit_vehicle_information": "Información del vehículo",
    "text_dates_difference_error": "¡Por favor, limite la fecha a un máximo de 365 días!",
    "type_of_packaging": "Tipo de embalaje",
    "basket_cartpage_partNo": "Pieza nro.",
    "text_storefinder_responsive_page_totalResults": "1-10 de {0} tiendas encontradas",
    "basket_page_totals_deliverycountry": "Destino de entrega",
    "basket_export_user_state": "Estado",
    "address_postcodeJP_invalid": "Ingrese el código postal precedido por el símbolo postal",
    "text_account_orderHistory_orderStatus": "Estado del pedido",
    "text_account_quote_action_display_VIEW": "Ver cotización",
    "checkout_orderConfirmation_checkoutSuccessful": "Pago exitoso",
    "checkout_multi_deliveryAddress_notprovided": "Debe proporcionar una dirección de envío para ir al siguiente paso.",
    "product_product_details_future_qty": "CANT.",
    "text_CloseMyAccount_label": "Cerrar mi cuenta",
    "text_account_order_shipto": "Enviar a",
    "text_vmrsCode": "Código VMRS (Vehicle Maintenance Reporting Standards)t",
    "checkout_page_delivery_address_emergency": "Agregar nueva dirección (solo pedidos de emergencia)",
    "text_cust_ref_no": "Item Ref No.",
    "account_error_account_exists_with_email_address_title": "Ya existe una cuenta para esta dirección de correo electrónico {0}",
    "text_quote_cancel_confirmation_message": "¿Seguro que quiere cancelar esta cotización?",
    "form_field_required": "Obligatorio",
    "label_emea_emgy": "Pedido urgente",
    "checkout_multi_shipment_items": "Envío - {0} Artículos",
    "text_account_order_title_details": "Detalles del pedido",
    "password_strength_veryweak": "Muy débil",
    "text_account_table_header_date": "Fecha de orden",
    "breadcrumb_cart": "Carrito",
    "text_link_home_label": "Inicio",
    "checkout_multi_deliveryAddress_select": "Seleccionar",
    "basket_restoration_view_cart_btn": "Ver carrito",
    "text_generalInfo_description": "Descripción",
    "checkout_summary_paymentMethod_addPaymentDetails_saveAndUseThesePaymentDetails": "Guardar y usar estos detalles de pago",
    "text_warranty_submit_part_scale_emea": "Escala",
    "general_month_may": "Mayo",
    "basket_save_cart_validation_name_size": "El nombre del carrito no puede tener más de 255 caracteres.",
    "basket_configure_product": "Configurar",
    "orderHistory_page_totalResults": "de {0} pedidos",
    "text_account_addressBook_manageDeliveryAddresses": "Gestione su dirección de entrega",
    "checkout_summary_deliveryAddress_edit": "Editar",
    "checkout_error_paymentethod_formentry_sop_missing_card_startMonth": "Ingrese un mes de emisión",
    "quote_enter_comment": "Agregue un comentario y presione enter",
    "text_addToCart": "Añadir a la cesta",
    "text_account_order_title_inProgressItems": "Artículos pedidos en progreso",
    "text_core_submit_address_addressEmail": "Email",
    "import_csv_savedCart_fileRequired": "El archivo no puede estar vacío.",
    "cart_page_merge_message": "You have multiple positions in the cart with same part number and requested delivery date which will be merged on checkout, do you wish to proceed?",
    "text_headline_additional": "Información adicional",
    "text_account_table_header_type": "Tipo de orden",
    "quote_cart_insufficient_access_rights_error": "Permisos de acceso insuficientes para el carrito {0}.",
    "pdp_page_netprice": "Precio neto",
    "quote_edit_locked": "Identificación de cotización: {0} está siendo editado actualmente por {1}",
    "storeDetails_table_address": "Dirección",
    "text_account_orderHistory_mobile_page_linkNextPage": "Siguiente &raquo;",
    "text_account_quote_status_display_BUYER_OFFER": "Cotización del proveedor",
    "text_storefinder_mobile_page_noResults": "No hay resultados para su área.",
    "text_core_submission_upgrade": "Actualizar",
    "text_account_profile_changePassword": "Cambiar su contraseña",
    "text_voucher_apply_applied_success": "El {0} se ha aplicado con éxito",
    "search_page_currentPage": "Página {0} de {1}",
    "search_nav_facetShowLess_collection": "menos colecciones...",
    "import_csv_savedCart_requestedDateApac": "Optional : Requested delivery date (format YYYY/MM/DD)",
    "checkout_summary_placeOrder": "Compra",
    "basket_information_quantity_noItemsAdded_maxOrderQuantityExceeded": "Lamentablemente, la cantidad que eligió superó la cantidad máxima de pedido para este producto.",
    "text_account_saveCart_edit_error": "Hubo un irregularidad al actualizar el carrito {0}",
    "breadcrumb_quote_view": "Cotizar {0}",
    "basket_export_user_industryRole": "Rol de la industria",
    "search_nav_facetShowLess_colour": "menos colores...",
    "checkout_paymentMethod_createSubscription_failed": "No se pudo crear la suscripción. Verifique los valores ingresados.",
    "text_quote_checkout_warning_message": "Modificar el carrito puede anular la cotización del proveedor.",
    "checkout_express_error_notAvailable": "El pago exprés no está disponible debido a que está deshabilitado.",
    "basket_page_update": "Actualizar",
    "text_account_quote_status_display_BUYER_ACCEPTED": "Aceptado",
    "pickup_pagination_first": "Primero",
    "text_loadingMessage": "Cargando...",
    "register_checkbox_net_label": "Precio neto",
    "text_account_core_search": "Mostrar todo",
    "product_view_more": "Más >",
    "text_consent_accept": "Acepte el aviso de privacidad y la cláusula de exención de responsabilidades de descarga",
    "product_variants_update": "actualizar",
    "text_account_profile_updateEmailAddress": "Ingrese su nueva dirección de correo electrónico y confirme con su contraseña",
    "pickup_product_by_store_location": "Producto por ubicación de tienda",
    "text_quote_conteroffer_confirmation_modal_title": "¿Confirmar cotización de proveedor {0}?",
    "basket_export_cart_error": "Hubo un irregularidad al exportar el carrito",
    "account_confirmation_signout_subtitle": "Su carrito de compras lo estará esperando cuando vuelva a iniciar sesión.",
    "checkout_multi_sop_useThisPaymentInfo": "Usar esta información de pago",
    "checkout_multi_paymentMethod_addPaymentDetails_paymentCard": "Detalles de la tarjeta",
    "checkout_error_paymentethod_formentry_sop_missing_shipTo_lastName": "Ingrese un valor para este campo",
    "review_headline_invalid": "Ingrese un título",
    "text_core_submit_address_requestedTime": "Horas disponibles de recogida: *",
    "text_core_submit_address_city": "Ciudad*",
    "basket_page_viewFuture_not_multisku": "El código seleccionado {0} no es un producto multidimensional.",
    "text_core_submit_itemQty_invalid": "Obligatorio",
    "checkout_error_paymentethod_formentry_sop_missing_shipTo_state": "Ingrese un valor para este campo",
    "checkout_express_error_deliveryMode": "El pago exprés no está disponible Se produjo un error al configurar el modo de entrega.",
    "review_write_title": "Escriba un comentario",
    "text_quickorder_template": "Plantilla de importe de pedido",
    "text_productreviews": "Comentarios",
    "quote_more_comments": "Ver más comentarios",
    "forgottenPwd_submit": "Enviar correo electrónico",
    "import_csv_savedCart_success": "Cada línea se pudo subir con éxito sin ningún error.",
    "address_furtherSubarea_invalid": "Ingrese el número de subárea adicional",
    "text_consent_button_accept": "OK",
    "checkout_multi_deliveryMethod_useThisDeliveryMethod": "Usar método de entrega seleccionado",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_firstName": "Ingrese un valor para este campo",
    "guest_checkPwd": "Confirmar contraseña*",
    "mycompany_user_delete_account": "Eliminar una cuenta de usuario",
    "checkout_page_summary_deliveryMode_selectDeliveryMethodForOrder_NA_error": "Seleccione un transportista para completar el proceso de pago.",
    "text_companyRegistrationRequest_content": "Va a encontrar más adelante, en el resumen, todas las solicitudes de registro de los empleados de su empresa que ya han solicitado el registro.Por favor revise cuidadosamente cada solicitud y, o bien edítelo para aprobarlo o rechazarlo.",
    "text_storefinder_desktop_page_lastPage": "&raquo;",
    "checkout_orderConfirmation_coupon_code": "Use el código de cupón: {0}",
    "register_company_address_zip_invalid": "Ingrese el código postal de la empresat",
    "select_collection_address_pdf": "Collection Address",
    "quote_edit": "Editar cotización",
    "text_account_selectSalesarea": "¿A qué área de ventas quiere acceder?t",
    "basket_validation_entryGroupError": "Uno de los grupos de entrada tiene errores que deben corregirse antes de proceder al pago.",
    "basket_page_totals_error_wrongcountry": "Seleccione un país / región",
    "forgottenPwd_title": "Restablecer contraseña",
    "text_account_orderHistory_viewOrders": "Ver su historial de pedidos",
    "register_termsOfUsage_accept": "Acepto elt",
    "order_history_status_details": "Detalles del estado del pedido",
    "checkout_multi_deliveryAddress_edit": "Editar",
    "guest_register": "Crear una cuenta",
    "checkout_page_summary_deliveryMode_selectDeliveryMethodForOrder_EMEA_error": "Seleccione un tipo de entrega para completar el proceso de pago.",
    "text_search": "Buscart",
    "checkout_multi_deliveryAddress_breadcrumb": "Lugar de envío / retiro",
    "text_account_savedCart_title_details": "Detalles del carrito guardado",
    "text_myaccount_orderHistory": "&laquo; Historial de pedido",
    "text_warranty_submit_part_requestedHandlingAmount": "Monto de la manipulación solicitada",
    "text_core_Ship-to_pdf": "Ship-to",
    "checkout_multi_paymentMethod_savedCards_select": "Seleccionar",
    "text_warranty_terms_cement_mixer": "Mezclador de cemento",
    "checkout_multi_paymentMethod_paymentDetails_expires": "Caduca {0} / {1}",
    "cart_page_title": "Su carrito de comprat",
    "product_grid_futurestock_hidefuture_availability": "Ocultar disponibilidad futura",
    "text_country_selector_MENA": "Middle East & Africa",
    "updatePwd_checkPwd_invalid": "Confirme su contraseña",
    "storeFinder_stores_nearby": "Tiendas cercanas",
    "warranty_duplicatePartNo": "La referencia ya se utiliza.",
    "register_checkbox_core_label": "Cargo del nucleo",
    "basket_page_packing_qty": "Vendido en múltiplos de",
    "coupon_already_redeemed": "El código de cupón ingresado ya ha sido canjeado.",
    "text_account_warranty_page_totalResults": "{0} reclamos encontrados",
    "storeFinder_meta_description_results": "tiendas ubicadas cerca de",
    "basket_validation_lowStock": "Lamentablemente, se guardó una cantidad menor de <a href",
    "text_quote_dateformat_datepicker_selection_hint": "dd/mm/aaaa",
    "text_account_orderHistory_back": "Regresar",
    "text_account_openPosition_emptyPositions": "No se encontraron posiciones abiertas",
    "text_account_savedCarts_page_sort_byDateModified": "Fecha modificada",
    "product_product_details_future_quantity": "Cantidad",
    "text_account_orderHistory_datePlaced": "Fecha seleccionada",
    "quick_order_page_alert_order_type_change": "Las fechas se han revisado según el tipo de pedido.",
    "order_date_from": "Fecha de pedido hasta *",
    "text_warranty_cahssis_number": "Número de chasis",
    "text_account_core_breadcrumbNA": "Centro de información básica de Bendix",
    "text_core_submission_coregrade": "Grado básico",
    "checkout_summary_select_payment_method": "Seleccionar método de pago",
    "text_company_users": "Los usuarios de la empresa",
    "text_quote_expiration_time_invalid": "Ingrese una fecha de caducidad válida",
    "text_language": "Seleccione el idiomat",
    "basket_page_totals_estimatedtotaltax": "Impuesto estimado:",
    "search_nav_facetShowMore_category": "más categorías...",
    "text_warranty_terms_dump_truck": "Camión de volteo",
    "text_generalInfo_dimension": "Dimensiones (largo x ancho x alto)",
    "text_headertext_error": "Errores",
    "error_account_myPart_template_format_confirm_msg": "El archivo seleccionado no tiene el formato correcto, ¿desea continuar?",
    "user_diaabled_invalid_msg": "Esta cuenta de usuario se ha cerrado, comuníquese con su administrador",
    "basket_error_admin_missing": "Cannot access the requested url ,as login customer does not belongs to admin group",
    "type_of_packaging_select": "Por favor seleccione",
    "text_warranty_shipping_packaging_tab_part_return": "Part Return Shipping Instruction:",
    "text_warranty_shipping_packaging_tab_product_claim": "Product claimed to be defective must be returned freight prepaid (Freight paid by the sender) via the Original Equipment (OE) dealership or authorized Bendix distributor within thirty (30) days after the date any defect is first discovered.",
    "text_warranty_shipping_packaging_tab__address": "Address to the Bendix Warranty Claim Center indicated below. Please be sure that \"Bendix Warranty Center\" and Warranty Claim number is clearly marked on the package.",
    "text_warranty_shipping_packaging_tab_us_address": "In the US, ship freight PRE-PAID to:",
    "text_warranty_shipping_packaging_tab_us_address_bendix": "Bendix Warranty Center",
    "text_warranty_shipping_packaging_tab_us_address_bendix_line1": "1155 East Franklin Street",
    "text_warranty_shipping_packaging_tab_us_address_bendix_line2": "Huntington, Indiana 46750",
    "text_warranty_shipping_packaging_tab_canada_address": "In Canada, ship freight PRE-PAID to:",
    "text_warranty_shipping_packaging_tab_canada_address_bendix": "Bendix Commercial Vehicle Systems Warranty Center",
    "text_warranty_shipping_packaging_tab_canada_address_bendix_line1": "8851 Crescent 4",
    "text_warranty_shipping_packaging_tab_canada_address_bendix_line2": "Anjou, Quebec H1J 1A9",
    "register_company_additionalSoldToLocations": "Ubicaciones adicionales",
    "heading_dtc_description": "DTC Description",
    "heading_service_data_sheet": "Service Data Sheet",
    "heading_dtc_search": "DTC Search",
    "dtc_go_btn": "Go",
    "homepage_teaser_name_fanclutches": "Fan Clutches",
    "homepage_teaser_name_StartersAlternators": "Starters and Alternators",
    "homepage_teaser_name_WorkshopTools": "Workshop Tools",
    "homepage_teaser_name_BrakePadFinder": "Brake Pad Finder",
    "homepage_teaser_name_EconX": "EconX®",
    "homepage_teaser_name_AirDryerCartridges": "Air Dryer Cartridges",
    "homepage_teaser_name_Compressors": "Compressors",
    "homepage_teaser_name_Contacts": "Contacts",
    "homepage_teaser_name_Filters": "Filters",
    "delete_all_no_text_label": "No",
    "na_help_title": "Centro de ayuda de Bendix",
    "na_welcome_to_help_center": "Bienvenido al Centro de ayuda de Bendix",
    "na_customer_text": "Como cliente, podrá ver todos los documentos de ayuda e instrucciones que le ayudarán a navegar por el sitio web.",
    "na_click_the_following_text": "Haga clic en las siguientes guías prácticas o busque palabras clave relacionadas con su solicitud",
    "na_search_placeholder": "Ingrese la palabra clave aquí",
    "na_help_search_button": "Buscar",
    "how_to_read_the_privacy": "Cómo leer la declaración de privacidad y de \"cookies“",
    "how_to_register_for_an_online_mx": "Cómo registrase en B2Bendix.com",
    "how_to_close_my_account": "Cómo cerrar mi cuenta",
    "how_to_export_my_data": "Cómo exportar mis datos",
    "how_to_rest_your_password": "Cómo restablecer su contraseña",
    "how_to_search_open_line": "Cómo buscar el estado de posición de línea abierta",
    "how_to_search_order_status": "Cómo buscar el estado del pedido",
    "how_to_use_the_order_import": "Cómo utilizar la plantilla de pedido de importación",
    "how_to_use_the_quick_order": "Cómo utilizar el formulario de pedido rápido",
    "text_orderimport_error_allotherlines_message": "Todas las demás líneas se cargaron correctamente en el carrito de compras.",
    "text_orderimport_error_errorinline_message": "Error en la línea",
    "text_orderimport_error_invaliddateformat_message": "Formato de fecha incorrecto para la fecha de entrega solicitada, por favor cámbielo a&nbsp",
    "text_orderimport_error_invalidcsvformat_message": "&nbspSeparador csv incorrecto, por favor cámbielo a&nbsp",
    "text_orderimport_error_notvalidornotfound_message": "&nbspNo válido/no encontrado.",
    "text_orderimport_error_partno_message": "&nbspNº de pieza&nbsp",
    "text_orderimport_error_tryagainorcontact_message": "&nbspInténtelo de nuevo o póngase en contacto con<a target",
    "text_orderimport_error_customerservice_message": "'> Servicio al clientet</a>",
    "text_orderimport_error_notpurchasable_message": "&nbspno se puede comprar y no se cargó",
    "text_orderimport_error_pleasecheck_message": "&nbsppor favor verifique  <a href ",
    "text_orderimport_error_notpurchasable1_message": "&nbspEl Nº de pieza o la cantidad no pueden star en blanco",
    "text_orderimport_error_deliverydate_message": "&nbspFecha de entrega solicitada para el Nº de pieza&nbsp",
    "text_orderimport_error_deliverydate1_message": "&nbspno puede estar en el pasado.",
    "text_orderimport_error_obsolete_message": "&nbspestá obsoleto y no se cargó, por favor verifique  <a href ",
    "text_orderimport_error_obsolete1_message": "'> Página de detalles del producto </a> para obtener más información.",
    "text_orderimport_error_semicolon_message": "punto y coma",
    "text_orderimport_error_comma_message": "coma",
    "text_dimension_width": "Anchura",
    "text_dimension_height": "Altura",
    "checkout_error_payment_address_empty": "Su solicitud no puede ser procesada, comuníquese con el servicio al cliente.",
    "text_saved_cart_qty_label": "Cant.:",
    "document_text_language": "Language : ",
    "document_video_launch_btn": "Iniciar vídeo",
    "document_text_releaseDate": "Fecha de la versión : ",
    "text_account_warranty_table_header_inspection_report": "Inspection Report",
    "ppd_freight_greater_than_subtotal_info": "Your cart total (exclude core charges) is {0} {1}. You can qualify for prepaid freight if you add {2} {1} worth of parts to your cart.",
    "text_account_document_favorite_totalResults": " documentos encontrados",
    "DEALER_ADB": "Formulario de solicitud de aplicación del freno",
    "text_account_document_favorite_table_doc_description": "Descripción del documento",
    "text_account_document_favorite_table_doc_number": "Número del documento",
    "text_account_document_favorite_table_doc_rev": "Revisión del documento",
    "text_account_document_favorite_table_doc_type": "Tipo de documento",
    "document_library_text_document": "Biblioteca de documentos",
    "document_download_btn": "Descargar documentos",
    "document_library_placeholder_text": "Ingrese el nombre o la descripción del documento",
    "text_breadcrumb_favorite_documents": "mis documentos favoritos",
    "text_account_document_favorite_heading": "Mis favoritos",
    "text_account_document_favorite_heading_NA": "Mis favoritos",
    "text_account_warranty_table_header_display_creditmemo_popup_content": "Comuníquese con sus oficinas corporativas para obtener detalles del pago. Todos los pagos de garantía se emiten a",
    "document_library_text_document_category": "Categoría del producto",
    "text_account_document_favorite_table_doc_language": "Traducción",
    "action_send_ticket_invite_confirm": "¿Está seguro de que desea mover CRM al boleto seleccionado?",
    "action_send_ticket_invite_sent_title": "Boleto movido a CRM.",
    "action_send_ticket_invite_error_title": "No se pudo mover CRM. Inténtelo más tarde.",
    "text_account_supporttickets_requestSupport": "Crear un boleto nuevo",
    "text_account_supporttickets_newticket": "Nuevo boleto",
    "text_account_supporttickets_search_ticketCategory_PSA": "Solicitud de Producto / Sistema",
    "text_account_supporttickets_search_ticketCategory_PSG": "Producto / Sistema (Información general)",
    "text_account_supporttickets_search_ticketCategory_TST": "Solución de problemas",
    "text_account_supporttickets_search_ticketCategory_SOther": "Soporte - Otro",
    "text_account_supporttickets_ticketType": "Tipo de boleto",
    "text_account_supporttickets_status_All": "Todos",
    "text_account_supporttickets_customerID": "Client ID",
    "text_account_supporttickets_status": "Statut",
    "text_account_supportTickets_page_totalResults_AllTickets": "{0} boletos encontrados",
    "supportticket_startDate_invalid": "Seleccione una fecha de inicio válida.",
    "supportticket_endDate_invalid": "Seleccione una fecha de finalización válida.",
    "text_account_supportticket_startDate": "Seleccione la fecha de inicio.",
    "text_account_search_to_date_invalid_future": "La fecha “Hasta” no puede ser futura.",
    "text_account_search_from_date_invalid_future": "La fecha “Desde” no puede ser futura.",
    "text_account_search_from_date_to_date_invalid": "La fecha “Desde” no puede ser mayor que la fecha del reclamo “Hasta”.",
    "text_account_search_to_date_invalid": "La fecha “Hasta” no puede ser menor que la fecha del reclamo “Desde”.",
    "text_account_supportticket_endDate": "Seleccione la fecha de finalización.",
    "text_account_supportticket_defaultSoldTo": "Seleccione CustomerID.",
    "text_account_supporttickets_createTicket_ticketCategory_ORDER": "Soporte para pedidos",
    "text_account_supporttickets_createTicket_ticketCategory_WARRANTY": "Soporte de garantía",
    "text_account_supporttickets_createTicket_ticketCategory_CORE": "Soporte básico",
    "text_account_supporttickets_createTicket_ticketCategory_SOTHER": "Soporte - Otro",
    "supportticket_category_invalid": "Ingrese una categoría válida",
    "supportticket_associatedTo_invalid": "Ingrese un asociado válido",
    "text_ADB_applicationNum": "Número de aplicación del freno*",
    "text_ADB_controlNumber": "Número de control de clientes",
    "text_ADB_axleManufacturer": "Fabricante del eje*",
    "text_ADB_oem": "Fabricante del equipo original (Original Equipment Manufacturer, OEM)*",
    "vehicleModel_code_value": "modelo del vehículo*",
    "text_ADB_vehicleType": "tipo de vehículo*",
    "text_ADB_chassisNumber": "Número de chasis*",
    "text_ADB_axleConfig": "Configuración del eje*",
    "text_ADB_vocation": "Uso*",
    "text_ADB_GAWR_Front": "Categoría del peso bruto del eje (gross axle weight rating, GAWR) frontal",
    "text_ADB_GAWR_Forward": "GAWR Delantero Posterior",
    "text_ADB_GAWR_Pusher": "GAWR Impulsor",
    "text_ADB_GAWR_Rear": "GAWR Posterior Posterior",
    "text_ADB_GAWR_Tag": "GAWR Etiqueta/Auxiliar",
    "text_ADB_Auxiliary_Axle": "Eje auxiliar",
    "text_ADB_GAWR_Mid_Rear": "GAWR Medio Posterior",
    "text_ADB_ADDITIONAL_AXLE": "GWMR del eje adicional",
    "text_ADB_Additional_Axle_Cust": "Limitación adicional del peso del eje del cliente",
    "text_ADB_tire_Type": "Tipo de neumático",
    "text_ADB_tire_TypeSLR": "Radio de carga estática del neumático (Statically Loaded Radius, SLR)",
    "text_ADB_gvwr": "Categoría del peso bruto del vehículo GVWR* (gross vehicle weight rating, GVWR)",
    "text_ADB_wheelBaseRange": "rango de distancia entre ejes*",
    "text_ADB_frontTires": "Neumáticos frontales*",
    "text_ADB_frontTiresSLR": "Radio estático cargado (Static loaded radius, SLR) del neumático frontal",
    "text_ADB_rearTire": "Neumático posterior*",
    "text_ADB_wheelBase": "Distancia entre ejes*",
    "text_ADB_cgHeightLaden": "Altura CG (cargada)*",
    "text_ADB_cgHeightUnladen": "Altura CG (descargada)*",
    "text_ADB_proposed_FR": "Frente Posterior Propuesto",
    "text_ADB_proposed_FM": "Frente Medio Propuesto",
    "text_ADB_proposed_SAB": "Frente Posterior Posterior Propuesto",
    "text_ADB_proposed_DAB": "Freno de eje de dirección propuesto",
    "text_ADB_please_note": "Nota importante:",
    "text_ADB_customer_information": "Información del cliente",
    "text_ADB_vehicle_information": "Información del vehículo:",
    "text_ADB_axle_gawr": "eje GAWR:",
    "text_ADB_add_an_aditional_axl_gawr": "Agregar un eje adicional GAWR:",
    "text_ADB_customer_axle_weight_limitation": "Limitación del peso del eje del cliente:",
    "text_ADB_add_aditional_customer_axle_weight_limitation": "Agregar limitación adicional del peso del eje del cliente:",
    "text_ADB_tire_statically_loaded_radius": "Radio de carga estática (SLR) del neumático",
    "text_ADB_vehicle_specification": "Especificaciones del vehículo",
    "text_ADB_proposed_tag_axle": "Eje propuesto de la etiqueta / Freno del eje auxiliar",
    "Bendix_break_application": "Formulario de solicitud de aplicación Bendix",
    "text_warranty_please_upload_all": "Cargue todos los documentos necesarios para procesar su formulario de solicitud de devolución.",
    "text_ADB_add_axel": "Agregar eje",
    "text_ADB_add_axel_cutomer": "Agregar eje del cliente",
    "text_ADB_tire_type": "Agregar tipo de neumático",
    "text_ADB_add_tire_slr": "Agregar SLR del neumático",
    "text_warranty_view_add_information": "Ver/Agregar",
    "text_break_submission_NA_text1": "Gracias por enviar el formulario de freno de disco neumático (Air Disc Brake, ADB).",
    "Bendix_break_application_msg1": "Este formulario se utilizará para enviar una solicitud de freno. Llene todos los campos y revise su formulario antes de enviarlo.",
    "Bendix_break_application_msg2": "Para obtener ayuda con respecto a cómo llenar este formulario, consulte el <a href='https://n0c357rmy1njbuit2friqwu.blob.core.windows.net/documents/OSMALy4oI0EBhB_Y497108_EN_000.pdf' target='_blank'> <b>PROCESO DEL FORMULARIO DE SOLICITUD DE FRENOS</b></a> para obtener más detalles",
    "text_bendix_search_text1": "Bendix ofrece a los clientes la posibilidad de buscar en línea el estado del formulario de solicitud de frenos. Puede buscar el envío de su formulario de solicitud de freno utilizando los siguientes criterios de búsqueda.",
    "text_bendix_search_text2": "Tenga en cuenta que la identificación del cliente y el rango de fechas son campos obligatorios.",
    "text_bendix_search_text3": "Búsqueda de formulario de solicitud de frenos",
    "text_ADB_rearTires": "Neumáticos posteriores*",
    "text_adb_submission_review_text": "Revise su formulario antes de enviarlo.",
    "text_account_warranty_claim_search": "Búsqueda de reclamos de garantía",
    "text_account_warranty_table_header_dsiplay_status": "Estado de reclamo",
    "text_account_warranty_claim_tracking_info": "Medio de devolución de piezas",
    "text_account_warranty_table_header_dsiplay_claim_number": "Puede abrir este reclamo presentado en formato PDF o en una plantilla nueva para crear un nuevo reclamo.",
    "text_account_warranty_table_header_dsiplay_claim_number_content": "El nuevo reclamo contendrá la misma información del vehículo que el reclamo original. Confirme que el número de identificación del vehículo (vehicle identification number, VIN) y la información de la solicitud sean correctos antes de enviarlos.",
    "text_account_warranty_table_header_dsiplay_claim_number_button_pdf": "Abrir reclamo como PDF",
    "text_account_warranty_table_header_dsiplay_claim_number_button_template": "Abrir reclamo como una plantilla nueva",
    "text_account_warranty_table_header_core_value": "Valor básico",
    "text_account_warranty_search_page_firstPage": "&laquo;",
    "search_page_product_cross_reference": "Referencia cruzada",
    "text_consent_read": "He leído el",
    "text_return_request_heading": "Formulario de solicitud de devolución",
    "text_return_request_po_number": "NRO. DE ORDEN DE COMPRA DEL CLIENTE*",
    "text_return_request_return_type": "Tipo de retorno*",
    "text_warranty_submit_kb_return_request_number": "Número de solicitud de devolución",
    "type_B2BCustomerAccessRequestEnum_CORE_REPORTS_name_oem": "N/A",
    "type_B2BCustomerAccessRequestEnum_CORE_REPORTS_name": "N/A",
    "text_account_order_tracking_ID": "ID de rastreo",
    "text_checkout_page_delivered_qty": "Cantidad entregada :",
    "text_ADB_add_aditional_customer_tire_type": "Tipo de neumático",
    "text_checkout_page_delivery_qty": "Cantidad de entrega:",
    "text_ticket_search_from_date": "Desde la fecha de inicio del entrenamiento",
    "text_ticket_search_to_date": "Hasta la fecha de finalización del entrenamiento",
    "text_account_supporttickets_createTicket_attachement_label": "Archivos adjuntos",
    "text_account_supporttickets_createTicket_no_attachement_label": "No se encontraron archivos adjuntos",
    "text_account_supporttickets_ticketIdAscending": "ID de ticket ascendente",
    "text_account_supporttickets_ticketIdDescending": "ID de ticket descendente",
    "text_account_supporttickets_categoryAscending": "Categoría ascendente",
    "text_account_supporttickets_categoryDescending": "Categoría descendente",
    "text_account_supporttickets_headlineAscending": "Asunto Ascendente",
    "text_account_supporttickets_headlineDescending": "Asunto descendente",
    "text_account_supporttickets_creationtimeAscending": "Fecha de creación ascendente",
    "text_account_supporttickets_creationtimeDescending": "Fecha de creación descendente",
    "text_account_supporttickets_modifiedtimeAscending": "Fecha de actualización ascendente",
    "text_account_supporttickets_modifiedtimeDescending": "Fecha de actualización Descendente",
    "text_account_supporttickets_stateAscending": "Estado ascendente",
    "text_account_supporttickets_stateDescending": "Estado descendente",
    "adb_approvalType_INREVIEW": "Revisión de Ing.",
    "adb_approvalType_RECEIVED": "Eng.Aprobado",
    "adb_approvalType_AWAITING": "Entrada requerida",
    "adb_approvalType_REJECTED": "Rechazado",
    "header_customer_channel_oem": "OEM",
    "header_customer_channel_distributor": "Distributor",
    "header_customer_channel_dealer": "Dealer",
    "header_customer_channel_service_new": "Service New",
    "text_company_manageUser_registration_zeroResults": "0 Nuevas solicitudes encontradas",
    "text_account_supporttickets_createTicket_ticketID": "Id de entradas",
    "account_adb_breadcrumbs": "Visite mi pagina",
    "text_request_search_bendix_adb_number": "Bendix ADB Número",
    "text_generalInfo_submitdate": "Fecha de creación",
    "text_core_search_appNumber": "Freno Número de aplicación",
    "text_headline_status": "estado",
    "text_ADB_brakeType": "Brake Tipo*",
    "text_ADB_approvalType": "Aprobación Tipo",
    "checkout_summary_adb_save": "Guardar",
    "addtional_comment_enginnering_admin": "Recomendaciones adicionales del equipo de ingeniería",
    "text_ADB_Comments": "Comentarios",
    "text_application_requestt": "Solicitudes de aplicación de frenos",
    "breadcrumb_bendixAdbCMSPage_text": "Aplicaciones de frenos",
    "text_application_request": "Formulario de solicitud de aplicación del freno",
    "text_productCompare_page_remove": "Eliminar",
    "text_account_supporttickets_tryLater": "Lo sentimos, hubo un problema. Vuelve a intentarlo más tarde.",
    "text_account_supporttickets_updateTicket_message_desc": "Actualiza un mensaje. Por favor, proporcione tanta información como sea posible.",
    "text_account_supporttickets_updateTicket_c4cMessage1": "Este ticket se mueve a Atención al cliente",
    "text_generalInfo_id": "ID",
    "text_account_supporttickets": "Tickets de soporte",
    "text_supporttickets_search_from_date": "Billete Fecha De",
    "text_supporttickets_search_to_date": "Billete Fecha A",
    "text_supporttickets_reset": "Reiniciar",
    "text_supporttickets_search": "Buscar",
    "text_generalInfo_customerid": "Cliente ID",
    "text_generalInfo_comments": "Comentarios",
    "adb_register_lastName": "Apellido",
    "text_ADB_register_company_phoneNumber": "Número de teléfono",
    "text_adb_admin_edit_adminName": "Nombre del administrador de ingeniería",
    "text_adb_admin_edit_applicationNum": "Numero de aplicacion",
    "text_adb_admin_edit_applicationDate": "Fecha de aplicacion",
    "text_adb_admin_edit_partNumber": "Número de pieza",
    "text_adb_admin_edit_additionComments": "Comentarios adicionales",
    "text_warranty_submit_customer_id": "Cliente ID",
    "text_account_supporttickets_updateTicket_c4cMessage2": "haga clic aquí",
    "text_account_supporttickets_updateTicket_c4cMessage3": "para actualizar el ticket",
    "software_library_placeholder_text": "Introduzca el nombre del software",
    "text_software_group_download_heading": "Grupo del Software",
    "text_warranty_button_uploadFile": "Subir archivo",
    "text_breakapplication_button_uploadfile": "Subir archivo",
    "text_breakapplication_uploadfile": "Subir archivo",
    "text_breakapplication_remove": "Eliminar",
    "text_booking_training_failed_noseats": "No hay plazas disponibles.",
    "myReport_page_text_SelectAll": "Seleccionar todo",
    "text_software_download_heading": "Tipo de Software",
    "text_software_download_heading2": "Tipo de paquete de Software Package",
    "myReport_page_text_download_your_report": "Descarga Sus Informes",
    "text_favorite_to_add": "Agregar al favoritos",
    "text_favorite_added": "Agregado al favoritos",
    "document_text_revision": "Tipo de documento : ",
    "please_select_your_customer_id": "Seleccione su Identificación del cliente",
    "text_part_remove": "Eliminar",
    "text_adb_placeholder": "Por favor Tipo Aquí",
    "text_account_supporttickets_createTicket_associatedTo_option_na": "No aplica",
    "text_account_supporttickets_invalid_format": "Nota: ¡Se permiten archivos word, xls, xlsx, csv, txt, tif, gif, jpg y pdf!",
    "text_request_search_claim_from_date": "Fecha de reclamo desde",
    "text_request_search_claim_to_date": "Fecha de reclamación hasta",
    "text_retrun_request_submit_part_nature_defect": "Razón de la devolución*",
    "text_return_request_please_upload_all": "Cargue todos los documentos que sean necesarios para revisar su formulario de solicitud de devolución.",
    "text_return_request_document_attachement_all": "Los documentos se pueden adjuntar si están en formato jpg, word o pdf y no superan los 9 MB en total.",
    "general_phone_number": "Ingrese un número de teléfono válido",
    "text_cart_popup_tag": "Haga click para ver escalado/ promoción",
    "text_cart_popup_tag_msg_title": "Precio escalado/ promoción",
    "text_cart_popup_tag_msg_content": "La siguiente referencia",
    "text_cart_popup_tag_msg_content2": "está actualmente en promoción",
    "text_cart_popup_tag_msg_content3": "hasta",
    "text_cart_popup_tag_msg_content1": "La siguiente referencia",
    "text_cart_popup_tag_msg": "tiene escalado de precio",
    "text_cart_popup_tag_datemsg": "Esta promoción va desde {0} hasta {1}",
    "text_cart_popup_tag_new": "Haga clic aquí para obtener información sobre los precios",
    "basket_page_cartId_message_new": "Haga clic en el icono de la etiqueta para ver información adicional sobre los precios de algunos artículos de su cesta",
    "text_cart_popup_tag_msg_title_new": "Información sobre precios",
    "text_scale_price": "Precios escalonados para",
    "text_scale_price_to": " a ",
    "text_scale_price_or": " o",
    "text_scale_price_more": ">",
    "text_scale_price_per_piece": "{0} por pieza",
    "text_ADB_proposed_Pusher": "Eje de carga propuesto",
    "text_ADB_proposed_Tag": "Eje simple o eje muerto propuesto",
    "text_ADB_proposed_AuxilaryAxle": "Eje auxiliar de carga propuesto",
    "general_quantity_license_number": "Ingrese una cantidad menor a 9",
    "placeholder_quantity_lable_validation": "Ingrese un valor entre 1 y 9",
    "text_software_request_form_dot_lable_elearning": "Fecha de capacitación / aprendizaje electrónico",
    "text_software_request_form_check_eLearning_course_lable": "¿El curso de aprendizaje electrónico se completó con éxito?",
    "text_software_thank_for_request_lable_na": "Gracias por la solicitud de descarga de software.",
    "text_software_search_type_code_content1_na": "Recibirás un correo electrónico. Para descargar este software, haga clic en el enlace incluido en el correo electrónico",
    "text_software_quantity_license": "Nº de licencias",
    "text_software_quantity_license_lable": "Cantidad",
    "text_software_language_lable": "Idioma",
    "text_software_size_lable": "Tamaño del Software",
    "text_software_operating_system_lable": "Sistema Operativo",
    "text_software_software_producer_lable": "Productor del software",
    "text_software_licence_lable": "Licencia",
    "text_software_software_version_lable": "Versión del Software",
    "text_software_last_update_lable": "Última actualización ({0})",
    "text_software_general_information_lable": "Información general",
    "text_software_information_lable": "Información sobre el software",
    "text_software_feature_list_lable": "Lista de características del software",
    "text_software_demo_lable": "Demo",
    "text_account_mypart_count_message": "Usted ha solicitado cargar sus propias referencias en el Sistema {0}.###Su archivo original muestra {1} referencias; su nuevo archive muestra {2} referencias.###Una vez que su archivo esté completamente cargado en el Sistema {3}, reemplazará cualquier información existente de su nuevo archive cargado.###¿Desea continuar cargando?",
    "text_software_service_lable": "Servicio",
    "text_software_oem-eol_lable": "OEM-EOL",
    "text_software_request_form_lable": "¡Por favor, rellene el siguiente formulario para solicitar su Software!",
    "text_software_request_form_choice_lable": "¿Necesita sólo el software o también una licencia para ello?",
    "text_software_request_form_choice_one_lable": "Software y Pin",
    "text_software_request_form_choice_two_lable": "Sólo Software",
    "text_software_request_form_company_information_lable": "Información de la Compañía",
    "text_software_request_form_company_lable": "Empresa*",
    "text_software_request_form_roleinindustry_lable": "Sector en la Industria*",
    "text_software_request_form_first_name_lable": "Nombre*",
    "text_software_request_form_last_name_lable": "apellido*",
    "text_software_request_form_department_lable": "Departamento",
    "text_software_request_form_street_lable": "calle",
    "text_software_request_form_postal_code_lable": "Código postal*",
    "text_software_request_form_city_lable": "ciudad*",
    "text_software_request_form_country_lable": "país*",
    "text_software_request_form_phone_lable": "Teléfono*",
    "text_software_request_form_phone_eol_lable": "Teléfono",
    "text_software_request_form_email_lable": "Email*",
    "text_software_request_form_information_about_training_lable": "Informacion sobre el curso",
    "text_software_request_form_check_person_lable": "¿La persona formada permanece todavía en la compañía?*",
    "text_software_request_form_check_yes_lable": "sí",
    "text_software_request_form_check_no_lable": "No",
    "text_software_request_form_check_certificate_lable": "Si disponible, por favor adjunte su certificado como PDF:",
    "text_software_request_form_ebs_person_firstname_lable": "Nombre de la persona formada en Trailer EBS*",
    "text_software_request_form_ebs_person_lastname_lable": "Apellido de la persona formada en Trailer EBS*",
    "text_software_request_form_trainer_name_lable": "Formación impartida por (nombre del formador)*",
    "text_software_request_form_dot_lable": "Fecha del curso",
    "text_software_request_form_place_of_training_lable": "Lugar de la formación*",
    "text_software_request_form_review_lable": "Revisar",
    "text_software_request_form_submit_button_lable": "Enviar",
    "text_software_request_form_withpin_lable": "Pedido con obligación de pago",
    "text_software_thank_for_request_lable": "¡Gracias por su solicitud de PIN / Software!",
    "text_software_return_homepage_lable": "Volver a la página principal",
    "text_software_request_form_termandcondition_lable": "Términos y Condiciones de Uso",
    "text_software_request_form_licence_agreement_lable": "Acuerdo de Licencia",
    "text_software_request_form_privacy_agreement_lable": "Aviso de Privacidad",
    "text_software_request_form_conditions_lable": "Términos de uso de la Webshop",
    "text_software_request_form_submit_lable": "Pedir software",
    "text_software_search_software_download_lable": "Software descargado",
    "text_software_search_lable": "Empresa",
    "text_software_search_software_lable": "Software",
    "text_software_search_language_lable": "idioma",
    "text_software_search_software_type_lable": "Tipo de Software",
    "text_software_search_button_reset_lable": "Reiniciar",
    "text_software_search_button_search_lable": "buscar",
    "text_software_search_title_lable": "Título del Software (idioma del paquete)",
    "text_software_search_type_lable": "Tipo de Software (idioma del paquete)",
    "text_software_search_description_lable": "description",
    "text_software_search_lang_lable": "idioma:",
    "text_software_search_version_lable": "versión",
    "text_software_search_release_lable": "lanzamiento",
    "text_software_search_button_download_lable": "Descarga Software",
    "text_software_search_button_viewdetails_lable": "Ver detalles",
    "text_software_search_button_download_pin_lable": "Descargar Software y Solicitar PIN",
    "text_software_search_title_code_lable": "Título del Software (TEBS G2)",
    "text_software_search_type_code_lable": "Tipo de Software (paquete de instalación)",
    "text_software_search_type_code_i_accept_the": "Yo acepto",
    "text_software_search_type_code_i_have_read": "He leído",
    "text_software_search_type_code_content1": "Su solicitud será procesada",
    "text_software_search_type_code_content2": "¡Recibirá un correo electrónico con su solicitud y otro en cuanto se apruebe la solicitud!",
    "storelocator_digits_validation": "Please enter 5 digits as zip code",
    "storelocator_valid_validation": "Please enter valid zip code",
    "storelocator_notFound_validation": "No se encontró ninguna coincidencia con el código postal, ingrese una ciudad y un estado",
    "na_core_over500lbs_msg": "<b>Más de</b> 500 libras o 100 zapatas de freno",
    "na_core_under500lbs_msg": "<b>Menos de</b> 500 libras (organice su propio envío)",
    "text_core_submission_product": "Tipo de producto*",
    "text_core_save_form_text": "You are saving this core return to be completed at a later date or when your shipment is ready for pickup.To open a saved form, go to Search Core Returns under My Account",
    "text_request_core_search_claim_from_date": "Fecha de presentación De*",
    "text_request_core_search_claim_to_date": "Fecha de presentación A*",
    "text_Show_core_of_coworkers": "Mostrar las peticiones básicas de los compañeros de trabajo",
    "text_core_submission_sucess_text1": "CANADA:<br/>Bendix CVS LLC / FastFrate<br/>9701 Hwy 50 <br/>Woodbridge, ON L4H 2G4 </br>***The core return documents must also be emailed for <500 lb. Canadian shipments.",
    "text_core_submission_sucess_text2": "US:<br/>Bendix CVS LLC<br/> 1850 Riverfork Dr East Dock.</br>Huntington, IN 46750</br>***UPS packages should be marked CORE on the outside",
    "pickup_address_provided": "Si la persona de contacto es distinta de la anterior, añádala a continuación:",
    "text_core_submission_address_na": "Si la dirección de recogida no figura en la lista de selección anterior, añada una nueva dirección a continuación:",
    "text_pickup_address": "Dirección de recogida",
    "text_core_submit_address_stateCode": "Estado/Provincia*",
    "text_bendix_search_text4": "Formulario de búsqueda del núcleo de retorn",
    "text_bendix_search_text5": "Los clientes pueden buscar sus devoluciones de núcleo en línea. Todas las declaraciones básicas presentadas por cualquier usuario vinculado al ID de cliente seleccionado serán visibles en la búsqueda.",
    "text_core_search_CustomerCR": "Referencia del cliente#",
    "select_pickup_address": "Seleccione una dirección de recogida a continuación:",
    "text_tooltip_actual_weight": "If you have the ability to weigh your return and it is different than our estimated weight above, please enter that here",
    "text_tooltip_package_type": "Pallets should be standard size, less than 48\" tall and under 2,000lbs.",
    "text_actual_weight": "Peso real",
    "text_core_search_contact": "Póngase en contacto con <u><a href=\"mailto:cores@bendix.com\"> cores@bendix.com </a></u> si tiene algún problema o pregunta.",
    "text_order_search_from_date_invalid_future": "La fecha de pedido desde no puede estar en una fecha futura.",
    "text_order_search_to_date_invalid": "La fecha de pedido hasta no puede ser menor que la fecha de pedido desde",
    "text_order_search_to_date_invalid_future": "La fecha de pedido A no puede estar en fecha futura",
    "text_order_search_from_date_to_date_invalid": "La fecha de pedido desde no puede ser mayor que la fecha de pedido hasta",
    "check_availability_btn_text": "Compruebe la disponibilidad",
    "rhs_top_heading_text": "Herramienta de clasificación de engranajes de dirección Sheppard",
    "rhsSearchText_placeHolder": "Por favor, introduzca el número de serie del engranaje",
    "rhs_beginning_text": "¡¡¡PARA!!! - LEA ESTO ANTES DE EMPEZAR.",
    "rhs_first_para_text": "Los engranajes de dirección Sheppard <b><u>remanufacturados, engranajes esclavos</u></b><b><u>&nbsp;NO ESTÁN</u></b> afectados por esta retirada, con la excepción del modelo HD94SAC2™. <p>Consulte el",
    "rhs_select_vehicle_gear_number_text": "Seleccione la marca de su vehículo e introduzca el número de serie completo de 8 caracteres antes del guión (-) como se muestra a continuación, sin espacios ni la \"-C\" al final",
    "rhs_select_vehicle_make_text": "Seleccione la marca del vehículo",
    "address_add_new_msg": "Añadir nueva dirección",
    "rhs_first_para_guide_label": "&nbsp;Guía de identificación",
    "rhs_first_para_identify_text": "&nbsp;para la identificación de los engranajes de dirección afectados, así como la interpretación del número de serie y de la pieza.",
    "heading_rhs_search": "Número de serie del engranaje Búsqueda",
    "rhs_search_details_heading": "Número de pieza/modelo del engranaje:",
    "rhs_search_details_vehicle_make": "Marca del vehículo (OEM) o AM:",
    "rhs_search_result_label": "Resultado",
    "rhs_search_details_label": "Detalles",
    "rhs_vehicle_serial_number_label": "Número de serie:",
    "rhs_vehicle_make_oem_mismatch_label": "La marca del vehículo (OEM) y el número de serie no coinciden",
    "rhs_search_form_error_not_found": "Número de serie del engranaje de dirección : No encontrado <br><br>Compruebe cuidadosamente el número de serie y vuelva a introducirlo_  Si sigue sin encontrarlo, póngase en contacto con Sheppard en <a href",
    "rhs_search_form_success_status_release": "Número de serie del engranaje de dirección : Bueno <br><br>El vehículo puede ser devuelto al servicio sin más acciones de remediación",
    "rhs_search_form_rhsRecertified_status_release": "Número de serie del engranaje de dirección : Bueno - Recertificado<br><br>El vehículo puede ser devuelto al servicio sin más acciones de remediación",
    "rhs_search_form_success_status_suspect": "Número de serie del engranaje de dirección : Sospechoso <br><br>Retirar y sustituir el engranaje según las instrucciones del fabricante del vehículo",
    "rhs_search_form_serialNum_empty": "Por favor, introduzca el número de serie completo de 8 dígitos sin espacios",
    "rhs_search_form_make_empty": "Por favor, seleccione la marca de su vehículo",
    "rhs_search_form_serialNum_endsWithHyphenC": "El número de serie no debe terminar con -C. Por favor, vuelva a introducir",
    "rhs_search_form_success_status_datarange": "El número de serie introducido está fuera del intervalo de fechas y no forma parte de la retirada.",
    "rhs_search_form_success_status_remanufactured": "El número de serie introducido corresponde a un engranaje refabricado y no forma parte de la retirada.",
    "rhs_search_form_success_status_reenter": "Compruebe el número de serie cuidadosamente y vuelva a introducir el número de serie según la imagen mostrada arriba",
    "rhs_search_form_mandate_check": "EL USUARIO ES EL ÚNICO RESPONSABLE DE LA INTRODUCCIÓN DE DATOS EXACTOS Y ASUME TODOS LOS RIESGOS ASOCIADOS A SU INCUMPLIMIENTO.",
    "myReport_page_text_download_your_reports_NA": "Tablón de anuncios de Bendix",
    "myReport_page_text_title_NA": "Descargue sus informes",
    "myReport_page_text_paragraph1_NA": "Aquí puede descargar sus informes. A continuación, verá una lista de informes a su disposición.",
    "myReport_page_text_paragraph2_NA": "Para utilizar esta función, seleccione los informes que desea descargar y haga clic en el botón de descarga.",
    "myReport_page_text_SelectAll_NA": "Sélectionner tout",
    "myReport_page_text_button_NA": "Télécharger les fichiers sélectionnés",
    "no_report_file_to_download_NA": "No hay archivos de informe para descargar.",
    "register_checkbox_customerDocDownloadAccess_label": "Download Customer Documents",
    "myaccount_brakeform_customer_id": "Customer ID",
    "myaccount_brakeform_levelofexp_text": "Level of experience with installation/design/testing of ADB or S-Cam brakes*",
    "myaccount_brakeform_check_apply": "Check all that apply",
    "myaccount_brakeform_levelofexp_tooltext": "Foundation brake refers to air-actuated systems (air disc brake, s-cam drum brake)<br/>The purpose of this question is to determine the level of support you, the OEM customer, may require during the application request stage and the verification/validation and part release stages.",
    "myaccount_brakeform_projectreq_text": "Project Requirements",
    "myaccount_brakeform_projecttarget_text": "Project Target (Reason for Request)*",
    "myaccount_brakeform_projecttarget_tooltext": "\"Brake Model\" refers to the type (ADB or S-Cam) and sub-model (e.g. ADB22X, SN7, etc) <br/> \"Duty Cycle\" refers to the frequency, duration, magnitude, and other characteristics of the brake cycle that affect brake durability and performance.",
    "myaccount_brakeform_required_sample_text": "Will you require samples?",
    "myaccount_brakeform_required_sample_tooltext": "Select Yes if at least one type is needed",
    "myaccount_brakeform_required_sampleA_text": "Planned Unit Numbers",
    "myaccount_brakeform_required_sampleA_tooltext": "Indicate the quantity of A-Samples needed (first functional or prototype sample)",
    "myaccount_brakeform_targetdate_text": "Do you have target dates for samples?",
    "myaccount_brakeform_targetdate_text_tooltext": "Indicate whether you have target delivery dates.",
    "myaccount_brakeform_targetdate_sampleA_text": "Customer Schedule",
    "myaccount_brakeform_targetdate_sampleA_tooltext": "Indicate the target delivery date from Bendix to the customer for A-Samples",
    "myaccount_brakeform_sop_targetdate_text": "Customer Schedule (Start of Production Date)*",
    "myaccount_brakeform_sop_targetdate_tooltext": "Indicate the target date of start of production of the vehicle (or axle, in the case of axle manufacturers)",
    "myaccount_brakeform_ppv_firstyear_text": "Planned Production Volume - 1st Year (# of Vehicles)*",
    "myaccount_brakeform_ppv_secondyear_text": "Planned Production Volume - 2nd Year (# of Vehicles)*",
    "myaccount_brakeform_ppv_thirdyear_text": "Planned Production Volume - 3rd Year (# of Vehicles)*",
    "myaccount_brakeform_ppap_level_text": "PPAP Level Required",
    "myaccount_brakeform_ppap_level_tooltext": "Bendix standard is Level 1 (Part Submission Warrant). Other requirements may incur additional cost and lead time.",
    "myaccount_brakeform_FMEA_text": "Are you able to provide FMEA (Design, System, or Process)?",
    "myaccount_brakeform_FMEA_tooltext": "Indicate whether you, the customer, are able to provide or show Bendix (under NDA) a Design, System, or Process FMEA at the level of the brake-to-axle interface",
    "myaccount_brakeform_conduct_fields_text": "Do you plan to conduct field tests for this application?*",
    "myaccount_brakeform_conduct_fields_tooltext": "A field test is a test using a fleet of vehicles in real world environments, serving the vehicle's primary vocation or purpose",
    "myaccount_brakeform_vehicles_used_text": "How many vehicles are or will be used in your field test(s)?",
    "myaccount_brakeform_field_test_text": "Have you performed field tests on similar applications? If yes, please provide detail*.",
    "myaccount_brakeform_field_test_tooltext": "Indicate whether you have performed field tests on similar applications. Provide detail on the vocation, axle weight ratings, brake models tested, number of vehicles tested, duration of the test, and the results",
    "myaccount_brakeform_legal_requirement_text": "Vehicle Operation Outside of USA/Canada?*",
    "myaccount_brakeform_legal_requirement_tooltext": "IF YES, List all countries where vehicle(s) will operate and the associated name/number of regulation(s) governing braking performance requirements in the COMMENTS section of this form",
    "myaccount_brakeform_cad_model_text": "Axle/chassis 3D CAD model availability for installation investigation*",
    "myaccount_brakeform_cad_model_tooltext": "\"3D CAD model\" refers to the customer model of the chassis or axle environment where the brake will be mounted.",
    "myaccount_brakeform_painting_condition_text": "Painting Conditions - Will Parts Be Painted after Delivery?",
    "myaccount_brakeform_painting_condition_tooltext": "Indicate whether parts will be painted after receipt, type and thickness of paint, and method of application",
    "myaccount_brakeform_vehicle_genral_tooltex": "Vehicle Information - General:",
    "myaccount_brakeform_Chassis_modification_text": "Post-Production Chassis Modification*",
    "myaccount_brakeform_Chassis_modification_tooltext": "Please describe whether you expect the chassis to be modified after delivery to your customer, and the details of the expected or known modification (e.g. body builder chassis modification)",
    "myaccount_brakeform_Vehicle_lifetime_text": "Lifetime of Vehicle*",
    "myaccount_brakeform_Vehicle_lifetime_tooltext": "Indicate the expected lifetime, in years, of the vehicle",
    "myaccount_brakeform_annual_use_text": "Annual Use (miles)*",
    "myaccount_brakeform_annual_use_tooltext": "Indicate expected or typical annual use, in miles per year",
    "myaccount_brakeform_highway_operation_text": "% On-Highway Operation*",
    "myaccount_brakeform_highway_operation_tooltext": "Indicate what percentage of total vehicle operation time is spent on-highway. Includes well-maintained major highways of excellent concrete or asphalt construction.Terrain may be level to rolling with occasional maximum adverse grades to 8%. Operations are subject to legal weight and dimensional limits.",
    "myaccount_brakeform_average_grade_text": "Average Grade (%)*",
    "myaccount_brakeform_avergae_grade_tooltext": "Indicate the average grade encountered during operation",
    "myaccount_brakeform_maximum_optimum_grade_text": "Maximum Operating Grade, Length, Speed (Descent)",
    "myaccount_brakeform_maximum_optimum_grade_tooltext": "Indicate the maximum grade encountered during typical operation (descent), length down grade, and speed down grade.",
    "myaccount_brakeform_endurance_brake_text": "What type of Endurance Brake System is onboard?*",
    "myaccount_brakeform_endurance_brake_tooltext": "Indicate the endurance brake systems equipped to the vehicle. An endurance brake system is an additional braking system having the capability to provide and to maintain a braking effect over a long period of time without a significant reduction in performance.",
    "myaccount_brakeform_service_brake_text": "Service Brake Duty Cycle (Excluding Parking)*",
    "myaccount_brakeform_service_brake_tooltext": "Describe the typical frequency (how often), duration (for how long), and magnitude (how hard) of the brake actuation. Describe typical speeds at which brakes are applied.",
    "myaccount_brakeform_parking_duty_text": "Parking Duty Cycle / Conditions*",
    "myaccount_brakeform_parking_duty_tooltext": "Describe the frequency and duration of the application of the parking brake, as well as the average and maximum grades on which the vehicle is expected to park",
    "myaccount_brakeform_parking_test_oem_text": "Parking Test Requirements - Customer (OEM)*",
    "myaccount_brakeform_parking_test_oem_tooltext": "*Note: Parking is a function of vehicle systems beyond the wheel end. The vehicle manufacturer is responsible for ensuring the vehicle meets parking requirements specified by FMVSS 121.",
    "myaccount_brakeform_parking_test_text": "Parking Test Requirements same as End User*",
    "myaccount_brakeform_parking_test_tooltext": "Indicate whether the end user's method to test parking performance is the same as your (the customer's) method",
    "myaccount_brakeform_Vehicle_Operating_text": "Vehicle's Operating Environment Conditions (as related to NVH)",
    "myaccount_brakeform_Vehicle_Operating_tooltext": "Select all usage/operational conditions that apply:",
    "myaccount_brakeform_required_NVH_text": "NVH Requirements, NVH Regional Concerns, NVH Application Concerns",
    "myaccount_brakeform_required_NVH_tooltext": "Please describe any NVH (Noise, Vibration, Harshness) expectations or requirements that Bendix is expected or required to meet. Consider NVH requirements specific to regions or countries the vehicle will be used in, or application-specific concerns. If none, type \"None\". If left blank, \"Bendix will contact you to obtain further clarification\".",
    "myaccount_brakeform_brake_type_text": "Brake Type",
    "myaccount_brakeform_brake_type_tooltext": "Indicate whether the vehicle uses or will use only ADB, only S-Cam, or a combination of ADB and S-Cam brakes on its axles",
    "myaccount_brakeform_axle_config_text": "Axle Configuration",
    "myaccount_brakeform_axle_config_tooltext": "Indicate the configuration of total wheel ends vs driven wheel ends (e.g. 6X4, 4X2, etc.)",
    "myaccount_brakeform_abs_sensor_text": "ABS Sensors for all wheel positions?",
    "myaccount_brakeform_abs_sensor_tooltext": "Indicate whether each wheel position has an ABS sensor",
    "myaccount_brakeform_abs_modular_count_text": "ABS Modulator Count*",
    "myaccount_brakeform_abs_modular_count_tooltext": "Indicate how many ABS modulators are equipped",
    "myaccount_brakeform_GVWR_lbs_text": "Gross Vehicle Weight Rating (GVWR) (lbs)*",
    "myaccount_brakeform_wheelbase_range_text": "Wheelbase Range (in)*",
    "myaccount_brakeform_cog_height_laden_text": "Center of Gravity Height (Laden) (in)*",
    "myaccount_brakeform_cog_height_unladen_text": "Center of Gravity Height (Unladen) (in)*",
    "myaccount_brakeform_abs_sensor_count_text": "ABS Sensor Count",
    "myaccount_brakeform_end_user_text": "End User (Fleet Customer)",
    "myaccount_brakeform_end_user_tooltext": "Indicate the end user(s) (your fleet customer(s), dealer(s), or other customer(s)) if known. If left blank, Bendix will assume the end user is unknown.",
    "myaccount_brakeform_vehicle_info_text": "Vehicle Information - Axle Information:",
    "myaacount_brakeform_steer_text": "Steer Axle",
    "myaacount_brakeform_drive_text": "Drive Axle",
    "myaccount_brakeform_axle_manu_text": "Axle Manufacturer*",
    "myaccount_brakeform_axle_manu_tooltext": "Indicate the manufacturer of the axle",
    "myaccount_brakeform_brake_assembly_text": "Party performing brake assembly install onto the axle(s)*",
    "myaccount_brakeform_brake_assembly_tooltext": "Indicate the manufacturer that installs the brake assembly onto the axle during production.",
    "myaccount_brakeform_axle_design_text": "Axle design release/production status*",
    "myaccount_brakeform_axle_design_tooltext": "Indicate the release status of the axle(s) on which the requested brakes will be mounted.",
    "myaccount_brakeform_axle_toc_text": "Type of Connection to Axle Flange*",
    "myaccount_brakeform_axle_toc_tooltext": "Indicate the type/manufacturer of the mounting interface to the axle",
    "myaccount_brakeform_brake_disc_text": "Rotor or Drum Intended Manufacturer and Part Number*",
    "myaccount_brakeform_brake_disc_tooltext": "Indicate the manufacturer and part number or model of the disc/drum of the requested brakes",
    "myaccount_brakeform_hub_intended_text": "Hub Intended Manufacturer and Part Number*",
    "myaccount_brakeform_hub_intended_tooltext": "Indicate the manufacturer and part number or model of the hub for the requested brakes",
    "myaccount_brakeform_actuator_intended_text": "Actuator/Chamber Intended Manufacturer and Part Number*",
    "myaccount_brakeform_act_intended_tooltext": "Indicate the manufacturer and part number or model of the actuator/chamber/cylinder of the requested brakes",
    "myaccount_brakeform_vcp_text": "Relay Valve Crack Pressure*",
    "myaccount_brakeform_steer_axle_text": "Steer Axle Driven?",
    "myaccount_brakeform_steer_axletype_text": "Axle Type*",
    "compare_product_note_footer_compare_block": "Comparar",
    "compare_product_note_footer": "Puede comparar hasta 4 referencias",
    "compare_product_note_footer_clear_all": "Limpiar todo",
    "compare_product_note_footer_compare": "Comparar",
    "compare_product_note_checkbox": "Comparar",
    "text_compare_part_number": "Puede comparar hasta 4 referencias",
    "text_back_to_result_button": "Volver al resultado",
    "myaccount_brakeform_steer_axletype_tooltext": "Indicate whether the axle is Single, Tandem, or Tridem (excluding pusher and tag axles)",
    "myaccount_brakeform_desired_parking_text": "Intended or Desired Parking Axle Configuration*",
    "myaccount_brakeform_desired_parking_tooltext": "Indicate which axle(s) are set up for or are allowed to be set up for parking.",
    "myaccount_brakeform_GAWR_lbs_text": "Gross Axle Weight Rating (GAWR) (lbs)*",
    "myaccount_brakeform_GAWR_lbs_tooltext": "Enter the gross axle weight rating",
    "myaccount_brakeform_axle_weight_text": "Customer Axle Weight Limit (lbs)",
    "myaccount_brakeform_axle_weight_tooltext": "Enter the axle weight limitation (below the GAWR), if any. This rating may be imposed by you, the customer, or the end user",
    "myaccount_brakeform_wheel_rimsize_text": "Wheel/Tire Size (example: 295/75R22.5)*",
    "myaccount_brakeform_tire_type_text": "Tire Type*",
    "myaccount_brakeform_tire_type_tooltext": "Indicate the tire type for the given axle",
    "myaccount_brakeform_tire_static_text": "Tire Static Loaded Radius (SLR) (in)*",
    "myaccount_brakeform_proposed_brake_text": "Customer-Proposed Brake",
    "myaccount_brakeform_proposed_brake_tooltext": "Indicate the proposed or desired brake model, friction material, chamber size, and slack adjuster (if applicable), for Bendix to consider for review",
    "myaccount_brakeform_disc_intended_tooltext": "Indicate the intended/requested manufacturer of the disc/drum of the requested brakes",
    "myaccount_brakeform_actuator_intended_tooltext": "Indicate the intended/requested manufacturer of the actuator/chamber/cylinder of the requested brakes",
    "myaccount_brakeform_value_crack_text": "Relay Valve Crack Pressure*",
    "myaccount_brakeform_axle_type_text": "Axle Type*",
    "myaccount_brakeform_axle_type_tooltext": "Indicate whether the axle is Single, Tandem, or Tridem (excluding pusher and tag axles)",
    "myaccount_brakeform_auxAxle_type_text": "Auxiliary Axle Type*",
    "myaccount_brakeform_auxAxle_type_tooltext": "Indicate whether the auxiliary axle is a \"pusher axle or tag axle\".",
    "myaccount_brakeform_auxAxle_attribute_text": "Auxiliary Axle Attributes",
    "myaccount_brakefor_addAux_button_text": "Add Auxiliary Axle",
    "myaccount_brakeform_auxAxle_attribute_tooltext": "Indicate whether the auxiliary axle is liftable and/or steerable, and whether it is set up for or intended for parking",
    "myaccount_brakeform_comments_attachments_tooltext": "Comments and Attachments",
    "myaccount_brakeform_pneumatic_system_text": "Bendix-Recommended Pneumatic System Design*",
    "myaccount_brakeform_pneumatic_system_tooltext": "Please indicate whether the vehicle's pneumatic system is a Bendix-recommended design",
    "myaccount_brakeform_brake_equipped_text": "Work Brake Equipped? If yes, enter pressure and application frequency*",
    "myaccount_brakeform_brake_equipped_tooltext": "Indicate whether the vehicle is equipped with a work brake and indicate the work brake pressure & application frequency. A work brake is a system or mechanism that allows the service brake to be applied at a defined pressure to act as a temporary parking brake. It may be activated (set) or deactivated by the driver but is not modulated by the driver through the treadle / pedal.",
    "myaccount_brakeform_brake_final_review": "Check Completeness",
    "text_adb_admin_edit_danaContactemail": "Bendix contact email",
    "sort_by_pdp": "Ordenar por:",
    "text_pdp_document_desc_asc": "Descripción del documento Ascendente",
    "text_pdp_document_desc_desc": "Descripción del documento Descendente",
    "text_pdp_document_type_asc": "Tipo de documento ascendente",
    "text_pdp_document_type_desc": "Tipo de documento descendente",
    "text_pdp_document_code_asc": "Número de documento ascendente",
    "text_pdp_document_code_desc": "Número de documento descendente",
    "text_pdp_document_relDate_asc": "Fecha de la versión de documento ascendente",
    "text_pdp_document_relDate_desc": "Fecha de la versión de documento descendente",
    "pdp_part_partNum_asc": "Número de pieza ascendente",
    "pdp_part_partNum_dsc": "Número de pieza descendente",
    "pdp_part_decs_asc": "Descripción ascendente",
    "pdp_part_desc_dsc": "Descripción descendente",
    "pdp_part_typeNum_asc": "Número de tipo ascendente",
    "pdp_part_typeNum_dsc": "Número de tipo descendente",
    "text_smartire_header": "SmarTire®",
    "text_smartire_return_investment": "Retorno de la inversión",
    "text_smartire_return_bottom_line": "Control de la presión de los neumáticos... Su cuenta de resultados.",
    "text_smartire_return_bottom_line_para": "El inflado insuficiente aumenta la cantidad de combustible que quema un vehículo y reduce la vida útil de la banda de rodadura y la carcasa del neumático. Cuando se multiplica por el número de vehículos de su flota y los miles de kilómetros que recorren al año, no es de extrañar que los neumáticos poco inflados representen el mayor gasto de mantenimiento de una flota comercial. A menudo descuidado como resultado de los altos costes y los elevados requisitos de mano de obra, el mantenimiento regular de los neumáticos de la flota puede realmente ahorrarle dinero cuando se realiza de manera consistente y eficiente.",
    "text_smartire_return_smartware": "Control activo de la presión de los neumáticos SmartWave",
    "text_smartire_return_smartware_para": "El sistema de control activo de la presión y la temperatura de los neumáticos SmartWave está diseñado para facilitar el mantenimiento periódico de los neumáticos. El sistema proporciona tanto a los conductores como al personal de mantenimiento las herramientas que necesitan para mantener los neumáticos rodando de la forma más segura y rentable posible. El sistema genera un rápido retorno de la inversión al maximizar la vida útil de los neumáticos, el ahorro de combustible y la seguridad vial, al tiempo que reduce el tiempo de inactividad no programado y la posibilidad de que se produzcan peligrosos reventones o incendios.",
    "text_smartire_return_calculator": "Calculadora ROI: USA Imperial",
    "text_smartire_return_calculator_para": "Introduzca su información en la calculadora que aparece a continuación y se generará un retorno de la inversión aproximado para el sistema SmartWave. Dado que cada flota es diferente, el valor generado es solo una estimación.",
    "text_smartire_company_info": "Información sobre la empresa",
    "text_smartire_units": "Unidades",
    "text_smartire_numberof_vahicles": "Número de vehículos:",
    "text_smartire_vehicles": "vehículos",
    "text_smartire_average_mileage": "Kilometraje medio por vehículo:",
    "text_smartire_numberof_tires": "Número de neumáticos por vehículo:",
    "text_smartire_per_year": "al año",
    "text_smartire_tire_inspection": "Intervalo de inspección de neumáticos:",
    "text_smartire_tires": "neumáticos",
    "text_smartire_per_month": "al mes",
    "text_smartire_average_under_inflation": "Subinflación media:",
    "text_smartire_average_anual_downtime": "Tiempo medio de inactividad anual:",
    "text_smartire_instance": "para cada",
    "text_smartire_tire_life": "Vida útil de los neumáticos (en distancia):",
    "text_smartire_miles": "Miles",
    "text_smartire_fuel_cunsumption": "Consumo de combustible:",
    "text_smartire_deafult_values": "Valores por defecto",
    "text_smartire_cost_fuel": "Coste del combustible (gasóleo):",
    "text_smartire_usd_per_gallon": "USD por galón",
    "text_smartire_cost_per_tire": "Coste por neumático:",
    "text_smartire_cost_downtime": "Coste por tiempo de inactividad:",
    "text_smartire_service_cost": "Coste de servicio por vehículo:",
    "text_smartire_minutes_per_tire": "minutos/neumático",
    "text_smartire_usd_per_hour": "USD por hora",
    "text_smartire_usd": "USD",
    "text_smartire_btn_calculate": "Calcule",
    "text_smartire_error_numeric": "Use numeric values",
    "text_smartire_xyz_trucking_co": "XYZ Trucking Co.",
    "text_smartire_normal": "Normal",
    "text_smartire_with_smartwave": "Con Smartwave",
    "text_smartire_saving": "Ahorro",
    "text_smartire_annual_tire_cost": "Coste anual de neumáticos:",
    "text_smartire_annual_fuel_cost": "Costes anuales de combustible:",
    "text_smartire_annual_tire_maintenance_cost": "Costes anuales de mantenimiento de neumáticos:",
    "text_smartire_annual_downtime_cost": "Costes anuales de inactividad:",
    "text_smartire_total": "TOTAL:",
    "text_smartire_annual_saving": "Ahorro anual por vehículo:",
    "text_smartire_calculate_following": "Los valores se calculan de la siguiente manera:",
    "text_smartire_reduce_tire_thread": "Un 20% de inflado insuficiente reduce la vida útil de los neumáticos en un 25%.",
    "text_smartire_reduce_fuel_economy": "Un 20% de inflado insuficiente reduce el ahorro de combustible en un 2%.",
    "text_smartire_tire_failure": "El 90% de las averías de neumáticos se deben a un inflado insuficiente",
    "text_smartire_tire_related": "Casi la mitad (49%) de las llamadas de asistencia en carretera están relacionadas con los neumáticos.",
    "text_smartire_smartwave_tpms": "SmartWave TPMS reducirá el tiempo de mantenimiento de los neumáticos:",
    "secure_update_application_title": "Crear una contraseña segura",
    "secure_password_update_title": "Secure Update Password",
    "secure_update_application_msg": "Estimados clientes, para administrar sus transacciones y sus datos en el portal del cliente de manera aún más segura, cambie su contraseña.",
    "secure_update_pwd_validation_title": "Su nueva contraseña segura debe cumplir con estas reglas:",
    "secure_update_pwd_validation_msg1": "Al menos 12 caracteres",
    "secure_update_pwd_validation_msg2": "Al menos 1 letra minúscula",
    "secure_update_pwd_validation_msg3": "Al menos 1 letra mayúscula",
    "secure_update_pwd_validation_msg4": "Al menos un número",
    "secure_update_pwd_validation_msg5": "Al menos uno de estos caracteres especiales: ( )~!@#$%^&*_-+=`|(){}[]:;\"'<>,?/",
    "secure_update_recentused_pwdMsg": "Las últimas 5 contraseñas no se pueden reutilizar",
    "secure_update_pwd_personalInfo_msg": "Por favor, no utilice ninguna información personal o nombres de empresas en su contraseña",
    "secure_update_pwd_mustChange_msg": "La contraseña debe cambiarse una vez al año",
    "secure_update_pwd_doesnot_meetReq_msg": "La contraseña elegida no cumple con los requisitos.",
    "secure_update_pwd_alreadyUsed_msg": "Esta contraseña ya ha sido utilizada, cree una nueva contraseña.",
    "secure_update_pwd_expiration_msg": "Su contraseña ha caducado después de 365 días. Cree una nueva contraseña.",
    "vizseek_Search_NOresults": "Comentarios de la búsqueda visual - sin resultados",
    "vizseek_Search_NOresults_found": "Lo sentimos, no hemos podido encontrar un resultado de producto utilizando la búsqueda visual.<br> Por favor, navegue utilizando el desglose de productos / categorías.",
    "vizseek_Search_category": "¿Es ésta la página de categoría de producto correcta?",
    "vizseek_Search_category_info": "Para más información",
    "vizseek_tooltip": "Imagen de búsqueda visual",
    "Vizseek_Search_Guide": "Guía de búsqueda",
    "vizseek_search_Invalid_text1": "Lo sentimos, no podemos localizar su categoría de producto.",
    "vizseek_search_Invalid_text2": "Consulte el",
    "vizseek_search_Invalid_text3": "o ",
    "vizseek_Search_results": "Comentarios de la búsqueda visual",
    "text_contactusform_submission_success": "Form Submitted Successfully.",
    "text_contactusform_submission_error": "Por favor, corrija los siguientes errores.",
    "text_contactusform_submission_failed": "Something went wrong. Please try again later.",
    "text_contactusform_page_title": "Póngase en contacto con nosotros",
    "contactUs_label_taxt": "Contacte con nosotros",
    "contactUS_form_select_empty": "Seleccione una opción",
    "contactUs_topics": "Tema*",
    "contactUs_firstName": "Nombre*",
    "contactUs_lastName": "Apellidos*",
    "contactUs_company_name": "Empresa",
    "contactUs_address_street_text": "Calle*",
    "contactUs_address_city_text": "Ciudad*",
    "contactUs_address_zip_text": "Código postal*",
    "contactUs_email_text": "Correo electrónico*",
    "contactUs_countryCode_text": "País*",
    "contactUs_phoneNumber_text": "Número de teléfono",
    "#contactUs_company_state_code_canada": "State/Province**",
    "#contactUs_company_companyStateCode": "State**",
    "contactUs_company_comments_text": "Su mensaje*",
    "contactUs_comments_note_text": "Escriba aquí la nota",
    "contactUs_dataprotection_acceptNA": "Acepto la",
    "contacUS_privacyPolicy_msgNA": "política de privacidad",
    "contactUs_privacyPolicy_accept_invalid": "Es obligatorio aceptar la política de privacidad",
    "typeMismatch_contactUSForm_termsOfUsageAcceptance": "Es obligatorio aceptar la política de privacidad",
    "register_captcha_invalid_msg": "Por favor, introduzca un Captcha válido",
    "contactUs_captcha_text": "Captcha",
    "contactUs_form_submit_msg": "Su mensaje se ha enviado correctamente",
    "contactUS_send_button_msg": "Enviar",
    "import_csv_savedCart_genericErrorNA": "Error in uploading the order template_ Please try again or contact <a href",
    "check_out_of_stock_table_text": "está agotado",
    "check_out_of_stock_text": "está agotado para",
    "value_calculator_header": "EnduraSure®-Pro Savings Summary",
    "value_calculator_title": "Bendix Value Calculator",
    "value_calculator_visitor_info_title": "Información para visitantes:",
    "value_calculator_firstName": "Nombre de pila",
    "value_calculator_lastName": "Apellidos",
    "value_calculator_email": "Dirección de correo electrónico de la empresa",
    "value_calculator_privacy_accept": "Acepto la cláusula de exención de responsabilidad",
    "value_calculator_privacy_accept_link": "calculadora(s) de valor",
    "available_product_text": "está disponible para",
    "value_calculator_next_button": "Siguiente",
    "value_calculator_back_button": "Volver",
    "value_calculator_flit_info_title": "Información sobre la flota:",
    "value_calculator_fleetSizeTractors": "Tamaño de la flota - Tractores*",
    "value_calculator_tractors_text": "Tractores",
    "value_calculator_tractorTradeInCycle": "Ciclo de intercambio de tractores*",
    "value_calculator_fleetSizeTrailers": "Tamaño de la flota - Remolques*",
    "value_calculator_trailers_text": "Remolques",
    "value_calculator_year_text": "Años",
    "value_calculator_trailerTradeInCycle": "Ciclo de intercambio de remolques*",
    "value_calculator_actuator_text": "Actuador",
    "value_calculator_usdOcc_text": "USD / Ocurrencia",
    "value_calculator_calls_text": "Llamadas",
    "value_calculator_usdDay_text": "USD / Día",
    "value_calculator_replacement_costNode_title": "Replacement Cost per Actuator",
    "value_calculator_replacement_cost_title": "Coste anual de sustitución por actuador:",
    "value_calculator_replacementFleetCostPerActuator": "Coste de sustitución por actuador",
    "value_calculator_replacementFleetCostPerActuator_toolTip": "Coste medio de la flota para el actuador averiado.",
    "value_calculator_laborToInstallActuator": "Mano de obra para instalar el actuador",
    "value_calculator_laborToInstallActuator_toolTip": "Coste de mano de obra basado en 30 minutos para instalar el actuador de sustitución.",
    "value_calculator_totalCostPerFailedActuator": "Coste total por actuador averiado",
    "value_calculator_numberOfActuatorsReplacedPerYear": "Número de actuadores sustituidos al año",
    "value_calculator_numberOfActuatorsReplacedPerYear_toolTip1": "Por término medio, las flotas sustituyen un actuador al año en el 15% de sus tractoras y el 12% de sus remolques.\\",
    "value_calculator_numberOfActuatorsReplacedPerYear_toolTip2": "Fuente: MacKay & Company 2023",
    "value_calculator_product_performance_title": "Rendimiento actual del producto:",
    "value_calculator_brandOfActuator": "Marca del actuador",
    "value_calculator_csa_title": "Costes de inactividad de CSA",
    "value_calculator_roadsideCallRate": "Índice de llamadas en carretera",
    "value_calculator_roadsideCallRate_toolTip": "Coste medio de una llamada de asistencia en carretera, incluido el tiempo de inactividad.",
    "value_calculator_annualRoadsideCallsToActuators": "Número anual de llamadas en carretera relacionadas con actuadores*",
    "value_calculator_violations_text": "Violations",
    "value_calculator_roadsideCallRateCsaViolation": "Índice de llamadas a la carretera por infracción de la CSA",
    "value_calculator_roadsideCallRateCsaViolation_toolTip": "Coste estimado de la asistencia en carretera durante un caso de CSA fuera de servicio (OOS).",
    "value_calculator_annualOutOfServiceCsaViolations": "Número anual de infracciones de la CSA por frenos fuera de servicio*",
    "value_calculator_fleetDowntimeRate": "Índice de tiempo de inactividad de la flota*",
    "value_calculator_upcharge_title": "Recargo por equipos nuevos",
    "value_calculator_estUpchargeForEndTractor": "Suplemento estimado para EnduraSure-Pro en el tractor sobre la opción actual",
    "value_calculator_estUpchargeForEndTractor_errorMsg": "Please enter Estimated upcharge for EnduraSure-Pro on tractor over current option",
    "value_calculator_estUpchargeForEndTrailer": "Suplemento estimado para EnduraSure-Pro en el remolque con respecto a la opción actual",
    "value_calculator_estUpchargeForEndTrailer_errorMsg": "Please enter Estimated upcharge for EnduraSure-Pro on trailer over current option",
    "value_calculator_enduraSure_summary": "Resumen de EnduraSure®-Pro",
    "value_calculator_unit_cost": "Coste unitario",
    "value_calculator_totalFleet_cost": "Coste total de la flota",
    "value_calculator_initialpurchase_tractor_cost": "Coste inicial de compra - tractor",
    "value_calculator_initialpurchase_trailer_cost": "Coste inicial de compra - remolque",
    "value_calculator_replacementTractor_cost": "Costes de sustitución de por vida - tractor",
    "value_calculator_replacementTrailer_cost": "Costes de sustitución de por vida - remolque",
    "value_calculator_csaTractor_cost": "Costes relacionados con CSA - tractor",
    "value_calculator_csaTrailer_cost": "Costes relacionados con CSA - remolque",
    "value_calculator_total_text": "Total",
    "value_calculator_return_investment": "Retorno de la inversión (ROI)",
    "value_calculator_TCO_perUnit_standard": "TCO por unidad - Estándar (USD)",
    "value_calculator_TCO_perUnit_Sealed": "TCO por unidad - Sellado (USD)",
    "value_calculator_fleet_saving": "Ahorro neto de flota (USD)",
    "value_calculator_description_text": "Descripción",
    "value_calculator_email_results": "Resultados del correo electrónico",
    "value_calculator_reset_text": "Restablecer",
    "value_calculator_email_text": "Email",
    "value_calculator_enduraSure_perTractor": "Coste adicional de EnduraSure®-Pro por tractor",
    "value_calculator_enduraSure_perTractor_desc": "Recargo estimado por EnduraSure®-Pro en tractor sobre la opción actual. El coste puede oscilar entre 50 y 150 dólares por tractor nuevo.",
    "value_calculator_enduraSure_perTrailer": "Coste adicional de EnduraSure®-Pro por remolque",
    "value_calculator_enduraSure_perTrailer_desc": "Estimación del recargo por EnduraSure®-Pro en el remolque respecto a la opción actual. El coste puede oscilar entre 50 y 150 dólares por remolque nuevo.",
    "value_calculator_proEmail_summary": "EnduraSure®-Pro Email Summary",
    "value_calculator_contact_info": "Contact Information",
    "valueCalculator_brandOfActuator_bendixEnduraSure": "Bendix EnduraSure",
    "valueCalculator_brandOfActuator_bendixEnduraSurePro": "Bendix EnduraSure-Pro",
    "valueCalculator_brandOfActuator_haldexGoldSeal": "Haldex Gold Seal",
    "valueCalculator_brandOfActuator_haldexLifeSeal": "Haldex Life Seal",
    "valueCalculator_brandOfActuator_tseOmni": "TSE Omni",
    "valueCalculator_brandOfActuator_tseUltra": "TSE Ultra",
    "valueCalculator_brandOfActuator_wabcoTristop": "WABCO Tristop",
    "valueCalculator_brandOfActuator_other": "Other",
    "value_cal_fleetSizeTractors_valMsg": "Introduzca el tamaño de la flota - Tractores",
    "value_cal_tractorTradeInCycle_valMsg": "Por favor, introduzca Tractor Trade-In Cycle",
    "value_cal_fleetSizeTrailers_valMsg": "Por favor, introduzca el tamaño de la flota - Remolques",
    "value_cal_trailerTradeInCycle_valMsg": "Por favor, introduzca el ciclo de intercambio de remolquese",
    "value_cal_repFleetCostPerActuator_valMsg": "Introduzca el coste de sustitución de la flota por actuador",
    "value_cal_laborToInstallActuator_valMsg": "Introduzca la mano de obra para instalar el actuador",
    "value_cal_noOfActuatorsReplacedPerYear_valMsg": "Introduzca el número de actuadores sustituidos al año",
    "value_cal_roadsideCallRate_valMsg": "Por favor, introduzca la tasa de llamadas en carretera",
    "value_cal_annualRoadsideCallsToActuators_valMsg": "Por favor, introduzca el Número Anual de Llamadas en Carretera relacionadas con Actuadoress",
    "value_cal_roadsideCallRateCsaViolation_valMsg": "Por favor, introduzca la tasa de llamadas en carretera por infracción de la CSA",
    "value_cal_annualOutOfServiceCsaViolations_valMsg": "Introduzca el número anual de infracciones de la CSA por frenos fuera de servicio",
    "value_cal_fleetDowntimeRate_valMsg": "Por favor, introduzca la tasa de tiempo de inactividad de la flota",
    "value_cal_greaterThan_zeroMsg": "Introduzca un valor superior a 0",
    "value_cal_landingPage_textMsg": "Descubra cuánto puede ahorrar al elegir los frenos de disco neumáticos Bendix®, los frenos de muelle EnduraSure®-Pro y el sistema de control de presión de neumáticos SmarTire® de Bendix CVS. Consulte nuestras calculadoras de valor fáciles de usar.",
    "value_cal_negativeVal_text": "No se obtiene ningún ahorro neto. La flota debe tener en cuenta otros beneficios, como la reducción de la garantía, el inventario de piezas y la utilización del tiempo de los técnicos.",
    "value_calculator_standardChamberLifetime": "Cámara estándar (de por vida)",
    "value_calculator_sealedChamberLifetime": "Cámara sellada (de por vida)",
    "value_calculator_formSubmit_success": "Your EnduraSure-Pro savings projection summary has been emailed.",
    "value_calculator_formSubmit_failed": "Something went wrong while submitting the  EnduraSure-Pro savings. Please try again later.",
    "value_calculator_estUpchargeForEndTractor_pdf": "Upcharge for EnduraSure-Pro per tractor",
    "value_calculator_estUpchargeForEndTrailer_pdf": "Upcharge for EnduraSure-Pro per trailer",
    "value_calculator_formSubmit_error": "Por favor, corrija los siguientes errores.",
    "value_calculator_fName_emptyMsg": "Nombre No puede estar vacío..",
    "value_calculator_lName_emptyMsg": "Apellido No puede estar vacío.",
    "value_calculator_email_emptyMsg": "Correo electrónico de la empresa No puede estar vacío.",
    "value_calculator_captcha_validMsg": "Por favor, introduzca un Captcha válido.",
    "value_calculator_captcha_expiredMsg": "Captcha caducado.",
    "value_calculator_captcha_failedMsg": "Error al cargar captcha.",
    "value_calculator_captcha_invalidMsg": "Captcha inválido, por favor inténtelo de nuevo.",
    "text_warranty_submit_datein_service_invalid": "Introduzca una fecha válida de entrada en servicio",
    "text_warranty_submit_date_removed_service_invalid": "Introduzca una fecha válida de retirada del servicio",
    "text_account_table_header_order": "Número de pedido de Bendix",
    "text_warranty_submit_part_mileage": "Millaje en servicio*",
    "register_site_description": "Al completar el siguiente formulario de registro, se enviará su solicitud de cuenta para su revisión. Recibirá una confirmación por correo electrónico con instrucciones adicionales.",
    "text_warranty_vinNumber_invalid": "Please enter a valid Vehicle ID/VIN-Number/Número de chasis",
    "register_submit": "Registrarse",
    "login_info": "Regístrese en Bendix y obtenga disponibilidad de productos, precios, información de pedidos y mucho más.",
    "text_warranty_submit_date_removed_invalid": "La fecha de retiro de servicio no puede ser anterior a la fecha de puesta en servicio.",
    "error_account_myPart_part_notcorrect": "línea {0}:  {1} El número de pieza {2} no se reconoce y no se cargó. Revise su entrada o comuníquese con su {3} servicio al cliente local.",
    "text_warranty_search_claim_number": "Número de reclamo de garantía Bendix",
    "error_account_myPart_part_dublicate": "Número de pieza ya utilizado.",
    "cart_page_req_delivery_date_for_all_items": "Fecha de entrega solicitada de todas las líneas",
    "text_warranty_search_part_number": "Número de pieza Bendix",
    "error_account_myPart_solto_select": "Seleccione cliente",
    "text_warranty_submit_kb_claim_generated": "generada automáticamente por Knorr-Bremse",
    "text_warranty_submit_returning_kbpart_number": "Devolución de la referencia de Knorr-Bremse*",
    "checkout_deliveryMethod_notSelected": "Seleccione un método de entrega para su pedido.",
    "text_warranty_submit_part_datein_service": "Fecha de puesta en servicio *",
    "text_account_warranty_table_header_claim_number": "Número de reclamo de garantía de Bendix",
    "text_warranty_submit_part_invoice_number": "Factura Knorr-Bremse  No.",
    "warranty_information": "Centro de información de garantía de Bendix",
    "text_core_search_coreGroup": "Ingrese grupo central",
    "text_warranty_submit_alphanumeric_invalid": "Please enter alphanumeric Number",
    "register_description": "Para un pago rápido, fácil acceso a pedidos anteriores y la capacidad de crear un directorio y guardar configuraciones. Regístrese a continuación.",
    "text_warranty_search_customer_part_number": "Número de pieza del cliente",
    "text_warranty_submit_part_type_number": "Tipo n.º",
    "text_warranty_submit_email": "Dirección de correo electrónico*",
    "text_core_search_partNumber": "Ingrese el N.º de pieza de Bendix",
    "error_account_myPart_part_notfound": "línea {0}:  {1} El número de pieza {2} no se reconoce y no se cargó. Revise su entrada o comuníquese con su {3} servicio al cliente local.",
    "text_warranty_claimRefNumber_invalid": "Please enter a valid Claim Number",
    "text_warranty_submit_datein_service_invalid_future": "Date In Service can't be in future date.",
    "text_warranty_submit_phone": "Número de teléfono",
    "text_warranty_submit_kb_claim_number": "Número de reclamo de Bendix",
    "import_csv_savedCart_customerPartNumber": "Número de pieza del cliente(determinará el número de pieza Bendix)",
    "quick_order_page_req_delivery_date_for_all_items": "Fecha de entrega solicitada de todas las líneas",
    "error_account_myPart_template_select": "Seleccione una plantilla",
    "text_warranty_submit_returning_part_number": "Número de pieza de devolución*",
    "text_account_warranty_table_header_part_number": "Bendix Part Number",
    "text_warranty_submit_date_removed_service_invalid_future": "Date Removed from Service can't be in future date.",
    "text_return_request_submit_returning_part_number": "Número de pieza Bendix*",
    "text_company_manageuser_disableuser_confirmation": "Doing this will prevent customer {0} from logging to storefront and placing order. Do you want to proceed?",
    "b2bcustomer_cancel": "Cancelar",
    "text_company_administrators_page_linkPreviousPage": "Página anterior",
    "b2busergroup_name": "User group Name",
    "text_company_manage_units_addressForm_edit_title": "Edit Address",
    "text_company_user_dr_name": "Dr.",
    "text_company_manageUsergroups_unit_edit": "Edit User group",
    "text_company_manage_units_createNewUnit": "New Unit",
    "text_company_members_page_sort_byUnit": "Unidad principal",
    "text_company_units_remove_confirmation_title_b2badmingroup": "Confirm removal of B2B Administrator",
    "text_company_permissions_page_linkPreviousPage": "Página anterior",
    "text_company_customers_page_linkNextPage": "Página siguiente",
    "text_company_manage_units_childUnits": "Child Units",
    "form_b2bunit_notunique": "Business unit with the same id already exists",
    "text_company_manageUsergroups_details": "{0}t",
    "text_company_costCenter_page_totalResults": "{0} Cost Centers found",
    "text_company_manageUser_usergroups_title": "User Groups",
    "text_company_on": "ON",
    "text_company_usergroup_button_createnew": "Editar",
    "text_company_manageUser_registration_showAllResults": "Mostrar todo",
    "text_company_usergroup_name_title": "User Name",
    "text_company_editOrDisableUsergroups": "Edit or disable order user groups",
    "text_company_usergroups_page_linkPreviousPage": "Página anterior",
    "text_company_organizationManagement": "Organization Management",
    "text_company_usergroups_page_sortTitle": "Ordenar por:",
    "b2buser_yes_button": "Sí",
    "text_company_administrators_page_sortTitle": "Ordenar por:",
    "header_link_company": "Mi empresa",
    "b2buser_no_button": "No",
    "text_company_costCenter_page_sortTitle": "Ordenar por:",
    "form_b2busergroup_parentunit_updated": "Please be aware that modifying a user group's parent unit can have adverse affects.",
    "text_company_manageUsergroups_remove": "Confirm Remove",
    "text_company_costCenter_disable_button": "Disable Cost Center",
    "text_company_costCenter_costCenterBreadCrumb": "Cost Center: {0}",
    "text_company_usergroups_page_showPageResults": "Mostrar paginado",
    "text_company_createNewUnits": "Create new units",
    "text_company_deselect_action_label": "Deselect",
    "text_company_budget_page_currentPage": "Página {0} de {1}",
    "text_company_managePermissions": "Permissions",
    "text_company_usergroups_viewDetails_label": "View User group Details",
    "text_company_budget_page_totalResults": "{0} Budgets found",
    "text_company_customers_page_sortTitle": "Ordenar por:",
    "text_company_costCenter_enabled_title": "Cost Center Enabled/disabled",
    "text_company_manage_budget_title": "Budgets",
    "text_Material_Core_Group": "Búsqueda de material/grupo central",
    "text_company_managePermissions_assignName_per": "PER",
    "text_company_managePermissions_page_firstPage": "&laquo;",
    "text_manageuser_password": "Please enter and confirm the password for customer {0}",
    "text_company_budget_status_active": "Active",
    "b2bunit_parent": "Unidad de negocios principal",
    "text_company_user_name": "First Name:",
    "text_company_managePermissions_page_lastPage": "&raquo;",
    "text_company_children_page_showPageResults": "Mostrar paginado",
    "text_company_managers_viewPage": "View Managers",
    "text_company_usergroup_value_title": "Value",
    "usergroup_unit_invalid": "Please select a Parent Business unit",
    "profile_currentPassword": "Contraseña actual*",
    "usergroup_uid_invalid": "Please select a unique identifier for the user group",
    "text_company_permissions_page_showAllResults": "Mostrar todo",
    "text_company_manage_units_unit_disable": "Confirm Disable",
    "text_company_manageUser_pageAll_firstPage": "&laquo;",
    "text_company_administrators_page_firstPage": "&laquo;",
    "form_select_empty": "Seleccione",
    "text_company_usergroup_unit_title": "Parent unit",
    "text_company_manage_units_newUnitButton": "Add New",
    "text_company_manageUsers_userDetails_title": "View User: {0}",
    "text_company_administrators_page_currentPage": "Página {0} de {1}",
    "text_company_manageusers_restpassword_breadcrumb": "Actualizar contraseña",
    "text_company_manageB2BUserGroup_title": "User Groups",
    "text_company_permissions_title": "Manage Permissions",
    "text_company_manageUser_registration_lastPage": "&raquo;",
    "text_company_managePermissions_page_totalResults": "{0} Permissions found",
    "account_confirmation_address_added": "Dirección creada con éxito",
    "text_company_managePermissions_threshold_value_error": "Please enter a value greater than zero",
    "text_company_permission_disable_confirm_yes": "Disable",
    "text_Document": "Documento",
    "text_company_approvers_page_linkNextPage": "Página siguiente",
    "text_company_manageUsergroup": "User groups",
    "text_company_managePermissions_threshold_value_invalid": "Please enter a valid amount",
    "form_b2bcustomer_adminrole_error": "A B2B Administrator can not downgrade their administrative role.",
    "b2bunit_approvalProcess": "Approval Process",
    "text_company_costCenter_page_showPageResults": "Mostrar paginado",
    "text_company_manage_units_addressForm_create_header": "Create Address for Unit: {0}",
    "text_company_managePermissions_unit_label": "Unidad principal",
    "text_company_managePermissions_create_type_label": "Tipo",
    "text_company_manageB2BUserGroup_page_firstPage": "&laquo;",
    "text_company_manageB2BUserGroup_subtitle": "User Groups allow you to assign permissions to multiple customers without adhering to the hierarchical structure of the organization hierarchy.",
    "text_company_customers_page_sort_byUnit": "Unidad principal",
    "text_costcenter_parentunit_disabled_error": "This cost center may not be set to active state because the parent B2B Unit not active.",
    "text_company_manageusers_usergroups_subtitle": "User groups allow you to assign permissions to multiple customers without adhering to the hierarchical structure of the organization hierarchy.",
    "text_company_manageUsergroups_remove_breadcrumb": "Remove {0} User group",
    "text_company_manage_units_create": "Create Child Unit for Unit: {0}",
    "profile_checkNewPassword_invalid": "Confirme su nueva contraseña",
    "text_company_user_ms_name": "SRTA",
    "text_company_users_remove_confirmation_title_usergroup": "Confirm removal of User Group",
    "text_mycompany_user_updateForm": "Please use this form to update customer {0} details",
    "text_How_to_guide": "Cómo guiar",
    "text_company_usergroups_page_sort_byDate": "Fecha",
    "text_company_manageUsergroups_detailsUserGroup_title": "User Group Details",
    "text_company_budget_SelectBudgets": "Select Budgets.",
    "text_company_manage_units_disabled_label": "disabled",
    "text_company_managePermissions_disable_breadcrumb": "Disable {0}",
    "text_company_manageusers_subtitle": "A user is an individual who is able to login to the {0}. The {0} functionality available to the user is dependent on the roles they have. B2B Administrators have access to the My Company area to modify the organization hierarchy. B2B Managers can view statistics on the sales of the organization (awaiting implementation). B2B Approvers can approve orders for which the B2B Customer did not have enough permissions. B2B Customers can place orders in the {0}front. In general, the visibility and jurisdiction of a user is restricted to the branch of the unit to which they are assigned.",
    "text_company_manage_units_managers_title": "Manage Managers for Unit: {0}",
    "text_company_editOrDisableBudgets": "Edit or disable budgets",
    "text_company_budget_createButton_displayName": "Add New",
    "text_company_managePermissions_view_page": "{0}t",
    "text_company_addExisting_button": "Add Existing",
    "text_company_manageUsergroups_disableUsergroup_confirmation": "Doing this will remove all the members from this User Group and it will become disabled. Do you want to proceed?",
    "text_company_usergroup_currency_title": "Currency",
    "text_company_manageUsergroups": "Manage User groups",
    "text_company_manage_units_addCostCenter_breadcrumb": "New Cost Center",
    "text_company_manageUsergroups_remove_success": "User group successfully removed",
    "b2busergroup_save": "Save Updates",
    "text_company_manageUser_pageAll_linkNextPage": "Página siguiente",
    "text_company_select_name": "Seleccionar",
    "text_company_manageUsers_edit_title": "Edit User",
    "text_company_manage_unit_address_cancelButton": "Cancelar",
    "text_company_manage_costcenters_subtitle": "All orders purchased on credit must be ordered against a cost center. The cost center&#145;s place within the organization structure defines who can place orders against it and its budget defines the limit of expenditure for that cost center at the {0}.",
    "text_company_costCenter_page_linkNextPage": "Página siguiente",
    "updatePwd_pwd_invalid": "La contraseña no cumple con los requisitos mínimos.",
    "text_company_children_page_lastPage": "&raquo;",
    "text_company_manage_units_addressForm_header": "Add Business Address",
    "text_company_manage_units_view_approvers_subtitle": "The approval process will assign orders to approvers referenced here if the individual has sufficient permissions to approve the order and an approver with lower sufficient permissions was not already found further down this branch of the organization hierarchy before reaching the cost center against which the order was placed.",
    "text_company_costCenter_disable_confirm": "Confirm Disable",
    "text_company_costCenter_page_sort_byCode": "Id",
    "text_company_manageB2BUserGroup_viewPage": "View Groups",
    "text_company_budget_page_sortTitle": "Ordenar por:",
    "text_account_profile_updatePasswordForm": "Contraseña",
    "text_company_manage_units_customers_mainTitle": "Select Customer(s)",
    "text_company_manageusers_edit": "Editar",
    "text_company_members_page_lastPage": "&raquo;",
    "text_company_manageUser_registration_sort_byEmail": "Email-Asc",
    "text_company_managePermissions_page_linkPreviousPage": "Página anterior",
    "text_company_user_rev_name": "Rev.",
    "text_company_costCenter_viewPage": "{0}t",
    "text_company_manage_costcenters_disable": "Disable",
    "text_company_managePermissions_create_permission_title": "New Permission",
    "text_company_manage_units_unit_edit_title": "Edit Unit: {0}",
    "text_company_managePermissions_title": "Permissions",
    "text_company_manageThresholds": "Manage Order Thresholds",
    "text_company_costCenter_addButton_displayName": "Create New Cost Center",
    "text_edit": "Editar",
    "text_myCompany_manageUsers_approvers_title": "Select Approver(s)",
    "b2bunit_name": "Business Unit Name",
    "b2busergroup_b2bapprovergroup_name": "B2B Approver",
    "text_company_usergroup_enable_button": "Enable",
    "text_company_manage_units_users_new_title": "New User",
    "user_email": "Email",
    "text_company_manageUser": "Usuarios",
    "text_company_manageUser_viewUsers": "View Users",
    "text_company_managePermissions_currency_label": "Permission currency",
    "text_company_permissions_page_totalResults": "{0} Permissions found",
    "text_company_manage_units_create_costCenter_title": "Create Cost Center for Unit: {0}",
    "text_company_manageUser_pageAll_lastPage": "&raquo;",
    "text_company_cancel_button": "Cancelar",
    "text_company_units_remove_b2bcustomergroup_confirmation": "Remove B2B Customer {0}",
    "text_company_manage_units_edit": "Editar",
    "text_company_approvers_page_totalResults": "{0} Approvers found",
    "text_company_manage_units_edituser_title": "Edit User for Unit: {0}",
    "text_account_user_saveUpdates": "Save Updates",
    "text_company_permissions_actions_title": "Acciones",
    "text_company_members_page_currentPage": "Página {0} de {1}",
    "text_company_manage_units_view_subtitle": "Units represent a logical grouping of individuals or function within an organization, such as a project team or a department. Units are placed into an organization hierarchy where units inherit properties from their parent unit, although this can be overridden for each unit.",
    "text_company_manageUser_pageAll_sort_byDate": "Fecha",
    "text_company_manage_costcenters_title": "Cost Centers",
    "text_company_editOrDisableUnits": "Edit or disable units",
    "text_company_costCenter_editPage_breadcrumb": "Edit Cost Center: {0}",
    "text_company_manage_units_button_createnew": "Create New",
    "text_company_members_page_sortTitle": "Ordenar por:",
    "text_company_manage_units_user_roles": "Roles",
    "text_confirmation_budget_created": "Budget created successfully",
    "text_confirmation_user_edited": "Customer successfully updated",
    "text_company_budget_page_sort_byValue": "Budget Amount",
    "text_company_addNewUsers": "Add new users",
    "text_company_addNew_button": "Add New",
    "text_company_manage_units_childrenUnits_id": "IDENTIFICACIÓN",
    "text_company_costCenter_state_active": "Active",
    "text_company_manageUsers_approvers_breadcrumb": "Approver(s)",
    "text_company_managePermissions_page_sort_byDate": "Fecha",
    "form_required": "Los campos marcados con asterisco (*) son obligatorios",
    "text_company_manageUser_registration_linkPreviousPage": "Página anterior",
    "text_company_manage_units_administrators_title": "Manage Administrators for Unit: {0}",
    "text_company_customers_page_sort_byName": "Nombre",
    "text_company_budget_page_sort_byUnitName": "Unidad principal",
    "text_company_costCenter_id_title": "Cost Center ID",
    "text_company_usergroup_edit_button": "Editar",
    "text_company_addNewUsergroup": "Add new user group",
    "text_company_budget_budgetId": "Budget ID",
    "text_company_manage_units_approvers_mainTitle": "Select Approver(s)",
    "user_title": "Título",
    "text_company_manage_units_administrators_subtitle": "Select or deselect users which should be administrators for this unit.",
    "text_company_budget_page_firstPage": "&laquo;",
    "text_company_managePermissions_viewDetails_page_title": "Permission Details",
    "text_company_diselect_name": "Diselect",
    "text_company_managePermissions_page_linkNextPage": "Página siguiente",
    "text_company_manage_units_adduser": "Create User for Unit: {0}",
    "text_company_usergroups_page_totalResults": "{0} User groups found",
    "text_company_select_budget": "Edit Related Budgets for Cost Center: {0}",
    "address_surname": "Apellido",
    "text_company_units_remove_confirmation_b2bmanagergroup": "Doing this will remove B2B Manager {0} from Business unit {1}. Do you want to proceed?",
    "text_company_customers_page_totalResults": "{0} Customers found",
    "text_company_units_remove_b2bmanagergroup_confirmation": "Remove B2B Manager {0}",
    "text_company_disable_confirm_yes": "Sí",
    "error_bugetcode_notfound": "Budget code is not valid",
    "text_company_manage_units_viewcustomer_breadcrumb": "{0}t",
    "text_company_permissions_page_sort_byUnitName": "Unidad principal",
    "text_company_managers_page_firstPage": "&laquo;",
    "text_company_budget_amount": "Budget Amount",
    "text_company_manageUser_pageAll_totalResults": "{0} usuario (s) encontrado",
    "text_company_manageUsergroups_usergroup_disable": "Confirm Disable",
    "text_company_customers_page_lastPage": "&raquo;",
    "text_company_approvers_page_linkPreviousPage": "Página anterior",
    "text_company_budget_endDateLesser_error_title": "End Date should be greater than Start Date",
    "text_account_addressBook_addEditform": "Utilice este formulario para agregar / editar una dirección.",
    "text_company_members_page_linkNextPage": "Página siguiente",
    "text_company_permissions_timespan_title": "Timespan",
    "text_company_manage_units_edituser": "Edit User for Unit: {0}",
    "text_company_manage_units_editCostCenter_breadcrumb": "Edit Cost Center for Unit: {0}",
    "text_company_permissions_type_label": "Permission type",
    "text_company_manageUser_registration_sort_byDateDesc": "Date-Desc",
    "text_company_manageUser_pageAll_showAllResults": "Mostrar todo",
    "text_company_roles_all_label": "All Roles:",
    "text_company_children_page_sort_byDate": "Fecha",
    "text_company_administrators_page_sort_byUnit": "Unidad principal",
    "text_company_managePermissions_status_enabled": "Enabled",
    "text_company_users_remove_confirmation_title_permission": "Confirm removal of Permission",
    "text_company_manage_units_remove": "Eliminart",
    "text_company_permission_disable_confirm_no": "Cancelar",
    "text_company_users_remove_confirmation_usergroup": "Doing this will remove member {0} from user group {1}. Do you want to proceed?",
    "text_company_usergroups_page_showAllResults": "Mostrar todo",
    "text_company_costCenter_unit_title": "Parent unit",
    "text_company_manage_units_view_units_subtitle": "Units represent a logical grouping of individuals or function within an organization, such as a project team or a department. The units below are descendant units of the current unit, for example, if this unit was \"Procurement\" then the child units might be \"Electricals Procurement\" and \"Office Supplies Procurement\". The child units, along with other business objects connected to them, form this branch of the organization hierarchy.",
    "text_company_manage_units_delete_address": "Eliminar dirección",
    "text_company_manageUser_registration_noRequestFound": "No hay solicitudes de registro pendientes.",
    "text_company_administrators_page_linkNextPage": "Página siguiente",
    "text_company_manage_units_unitDetails": "Unit Details",
    "text_company_user_resetPassword": "Restablecer contraseña",
    "text_company_costCenter_page_lastPage": "&raquo;",
    "text_company_managers_page_linkNextPage": "Página siguiente",
    "text_confirmation_user_close": "The user account {0} has been closed",
    "text_company_unit_contactNumber": "Contact Number",
    "text_company_managePermissions_edit_cancelButton": "Cancelar",
    "text_company_manageUsergroups_createUsergroup_breadcrumb": "Nuevo",
    "unit_name_invalid": "Please select a name for the business unit",
    "text_company_costCenter_code_exists_error_title": "This Cost Center ID already exists.",
    "text_company_manageB2BUserGroup_page_sort_byUnitName": "Unidad principal",
    "text_company_manage_units_disableUnit_confirmation": "Warning! Disabling this unit will also disable its child units, users, budgets, and cost centers.",
    "text_company_costCenter_create_label": "Create Cost Center",
    "text_company_managePermissions_enable_button": "Enable",
    "b2bunit_save": "Save changes",
    "address_postcode": "Código postal",
    "text_company_managePermissions_page_sort_byName": "Nombre",
    "success_remove_user_from_unit": "{0} successfully removed from {1} Business Unit",
    "text_company_members_page_showAllResults": "Mostrar todo",
    "text_company_units_remove_confirmation_title_b2bapprovergroup": "Confirm removal of B2B Approver",
    "text_company_manage_units_customers": "Customer(s)",
    "text_company_budget_addPage": "Nuevo",
    "text_mails_doubleopt_triggered": "Double Opt in Mail has been sent to : {0}",
    "text_company_manage_units_customers_subtitle": "Select or deselect users which should be customers for this unit.",
    "text_company_usergroups_page_linkNextPage": "Página siguiente",
    "text_company_managePermissions_value_label": "Threshold Amount",
    "text_company_manageUsergroups_breadcrumb": "User groups",
    "text_company_manage_unit_user_view": "Vert",
    "text_company_managers_page_sort_byUnit": "Unidad principal",
    "text_company_customers_page_linkPreviousPage": "Página anterior",
    "text_company_costCenter_update_success": "Cost Center updated successfully",
    "text_company_budget_viewPage_costCenters": "Cost Centers",
    "text_company_managers_page_totalResults": "{0} Managers found",
    "text_company_members_page_linkPreviousPage": "Página anterior",
    "text_company_usergroups_viewPage": "View User groups",
    "text_company_managePermissions_edit_page": "Editar",
    "text_company_children_page_currentPage": "Página {0} de {1}",
    "text_company_user_mr_name": "SR",
    "text_company_customers_page_currentPage": "Página {0} de {1}",
    "text_company_budget_edit_title_label": "Edit Budget",
    "text_company_permissions_value_title": "Value",
    "text_company_managePermissions_disable_confirm": "Confirm Disable",
    "text_company_manage_units_childrenUnits_actions": "Acciones",
    "text_company_manageUser_userDetails": "Detalles de usuario",
    "b2bunit_no_button": "No",
    "text_company_budget_noBudgetMessage": "No Budgets found.",
    "text_company_permissions_view_page": "View Permission {0}",
    "text_company_costCenter_selectBox_unit": "Please select unit",
    "text_company_permissions_unit_label": "Unidad de negocios principal",
    "text_company_manageUsers_users_new_title": "New User",
    "text_company_organizationManagement_manageUsergroup_breadcrumb": "Manage User group",
    "text_company_manageUsergroups_createUserGroup_title": "New User Group",
    "text_company_costCenter_state_title": "Estado",
    "text_company_manageUser_registration_request_breadcrumb": "Peticiones",
    "text_company_units_remove_confirmation_title_b2bmanagergroup": "Confirm removal of B2B Manager",
    "text_company_manage_unit_editAddress": "Edit Address",
    "text_company_budget_page_linkNextPage": "Página siguiente",
    "text_company_members_page_firstPage": "&laquo;",
    "text_company_managePermissions_actions_title": "Acciones",
    "text_company_managePermissions_permissionType_title": "Permission Type",
    "text_user_disabled": "Disabled User",
    "text_company_manage_unit_costCenter_edit": "Editar",
    "text_company_disable_name": "Disable",
    "text_company_permissions_viewDetails_page_title": "View Permissions",
    "text_company_manage_units_button_enableUnit": "Enable Unit",
    "text_company_permission_disable_confirm_message": "Warning! Disabling this Permission will not allow it to be used.",
    "text_company_manage_unit_saveAddress": "Guardar dirección",
    "text_company_manageB2BUserGroup_page_sortTitle": "Ordenar por:",
    "text_company_usergroups_page_firstPage": "&laquo;",
    "text_company_manageUser_registration_sort_byCountry": "Country-Asc",
    "text_company_editOrDisableUsers": "Edit or disable users",
    "text_company_costCenter_page_firstPage": "&laquo;",
    "text_company_manageB2BUserGroup_page_showPageResults": "Mostrar paginado",
    "text_company_costCenter_currency_title": "Currency",
    "text_company_unit_parent": "Unidad principal",
    "text_company_column_status_name": "Estado",
    "text_company_managePermissions_page_showAllResults": "Mostrar todo",
    "text_company_managePermissions_subtitle": "Permissions define the financial limits of a user. Permissions can be on a per-order or per-timespan basis.",
    "text_company_usergroups_page_sort_byName": "Nombre",
    "text_company_managePermissions_name_label": "Permission ID",
    "text_company_manageUsers_usergroups_breadcrumb": "User Group(s)",
    "text_company_managePermissions_code_exists_error_title": "Permission with this name already exists.",
    "text_company_managePermissions_page_sortTitle": "Ordenar por:",
    "text_company_manageUser_permission_title": "Permissions",
    "text_company_managePermissions_add_page_title": "Create Permission",
    "text_company_costCenter_add_new_label": "New Cost Center",
    "text_company_members_page_sort_byName": "Nombre",
    "text_company_costCenter_saveButton_displayName": "Guardar",
    "text_company_managePermissions_selectBox_permissionType": "Seleccionar",
    "text_company_manage_units_parentUnit_disabled": "It is not possible to enable unit whose parent unit is disabled",
    "text_company_user_parentBusinessUnit": "Unidad de negocios principal",
    "text_company_customers_viewPage": "View Customers",
    "text_company_administrators_page_sort_byName": "Nombre",
    "text_company_budget_noCostCentersFound_message": "No Cost Centers found.",
    "text_company_manageUsers_back_button": "Back to Users",
    "text_company_budget_code_exists_error_title": "Budget Id already exists.",
    "text_company_usergroups_page_sort_byUnitName": "Unidad principal",
    "text_company_myCompany": "Mi empresa",
    "text_company_roles_name": "Roles",
    "text_company_manage_unit_costCenter_id": "IDENTIFICACIÓN",
    "text_company_manageUser_registration_sort_byDate": "Date-Asc",
    "address_title_pleaseSelect": "título",
    "text_company_budget_edit": "Editar",
    "text_company_addNewCostCenters": "Add new cost center",
    "text_company_units_remove_confirmation_b2bcustomergroup": "Doing this will remove B2B Customer {0} from Business unit {1}. Do you want to proceed?",
    "text_company_budget_saveButton_displayName": "Guardar",
    "text_company_manage_costcenters_edit_budgets_subtitle": "A cost center needs an active budget in so that a customer can place orders against it.",
    "text_company_manageusers_permission_edit": "Edit Permission {0}",
    "text_company_manage_units_childrenUnits_name": "Nombre",
    "text_company_manage_units_usergroups_title": "Manage User groups for User: {0}",
    "text_company_manageUser_user_parentUnit": "Unidad principal",
    "text_company_editOrDisableCostCenters": "Edit or disable cost centers",
    "usergroup_disabled": "User group is not active, in order to activate it add members to this user group",
    "text_company_budget_end": "End",
    "text_company_usergroups_users_subtitle": "Users within a User group will in-effect be assigned the Permissions of the User group.",
    "text_company_manageusers_button_enableuser": "Enable User",
    "text_company_budget_page_sort_byName": "Nombre",
    "profile_newPassword": "Nueva contraseña*",
    "text_company_manage_units_approvers_subtitle": "Select or deselect users which should be approvers for this unit.",
    "text_company_manageUser_pageAll_currentPage": "Página {0} de {1}",
    "text_company_costCenter_name_title": "Cost Center Name",
    "text_company_manageUsergroups_newUserGroupButton": "Create New User group",
    "text_company_managePermissions_create_step2_page": "Step2",
    "text_company_costCenter_disable_warning_message": "Warning!  Disabling this Cost Center will make it unavailable when placing orders.",
    "text_company_budget_status": "Estado",
    "text_company_permissions_page_sort_byDate": "Fecha",
    "text_company_manage_units_accountManager_name": "Nombre",
    "text_company_manageUser_addedituser": "Edit User",
    "text_company_manage_units_managers_subtitle": "Select or deselect users which should be managers for this unit.",
    "text_parentunit_disabled_warning": "The parent business unit of this customer is not active. In order to manage this customer activate the parent unit first.",
    "text_company_managePermissions_timespan_label": "Time Period",
    "text_company_approvers_page_sort_byUnit": "Unidad principal",
    "text_company_manageUser_back_button": "Back to User Details",
    "text_company_manage_units_label": "Units",
    "text_company_members_actions_title": "Acciones",
    "text_company_manage_unit_childrenUnits_edit": "Editar",
    "text_company_manage_units_addnewUnit": "Add New Unit",
    "text_company_manage_units_header_approvers": "Approvers",
    "text_company_manageUsers_details_breadcrumb": "{0}t",
    "text_company_manage_costcenters_view_budgets_subtitle": "A cost center needs budgets assigned to it so that customers can place orders against the cost center. This is possible until the limit of the active budget is reached.",
    "text_company_approvers_viewPage": "View Approvers",
    "text_company_approvers_name_title": "Nombre",
    "text_company_manage_units_managers": "Manager(s)",
    "text_company_users_remove_confirmation_permission": "Doing this will remove Permission {0} from Customer {1}. Do you want to proceed?",
    "text_company_budget_id": "IDENTIFICACIÓN",
    "text_company_budget_disable_confirm_yes": "Sí",
    "text_company_manage_units_editUnit_breadcrumb": "Editar",
    "text_company_manageUser_pageAll_sortTitle": "Sort By:",
    "text_mails_passwordSetup_triggered": "Password Setup Mail has been sent to : {0}",
    "text_company_addNewPermission": "Add new permission",
    "text_company_parentUnit_name": "Unidad principal",
    "text_company_approvers_page_firstPage": "&laquo;",
    "text_company_user_title": "Title:",
    "text_company_manage_budget_view_subtitle": "Budgets limit the amount your organization can spend at the {0}. For a budget to be used by the system it must be assigned to a cost center so that it is assessed when an order is placed against the cost center.",
    "text_company_usergroup_permission_name": "Permission Name",
    "text_company_customers_page_showAllResults": "Mostrar todo",
    "text_company_managePermissions_active_label": "Permission enabled/disabled",
    "text_company_costCenter_edit_title": "Editar",
    "text_company_managers_page_showAllResults": "Mostrar todo",
    "text_company_managePermissions_assignName_budget": "BUDGET",
    "text_company_children_page_firstPage": "&laquo;",
    "user_lastName": "Apellido",
    "text_company_approvers_unit_title": "Unidad principal",
    "b2bunit_disabled_infomsg": "This business unit is disabled",
    "text_company_manageUsers_usergroups_title": "Select User Group(s)",
    "text_company_budget_actions": "Acciones",
    "profile_newPassword_invalid": "Ingrese su nueva contraseña",
    "text_company_budget_page_linkPreviousPage": "Página anterior",
    "text_company_manageUsergroups_editUserGroup_title": "Edit User Group",
    "profile_email_invalid": "Ingrese un correo electrónico válido",
    "text_company_column_roles_name": "Roles",
    "text_company_manageB2BUserGroup_page_linkPreviousPage": "Página anterior",
    "text_company_manageUser_registration_totalResults": "Solicitudes encontradas",
    "text_confirmation_user_disable": "The user {0} has been disabled",
    "address_line1": "Dirección*",
    "text_company_budget_viewPage_back": "Back to Budgets",
    "address_line2": "Dirección Línea 2",
    "b2bunit_cancel": "Cancelar",
    "text_company_manageUser_registration_sort_byName": "Name-Asc",
    "text_company_managePermissions_page_sort_byUnitName": "Unidad principal",
    "text_company_budget_page_showPageResults": "Mostrar paginado",
    "text_company_manageusers_button_disableuser": "Disable User",
    "text_company_usergroups_permissions_title": "Select Permission(s)",
    "text_company_manageusers_permissions_subtitle": "Permissions define the financial limits of a user. Permissions can be on a per-order or per-timespan basis.",
    "text_company_budget_disableButton_displayName": "Disable Budget",
    "text_company_manage_units_button_create": "Create",
    "text_company_budget_status_disabled": "Disabled",
    "text_company_administrators_page_showAllResults": "Mostrar todo",
    "text_company_users_remove_permission_confirmation": "Remove Permission {0}",
    "text_company_manage_units_addressForm_create_title": "New Address",
    "text_company_members_roles_title": "Roles",
    "text_company_usergroup_disable_label": "Disable User Group",
    "text_company_user_mrs_name": "SRA",
    "b2busergroup_b2bcustomergroup_name": "B2B Customer",
    "text_company_manage_costcenters_view_subtitle": "All orders purchased on credit must be ordered against a cost center. The cost center's parent unit defines its place within the organization and hence the users who can place orders against it.",
    "text_company_manage_units_children": "Business Unit {0} Child Units",
    "text_company_permissions_page_sort_byName": "Nombre",
    "text_company_manage_units_delete_address_message": "Are you sure you would like to delete this address?",
    "text_company_usergroup_delete_warning_message": "Warning! Are you sure you would like to delete this user group?",
    "text_company_column_parentUnit_name": "Unidad principal",
    "text_confirmation_user_rejected": "The registration request for {0} been rejected.",
    "text_company_managePermissions_currency_title": "Currency",
    "text_company_managers_page_currentPage": "Página {0} de {1}",
    "text_company_manage_units_button_disableUnit": "Disable Unit",
    "text_company_usergroup_disable_warning_message": "Warning! Disabling {0} will remove all users.",
    "text_company_permissions_value_label": "Permission value",
    "text_company_name_name_title": "Nombre",
    "account_confirmation_address_removed": "Dirección eliminada con éxito",
    "text_company_manage_units_address_country": "País / región",
    "text_company_user_email": "Email",
    "text_company_manageUser_permission": "Permiso",
    "text_company_unit_approvalProcess": "Approval Process",
    "text_company_manage_units_address_actions": "Acciones",
    "text_company_manageB2BUserGroup_page_totalResults": "{0} User Groups found",
    "text_company_permissions_page_currentPage": "Página {0} de {1}",
    "text_confirmation_budget_updated": "Budget updated successfully",
    "text_company_manageUser_pageAll_linkPreviousPage": "Página anterior",
    "text_company_costCenter_create_success": "Cost Center created successfully",
    "text_company_usergroups_page_currentPage": "Página {0} de {1}",
    "text_company_manageUsergroups_editUsergroup_breadcrumb": "Editar",
    "text_company_save_button": "Guardar",
    "text_company_save_later_button": "Save for later",
    "account_confirmation_address_updated": "Dirección actualizada con éxito",
    "text_company_manageUser_registration_sort_byNameDesc": "Name-Desc",
    "text_company_manageBudgets_budget_invalid": "Please enter a valid budget",
    "text_company_managePermissions_type_label": "Permission type",
    "text_company_manage_unit_costCenter_actions": "Acciones",
    "text_company_manageBudgets": "Budgets",
    "text_company_permissions_name_title": "Permission Name",
    "text_company_manageB2BUserGroup_page_currentPage": "Página {0} de {1}",
    "text_company_manageUser_user_viewDetails": "View User Detail",
    "text_company_permissions_subtitle": "Permissions define the financial limits of a user. Permissions can be on a per-order or per-timespan basis.",
    "text_company_units_remove_b2bapprovergroup_confirmation": "Remove B2B Approver {0}",
    "text_company_editOrDisableUsergroups_confirm": "Confirm User group Changes",
    "text_company_budget_viewPage_label": "Budget Details",
    "text_company_delete_button": "Eliminar",
    "text_confirmation_password_updated": "Password of the customer updated successfully",
    "text_company_administrators_page_sort_byDate": "Fecha",
    "text_company_status_active_true": "Active",
    "text_company_manageUsers": "Usuarios",
    "text_company_not_applicable": "n/a",
    "text_company_manage_units_addressForm_edit_header": "Edit Address for Unit: {0}",
    "text_company_managePermissions_addButton_displayName": "Add New",
    "text_company_manage_units_button_editUnit": "Editar",
    "text_company_column_name_name": "Nombre",
    "text_company_manage_units_administrators": "Administrator(s)",
    "text_company_budget_currency": "Currency",
    "text_company_column_type": "Tipo",
    "text_company_usergroups_permissions_breadcrumb": "Permission(s)",
    "text_company_managePermissions_status_disabled": "Disabled",
    "text_company_permissions_unit_title": "Unidad de negocios principal",
    "text_company_name_name": "Nombre",
    "text_company_budget_create_title_label": "New Budget",
    "text_company_select_action_label": "Seleccionar",
    "text_company_manage_unit_costCenter_currency": "Currency",
    "text_company_noentries": "No Entries",
    "text_company_budget_start": "Comenzar",
    "text_company_costCenter_page_currentPage": "Página {0} de {1}",
    "address_townCity": "Ciudad",
    "text_company_select_budgets": "Select Budget(s)",
    "text_company_costCenter_addNew": "Add New",
    "text_company_permissions_page_sortTitle": "Ordenar por:",
    "b2busergroup_id": "User group ID",
    "text_confirmation_user_approved": "Se aprobó la solicitud de registro para {0}.",
    "text_company_usergroup_id_title": "User group ID",
    "text_company_manage_units_user_actions": "Acciones",
    "text_company_manageB2BUserGroup_page_linkNextPage": "Página siguiente",
    "text_company_deselect_action_label_confirm": "Confirm Deselect",
    "text_company_managers_page_linkPreviousPage": "Página anterior",
    "text_company_manageusers_label": "Usuarios",
    "text_company_manage_units_disabled": "Business Unit has been disabled",
    "text_company_budget_enabledDisabled": "Estado",
    "text_company_manage_units_approvers_manage_title": "Manage Approvers for Unit: {0}",
    "text_company_manage_units_view_addresses_subtitle": "The Addresses will be available to a customer ordering for a cost center related to this unit.",
    "text_company_manage_units_view_managers_subtitle": "Users with the manager role have the ability to see reports using the reports area of the storefront (awaiting implementation). Adding or removing a user here adds or removes the manager role from the user.",
    "text_company_permissions_timespan_label": "Permission timespan",
    "text_company_manageB2BUserGroup_page_sort_byName": "Nombre",
    "text_company_manageB2BUserGroup_page_showAllResults": "Mostrar todo",
    "text_company_manage_units_addAddress": "New Address",
    "text_company_user_password": "Password:",
    "text_company_costCenter_page_sort_byUnitName": "Unidad principal",
    "text_company_manage_units_address_towncity": "Town/City",
    "unit_uid_invalid": "Please select a unique identifier for the business unit",
    "text_company_approvers_page_lastPage": "&raquo;",
    "text_company_budget_disable_confirm_no": "No",
    "text_company_usergroup_delete_label": "Delete User Group",
    "text_company_usergroups_page_lastPage": "&raquo;",
    "text_company_manageUsergroup_editForm": "Please use this form to update user group details",
    "text_company_manage_units_customers_title": "Manage Customers for Unit: {0}",
    "text_company_budget_budgetBreadCrumb": "Budget {0}",
    "text_company_manage_units_createUnit_breadcrumb": "Nuevo",
    "text_company_manage_units_view_administrators_subtitle": "Users with the administrator role have the ability to administrate this branch of the organization using the My Company area of the storefront. Adding or removing a user here adds or removes the administrator role from the user.",
    "text_company_units_remove_confirmation_title_b2bcustomergroup": "Confirm removal of B2B Customer",
    "text_coreSearchTab_error": "Invalid input or no results found, please try again.",
    "text_company_manage_units_user_email": "Email",
    "text_company_costCenter_disable_confirm_yes": "Sí",
    "text_company_user_miss_name": "Miss",
    "text_company_editOrDisablePermissions": "Edit or disable permissions",
    "text_company_organizationManagement_createuser": "Nuevo",
    "text_company_costCenter_edit_required_label": "Fields marked with * are required",
    "text_company_manageUser_noUser": "No tienes usuarias",
    "text_company_usergroup_timespan_title": "TimeSpan",
    "address_selectCountry": "País",
    "text_company_budget_page_showAllResults": "Mostrar todo",
    "validation_checkPwd_equals": "La contraseña y la confirmación no coinciden",
    "text_company_manage_units_address_zipcode": "Postal Code",
    "text_company_managePermissions_create_new_permission": "Nuevo",
    "text_company_units_remove_b2badmingroup_confirmation": "Remove B2B Administrator {0}",
    "text_company_approvers_page_sort_byName": "Nombre",
    "text_company_permissions_page_showPageResults": "Mostrar paginado",
    "text_company_children_page_linkNextPage": "Página siguiente",
    "text_confirmation_approver_removed": "Approver removed successfully",
    "text_company_manageUsers_edituser_title": "Editar detalles de usuario",
    "text_company_members_page_totalResults": "{0} Members found",
    "text_company_manageusers_approvers_subtitle": "The approval process will assign orders to approvers if the customer placing the order has insufficient permissions to do so. By default approvers are picked from the organization hierarchy, but additional approvers can be assigned to a specific customer here.",
    "text_company_costCenter_id": "IDENTIFICACIÓN",
    "text_company_costCenter_budget_title": "Budget(s)",
    "text_company_manageUser_registration_sort_byCity": "City-Asc",
    "text_company_manageUser_registration_sortTitle": "Sort By:",
    "text_company_actions_name": "Acciones",
    "text_company_costCenter_page_sort_byName": "Nombre",
    "text_company_manageUser_button_edit": "Editar",
    "text_company_manage_units_permissions_breadcrumb": "Permission(s)",
    "text_company_managers_page_lastPage": "&raquo;",
    "text_company_manage_unit_user_enable": "Enable",
    "text_company_managers_page_sort_byName": "Nombre",
    "text_company_manageUser_registration": "Mostrar todo",
    "text_company_manageUser_registration_currentPage": "Página {0} de {1}",
    "text_company_manage_units_view_customers_subtitle": "Users with the customer role have the ability to place orders against cost centers to which they have access. Adding or removing a user here adds or removes the customer role.",
    "form_global_error": "Corrija los siguientes errores.",
    "text_company_manageUser_registration_showPageResults": "Mostrar paginado",
    "text_company_permissions_page_firstPage": "&laquo;",
    "text_company_usergroups_members_breadcrumb": "User(s)",
    "text_company_off": "OFF",
    "text_company_manageUser_registration_firstPage": "&laquo;",
    "user_firstName": "Nombre",
    "text_company_permission_disable_confirm": "Disable Permission",
    "text_confirmation_permission_created": "Permission created successfully",
    "myCompany_login_myCompanyHome": "Login to My Company",
    "address_firstName": "Nombre",
    "text_company_manageUser_user_firstName": "Nombre",
    "text_company_manageusers_roles_subtitle": "A user is an individual who is able to login to the {0}. The functionality available to a user is dependent on the roles they have. B2B Administrators have access to the My Company area to modify the organization hierarchy. B2B Managers can view statistics on the sales of the organization (awaiting implementation). B2B Approvers can approve orders for which the B2B Customer did not have enough permissions. B2B Customers can place orders in the {0}front.",
    "text_company_budget_disable_confirm": "Confirm Disable",
    "text_company_editOrDisableUsergroups_confirm_action_label_confirm": "Confirm Changes",
    "text_company_administrators_viewPage": "View Administrators",
    "usergroup_no_button": "No",
    "text_company_manage_unit_user_disable": "Disable",
    "text_company_costCenter_selectBox_currency": "Please select currency",
    "text_company_manage_budget_view_costcenter_subtitle": "The budget is assigned to these cost centers.<br /> To modify these assignments you need to navigate to the respective cost center using the links below.",
    "text_company_units_remove_confirmation_b2bapprovergroup": "Doing this will remove B2B Approver {0} from Business unit {1}. Do you want to proceed?",
    "text_company_costCenter_back": "Back to Cost Centers",
    "text_company_members_name_title": "Nombre",
    "form_b2busergroup_notunique": "User group with the same id already exists",
    "text_company_disable_confirm_no": "No",
    "text_company_organizationManagement_manageUser_breadcrumb": "Manage User",
    "text_company_unit_name": "Unit Name",
    "text_company_manage_unit_user_edit": "Editar",
    "text_manageuser_error_email_exists_title": "Email already exists",
    "text_company_approvers_page_sortTitle": "Ordenar por:",
    "text_company_managePermissions_edit_page_title": "Edit Permission",
    "text_company_managePermissions_create_step1_page": "Create Permission - Step 1",
    "usergroup_name_invalid": "Please select a name for the user group",
    "text_company_children_page_sortTitle": "Ordenar por:",
    "text_company_manageUser_registration_sort_byActiveDesc": "Active-Desc",
    "text_company_members_unit_title": "Parent unit",
    "text_company_back": "Regresar",
    "text_company_usergroup_back_button": "Back to User Groups",
    "text_company_id_name": "IDENTIFICACIÓN",
    "text_company_managePermissions_name_title": "Permission Name",
    "text_company_members_page_sort_byDate": "Fecha",
    "text_company_managePermissions_selectBox_timespan": "Select a timespan",
    "text_company_users_remove_confirmation_title_b2bapprovergroup": "Confirm removal of B2B Approver",
    "general_required": "Obligatorio",
    "text_company_costCenter_disable_confirm_message": "Doing this will prevent this cost center from being used when placing orders. Do you wish to continue?",
    "text_company_manageB2BUserGroup_page_lastPage": "&raquo;",
    "b2busergroup_parent": "Unidad de negocios principal",
    "text_company_costCenter_viewDetails_label": "Cost Center Details",
    "text_company_manageUsergroups_unit_create": "Create User group",
    "text_company_user_roles": "Roles",
    "text_coreSearchTab_content": "Si no está seguro del número de material o del grupo central, ingrese la información conocida a continuación en el campo correspondiente.",
    "text_company_budget_endDate": "End Date",
    "text_company_manage_units_details": "{0}t",
    "text_company_managePermissions_create_continueButton": "Continuar",
    "address_title_none": "Ninguno",
    "text_company_manageUser_user_lastName": "Apellido",
    "text_company_manage_units_unit_create": "Create Child Unit for Unit: {0}",
    "text_company_manage_unit_costCenter_view": "Vert",
    "text_confirmation_permission_updated": "Permission updated successfully",
    "text_company_editOrDisableUsergroups_confirm_action_label_cancel": "Cancelar",
    "text_company_done_button": "Listo",
    "text_company_manage_units_view_accountManagers_subtitle": "The Account Managers are the {0} contacts for this unit.",
    "text_company_manage_unit_costCenter_name": "Nombre",
    "text_company_manage_units_header_administrators": "Administrators",
    "text_company_manage_units_users_button_edit": "Editar",
    "text_company_budget_viewPage": "{0}t",
    "text_company_budget_name": "Budget Name",
    "text_company_managers_page_showPageResults": "Mostrar paginado",
    "text_company_budget_startDate": "Start Date",
    "text_company_manage_costcenter_budget_title": "Budgets",
    "text_company_managePermissions_value_title": "Threshold Value",
    "text_company_permissions_currency_title": "Currency",
    "text_Shipping_Packaging": "Envío/Embalaje",
    "text_company_budget_page_sort_byCode": "Id",
    "usergroup_notfound": "User group not found",
    "text_company_costCenter_addPage": "Nuevo",
    "text_company_manage_units_disable_breadcrumb": "Disable {0} Business Unit",
    "text_company_budget_deselect_confirm": "Confirm Budget Deselect",
    "text_company_manage_units_approvers": "Approver(s)",
    "text_company_manage_units_user_name": "Nombre",
    "text_account_dropship_address": "Dirección de envío directo",
    "text_confirmation_user_accepted": "The Registration request has been accepted.",
    "usergroup_yes_button": "Sí",
    "text_company_add_button": "Agregar",
    "text_company_manageUser_pageAll_sort_byName": "Nombre",
    "text_company_editOrDisableUsergroups_confirm_message": "There are possible implications or limitations associated with modifying a user group's parent unit.  Please confirm these changes are intended.",
    "text_company_approvers_page_showAllResults": "Mostrar todo",
    "text_company_budget_cancelButton_displayName": "Cancelar",
    "text_confirmation_permission_removed": "Permission removed successfully",
    "text_company_managePermissions_disable_confirm_message": "Doing this will stop this permission level from being used. Do you wish to continue?",
    "text_company_manageusers_details_subtitle": "The functionality available to a user is dependent on the roles they have. In general, the visibility and jurisdiction of a user is restricted to the branch of the unit to which they are assigned.",
    "text_company_manageUser_pageAll": "Mostrar todo",
    "text_company_manageUser_registration_sort_byCountryDesc": "Country-Desc",
    "text_company_managers_page_sortTitle": "Ordenar por:",
    "form_b2bcustomer_parentunit_error": "A B2B Administrator can not modify his parent unit.",
    "text_company_costCenter_select_budget": "Edit Related Budgets",
    "text_mycompany_user_createForm": "Please use this form to create a new customer",
    "text_company_usergroup_members": "Usuarios",
    "text_company_managePermissions_disable_confirm_no": "No",
    "form_b2bunit_success": "Business unit saved successfully",
    "text_company_costCenter_cancelButton_displayName": "Cancelar",
    "text_company_manageUser_registration_sort_byEmailDesc": "Email-Desc",
    "text_company_permissions_page_linkNextPage": "Página siguiente",
    "error_budget_parentunit_disabled": "This budget may not be set to not active state because the parent B2B Unit not active.",
    "text_company_usergroups_page_sort_byGroupID": "Id",
    "text_company_managePermissions_disable_button": "Disable Permission",
    "text_confirmation_user_saved": "The user details for {0} has been saved.",
    "text_company_managePermissions_unit_title": "Unidad de negocios principal",
    "text_company_manageUser_user_costCenter": "Cost Centers",
    "text_company_manage_units_button_editChildren": "Editar",
    "text_company_manage_units_costCenters": "Cost Centers",
    "b2busergroup_cancel": "Cancelar",
    "text_company_manage_unit_user_remove": "Eliminart",
    "text_company_manage_units_adduser_title": "Create User for Unit: {0}",
    "profile_checkNewPassword": "Confirmar nueva contraseña*",
    "text_company_unit_id": "Unit ID",
    "text_company_manage_units_view_costCenters_subtitle": "The cost centers will be available to members of this branch when placing an order.",
    "text_company_manageUser_user_roles": "Roles",
    "text_company_managePermissions_page_currentPage": "Página {0} de {1}",
    "address_country": "País / región",
    "text_manageuser_restpasswordform": "Restablecer contraseña",
    "text_company_customers_page_sort_byDate": "Fecha",
    "text_company_costCenter_name": "Nombre",
    "text_company_manageCostCenters": "Cost Centers",
    "text_company_administrators_page_showPageResults": "Mostrar paginado",
    "text_company_children_page_sort_byName": "Nombre",
    "text_company_status_title": "Estado",
    "text_company_approvers_page_currentPage": "Página {0} de {1}",
    "text_company_breadcrumb": "Mi cuenta de empresa",
    "text_company_user_userEnabledStatus": "User Enabled Status",
    "text_company_manageUser_registration_totalResultsSinglePag": "{0} nuevas solicitudes encontradas",
    "text_company_user_unit_title": "Unidad principal",
    "text_company_manageUser_registration_request_details": "Request Details",
    "text_confirmation_user_enable": "The user {0} has been enabled",
    "form_b2busergroup_success": "User group updated successfully",
    "text_company_manageUser_registration_sort_byCityDesc": "City-Desc",
    "b2bunit_notfound": "Business Unit was not found",
    "text_company_customers_page_firstPage": "&laquo;",
    "text_company_manage_units_addresses": "Addresses",
    "text_company_managePermissions_status_title": "Estado",
    "text_company_manageUser_pageAll_showPageResults": "Mostrar paginado",
    "text_company_manageUser_roles": "Roles",
    "text_company_manageUser_registration_linkNextPage": "Página siguiente",
    "text_company_manage_units_users_button_createnew": "Nuevo",
    "text_company_manage_units_address_line2": "Dirección Línea 2",
    "text_company_manage_units_address_line1": "Address Line 1",
    "text_company_manageusers_permissions_title": "Select Permission(s)",
    "text_company_costCenter_disable_confirm_no": "No",
    "text_company_costCenter_state_inactive": "Disabled",
    "text_company_manageUser_button_create": "Crear nuevo usuario",
    "text_company_approvers_page_showPageResults": "Mostrar paginado",
    "text_company_costCenter_enable_button": "Enable",
    "text_company_administrators_page_lastPage": "&raquo;",
    "text_company_manage_units_administrators_mainTitle": "Select Administrator(s)",
    "text_company_managePermissions_create_step1": "Step 1 of 2",
    "text_company_managePermissions_create_step2": "Step 2 of 2",
    "address_title": "Título",
    "text_company_manage_units": "Units",
    "text_company_managePermissions_disable_confirm_yes": "Sí",
    "text_company_managePermissions_page_showPageResults": "Mostrar paginado",
    "text_company_manageuser_user_disable": "Confirm Disable",
    "text_company_budget_enableButton_displayName": "Enable",
    "text_company_budget_page_lastPage": "&raquo;",
    "text_confirmation_user_added": "Customer successfully created",
    "b2busergroup_b2badmingroup_name": "B2B Administrator",
    "text_company_permission_enable_confirm": "Enable Permission",
    "text_company_manage_units_createuser_breadcrumb": "New User",
    "text_company_manage_unit_childrenUnits_view": "Vert",
    "text_company_costCenter_button_displayName": "Editar",
    "form_b2bunit_approvalProcessCode_required": "Please select an approval process for the root unit",
    "text_company_column_id_name": "IDENTIFICACIÓN",
    "text_company_members_page_showPageResults": "Mostrar paginado",
    "text_company_approvers_actions_title": "Acciones",
    "text_company_managePermissions_timespan_title": "Timespan",
    "text_company_costCenter_edit_label": "Edit Cost Center",
    "text_company_disable_confirm": "Confirm Disable",
    "text_company_manageUser_registration_totalResultsSingleOrder": "1 Solicitudes encontradas",
    "text_company_manage_budget_subtitle": "Budgets limit the amount your organization can spend at the {0}.",
    "text_company_managePermissions_assignName_order": "ORDER",
    "text_company_users_remove_confirmation_b2bapprovergroup": "Doing this will remove B2B Approver {0} from Customer {1}. Do you want to proceed?",
    "text_company_usergroup_disable_button": "Disable",
    "text_company_children_page_showAllResults": "Mostrar todo",
    "b2bunit_id": "Business Unit ID",
    "text_company_disable_button": "Disable",
    "text_company_children_page_totalResults": "{0} Child Units found",
    "text_company_manage_units_header_managers": "Managers",
    "text_company_manageUser_registration_sort_byActive": "Active-Asc",
    "text_company_managePermissions_edit_saveButton": "Guardar",
    "text_company_usergroups_members_title": "Select User(s)",
    "text_company_manage_units_subtitle": "Units represent a logical grouping of individuals or function within an organization, such as a project team or a department. Units are placed into an organization hierarchy, which is navigable below. Units inherit from their parent unit (unless overridden locally) and as such the placement of a unit within the hierarchy is important. The organization hierarchy also affects such things as available cost centers, budgets, delivery addresses and the escalation of such things as order approval.",
    "text_company_manage_units_userDetails": "View User for Unit: {0}",
    "text_company_manageUser_pageAll_sort_byUnit": "Unidad principal",
    "text_company_budget_unit": "Parent business unit",
    "text_company_manage_units_header_customers": "Customers",
    "b2busergroup_b2bmanagergroup_name": "B2B Manager",
    "text_company_permissions_page_lastPage": "&raquo;",
    "text_company_administrators_page_totalResults": "{0} Administrators found",
    "text_company_manageB2BUserGroup_page_sort_byGroupID": "Id",
    "text_confirmation_usergroup_removed": "User group removed successfully",
    "text_company_manageUsers_adduser_title": "Agregar detalles de usuario",
    "text_company_manageUser_edituser": "Editar detalles de usuario",
    "text_company_budget_editPage": "Editar",
    "form_b2busergroup_noeditpermissions": "You don't have an appropriate permissions to edit this group.",
    "b2bunit_yes_button": "Sí",
    "text_company_units_remove_confirmation_b2badmingroup": "Doing this will remove B2B Administrator {0} from Business unit {1}. Do you want to proceed?",
    "text_company_manage_units_editForm": "Please use this form to update business unit details",
    "text_company_costCenter_page_linkPreviousPage": "Página anterior",
    "text_company_manage_units_accountManagers": "Account Managers",
    "text_company_manageUser_adduser": "Add User",
    "text_company_children_page_linkPreviousPage": "Página anterior",
    "text_company_status_active_false": "Disabled",
    "text_company_customers_page_showPageResults": "Mostrar paginado",
    "text_company_manageUsergroups_remove_confirmation": "Doing this will remove User Group : {0} . Do you want to proceed?",
    "text_company_addNewBudgets": "Add New Budgets",
    "text_company_manageUser_registration_totalResultsCurrPage": "{0} de {1} solicitudes encontradas",
    "text_company_budget_disable_confirm_message": "Doing this will prevent this budget from being used. Do you wish to continue?",
    "text_company_manage_units_managers_mainTitle": "Select Manager(s)",
    "text_company_costCenter_page_showAllResults": "Mostrar todo",
    "text_account_document_favorite_table_doc_subscribed": "Subscribed",
    "text_account_document_favorite_subscribed_boolean": "Sí",
    "text_account_document_favorite_not_subscribed_boolean": "No",
    "na_crm_alreadyused_message": "The CR entered has already been used, please enter a different CR number.",
    "text_account_table_header_category": "Pedido Categoría",
    "replenishmentScheduleForm_weekly_daysOfWeek": "Enviar cada",
    "text_account_orderApproval_rejectButton_displayName": "Rechazar pedido",
    "text_account_OrderDateTo": "Fecha de pedido: hasta",
    "text_account_order_status_title": "Estado",
    "text_account_order_orderDetails_validUntil": "Válido hasta",
    "text_account_orderStatus": "Estado del pedido",
    "text_account_replenishment_page_linkNextPage": "Página siguiente",
    "text_account_replenishment_orders": "Pedidos de reposición",
    "checkout_multi_costCenter_title_pleaseSelect": "Seleccione...",
    "search_advanced_search": "Buscar",
    "text_account_orderHistory_replenishment_link": "Ver el programa de reposición",
    "text_account_orderApprovalDetails_parentBusinessUnit": "Unidad de negocios principal",
    "text_account_yes_button": "Sí",
    "text_account_manageReplenishment_confirm_cancel_breadcrumb": "Eliminar programa de reposición {0}",
    "text_account_table_header_sentBy": "Sent By",
    "text_account_replenishment_noOrdersFound": "No se encontraron pedidos de reposición",
    "search_advanced_meta_description_title": "Formularios de pedido",
    "search_advanced_productids_add": "Agregar",
    "replenishmentScheduleForm_startDate": "Comenzar la reposición automática el",
    "responsive_replenishmentScheduleForm_monthly_day": "En este día del mes:",
    "text_account_orderApprovalDetails_OrderNumber": "Número de pedido",
    "text_account_order_status_display_approved": "Aprobado",
    "text_account_naPartNumber": "Número de pieza del Bendix/Número de pieza del cliente",
    "replenishmentScheduleForm_activateDaily": "Activar diariamente",
    "text_account_replenishment_page_firstPage": "&laquo;",
    "text_account_order_status_display_merchant_rejected": "Comerciante rechazado",
    "text_account_orderHistoryEntry_merchantTitle": "Detalles de aprobación del comerciante",
    "text_account_orderApprovalDetails_paidOntoAccount": "Pagado en cuenta",
    "text_account_replenishment_manageReplenishmentSchedule": "Gestionar su programa de reposición",
    "text_account_replenishment_actions": "Cancelar",
    "order_reorder_error": "Error al reordenar.",
    "text_account_naOrderNumber": "Número de pedido de Bendix",
    "text_account_replenishment_replenishmentOrderDetailBreadcrumb": "Pedido {0}",
    "checkout_multi_paymentType_continue": "Siguiente",
    "checkout_multi_paymentType_notprovided": "Debe indicar un método de pago para ir al siguiente paso.",
    "checkout_error_paymenttype_formentry_invalid": "El número de orden de compra del cliente es obligatorio para completar el proceso de pago.",
    "text_account_orderApprovalDetails_label": "Detalles de aprobación del pedido",
    "replenishmentScheduleForm_monthly_day": "Enviar el",
    "text_account_table_header_currency": "Currency",
    "search_advanced_keyword": "Búsqueda por palabra clave",
    "text_account_order_purchase": "Comprador",
    "order_replenishment_confirmation": "Confirmación del pedido de reposición",
    "text_account_table_header_customerNo": "Número de pieza del cliente",
    "text_account_openPosition_page_totalResultsCurrPage": "{0} of {1} Posiciones abiertas encontradas",
    "text_account_replenishment_replenishmentNumber": "Reposición nro.",
    "text_user_table_header_Core": "Principalt",
    "text_account_table_header_poNumber": "Número de PO",
    "text_account_openPosition_page_totalResults": "{0} Posiciones abiertas encontradas",
    "text_account_open_positions": "Buscar abierto posiciones",
    "text_account_replenishment_page_showAllResults": "Mostrar todo",
    "search_advanced_catalog": "Catalogar",
    "text_account_replenishment_nextOrderDate": "Fecha del próximo pedido",
    "text_account_orderApprovalDetails_orderPlacedBy": "Pedido realizado por",
    "text_user_table_header_order": "Pedido",
    "checkout_multi_paymentType_stepHeader": "Método de pago",
    "text_account_order_approver_title": "Aprobador",
    "replenishmentScheduleForm_weekly_weeks": "Cada",
    "text_account_replenishment_page_currentPage": "Página {0} de {1}",
    "responsive_replenishmentScheduleForm_daily_days": "Cada # de días:",
    "text_account_table_header_partNo": "Aspectos generales",
    "checkout_multi_costCenter_label": "Centro de costos",
    "text_account_order_orderDetails_purchaseOrderNumber": "Orden de compra de orden de compra",
    "checkout_multi_purchaseOrderNumber_label": "Orden de compra Nro.",
    "checkout_summary_replenishmentScheduleForm_title": "Establecer calendario de reposición",
    "checkout_multi_replenishment": "Reposición",
    "text_account_orderApproval_addApproverComments": "Agregue comentarios para su decisión",
    "checkout_summary_requestApproval_cancel": "Cancelar",
    "search_nav_facetShowLess_fit": "menos ajustes...",
    "header_link_login": "Iniciar sesión / Registrarse",
    "checkout_multi_costCenter_notprovided": "Debe indicar un centro de costos para ir al siguiente paso.",
    "text_account_order_approval_title": "Detalles de aprobación",
    "text_account_replenishment_page_sort_byReplenishmentNumber": "Número de reposición",
    "text_account_replenishment_confirmation_canceled": "Su pedido de reposición ha sido cancelado",
    "text_account_orderApprovalDashBoard_orderCreated": "Pedido creado",
    "text_account_orderApprovalDashBoard_viewOrdersPendingForApproval": "Pedidos pendientes para su aprobación",
    "text_Show_orders_of_coworkers": "Mostrar pedidos de compañeros de trabajo",
    "text_notAvailable": "No aplica",
    "text_account_quote_active": "Eficacia",
    "text_account_orderApprovalDashboard": "Panel de aprobación de pedidos",
    "text_account_replenishment_cancel_button": "Cancelar reposición",
    "text_account_orderApproval_reject_reason": "Agregue la razón del rechazo a continuación",
    "text_account_order_permission_notes": "Comentarios del aprobador",
    "text_user_table_lock_user_account": "Bloquear cuenta de usuario",
    "text_account_manageReplenishment": "Gestionar programa de reposición",
    "text_account_replenishment_page_sort_byOrderNumber": "Número de pedido",
    "text_account_replenishment_total": "Total estimado",
    "text_user_table_approve": "Aprobar",
    "text_account_table_header_kbnumber": "Aspectos generales",
    "text_account_orderHistoryEntry_customerTitle": "Detalles de aprobación del cliente",
    "text_account_endNow": "Terminar ahora",
    "text_store_dateformat": "dd/MM/aaaa",
    "text_account_replenishmentOrderDetails_title": "Detalles del pedido de reposición",
    "text_account_replenishment_page_sort_byDate": "Fecha de creación",
    "text_account_openPosition_page_totalResultsSingleOrder": "1 posición encontrada",
    "text_account_replenishment_datePlaced": "Fecha seleccionada",
    "text_account_table_header_estDelDate": "Ver flete",
    "text_account_table_header_reqDelDate": "Fecha de entrega solicitada",
    "text_account_OrderDate": "Fecha de pedido: desde",
    "text_account_openPositions_export": "Exportar datos",
    "checkout_multi_summary_orderPlacedBy": "Pedido realizado por",
    "text_order_reorderbutton": "Reordenar",
    "text_account_replenishment_noReplenishment": "No tiene pedidos de reposición programados",
    "replenishmentScheduleForm_activateMonthly": "Activar mensualmente",
    "responsive_replenishmentScheduleForm_activateWeekly": "Semanal",
    "text_account_table_header_typeNo": "Ingrese un número",
    "text_account_replenishment_remove_confirmation_title": "Confirmar extracción",
    "text_account_replenishment_orderNumber": "Número de pedido",
    "text_account_replenishment_replenishmentBreadcrumb": "Programa de reposición {0}",
    "responsive_replenishmentScheduleForm_activateMonthly": "Mensual",
    "checkout_summary_scheduleReplenishment": "Volver al pago",
    "text_account_table_header_pricePerUnit": "Precio neto*",
    "text_store_dateformat_datepicker_selection_hint": "dd/mm/aaaa",
    "text_account_order_orderDetails_CostCenter": "Centro de costos",
    "responsive_replenishmentScheduleForm_activateDaily": "Diario",
    "text_account_orderHistory_replenishment_schedule": "Programa de reposición: {0}",
    "replenishmentScheduleForm_daily_days": "Reponer todos los",
    "search_nav_facetShowMore_color": "más colores...",
    "text_account_orderApprovalDashBoard_orderNumber": "Número de pedido",
    "text_account_order_permission_title": "Permiso",
    "text_account_replenishment_frequency": "Frecuencia",
    "text_account_replenishment_page_totalResults": "{0} reposiciones encontradas",
    "text_account_replenishment_canceled": "Cancelado",
    "text_account_order_status_display_rejected": "Rechazado",
    "text_account_replenishment_page_sort_byNextOrderDate": "Fecha del próximo pedido",
    "search_advanced": "Formularios de pedido",
    "search_advanced_onlyproductids": "Identificación del producto solamente",
    "text_account_table_header_naNumber": "Número de pedido de Bendix",
    "search_nav_facetShowMore_fit": "más ajustes...",
    "checkout_summary_placeReplenishmentOrder": "Realizar pedido de reposición",
    "text_account_replenishment_noOrders": "No tiene pedidos",
    "replenishmentScheduleForm_weeks": "semanas",
    "search_advanced_createorderform": "Crear formulario de pedido",
    "search_advanced_orderform": "Formulario de pedido",
    "text_account_replenishment_page_linkPreviousPage": "Página anterior",
    "text_account_replenishment_confirm_cancel": "Finalizar programación de orden ahora. ¿Está seguro de que desea detener la reposición automática de este pedido ({0})?",
    "order_replenishment_schedule_title": "Su calendario de reposición",
    "text_account_replenishment_details": "Detalles de reposición",
    "text_account_table_header_confirmedQty": "Confirmed Quantity",
    "text_account_orderApproval_approve_reason": "Agregue el comentario de aprobación a continuación (opcional):",
    "text_account_table_header_entry_status": "Order Item Status",
    "text_account_orderApprovalDashBoard_orderStatus": "Estado del pedido",
    "replenishmentScheduleForm_month": "día / mes",
    "search_advanced_productids": "Ingrese los identificadores del producto separados por una coma",
    "checkout_multi_paymentType_selectPaymentTypeMessage": "Seleccione su método de pago.",
    "text_user_table_linked_customer": "Identificación de cliente vinculado/Seleccione “Default sold to” (Vendido por defecto a)",
    "text_account_order_status_display_merchant_approved": "Comerciante aprobado",
    "replenishmentScheduleForm_activateWeekly": "Activar semanalmente",
    "checkout_multi_paymentType_breadcrumb": "INFORMACIÓN DEL CLIENTE",
    "text_account_customerID": "Cliente ID",
    "text_account_replenishment_history": "Historial de reposición",
    "order_replenishment_thankYou": "¡Gracias por programar su pedido de reposición!",
    "responsive_checkout_summary_requestApproval_maxchars": "Máximo 255 caracteres",
    "responsive_replenishmentScheduleForm_weekly_daysOfWeek": "En los siguientes días:",
    "checkout_error_paymenttype_formentry_repeat": "El número de orden de compra ingresado ya se ha utilizado, ingrese un nuevo número de orden de compra de cliente",
    "checkout_multi_paymentType": "INFORMACIÓN DEL CLIENTE",
    "search_nav_facetShowLess_color": "menos colores...",
    "checkout_multi_deliveryAddress_noPickup": "DIRECCIÓN DE ENVÍO",
    "text_account_replenishment_shipToItems": "Enviar a artículos",
    "text_account_orderApproval_approveButton_displayName": "Aceptar pedido",
    "text_account_orderApprovalDetails_comments_label": "Comentarios",
    "text_account_orderApproval_orderStatus": "Estado del pedido",
    "checkout_error_invalid_accountType": "Su cuenta no le permite pagar aquí.",
    "text_account_replenishment_page_showPageResults": "Mostrar paginado",
    "text_account_replenishment_Schedule": "Programa",
    "checkout_multi_deliveryAddress_noPickup_breadcrumb": "DIRECCIÓN DE ENVÍO",
    "responsive_replenishmentScheduleForm_weekly_weeks": "Cada # de semanas:",
    "text_account_table_header_description": "Descripciónt",
    "text_account_openPosition_page_totalResultsSinglePag": "{0} Posiciones abiertas encontradas",
    "text_account_no_button": "No",
    "text_account_table_header_lineItem": "Position No.",
    "text_account_myReplenishment": "Mis pedidos de reposición",
    "text_account_replenishment_creationDate": "Fecha de creación",
    "text_account_orderHistory_replenishment_startFrom": "Comenzar la reposición desde: {0}",
    "text_account_search": "Buscar",
    "text_account_orderApprovalDashBoard_actions": "Acciones",
    "text_account_orderApprovalDashBoard_purchaseOrderNumber": "Número de la orden de compra:",
    "text_account_replenishment_purchaseOrderNumber": "Orden de compra Nro.",
    "order_replenishment_confirmation_number": "Número de confirmación:",
    "text_account_orderHistory_purchaseOrderNumber": "Orden de compra de orden de compra",
    "text_account_order_status_display_pending_merchant_approval": "Aprobación del comerciante pendiente",
    "checkout_multi_paymentType_continue_NA": "Siguiente",
    "text_account_order_status_display_pending_approval": "Aprobación pendiente",
    "text_account_orderApprovalDetails_purchaseOrderNumber": "Número de la orden de compra:",
    "text_account_replenishment_page_lastPage": "&raquo;",
    "text_account_orderHistory_replenishment": "Este es un pedido programado",
    "text_account_order_status_display_assigned_admin": "Asignado al administrador",
    "text_account_replenishment_orderStatus": "Estado del pedido",
    "checkout_summary_replenishmentScheduleForm_cancel": "Cancelar",
    "replenishmentScheduleForm_days": "días",
    "text_account_order_orderDetails_ParentBusinessUnit": "Unidad principal",
    "text_account_orderApprovalDetails_orderStatusDetails_label": "Detalles del estado del pedido",
    "text_account_replenishment_viewReplenishmentOrders": "Ver sus pedidos de reposición",
    "text_account_table_header_orderedQty": "Ordered Quantity",
    "text_store_dateformat_datepicker_selection": "dd/mm/aa",
    "text_account_replenishment_page_sortTitle": "Ordenar por:",
    "text_account_replenishment_startDate": "Comenzar",
    "text_account_orderApprovalDetails_costCenter": "Centro de costos",
    "text_order_status_partially_delivered": "Entregado parcialmente",
    "text_training_elearingrequired": "incluir reservas de eLearning",
    "type_WarrantyClaim_name": "Warranty Claim",
    "type_B2BCustomerWarrantyRightsEnum_WARRANTY_SEARCH_name": "Buscar garantía",
    "type_productWeight_unit_name": "Precio de lista",
    "type_B2BCustomerCoreRightsEnum_CORE_SUBMISSION_name": "Envío principal",
    "type_CoreCollectionAddress_zipCode_name": "Zip Code",
    "type_AbstractOrderEntry_updatedEntryNumber_name": "Herramienta de servicio",
    "type_ProductPlantStructure_plantNumber_name": "Distribuidor",
    "type_SapOrderType_WEB_name": "WEB",
    "type_salesdata_product_name": "Fecha de entrega solicitada",
    "type_CoreGradeType_SC_name": "Chatarra",
    "type_WarrantyClaim_businessType_name": "Tipo de negocio",
    "type_KbEcomImportDataCronJob_name": "Producto de mercado de repuestos",
    "type_product_customerLimitations_name": "Lista KB/Precio neto",
    "type_saleableItemType_IC_name": "Al día siguiente antes de las 12 p.m.",
    "type_WarrantyClaimProcess_warranty_name": "Warranty Claim",
    "type_SapOrderType_CONV_name": "CONV",
    "type_B2BCustomerAccessRequestEnum_name": "Trabajo de asignación de categoría de producto",
    "type_Product2KbEcomDocumentRel_name": "Código de dispositivo",
    "type_CoreCollectionAddress_emailAddress_name": "Dirección de correo electrónico",
    "type_CoreRequest_crmNumber_name": "Número de CRM",
    "type_productReferenceTypeEnum_HasServiceTool_name": "Nombre de la pieza",
    "password_policy_violation_regex_disallowed_not12345678": "Descargas",
    "type_EngineManufacturer_code_name": "Código",
    "type_CoreRequest_exportStatus_name": "Export Status",
    "type_AbstractOrder_cutOffTimeMessage_name": "Región de ventas",
    "type_SAPCpiOutboundOrder_referenceNumber_name": "Centro de servicio de red de expertos",
    "type_CoreGradeType_PD_name": "1- Part Damage",
    "type_KbEcomDocument_url_name": "Contenedor de medios descargable",
    "type_CoreRequest_name_name": "Nombre ",
    "type_CoreRequest_packageInfo_name": "Package Info",
    "type_CorePackaging_Weight_name": "Peso total",
    "type_WarrantyClaim_customer_name": "Client",
    "type_saleableItemType_IY_name": "Obsoleto",
    "password_policy_violation_blacklist_blacklistedpassword": "Descargas",
    "type_ProductPlantStructure_product_name": "Documentos",
    "type_WarrantyClaim_exportStatus_name": "Export Status",
    "type_WarrantyClaim_vinNumber_name": "VIN-Numme",
    "type_BaseSite_registrationCustomerIndustryRoles_name": "Peso del producto",
    "type_RecallNumber_code_name": "Código",
    "type_product_typenumber_name": "Tipo Número",
    "type_CoreRequest_user_name": "User",
    "type_B2BCustomerIndustryRoleEnum_EXPERT_NETWORK_SERVICE_CENTRE_name": "Registro - Roles de la industria",
    "type_product_vmrsCodeRear_name": "Última hora ejecutada",
    "productSalesStatus_label_APAC_CODE10": "Obsolète",
    "type_Order_idocNumber_name": "Regiones de ventas",
    "type_Product2SalesRegions_name": "Limitación de ventas específicas del cliente",
    "type_Category_externalUrl_name": "External URL",
    "type_CMSNavigationNode_productCategoryTree_name": "Producto",
    "type_ProductSalesStatus_CODE40_name": "Tipo de referencia del producto",
    "type_OrderTypeQuantityMapping_salesOrgId_name": "Recogida de consignación activada con éxito",
    "type_ProductImageMediaConversionCronJob_pictureMediaFormat_name": "Transportador",
    "type_OrderTypeQuantityMapping_name": "Entrega completa",
    "type_CorePackaging_typeOfpackaging_name": "Packaging Type",
    "type_WarrantyPart_serialNumber_name": "Serial Number",
    "type_WarrantyClaim_submitDate_name": "Submit Date",
    "type_WarrantyPart_quantity_name": "Cantidad",
    "type_CoreCollectionAddress_totalWeight_name": "Total Weight",
    "type_PrimaryComplaint_name": "Queja principal",
    "type_AbstractOrderEntry_listPrice_name": "Entrega al día siguiente sábado am",
    "type_WarrantyPart_otherCost_name": "Otro costo",
    "type_WarrantyPart_hourlyLaborRate_name": "Tarifa de mano de obra por hora",
    "type_KbOrderStatus_D_name": "Cancelado",
    "type_KbEcomImportDataCronJob_catalogVersion_name": "Solo mercado de repuestos (aftermarket, AM)",
    "type_Chassis_name_name": "Nombre ",
    "type_CrossReferenceRelation_name": "Tipo de entrega",
    "type_CoreCollectionAddress_tailLiftRequired_name": "Tail Lift",
    "type_B2BUnit_deliveryPriority_name": "Organización de ventas",
    "type_CoreRequestItem_qty_name": "Cantidad",
    "productSalesStatus_label_APAC_CODE20": "Non vendable à l'IAM",
    "type_B2BCustomerIndustryRoleEnum_DISTRIBUTER_name": "Distribuidor",
    "type_ProductWeight_name": "Entrega antes de las 9 am del día siguiente",
    "type_salesChannelLimitation_OEtruckonly_name": "Falla en envío de orden correo electrónico enviado",
    "type_ProductSalesStatus_CODE20_name": "Contenedor de medios del producto",
    "type_WarrantyPart_invoiceNumber_name": "InvoiceNumber",
    "type_B2BCustomerIndustryRoleEnum_WORKSHOP_name": "Países vendibles independientes de la región",
    "type_AbstractOrderEntry_posType_name": "ENVÍO AL DÍA SIGUIENTE",
    "type_B2BCustomer_defaultB2BUnit_name": "Nombre del archivo",
    "productSalesStatus_label_APAC_CODE30": "Vendable à l'IAM",
    "type_VehicleManufacturer_name_name": "Nombre ",
    "type_CustomerPartNumber_code_name": "Código",
    "type_PrimaryComplaint_name_name": "Nombre ",
    "type_PackageType_CONTAINER_name": "Container",
    "type_product_dimension_name": "Altura",
    "type_WarrantyPart_dateInService_name": "Fecha de puesta en servicio",
    "type_ProductDimension_height_name": "Competidor",
    "type_SAPCpiOutboundOrderItem_purchaseOrderNumber_name": "Número de orden de compra",
    "type_saleableItemType_IK_name": "Ninguna limitación",
    "type_CrossReference_alternativeXref_name": "Alternative X-ref",
    "type_WarrantyPart_attachments_name": "Attachments",
    "type_saleableItemType_N_name": "Obsoleto",
    "type_CoreRequest_packageCount_name": "Package Count",
    "type_ExternalLanguageMapping_languages_name": "Tipo POS",
    "productSalesStatus_label_APAC_CODE40": "Vendable à l'IAM - jusqu'à épuisement des stocks",
    "type_productReferenceTypeEnum_IsReplacedBy_name": "Número de la pieza",
    "type_PartsDisposition_name": "Parts Disposition",
    "type_WarrantyPart_warrantyClaim_name": "Warranty Claim",
    "type_KBOrderTypeEnum_SAND_name": "Vista web",
    "type_WarrantyPart_scale_name": "Escala",
    "type_B2BUnit_orderBlocked_name": "Estado vendible",
    "type_CoreItemsEMEA_WeightAppx_name": "Weight Approx",
    "type_productReferenceTypeEnum_IsAccessoryPartFor_name": "Precios de modo de llamada",
    "type_SalesRegionCountryRelation_countries_name": "Cliente",
    "type_WarrantyClaim_phoneNumber_name": "Número de teléfono",
    "type_CoreGradeType_GC_name": "Good Core",
    "type_CoreGradeType_PSD_name": "2- Parts Damaged",
    "type_CoreItemsEMEA_description_name": "Descripción",
    "type_CoreCollectionAddress_firstName_name": "Nombre",
    "type_ExternalLanguageMapping_sourceSystem_name": "Componente único",
    "type_KbEcomImportDataCronJob_fileName_name": "Todos los mercados (nuevo)",
    "type_VehicleManufacturer_customerSite_name": "Site",
    "type_CustomerPartNumber_customer_name": "Client",
    "type_SapOrderType_EDI_name": "EDI",
    "type_B2BCustomerAccessRequestEnum_INFORMATION_ONLY_name": "Solo información",
    "type_WarrantyClaim_site_name": "Site",
    "type_Address_stateCode_name": "URL de documento remoto",
    "type_product_minimumDeliveryUnit_name": "Es producto de intercambio para",
    "type_ProductWeight_netWeight_name": "Versión del catálogo",
    "type_CoreCollectionAddress_lastName_name": "Apellido",
    "type_product_salesDatas_name": "Fecha de entrega solicitada",
    "type_WarrantyPart_laborAmount_name": "Monto de mano de obra ",
    "type_VehicleManufacturer_name": "del fabricante del vehículo",
    "type_CoreItemsEMEA_qty_name": "Cantidad",
    "type_ProductImageMediaConversionCronJob_thumbnailMediaFormat_name": "En venta - Hasta agotarse la existencia",
    "type_productWeight_grossWeight_name": "Longitud",
    "type_marketType_NoExternalMarket_name": "No hay mercado exterior",
    "type_OrderTypeQuantityMapping_overWritten_description": "País de origen",
    "type_product_excludedCountries_name": "Es reemplazado por",
    "type_ProductDimension_width_name": "Estado de la empresa",
    "type_saleableItemType_name": "Nombre",
    "type_B2BCustomerApprovalStatus_name": "Producto",
    "type_DocumentType_name_name": "Fecha de entrega estimada",
    "type_CoreRequest_fax_name": "Fax",
    "type_User_isPasswordExpired_name": "Password Expired",
    "export_openpositions_seebelow": "See Below",
    "type_salesChannelLimitation_NoLimitation_name": "Número de referencia",
    "type_AbstractOrderEntry_customerReferenceNumber_name": "Número de referencia del cliente",
    "type_B2BCustomerWarrantyRightsEnum_WARRANTY_SEARCH_name": "Buscar garantía",
    "type_productReferenceTypeEnum_HasSparesKits_name": "Envío de paquete 48 horas",
    "type_CoreRequest_coreDate_name": "Core Date",
    "type_Product2SalesRegions_salesRegions_name": "Formato de fecha",
    "type_PriceDocument_document_name": "Nombre ",
    "type_ExternalLanguageMapping_code_name": "URL inicial del sitio",
    "type_KBOrderTypeEnum_EMGY_name": "Orden de emergencia",
    "type_WarrantyClaim_email_name": "Email",
    "type_B2BCustomer_customerSite_name": "Flota",
    "type_B2BCustomerApprovalStatus_DENIED_name": "Asignación de categoría de producto",
    "type_product_productHierarchy_name": "KB Importar datos CronJob",
    "type_ProductMediaContainer_name": "Estado de aprobación",
    "type_CoreRequestItem_coreGroupUpgrade_name": "Core Group Upgrade",
    "type_AbstractOrderEntry_updateFlag_name": "Herramienta de servicio",
    "type_WarrantyPart_laborRequested_name": "Mano de obra solicitada",
    "type_ProductDimension_product_name": "Dirección 2 de la empresa",
    "password_policy_violation_regex_disallowed_not12341234": "Descargas",
    "type_AbstractOrderEntry2AbstractOrderEntry_entries_name": "Entradas",
    "type_B2BCustomerAccessRequestEnum_CORE_REPORTS_name": "Informes básicos / Presentación de informes básicos",
    "type_AbstractOrderEntry_estimatedDeliveryDate_name": "Ver flete",
    "type_KBOrderTypeEnum_SHFD_name": "Enviar al día siguiente",
    "type_B2BCustomerCoreRightsEnum_CORE_REPORTS_name": "Informes de cascos",
    "type_WarrantyPart_repairTime_name": "Tiempo de reparación (en horas)",
    "type_CoreRequest_warrantyMaterial_name": "Material de garantía incluido",
    "type_Chassis_code_name": "Código",
    "type_productDimension_width_name": "Tipo de material",
    "type_salesChannelLimitation_ContractPartneronly_name": "Solo OEM",
    "type_CrossReference_target_name": "Eliminar activos de blob",
    "type_SalesRegion_name_name": "Relación de referencia cruzada",
    "type_KbEcomDocument_code_name": "Documentos",
    "type_AbstractOrderEntry_entries_name": "Entradas",
    "type_BaseSite_siteInitialUrl_name": "Código",
    "type_SAPConfiguration_allSAPDistributionChannel_name": "Todos los canales de distribución de SAP",
    "type_DeliveryType_name": "Unidad de peso",
    "type_EngineManufacturer_name_name": "Nombre ",
    "type_EngineManufacturer_name": "Fabricant du moteur",
    "type_CoreRequestItem_coreGrade_name": "Core Grade",
    "type_salesChannelLimitation_OEMonly_name": "Tipo de orden ",
    "type_PartsDisposition_name_name": "Nombre ",
    "type_B2BUnit_customerHierarchy_name": "Se puede vender al IAM",
    "type_marketType_AftermarketNew_name": "Posventa (nuevo)",
    "type_WarrantyPart_axleNumber_name": "Axle Number",
    "type_B2BCustomer_showNetPrice_name": "Relación de documentos del producto",
    "type_productReferenceTypeEnum_name": "Tipo de orden",
    "type_Address_displayPobox_name": "PO Box",
    "type_WarrantyClaim_name_name": "Nombre ",
    "password_policy_violation_regex_required_mustcontaindigit": "peso",
    "type_productReferenceTypeEnum_HasExchangeProduct_name": "Sobrescrito",
    "type_ProductWeight_grossWeight_name": "Transportistas",
    "type_PriceDocument_catalogVersion_name": "Version du catalogue",
    "type_product_webView_name": "Medios de información",
    "type_B2BCustomer_industryRoles_name": "Dimensión del producto",
    "type_productReferenceTypeEnum_REPAIRKIT_name": "Código de tipo de orden",
    "type_product_sapSalesStatus_name": "Tipos de entrega admitidos",
    "type_product_titleId_name": "Limitación del canal de ventas",
    "type_productDimension_unit_name": "Tipo de mercado",
    "type_WarrantyClaim_vehicleId_name": "Número de vehículo / unidad",
    "type_B2BCustomer_approvalStatus_name": "Kit de reparación",
    "type_CustomerSite_name": "Site",
    "type_salesChannelLimitation_OEtraileronly_name": "Esquema de orden",
    "type_KbEcomDocument_description_name": "Nombre del tipo de documento",
    "type_productWeight_unit_name": "Precio de lista ",
    "type_saleableItemType_IF_name": "Sin mercado externo",
    "type_PartsDisposition_customerSite_name": "Site",
    "type_B2BUnit_erpID_name": "Se puede vender al IAM - hasta agotar existencias",
    "type_WarrantyPart_product_name": "Numéro d'article",
    "type_KbCoreDocument_CoreDocuments_name": "Core Document",
    "type_product_vmrsList_name": "Es una herramienta de servicio para",
    "type_productReferenceTypeEnum_HasAccessoryPart_name": "Producto",
    "type_KbOrderStatus_A_name": "Reconocido",
    "type_CrossReference_webName_name": "Prioridad de entrega",
    "type_B2BCustomerIndustryRoleEnum_OEM_name": "OEM",
    "type_KBOrderTypeEnum_name": "Unidad de longitud",
    "type_Address_displayPostalCode_name": "Postal Code",
    "type_productReferenceTypeEnum_IsSparesKitsFor_name": "Nombre web",
    "type_CoreItemsEMEA_WeightComplete_name": "Complete Weight",
    "type_KBOrderTypeEnum_AFRT_name": "En espera de aprobación",
    "type_Product2KbEcomDocumentRel_products_name": "Tipo/código de dispositivo",
    "type_productReferenceTypeEnum_HasAftermarketProduct_name": "Equipo original",
    "type_DocumentTimeStamp_b2bUnit_name": "B2b Unit",
    "type_productReferenceTypeEnum_HasRationalisedProduct_name": "Padre",
    "type_productDimension_length_name": "Asignación de un código de lenguaje externo a una lista de lenguajes actuales",
    "type_CoreRequest_phoneNumber_name": "Número de teléfono",
    "type_CoreRequest_totalWeight_name": "Total Weight",
    "type_WarrantyClaim_parts_name": "Parts",
    "type_CoreCollectionAddress_additionInfo_name": "Additional Info",
    "type_B2BCustomerIndustryRoleEnum_FLEET_name": "Flota",
    "type_CoreRequest_corePdfMedia_name": "PDF",
    "type_salesChannelLimitation_name": "Solo camión OE",
    "type_salesChannelLimitation_AMonly_name": "Esquema de orden",
    "type_productReferenceTypeEnum_COMPETITOR_name": "Productos",
    "type_saleableItemType_IT_name": "No para la venta",
    "type_SalesRegion_name": "Referencia cruzada",
    "type_PackageType_BOX_name": "Box ",
    "type_CoreRequest_coreReturnItems_name": "Core Items(NA)",
    "type_WarrantyDecision_code_name": "Código",
    "type_AbstractOrderEntry2AbstractOrderEntry_originalEntry_name": "Entrada original",
    "type_AbstractOrder_shippingCondition_name": "Etiqueta de estado de ventas",
    "type_B2BUnit_versionNumber_name": "ID de la organización de ventas",
    "type_CorePackaging_size_name": "Tamaño",
    "type_CoreCollectionAddress_country_name": "Counrty",
    "type_product_hazardousMaterial_name": "Es un producto racionalizado para",
    "type_PricingProceduresSubtotal_KZWI3_name": "Mostrar precio principal",
    "type_B2BUnit_salesOffice_name": "Región de ventas",
    "type_SAPConfiguration_sappricingbol_surchargeSub_name": "Mostrar precio de lista",
    "type_CoreRequestItem_itemWeight_name": "Item Weight",
    "type_PricingProceduresSubtotal_KZWI1_name": "Instrucciones de envío",
    "type_CMSStaticCategoryPageRestriction_description": "Producto",
    "type_AbstractOrder_lastPricingCallMode_name": "Tipo de artículo vendible",
    "type_BaseStore_timeZone_name": "Tipo de mercado SAP",
    "type_WarrantyPart_partInService_name": "Kilometraje / Pieza en el servicio *",
    "type_Order_sapOrderId_name": "Regiones de ventas",
    "type_KbEcomDocument_revision_name": "Tipo de documento",
    "type_AbstractOrder_countryIsoCode_name": "País",
    "type_WarrantyDecision_decision_name": "Decision",
    "type_KBOrderTypeEnum_STOR_name": "Orden de almacenamiento",
    "type_saleableItemType_IA_name": "Nombre",
    "type_DocumentType_name": "EMERGENCIA",
    "type_BaseStore_maxRadiusForPoSSearch_name": "Max Radius for POS Search",
    "type_product_marketType_name": "IDENTIFICACIÓN",
    "type_ProductSalesStatus_name": "Conversión de medios de la imagen principal del producto",
    "type_WarrantyClaim_claimType_name": "Tipo de reclamo",
    "type_B2BCustomerApprovalStatus_PENDING_name": "Producto",
    "type_product_salesStatusDescription_name": "Recargo",
    "type_WarrantyClaim_email2_name": "Email2",
    "type_CoreCollectionAddress_requestedTime_name": "Requested Time",
    "type_ProductPlantStructure_countryOfOrigin_name": "Descripción del documento",
    "type_salesChannelLimitation_OESonly_name": "Comprar en línea",
    "type_CustomerPartNumber_sourceSystem_name": "Système source",
    "type_SalesRegionCountryRelation_salesRegions_name": "Cliente",
    "type_ProductCategoryMapping_name": "Categoría",
    "type_saleableItemType_IM_name": "No vendible para el IAM",
    "type_KbCoreReports_b2bUnit_name": "Matriz básica",
    "type_WarrantyPart_natureOfDefect_name": "Nature Of Defect",
    "type_CustomerHierarchyUnit_parent_name": "Limitación de página de categoría estática",
    "type_WarrantyClaim_partsDisposition_name": "Disposición de piezas si se rechaza* ",
    "type_Product_crossReferences_name": "Prioridad de entrega",
    "type_B2BCustomerApprovalStatus_APPROVED_name": "Producto",
    "productSalesStatus_label_EMEA_CODE40_anonymous": "Unidad",
    "type_WarrantyPart_name": "Warranty Part",
    "type_Product2KbEcomDocumentRel_kbEcomDocuments_name": "dimensión",
    "type_ProductMediaContainer_assetId_name": "Identificación del activo",
    "type_B2BCustomer_showListPrice_name": "Característica de producto",
    "type_WarrantyClaim_tagSerialNumber_name": "Número de serie de garantía de aire total (Total Air Guarantee, T.A.G.)",
    "type_CorePackaging_stackable_name": "Stackable",
    "type_WarrantyClaim_date_name": "Fecha",
    "type_VehicleMfg2ChassisRelation_chassis_name": "Chassis(chass-eez)",
    "type_AbstractOrderEntry_estimatedQuantity_name": "Falla en la orden de envío por correo electrónico después de exceder el número máximo de reintentos.",
    "type_CoreCollectionAddress_fax_name": "Fax",
    "type_WarrantyClaim2PartInfo_parts_name": "Parts",
    "type_VehicleManufacturer_code_name": "Código",
    "type_WarrantyTypeOperation_name": "Warranty Type Operation",
    "type_saleableItemType_IP_name": "No para venta externa",
    "type_productReferenceTypeEnum_IsRationalisedProductFor_name": "Formato de imagen",
    "type_AbstractOrder_minOrderCharge_name": "Relación de regiones de ventas a países",
    "type_AbstractOrder_currentDeliveryType_name": "Estado del ciclo de vida Sap",
    "type_WarrantyClaim_claimRefNumber_name": "Claim Reference Number",
    "type_WarrantyPart_returningPartNumber_name": "Número de pieza del cliente existente",
    "type_CustomerPartNumber_customerPartNumber_name": "Numéro de pièce client",
    "type_WarrantyClaim_attachments_name": "Attachments",
    "type_WarrantyClaim_barCodeLabel_name": "BarCode Label",
    "type_OrderTypeQuantityMapping_lPriority_name": "Grupo principal",
    "type_productReferenceTypeEnum_IsExchangeProductFor_name": "Términos de pago",
    "type_product_regionIndependentSaleableCountries_name": "Es producto de mercado de repuestos para",
    "type_KBOrderTypeEnum_PEPR_name": "PEDIDO PROGRAMA",
    "type_CMSSiteRestriction_name": "Producto",
    "type_CoreRequest_totalQuantity_name": "Total Quantity",
    "password_policy_violation_regex_required_certainsize": "Descargas",
    "type_SalesData_minOrderQuantity_name": "Comprobar",
    "type_Category_productCategoryMapping_name": "Cartographie des catégories de produits",
    "type_PartsDisposition_code_name": "Código",
    "type_marketType_AftermarketRemanufactured_name": "Posventa (Remanufacturado)",
    "productSalesStatus_label_EMEA_CODE10": "Identificación del título",
    "type_SAPConfiguration_kbOrderTypes_name": "Tipos de pedidos",
    "type_CoreCollectionAddress_forkListRequired_name": "Fork Lift",
    "type_Address_displayCompany_name": "Company",
    "type_WarrantyClaim_chassis_name": "Chasis ",
    "type_B2BCustomerIndustryRoleEnum_name": "Productos",
    "type_ProductSalesStatus_CODE30_name": "Estructura de planta del producto",
    "type_ProductDimension_name": "Colección",
    "type_salesChannelLimitation_IAMonly_name": "Pedido bloqueado",
    "type_saleableItemType_IE_name": "Solo remolque original (original equipment, OE)",
    "type_WarrantyDecision_name": "Warranty Decision",
    "type_WarrantyClaim_name": "Warranty Claim",
    "type_WarrantyClaim_language_name": "Language",
    "type_productReferenceTypeEnum_IsServiceToolFor_name": "Datos de planta",
    "type_CMSSiteRestriction_cmssite_name": "Producto",
    "type_KBOrderTypeEnum_SFRT_name": "Peso",
    "productSalesStatus_label_EMEA_CODE20": "Identificación del título",
    "type_CoreCollectionAddress_phone_name": "Phone",
    "type_sapMarketType_name": "Entradas de línea máximas permitidas",
    "type_product_sapMarketType_name": "Solo mercado de repuestos independiente (independent aftermarket, IAM)",
    "type_KBOrderTypeEnum_PS48_name": "Código VMRS",
    "type_B2BCustomer_accessRequests_name": "Asignación de categoría de producto",
    "type_ProductDimension_length_name": "Sector en la industria de la empresa",
    "type_product_articleType_name": "Es reemplazo para",
    "type_CoreRequest_email_name": "Email",
    "type_WarrantyTypeOperation_code_name": "Código",
    "type_OrderProcess_sendOrderFailEmail_name": "Ruta de la jerarquía del cliente",
    "type_product_sapLifecycleStatus_name": "Solo entre empresas",
    "type_SAPCpiOutboundOrderItem_deliveryPriority_name": "Producto de intercambio",
    "type_productReferenceTypeEnum_IsAftermarketProductFor_name": "Entrega parcial",
    "productSalesStatus_label_EMEA_CODE30": "Ingrese un número",
    "type_KbEcomDocument_catalogVersion_name": "Documentos",
    "type_KBOrderTypeEnum_PKSH_name": "Número de entrada actualizado",
    "type_ProductCategoryMapping_deviceCode_name": "Página de sistema de gestión de contenido (content management system, CMS)",
    "type_SalesRegion_products_name": "Referencias cruzadas",
    "type_SAPCpiOutboundOrder_purchaseOrderType_name": "Producto de intercambio",
    "type_OrderTypeQuantityMapping_maxQuantityAllowed_name": "Clase principal",
    "type_CrossReference_name": "Moneda predeterminada",
    "type_SalesRegion_countries_name": "Valor de referencia cruzada (número de material X-ref)",
    "type_CoreGradeType_NA_name": "No aplica",
    "type_Employee_isPasswordExpired_name": "Password Expired",
    "type_B2BUnit_shippingInstructions_name": "Oficina de ventas",
    "type_WarrantyClaim_idocNumber_name": "Numéro IDoc",
    "type_WarrantyClaim_email1_name": "Email1",
    "type_B2BCustomerAccessRequestEnum_SUBMIT_WARRANTY_name": "Enviar reclamo de garantía",
    "type_WarrantyPart_partsDisposition_name": "Parts Disposition if denied",
    "type_PrimaryComplaint_code_name": "Código",
    "type_DownloadableMediaContainer_url_name": "Estado de aprobación",
    "type_B2BUnit_defaultCurrency_name": "Lista de materiales (bill of material, BOM) de ventas",
    "type_product_salesStatus_name": "Estado de las ventas",
    "productSalesStatus_label_EMEA_CODE40": "Vendible para recambio IAM - hasta agotar existencias",
    "type_product_salesChannelLimitation_name": "Precio de cliente KB",
    "type_RecallNumber_name": "Recall Number",
    "type_CoreCollectionAddress_requestedDate_name": "Requested Date",
    "type_WarrantyPart_dateCode_name": "Date Code",
    "type_ProductMediaContainer_product_name": "Aprobado",
    "type_SalesRegionCountryRelation_name": "Referencias cruzadas (números de material X-ref)",
    "type_WarrantyClaim2PartInfo_name": "Warranty Claim to Parts relation",
    "type_WarrantyClaim_store_name": "Base Store",
    "type_B2BUnit_incoTerms1_name": "Limitación del canal de ventas",
    "type_B2BUnit_customerHierarchyUnit_name": "Tipo de artículo vendible",
    "type_ProductCategoryMapping_category_name": "Código",
    "productSalesStatus_label_NA_CODE20": "No se vende",
    "type_CoreCollectionAddress_companyAddress2_name": "Dirección 2t",
    "type_CoreCollectionAddress_companyAddress_name": "Dirección",
    "type_B2BCustomer_doubleOptCheck_name": "Marcador para habilitar o deshabilitar la fecha de entrega de la solicitud sobrescrita desde la IU.",
    "productSalesStatus_label_APAC_CODE40_anonymous": "Vendable à l'IAM",
    "type_WarrantyClaim_natureOfDefect_name": "Nature Of Defect",
    "type_CoreRequest_coreItemsEMEA_name": "Core Items(EMEA)",
    "type_PriceDocument_code_name": "Price Document",
    "type_marketType_AllMarketsNew_name": "Cantidad mínima de entrega",
    "type_KBEcomProductCategoryMappingJob_name": "días",
    "type_CoreRequest_coreCollectionAddress_name": "Dirección de la recogida",
    "type_Product2SalesRegions_products_name": "Mensaje de tiempo de corte",
    "type_WarrantyClaimProcess_sendWarrantyClaimRetryCount_name": "Number of attempts to send new warranty",
    "type_CrossReference_source_name": "Prioridad de entrega",
    "type_KbOrderStatus_B_name": "En proceso",
    "type_productReferenceTypeEnum_IsSoftwareFor_name": "Número de planta",
    "type_DocumentTimeStamp_lastDownloadtime_name": "Last Download Time",
    "type_CoreRequest_coreMonth_name": "Core Month",
    "productSalesStatus_label_NA_CODE30": "Se vende",
    "type_KBOrderTypeEnum_COLL_name": "Se usa para controlar si se muestra la página de categoría estática o la página de cuadrícula de productos híbridos estándar",
    "type_WarrantyClaim_recallNumber_name": "Recall Number",
    "type_CoreRequest_site_name": "Site",
    "type_PackageType_PALLET_name": "Pallet",
    "type_B2BUnit_glnNumber_name": "Regiones de ventas",
    "type_ProductWeight_unit_name": "Versión del catálogo",
    "type_product_saleableItemType_name": "Recargo por depósito KB",
    "type_SAPCpiOutboundOrder_deliveryPriority_name": "Países excluidos",
    "type_RecallNumber_name_name": "Nombre ",
    "type_WarrantyClaim_user_name": "User",
    "type_WarrantyClaim_engineManufacturer_name": "Fabricant du moteur",
    "type_WarrantyDecision_name_name": "Nombre ",
    "type_VehicleMfg2ChassisRelation_name": "Vehicle Manufacturer to Chassis(chass-eez) Relation",
    "type_Country_salesRegions_name": "Jerarquía de clientes",
    "type_KBOrderTypeEnum_B9ND_name": "Datos web",
    "type_product_xSuffixPart_name": "X Suffix Part",
    "type_Product_productPlantStructures_name": "Tipo de documento",
    "type_DeliveryType_Partial_name": "Ancho",
    "type_KbOrderStatus_C_name": "Enviado",
    "type_Chassis_name": "Chasis ",
    "type_salesdata_salesOrganizationID_name": "Perfil de redondeo",
    "type_WarrantyPart_requestedPartCost_name": "Monto de la pieza solicitada",
    "type_CoreCollectionAddress_shipTo_name": "B2b Unit",
    "type_ProductSalesStatus_CODE10_name": "Contenedor de medios del producto",
    "type_CoreRequest_language_name": "Language",
    "type_OrderTypeQuantityMapping_maxLineEntriesAllowed_name": "Solo socio contractual",
    "type_ClaimType_name": "Tipo de reclamo",
    "type_CoreRequestItem_coreGroup_name": "Grupo principal",
    "type_KbCoreReports_pfdMedia_name": "PDF",
    "type_WarrantyClaim2PartInfo_warrantyClaim_name": "Warranty Claim",
    "type_CMSSiteRestriction_description": "Producto",
    "productSalesStatus_label_NA_CODE10": "Obsoleto",
    "type_B2BCustomerWarrantyRightsEnum_WARRANTY_CLAIM_name": "Solicitud de garantía",
    "type_B2BCustomer_showCorePrice_name": "Jerarquía del producto",
    "type_OrderTypeQuantityMapping_days_name": "Cargo del nucleo",
    "type_Address_companyAddressTwo_name": "URL de imagen remota",
    "type_SAPCpiOutboundOrder_completeDelivery_name": "Kit de acción de campo",
    "type_marketType_name": "Cantidad máxima permitida",
    "type_WarrantyClaimProcess_name": "Warranty Document Media",
    "type_CustomerHierarchyUnit_children_name": "ORDEN DE STOCK",
    "type_BaseStore_dateFormat_name": "Número de pedido de SAP",
    "type_ProductImageMediaConversionCronJob_name": "En venta",
    "type_CoreRequest_uid_name": "IDENTIFICACIÓN",
    "type_product_vmrsCode_name": "Idiomastt",
    "type_ProductMediaContainer_mediasMap_name": "Tipo de artículo",
    "type_OrderTypeQuantityMapping_supportedDeliveryTypes_name": "Types de livraison pris en charge",
    "type_DownloadableMediaContainer_name": "Aprobación denegada",
    "type_MaintenanceScale_name": "Escala",
    "type_VehicleManufacturer_chassis_name": "Chassis(chass-eez)",
    "type_Address_displayStreetNumber_name": "Street Number",
    "type_DocumentType_code_name": "Identificación ERP (enterprise resource planning)",
    "type_ProductCategoryMapping_titleId_name": "Niños",
    "type_productReferenceTypeEnum_CUSTOMER_name": "Productos",
    "type_AbstractOrderEntry_surcharge_name": "Regiones de ventas",
    "type_B2BCustomerIndustryRoleEnum_DEALER_name": "Dealer",
    "type_productDimension_height_name": "Prioridad de gravamen",
    "type_B2BCustomerAccessRequestEnum_ORDER_ONLINE_name": "Comprar online",
    "type_ProductWeight_product_name": "Tipo de transportista",
    "validation_B2BCustomer_DefaultB2BUnit_missing": "système",
    "type_salesdata_distributionChannelID_name": "Fecha de entrega solicitada",
    "type_WarrantyTypeOperation_name_name": "Nombre ",
    "type_CoreCollectionAddress_city_name": "Ciudad",
    "type_productReferenceTypeEnum_IsReplacementFor_name": "Datos de planta",
    "type_saleableItemType_IB_name": "Peso neto",
    "type_WarrantyClaim_primaryComplaint_name": "Queja principal",
    "type_KBEcomProductCategoryMappingJob_lastExecutedtime_name": "Comerciante",
    "type_product_coreClass_name": "Número de ubicación global (global location number, GLN)",
    "type_CoreRequest_b2bUnit_name": "B2b Unit",
    "type_product_webData_name": "Datos de ventas",
    "type_KbCoreReports_csvMedia_name": "CSV",
    "type_productDimension_product_name": "Tipo de mercado",
    "type_TypeOfOperation_name_name": "Nombre ",
    "type_product_code_name": "Aspectos generales",
    "type_CoreItemsEMEA_coreGroup_name": "Grupo principal",
    "productSalesStatus_label_NA_CODE40": "Se venta - hasta agotar existencias",
    "type_OrderTypeQuantityMapping_carriers_name": "Informes principales",
    "type_WarrantyClaim_claimNumber_name": "Claim Number",
    "type_AbstractOrder_currentOrderType_name": "Datos de ventas",
    "type_WarrantyDecision_customerSite_name": "Site",
    "type_CoreCollectionAddress_packagingItems_name": "Packaging Info",
    "type_WarrantyPart_totalCost_name": "Costo total ",
    "type_SapOrderType_code_name": "Sap Order Type",
    "type_product_materialType_name": "Altura",
    "type_ProductPlantStructure_name": "ID del canal de distribución",
    "type_Country_products_name": "Sitio para clientes",
    "type_WarrantyPart_dateRemoved_name": "Fecha de retiro",
    "type_ProductPlantStructure_tariffNumber_name": "Número de documento",
    "type_KbEcomDocument_name": "Documentos",
    "type_product_name_name": "Número de documento intermedio (intermediate document, IDoc)",
    "type_WarrantyClaim_dealerCode_name": "Dealer Code",
    "type_CoreRequest_coreTransportRequired_name": "Core Transport Required",
    "type_AbstractOrderEntry_entryPricingError_name": "Error de precio",
    "type_WarrantyDocumentMedia_name": "Warranty Claim Process",
    "type_TypeOfOperation_code_name": "Código",
    "type_KbCoreReports_statementDate_name": "Statement Date",
    "type_KbEcomDocument_documentType_name": "Código del tipo de documento",
    "type_AbstractOrder_docType_name": "Estado de ventas",
    "type_PackageType_OTHER_name": "Autre",
    "type_ProductDimension_unit_name": "Entrega completa",
    "type_DeliveryType_Complete_name": "Ancho",
    "type_product_coreGroup_name": "Peso bruto",
    "type_Address_displayDistrict_name": "Distrito",
    "type_PricingProceduresSubtotal_KZWI2_name": "Condición de envío",
    "type_AbstractOrder_currentCarrierType_name": "Tipo de mercado SAP",
    "type_CustomerPartNumber_product_name": "Producto",
    "type_KbCoreReports_reportType_name": "Report Type",
    "type_B2BUnit_incoTerms2_name": "Datos de ventas",
    "type_KbEcomImportDataCronJob_deleteAssetsFromBlob_name": "Flete aéreo",
    "type_SalesData_minDeliveringQuantity_name": "Fecha de entrega solicitada",
    "type_WarrantyClaim_typeOfOperation_name": "Tipo de operación",
    "type_B2BCustomer_countryIsoCode_name": "País",
    "type_AbstractOrder_supportedDeliveryTypes_name": "Tipo de documento SAP",
    "type_Chassis_vehicleManufacturer_name": "del fabricante del vehículo",
    "type_WarrantyClaim_warrantyPdf_name": "Warranty PDF",
    "type_CustomerHierarchyUnit_b2bUnits_name": "Enviar reclamos de garantía",
    "type_product_salesRegions_name": "Es accesorio para",
    "type_CoreRequestItem_coreClass_name": "Clase principal",
    "type_CorePackaging_packageQty_name": "Cantidad",
    "type_CustomerHierarchyUnit_name": "Sistema fuente",
    "type_CrossReferenceRelation_crossReferences_name": "Descripción",
    "type_AbstractOrderEntry_originalEntry_name": "Entrada original",
    "type_B2BUnit_accountGroup_name": "Se puede vender al IAM",
    "type_productReferenceTypeEnum_HasSoftware_name": "Tipo POS",
    "type_ExternalLanguageMapping_name": "Mostrar precio neto",
    "type_WarrantyClaim_countryIsoCode_name": "País",
    "type_CustomerHierarchyUnit_name_name": "Kit de piezas de recambio/pieza",
    "type_product_deviceCode_name": "Material Peligroso",
    "type_OrderTypeQuantityMapping_orderTypeCode_name": "Contiene árbol de categoría",
    "type_CrossReference_customer_name": "Predeterminado vendido a",
    "type_CustomerHierarchyUnit_uid_name": "Kit de piezas de recambio",
    "type_Address_dealerCode_name": "Dealer Code",
    "type_productWeight_product_name": "Longitud",
    "type_salesChannelLimitation_Intercompanyonly_name": "Solo proveedor original (original equipment supplier, OES)",
    "type_Category_useExternalUrl_name": "Use External URL",
    "type_VehicleMfg2ChassisRelation_vehicleManufacturer_name": "del fabricante del vehículo",
    "type_CoreCollectionAddress_companyName_name": "Company Name",
    "type_TypeOfOperation_name": "Tipo de operación",
    "type_product_weight_name": "Es software para",
    "type_CMSStaticCategoryPageRestriction_name": "Producto",
    "type_ExternalLanguageMapping_description": "Restricción lateral",
    "type_SAPCpiOutboundOrderItem_requestedDeliveryDate_name": "Cantidad estimada",
    "type_WarrantyPart_otherCostDescription_name": "Descripciones de otros costos",
    "type_SAPCpiOutboundOrder_requestedDeliveryDate_name": "Asignación de lenguaje externo",
    "type_KBOrderTypeEnum_FWDR_name": "Actualizar bandera",
    "type_CoreGradeType_DN_name": "Don't Know",
    "type_WarrantyPart_requestedHandlingCost_name": "Monto de la manipulación solicitada",
    "type_WarrantyPart_replacementType_name": "Tipo de reemplazo",
    "type_WarrantyClaim_vehicleManufacturer_name": "del fabricante del vehículo",
    "type_SalesRegion_code_name": "Referencia cruzada",
    "type_AbstractOrderEntry2AbstractOrderEntry_name": "AbstractOrderEntry2AbstractOrderEntry Relation",
    "type_B2BCustomer_doubleOptUrl_name": "Nombre del archivo",
    "type_CoreRequest_store_name": "Tienda",
    "type_KbEcomDocument_fileName_name": "Doble Verificación opt",
    "type_OrderTypeQuantityMapping_overWritten_name": "Países",
    "type_SalesData_roundingProfile_name": "Rol",
    "type_CrossReferenceRelation_source_name": "Tipo de entrega Enum",
    "type_KbEcomDocument_products_name": "URL de doble opt",
    "type_Address_displayTown_name": "Town",
    "type_KbCoreDocument_TabCode_name": "Tab Name",
    "type_AbstractOrderEntry_requestedDeliveryDate_name": "Estado de ventas de SAP",
    "type_Address_displayStreetName_name": "Street Name",
    "type_OrderProcess_sendOrderFailEmail_description": "Unidad de jerarquía de clientes",
    "type_Product_kbEcomDocuments_name": "Unidades B2B asignadas directamente",
    "type_B2BUnit_paymentTerms_name": "Limitación del canal de ventas",
    "type_OrderTypeQuantityMapping_days_description": "Países",
    "type_ReplacementType_name": "Tipo de reemplazo",
    "type_marketType_OriginalEquipment_name": "Equipo original",
    "type_KbOrderStatus_code_name": "Estado del pedido",
    "type_B2BCustomerWarrantyRightsEnum_WARRANTY_CLAIM_VALUES_name": "Valor de reclamo de garantía",
    "type_CustomerPartNumber_catalogVersion_name": "Catalog Version",
    "type_KbEcomImportDataCronJob_lastRunTime_name": "Last Run Time",
    "type_KbEcomImportDataCronJob_exportedFiles_name": "Exported Files",
    "type_CorePackagingType_GITTERBOX_name": "Gitter Box",
    "type_CorePackagingType_EUR_PALLET_name": "EUR Pallet",
    "type_CorePackagingType_ONE_WAY_PALLET_name": "One Way Pallet",
    "text_excel_customerPartNumber": "Customer Part Number",
    "text_excel_partNumber": "Part Number",
    "type_KbEcomDocument_createdDocumentDate_name": "Document Creation Date ",
    "type_B2BUnit_warrantyPeriod_name": "Warranty Period",
    "type_B2BUnit_sdpGrp01_name": "SDP Group",
    "type_FavoriteList_code_name": "Favorite List",
    "type_FavoriteList_code_description": "Favorite List for adding list of documents to the user",
    "type_FavoriteListEntry_document_name": "document",
    "type_FavoriteListEntry_document_description": "document in each entry list",
    "type_FavoriteListEntry_addedDate_name": "Added Date",
    "type_FavoriteListEntry_addedDate_description": "Added Date of each entry list",
    "type_FavoriteListEntry_documentLanguage_name": "Document Language",
    "type_FavoriteListEntry_documentLanguage_description": "Added Document Language of each entry list",
    "type_DocUser_name": "Doc User",
    "type_DocUser_description": "Doc User for Favorite List ",
    "type_DocUser_email_name": "Doc User Email",
    "type_DocUser_email_description": "Doc User email",
    "type_GuestUser2FavoriteList_name": "GuestUser to FavoriteList",
    "type_GuestUser2FavoriteList_description": "GuestUser2FavoriteList",
    "type_GuestUser2FavoriteList_docUser_name": "Doc User",
    "type_GuestUser2FavoriteList_docUser_description": "Doc User in GuestUser2FavoriteList Relation",
    "type_GuestUser2FavoriteList_favoriteList_name": "Favorite List",
    "type_GuestUser2FavoriteList_favoriteList_description": "Favorite List in GuestUser2FavoriteList Relation",
    "type_AbstractOrder_ppdDelta_name": "PPD Delta Price",
    "type_AbstractOrder_ppdDelta_description": "PPD Delta Price coming from SAP response during price call ",
    "type_B2BCustomer_technicalTrainingAccess_name": "Formación técnica",
    "type_B2BCustomerAccessRequestEnum_TECHNICAL_TRAINING_name": "Formación técnica",
    "type_B2BCustomer_additionalSoldToLocations_name": "Ubicaciones adicionales vde venta",
    "type_UserGroup_asmLocationIsoCodeAccess_name": "ASM Location Access ISOCODES",
    "type_UserGroup_asmLocationIsoCodeAccess_description": "All the ISOCode locations that ASM users that can access to (similar functionality to backoffice locations per backoffice user)",
    "productSalesStatus_label_NA_CODE50": "Se vende (restringido)",
    "productSalesStatus_label_NA_CODE60": "Se venta (restringido) - hasta agotar existencias",
    "type_ExportStatus_saved_name": "Saved (Not Submitted)",
    "value_calculator_header": "EnduraSure®-Pro Savings Summary ",
    "value_calculator_title": "Bendix Value Calculator",
    "value_calculator_visitor_info_title": "Información para visitantes",
    "airDisc_value_calculator_visitor_info_title": "Información para visitantes",
    "value_calculator_firstName": "Nombre de pila",
    "value_calculator_lastName": "Apellidos",
    "value_calculator_email": "Dirección de correo electrónico de la empresa",
    "value_calculator_privacy_accept": "Acepto la cláusula de exención de responsabilidad",
    "value_calculator_privacy_accept_link": "calculadora(s) de valor",
    "value_calculator_next_button": "Siguiente",
    "value_calculator_back_button": "Volver",
    "value_calculator_flit_info_title": "Información sobre la flota",
    "airdisc_value_calculator_flit_info_title": "Información sobre la flota",
    "value_calculator_fleetSizeTractors": "Tamaño de la flota - Tractores*",
    "value_calculator_tractors_text": "Tractores",
    "value_calculator_tractorTradeInCycle": "Ciclo de intercambio de tractores*",
    "value_calculator_fleetSizeTrailers": "Tamaño de la flota - Remolques*",
    "value_calculator_trailers_text": "Remolques",
    "value_calculator_year_text": "Años",
    "value_calculator_trailerTradeInCycle": "Ciclo de intercambio de remolques*",
    "airDisc_value_calculator_trailerTradeInCycle": "Ciclo de intercambio de remolques",
    "value_calculator_actuator_text": "Actuador",
    "value_calculator_usdOcc_text": "USD / Ocurrencia",
    "airDisc_value_calculator_usdOcc_text": "USD / ocurrencia",
    "value_calculator_calls_text": "Llamadas",
    "value_calculator_usdDay_text": "USD / Día",
    "value_calculator_replacement_costNode_title": "Replacement Cost per Actuator",
    "value_calculator_replacement_cost_title": "Coste anual de sustitución por actuador:",
    "value_calculator_replacementFleetCostPerActuator": "Coste de sustitución por actuador",
    "value_calculator_replacementFleetCostPerActuator_toolTip": "Coste medio de la flota para el actuador averiado.",
    "value_calculator_laborToInstallActuator": "Mano de obra para instalar el actuador",
    "value_calculator_laborToInstallActuator_toolTip": "Coste de mano de obra basado en 30 minutos para instalar el actuador de sustitución.",
    "value_calculator_totalCostPerFailedActuator": "Coste total por actuador averiado",
    "value_calculator_numberOfActuatorsReplacedPerYear": "Número de actuadores sustituidos al año",
    "value_calculator_numberOfActuatorsReplacedPerYear_toolTip1": "Por término medio, las flotas sustituyen un actuador al año en el 15% de sus tractoras y el 12% de sus remolques.\\",
    "value_calculator_numberOfActuatorsReplacedPerYear_toolTip2": "Fuente: MacKay & Company 2023",
    "value_calculator_product_performance_title": "Rendimiento actual del producto",
    "value_calculator_brandOfActuator": "Marca del actuador",
    "value_calculator_csa_title": "Costes de inactividad de CSA",
    "value_calculator_roadsideCallRate": "Índice de llamadas en carretera",
    "value_calculator_roadsideCallRate_toolTip": "Coste medio de una llamada de asistencia en carretera, incluido el tiempo de inactividad.",
    "value_calculator_annualRoadsideCallsToActuators": "Número anual de llamadas en carretera relacionadas con actuadores*",
    "value_calculator_violations_text": "Violations",
    "value_calculator_roadsideCallRateCsaViolation": "Índice de llamadas a la carretera por infracción de la CSA",
    "value_calculator_roadsideCallRateCsaViolation_toolTip": "Coste estimado de la asistencia en carretera durante un caso de CSA fuera de servicio (OOS).",
    "value_calculator_annualOutOfServiceCsaViolations": "Número anual de infracciones de la CSA por frenos fuera de servicio*",
    "value_calculator_fleetDowntimeRate": "Índice de tiempo de inactividad de la flota*",
    "value_calculator_upcharge_title": "Recargo por equipos nuevos",
    "value_calculator_estUpchargeForEndTractor": "Suplemento estimado para EnduraSure-Pro en el tractor sobre la opción actual",
    "value_calculator_estUpchargeForEndTractor_errorMsg": "Please enter Estimated upcharge for EnduraSure-Pro on tractor over current option",
    "value_calculator_estUpchargeForEndTrailer": "Suplemento estimado para EnduraSure-Pro en el remolque con respecto a la opción actual",
    "value_calculator_estUpchargeForEndTrailer_errorMsg": "Please enter Estimated upcharge for EnduraSure-Pro on trailer over current option",
    "value_calculator_enduraSure_summary": "Resumen de EnduraSure®-Pro",
    "value_calculator_unit_cost": "Coste unitario",
    "value_calculator_totalFleet_cost": "Coste total de la flota",
    "value_calculator_initialpurchase_tractor_cost": "Coste inicial de compra - tractor",
    "value_calculator_initialpurchase_trailer_cost": "Coste inicial de compra - remolque",
    "value_calculator_replacementTractor_cost": "Costes de sustitución de por vida - tractor",
    "value_calculator_replacementTrailer_cost": "Costes de sustitución de por vida - remolque",
    "value_calculator_csaTractor_cost": "Costes relacionados con CSA - tractor",
    "value_calculator_csaTrailer_cost": "Costes relacionados con CSA - remolque",
    "value_calculator_total_text": "Total",
    "value_calculator_return_investment": "Retorno de la inversión (ROI)",
    "value_calculator_TCO_perUnit_standard": "TCO por unidad - Estándar (USD)",
    "value_calculator_TCO_perUnit_Sealed": "TCO por unidad - Sellado (USD)",
    "value_calculator_fleet_saving": "Ahorro neto de flota (USD)",
    "value_calculator_description_text": "Descripción ",
    "value_calculator_email_results": "Resultados del correo electrónico",
    "value_calculator_reset_text": "Restablecer",
    "value_calculator_email_text": "Email",
    "value_calculator_enduraSure_perTractor": "Coste adicional de EnduraSure®-Pro por tractor",
    "value_calculator_enduraSure_perTractor_desc": "Recargo estimado por EnduraSure®-Pro en tractor sobre la opción actual. El coste puede oscilar entre 50 y 150 dólares por tractor nuevo.",
    "value_calculator_enduraSure_perTrailer": "Coste adicional de EnduraSure®-Pro por remolque",
    "value_calculator_enduraSure_perTrailer_desc": "Estimación del recargo por EnduraSure®-Pro en el remolque respecto a la opción actual. El coste puede oscilar entre 50 y 150 dólares por remolque nuevo.",
    "value_calculator_proEmail_summary": "EnduraSure®-Pro Email Summary",
    "value_calculator_contact_info": "Contact Information",
    "airDisc_value_calculator_contact_info": "Información de contacto",
    "valueCalculator_brandOfActuator_bendixEnduraSure": "Bendix EnduraSure",
    "valueCalculator_brandOfActuator_bendixEnduraSurePro": "Bendix EnduraSure-Pro",
    "valueCalculator_brandOfActuator_haldexGoldSeal": "Haldex Gold Seal",
    "valueCalculator_brandOfActuator_haldexLifeSeal": "Haldex Life Seal",
    "valueCalculator_brandOfActuator_tseOmni": "TSE Omni",
    "valueCalculator_brandOfActuator_tseUltra": "TSE Ultra",
    "valueCalculator_brandOfActuator_wabcoTristop": "WABCO Tristop",
    "valueCalculator_brandOfActuator_other": "Other",
    "value_cal_fleetSizeTractors_valMsg": "Introduzca el tamaño de la flota - Tractores",
    "value_cal_tractorTradeInCycle_valMsg": "Por favor, introduzca Tractor Trade-In Cycle",
    "value_cal_fleetSizeTrailers_valMsg": "Por favor, introduzca el tamaño de la flota - Remolques",
    "value_cal_trailerTradeInCycle_valMsg": "Por favor, introduzca el ciclo de intercambio de remolquese",
    "value_cal_repFleetCostPerActuator_valMsg": "Introduzca el coste de sustitución de la flota por actuador",
    "value_cal_laborToInstallActuator_valMsg": "Introduzca la mano de obra para instalar el actuador",
    "value_cal_noOfActuatorsReplacedPerYear_valMsg": "Introduzca el número de actuadores sustituidos al año",
    "value_cal_roadsideCallRate_valMsg": "Por favor, introduzca la tasa de llamadas en carretera",
    "value_cal_annualRoadsideCallsToActuators_valMsg": "Por favor, introduzca el Número Anual de Llamadas en Carretera relacionadas con Actuadoress",
    "value_cal_roadsideCallRateCsaViolation_valMsg": "Por favor, introduzca la tasa de llamadas en carretera por infracción de la CSA",
    "value_cal_annualOutOfServiceCsaViolations_valMsg": "Introduzca el número anual de infracciones de la CSA por frenos fuera de servicio",
    "value_cal_fleetDowntimeRate_valMsg": "Por favor, introduzca la tasa de tiempo de inactividad de la flota",
    "value_cal_greaterThan_zeroMsg": "Introduzca un valor superior a 0",
    "value_cal_landingPage_textMsg": "Descubra cuánto puede ahorrar al elegir los frenos de disco neumáticos Bendix®, los frenos de muelle EnduraSure®-Pro y el sistema de control de presión de neumáticos SmarTire® de Bendix CVS. Consulte nuestras calculadoras de valor fáciles de usar.",
    "value_cal_negativeVal_text": "No se obtiene ningún ahorro neto. La flota debe tener en cuenta otros beneficios, como la reducción de la garantía, el inventario de piezas y la utilización del tiempo de los técnicos.",
    "value_calculator_standardChamberLifetime": "Cámara estándar (de por vida)",
    "value_calculator_sealedChamberLifetime": "Cámara sellada (de por vida)",
    "value_calculator_formSubmit_success": "Your EnduraSure-Pro savings projection summary has been emailed.",
    "value_calculator_formSubmit_failed": "Something went wrong while submitting the  EnduraSure-Pro savings. Please try again later.",
    "value_calculator_estUpchargeForEndTractor_pdf": "Upcharge for EnduraSure-Pro per tractor",
    "value_calculator_estUpchargeForEndTrailer_pdf": "Upcharge for EnduraSure-Pro per trailer",
    "value_calculator_formSubmit_error": "Por favor, corrija los siguientes errores.",
    "value_calculator_fName_emptyMsg": "Nombre No puede estar vacío..",
    "value_calculator_lName_emptyMsg": "Apellido No puede estar vacío.",
    "value_calculator_email_emptyMsg": "Correo electrónico de la empresa No puede estar vacío.",
    "value_calculator_captcha_validMsg": "Por favor, introduzca un Captcha válido.",
    "value_calculator_captcha_expiredMsg": "Captcha caducado.",
    "value_calculator_captcha_failedMsg": "Error al cargar captcha.",
    "value_calculator_captcha_invalidMsg": "Captcha inválido, por favor inténtelo de nuevo.",
    "text_warranty_submit_datein_service_invalid": "Introduzca una fecha válida de entrada en servicio",
    "text_warranty_submit_date_removed_service_invalid": "Introduzca una fecha válida de retirada del servicio",
    "airdisc_value_calculator_tractors_text": "Tractors",
    "airdisc_value_calculator_privacy_accept": "Acepto las cláusulas de exención de responsabilidad",
    "airdisc_value_calculator_privacy_accept_link": "de Value Calculator(s)",
    "airDiscBrake_value_calculator_header": "Resumen de frenos de tambor frente a frenos de disco",
    "airDiscBrake_value_calculator_drumvsadb": "Freno de tambor vs. freno de disco resumen",
    "airDiscBrake_value_calculator_firstName": "Nombre",
    "airDiscBrake_value_calculator_lastName": "Apellido",
    "airDiscBrake_value_calculator_email": "Dirección de correo electrónico de la empresa",
    "airDiscBrake_value_calculator_adbValueCalculatorType": "Calculadora de valor ADB tipo*",
    "airDiscBrake_value_calculator_fleetSize": "Tamaño de la flota*",
    "airDiscBrake_value_calculator_totalNumberOfAxlesPerUnit": "Número total de ejes por unidad",
    "airDiscBrake_value_calculator_tractorTradeInCycle": "Ciclo de intercambio de tractores",
    "airDiscBrake_value_calculator_averageAnnualUnitMileage": "Kilometraje unitario anual medio del vehículo*",
    "airDiscBrake_value_calculator_drumtoshorereplacementFrequency": "Frecuencia de sustitución del freno de tambor a la zapata de freno",
    "airDiscBrake_value_calculator_drumtoshorereplacementFrequency_everyFrictionChange": "Cada cambio de fricción",
    "airDiscBrake_value_calculator_drumtoshorereplacementFrequency_everyOtherFrictionChange": "Cada dos cambios de fricción",
    "airDiscBrake_value_calculator_adbupcharge": "Freno de disco neumático más caro que el de tambor",
    "airDiscBrake_value_calculator_adbResidualValueatTradeIn": "Valor residual de los frenos de disco de aire en el momento del canje (aumento con respecto al tambor)",
    "airDiscBrake_value_calculator_fleetDowntimeRate": "Tasa de inactividad de la flota*",
    "airDiscBrake_value_calculator_fleetMaintenanceLaborRate": "Tasa de mano de obra de mantenimiento de la flota.",
    "airDiscBrake_value_calculator_annualFleetAccidentRate": "Siniestralidad anual de la flota*",
    "airDiscBrake_value_calculator_noofRearEndCollisionsDuringLifeCycle": "Número de colisiones traseras durante la vida útil",
    "airDiscBrake_value_calculator_rearEndCollisionUnitCost": "Colisión por alcance coste unitario",
    "airDiscBrake_value_calculator_lifeCycleRearEndCollisionsFleetCost": "Ciclo de vida de las colisiones por alcance coste de la flota",
    "airDiscBrake_value_calculator_noOfFrictionReplacementsInTradeIn": "Número de sustituciones por fricción en el momento de la entrega",
    "airDiscBrake_value_calculator_brakeFrictionRequirementAtTradeIn": "Requisitos de fricción de los frenos en el momento de la entrega",
    "airDiscBrake_value_calculator_brakeFrictionRequirementAtTradeIn_minimum": "Fricción mínima del 50% en el momento de la entrega",
    "airDiscBrake_value_calculator_brakeFrictionRequirementAtTradeIn_nominimum": "Sin requisito mínimo en el canje",
    "airDiscBrake_value_calculator_numberOfDrumReplacementsAtTradeIn": "Número de sustituciones de bidones en el momento de la entrega",
    "airDiscBrake_value_calculator_drumBrakeShoeReplacementUnitCost": "Coste unitario de sustitución de la zapata del freno de tambor",
    "airDiscBrake_value_calculator_drumBrakeReplacementUnitCost": "Coste de la unidad de sustitución de los frenos de tambor",
    "airDiscBrake_value_calculator_drumReplacementUnitCost": "Coste de la unidad de sustitución del tambor",
    "airDiscBrake_value_calculator_drumbrakeReplacementFleetCost": "Sustitución de frenos de tambor coste de flota",
    "airDiscBrake_value_calculator_drum_maintenance": "Costes de servicio de los frenos de tambor (inspección, ajuste y lubricación de los frenos)",
    "airDiscBrake_value_calculator_drumBrakeServiceLaborCost": "Coste de la mano de obra del servicio de frenos de tambor",
    "airDiscBrake_value_calculator_totalDrumBrakeServiceUnitCost": "Coste total de la unidad de servicio de frenos de tambor",
    "airDiscBrake_value_calculator_drumBrakeServiceAnnualFrequency": "Frecuencia anual del servicio de frenos de tambor",
    "airDiscBrake_value_calculator_totalDrumBrakeServiceFleetCost": "Coste total de la unidad de servicio de frenos de tambor",
    "airDiscBrake_value_calculator_csaViolationsAnnualPercentage": "Porcentaje anual de infracciones de la CSA",
    "airDiscBrake_value_calculator_numberofCSAViolations": "Número de infracciones de la CSA",
    "airDiscBrake_value_calculator_roadsideCallRateForCSAViolation": "Índice de llamadas a carretera por infracción de la CSA*",
    "airDiscBrake_value_calculator_annualNoOfOutOfServiceBrakeCSAViolations": "Número anual de infracciones de la CSA por frenos fuera de servicio*",
    "airDiscBrake_value_calculator_CSAUnitCost": "Coste unitario CSA (incluye el tiempo de inactividad)",
    "airDiscBrake_value_calculator_lifecycleCSAFleetCost": "Coste del ciclo de vida de la flota CSA",
    "airDiscBrake_value_calculator_drumbrakeReplacementDueToRustJacking": "Sustitución de frenos de tambor por oxidación",
    "airDiscBrake_value_calculator_rustJackingShoeReplacementUnitCost": "Coste unitario de sustitución de la zapata de freno por oxidación",
    "airDiscBrake_value_calculator_rustJackingShoeReplacementFleetCost": "Sustitución de zapatas de freno Coste de flota por oxidación",
    "airDiscBrake_value_calculator_adbImpactWithImprovedStoppingDistance": "Impacto del ADB con distancia de frenado mejorada",
    "airDiscBrake_value_calculator_adbImpactWithImprovedStoppingDistance_ZERO": "0",
    "airDiscBrake_value_calculator_adbImpactWithImprovedStoppingDistance_ONE": "1",
    "airDiscBrake_value_calculator_adbImpactWithImprovedStoppingDistance_TWO": "2",
    "airDiscBrake_value_calculator_adbImpactWithImprovedStoppingDistance_FIVE": "5",
    "airDiscBrake_value_calculator_adbImpactWithImprovedStoppingDistance_TEN": "10",
    "airDiscBrake_value_calculator_initialAdbFleetCost": "Coste inicial de la flota ADB",
    "airDiscBrake_value_calculator_impactToFleetAccidentCosts": "Impacto en los costes de siniestralidad de la flota",
    "airDiscBrake_value_calculator_accidentcost": "Impacto en los costes de siniestralidad de la flota ¹,²",
    "airDiscBrake_value_calculator_adbFrictionMileage": "ADB fricción kilometraje",
    "airDiscBrake_value_calculator_adbFriction": "ADB fricción kilometraje ³",
    "airDiscBrake_value_calculator_noOfPadReplacementsAtTradeIn": "Número de sustituciones de pastillas de freno en el momento del canje",
    "airDiscBrake_value_calculator_noOfRotarReplacementsAtTradeIn": "Número de rotores sustituidos en el momento del canje",
    "airDiscBrake_value_calculator_padandRotarReplacementUnitCost": "Coste unitario de sustitución de pastillas y discos",
    "airDiscBrake_value_calculator_lifeCyclePadAndRotarReplacementFleetCosts": "Ciclo de vida de las pastillas y los rotores costes de flota",
    "airDiscBrake_value_calculator_adbBrakeAdjustmentMaintanaceFleetCost": "ADB ajuste de frenos mantenimiento coste de la flota",
    "airDiscBrake_value_calculator_csaViolationFleetCost": "Coste de la flota por infracción de la CSA",
    "airDiscBrake_value_calculator_adbRustJackingPadReplacementFleetCost": "Coste de la flota de sustitución de pastillas de freno ADB por oxidación",
    "airDiscBrake_value_calculator_totalAdbUnitCost": "Coste unitario total del freno de disco",
    "airDiscBrake_value_calculator_totalAdbFleetCost": "Coste total de la flota de frenos de disco",
    "airDiscBrake_value_calculator_tractorDrumvsAirDiscBrakeSummaryCosts": "Resumen de costes de frenos de tambor vs. frenos de disco para tractores (USD)",
    "airDiscBrake_value_calculator_trailerDrumvsAirDiscBrakeSummaryCosts": "Resumen de costes de frenos de tambor y frenos de disco para remolques (USD)",
    "airDiscBrake_value_calculator_drum": "Freno de tambor",
    "airDiscBrake_value_calculator_adb": "Freno de disco",
    "airDiscBrake_value_calculator_description": "Descripción",
    "airDiscBrake_value_calculator_unit_cost": "Coste unitario",
    "airDiscBrake_value_calculator_totalFleet_cost": "Coste total de la flota",
    "airDiscBrake_value_calculator_initialpurchase_cost": "Coste de compra inicial",
    "airDiscBrake_value_calculator_residualValueAtTradeIn": "Valor residual en el momento de la entrega",
    "airDiscBrake_value_calculator_estimatedImpactOfSafety": "Impacto estimado en la seguridad",
    "airDiscBrake_value_calculator_estimatedReplacementMaintenanceCost": "Coste estimado de mantenimiento de sustitución",
    "airDiscBrake_value_calculator_continuiousMaintananceCost": "Coste de mantenimiento continuo",
    "airDiscBrake_value_calculator_csaRelatedCosts": "Costes relacionados con la CSA",
    "airDiscBrake_value_calculator_rustJackingCosts": "Coste del óxido",
    "airDiscBrake_value_calculator_total_text": "Coste total",
    "airDiscBrake_value_calculator_returnOnInvestmentROI": "Return on Investment (ROI)",
    "airDiscBrake_value_calculator_roiOverLifeCycleUSD_UNIT": "Retorno de la inversión a lo largo del ciclo de vida (USD / unidad)",
    "airDiscBrake_value_calculator_roiOVerLifeCycleUSD": "Retorno de la inversión a lo largo del ciclo de vida (USD)",
    "airDiscBrake_value_calculator_changeFriction": "Kilometraje medio hasta el cambio de fricción",
    "airDiscBrake_value_calculator_replacementCycle": "Ciclos de sustitución",
    "airDiscBrake_value_calculator_usd_hour": "USD / hora",
    "airDiscBrake_value_calculator_usd_unit": "USD / unidad",
    "airDiscBrake_value_calculator_hours_wheelend": "Horas por extremo de rueda",
    "airDiscBrake_value_calculator_times/year": "Veces al año",
    "airDiscBrake_value_calculator_drum_service": "Coste total de la flota de servicio de frenos de tambor",
    "airDiscBrake_value_calculator_CSA_violation": "Costes de infracción de la CSA (desajustados o con la fricción agrietada)",
    "airDiscBrake_value_calculator_drum_rust": "Mantenimiento de frenos de tambor por oxidación",
    "airDiscBrake_value_calculator_brake_summary": "Resumen de costes de los frenos de disco",
    "airDiscBrake_value_calculator_adb_percentage": "% with ADB",
    "airdisc_value_calculator_proEmail_summary": "Resumen del ahorro en frenos de disco neumàticos Bendix",
    "airDiscBrake_value_calculator_totalNumberOfAxlesPerUnit_tooltip": "Número total de ejes por configuración de la unidad (por ejemplo: 3 ejes para un tractor 6x4 o un remolque de eje tridem, 2 ejes para un vehículo 4x2 o un remolque de eje tándem, etc.).",
    "airDiscBrake_value_calculator_drumtoshorereplacementFrequency_tooltip": "Seleccione la frecuencia de sustitución del tambor en relación con la frecuencia de sustitución de la zapata del tambor.",
    "airDiscBrake_value_calculator_adbupcharge_tootlip": "Suplemento por ADB en las cuatro ruedas (ejes de dirección y tracción delanteros).  Varía en función del OEM (ten en cuenta los créditos de eliminación de tambores).",
    "airDiscBrake_value_calculator_popup_tradeIn": "Proporcionar la cantidad residual que el vehículo ADB obtendría en el canje sobre el tambor.",
    "airDiscBrake_value_calculator_popup_fleet": "Tasa de tiempo de inactividad (USD / día) mientras el camión no está operativo.  (Media de la encuesta sobre flotas = 850 USD / día) ",
    "airDiscBrake_value_calculator_popup_annualfeet": "Proporcione la tasa de accidentes anual estimada para la flota.  Tasa de accidentes típica del 7% basada en datos de RigDig™ para las 200 principales flotas (por ejemplo: una flota de 100 unidades con 5 accidentes al año tendría una tasa de accidentes del 5%).",
    "airDiscBrake_value_calculator_popup_annualfeet_title": "Siniestralidad anual de la flota",
    "airDiscBrake_value_calculator_popup_rearendCycle": "Se estima que el 22.8% de los accidentes de vehículos comerciales se caracterizan como colisiones traseras según FMCSA Large Truck and Bus Crash Facts (2022).",
    "airDiscBrake_value_calculator_popup_rearendCost": "Las colisiones traseras promedian 75,301 USD / incidente (sólo daños a la propiedad) para cálculos estimados según 2020 FMCSA Pocket Guide to Large Truck and Bus Statistics.",
    "airDiscBrake_value_calculator_popup_changeFriction": "Kilometraje medio del vehículo para sustituir la fricción normalmente desgastada.",
    "airDiscBrake_value_calculator_popup_brakeFrictionRequirementAtTradeIn": "Elija entre los requisitos de fricción de frenos definidos en el momento de la entrega del vehículo.",
    "airDiscBrake_value_calculator_popup_drumBrakeShoeReplacementUnitCost": "Coste por vehículo para sustituir las zapatas de freno de tambor en todas las posiciones de las ruedas (por ejemplo: 60 USD / kit de zapatas x 6 kits de zapatas / vehículo = 360 USD / unidad).",
    "airDiscBrake_value_calculator_popup_drumReplacementUnitCost": "Coste por vehículo para sustituir los tambores en todas las posiciones de las ruedas (por ejemplo: 100 USD / tambor x 6 tambores / vehículo = 600 USD / unidad).",
    "airDiscBrake_value_calculator_popup_drumBrakeReplacementUnitCost": "Costes medios de sustitución de la fricción y el tambor (por vehículo) acumulados durante el ciclo de vida. (Sólo costes de piezas de recambio y mano de obra)",
    "airDiscBrake_value_calculator_popup_drumBrakeServiceLaborCost": "Tiempo de trabajo (horas/extremo de rueda) necesario para inspeccionar visualmente los frenos, medir el ajuste y engrasar los ajustadores de holgura y los tubos de leva. (por ejemplo: 10 minutos = 0.17 horas)",
    "airDiscBrake_value_calculator_popup_drumBrakeServiceAnnualFrequency": "Número medio de veces que se inspeccionan/ajustan anualmente los frenos de tambor.",
    "airDiscBrake_value_calculator_popup_csaViolationsAnnualPercentage": "Estimación de las infracciones del CSA como porcentaje anual de los vehículos de una flota.",
    "airDiscBrake_value_calculator_popup_roadsideCallRateForCSAViolation": "Coste estimado de la asistencia en carretera durante un caso de CSA fuera de servicio (OOS).",
    "airDiscBrake_value_calculator_popup_annualNoOfOutOfServiceBrakeCSAViolations": "Número calculado de infracciones de la CSA resultantes de frenos fuera de servicio (OOS), basado en el 13% de infracciones de la CSA relacionadas con frenos OOS.",
    "airDiscBrake_value_calculator_popup_CSAUnitCost": "Costes totales del ciclo de vida estimados de la infracción CSA por vehículo, incluido el tiempo de inactividad.",
    "airDiscBrake_value_calculator_popup_drumbrakeReplacementDueToRustJacking": "Número anual de vehículos que requieren la sustitución de la zapata del tambor debido a la oxidación.",
    "airDiscBrake_value_calculator_popup_rustJackingShoeReplacementUnitCost": "Coste unitario total del ciclo de vida de sustitución de las zapatas de freno asociado al óxido (por vehículo), incluye mano de obra y tiempo de inactividad.",
    "airDiscBrake_value_calculator_popup_adbImpactWithImprovedStoppingDistance": "Aportación de la flota para el nivel estimado de impacto asociado a las colisiones por alcance mediante la mejora del rendimiento de la distancia de frenado del vehículo con respecto a los frenos de tambor.  (Por ejemplo: un impacto del 2% en 125 colisiones traseras estimadas equivaldría aproximadamente a 3 incidentes).",
    "airDiscBrake_value_calculator_popup_impactToFleetAccidentCosts": "Estimación de los costes evitados basada en el nivel de impacto asociado a las colisiones por alcance (por ejemplo: 2 incidentes x 75,301 USD / incidente = 150,602 USD evitados).",
    "airDiscBrake_value_calculator_popup_adbFrictionMileage": "El cálculo de la tasa de desgaste supone una mejora de 1.5 veces en la vida útil de la pastilla Bendix ADB con respecto a la vida útil de la fricción del freno de tambor.",
    "airDiscBrake_value_calculator_popup_noOfRotarReplacementsAtTradeIn": "Número calculado de sustituciones de rotores basado en el número estimado de sustituciones de pastillas (se supone la sustitución del rotor con la segunda sustitución de la pastilla).",
    "airDiscBrake_value_calculator_popup_adbBrakeAdjustmentMaintanaceFleetCost": "Los frenos de disco neumáticos tienen un mecanismo de ajuste interno que no requiere mano de obra de mantenimiento para inspeccionar o mantener el ajuste.",
    "airDiscBrake_value_calculator_popup_csaViolationFleetCost": "Los frenos de disco neumáticos disponen de un mecanismo de ajuste interno que reduce el riesgo de infracciones de la CSA relacionadas con frenos desajustados y/o rotura de la fricción relacionada con el levantamiento de óxido.",
    "airDiscBrake_value_calculator_popup_adbRustJackingPadReplacementFleetCost": "El diseño de la almohadilla ADB no permite que los contaminantes se introduzcan bajo la fricción, lo que elimina los costes asociados a la sustitución de la fricción debido a la oxidación.",
    "value_calculator_adb_calculatorTypes": "Calculadora de valor ADB tipo",
    "value_calculator_adb_tractors": "Tractor",
    "value_calculator_adb_trailer": "Remolque",
    "value_calculator_fleetSize": "Tamaño de la flota",
    "value_calculator_fleet_error": "Enter greater than 1",
    "value_calculator_fleet_mileage": "Kilometraje unitario anual medio del vehículo",
    "value_calculator_fleet_axles_unit": "Ejes / unidad",
    "value_calculator_fleet_miles": "Miles",
    "value_calculator_fleet_residualValue": "Valor residual de los frenos de disco de aire en el momento del canje (aumento con respecto al tambor)",
    "value_calculator_fleet_safety_title": "Costes de seguridad de la flota",
    "value_calculator_fleet_drumBrake_title": "Mantenimiento de los frenos de tambor asociado a la inspección, el ajuste y la lubricación de los frenos",
    "airdiscBrake_value_calculator_violations_text": "Infracciones",
    "airdiscBrake_calculator_drum_costs": "Costes del servicio de frenos de tambor",
    "airdiscBrake_calculator_csa_costs": "Costes de infracción de la CSA",
    "airdiscBrake_calculator_rust": "Mantenimiento de la oxidación",
    "airdiscBrake_calculator_adbCost": "Resumen de costes de ADB",
    "airdiscBrake_value_calculator_negative_roi": "No se obtiene ningún ahorro neto.  La flota podría considerar otros beneficios como la reducción de la garantía, el inventario de piezas y la utilización del tiempo de los técnicos.",
    "airdiscBrake_value_calculator_annualOutOfServiceCsaViolations": "Número anual de infracciones de la CSA por frenos fuera de servicio",
    "airdiscBrake_value_calculator_emailResult": "Bendix ADB Savings Summary",
    "airdiscBrake_value_calculator_cost_summary": "Las colisiones traseras promedian 75,301 USD / incidente (sólo daños a la propiedad) para cálculos estimados.",
    "airdiscBrake_value_calculator_cost_line": "(2020 FMCSA Pocket Guide to Large Truck and Bus Statistics)",
    "airdiscBrake_value_calculator_cost_secondsummary": "Este es un costo estimado basado en datos de la flota y no representa un costo validado por Bendix.",
    "airdiscBrake_value_calculator_cost_thirdsummary": "Los kilometrajes estimados se basan en los resultados de las pruebas de desgaste. Los resultados reales pueden variar en función de (pero sin limitarse a) la variación de la flota, las prácticas de mantenimiento, las especificaciones del equipo, el comportamiento del conductor, la aplicación, el ciclo de trabajo, etc. El mantenimiento adecuado es un requisito importante en el mantenimiento de cualquier sistema de frenos para optimizar su rendimiento.",
    "airdisc_value_calculator_fleet_drumBrake_title": "Fricción / Mantenimiento del tambor",
    "airdiscBrake_value_calculator_negative_estimated_roi": "Basándose en los datos de su flota, la elección de los frenos de disco neumáticos proporciona un ROI neto estimado para su flota.",
    "airdiscBrake_value_calculator_formSubmit_success": "Su Resumen de frenos de disco neumáticos ha sido enviado por correo electrónico.",
    "airdiscBrake_value_calculator_formSubmit_failed": "Se ha producido un error al enviar el ahorro en frenos de disco neumáticos.  Por favor, inténtelo de nuevo más tarde.",
    "airdiscbreak_calculator_title": "Freno de disco neumático",
    "airdiscBrake_value_calculator_title": "Calculadoras de Valor Bendix",
    "airDisc_value_calculator_title": "Calculadora de valor",
    "text_select_master_country_europe": "Europa",
    "text_select_master_country_na": "Norte América",
    "text_select_master_country_asia": "Asia Pacífico",
    "text_select_master_country_africa": "Medio Este y África",
    "text_select_master_country_frenchoverseas": "Territorios Franceses de Ultramar",
    "text_account_supporttickets": "Tickets de soporte",
    "text_account_supporttickets_heading": "Tickets de soporte",
    "text_account_supporttickets_history": "Tickets de soporte",
    "text_account_supporttickets_noSupporttickets": "No tiene vales de servicio de soporte",
    "text_account_supporttickets_subHeading": "Gestione sus vales de servicio de soporte",
    "text_account_supporttickets_requestSupport": "Crear un boleto nuevo",
    "text_account_supporttickets_ticketId": "ID de vale de servicio",
    "text_account_supporttickets_subject": "Asunto",
    "text_account_supporttickets_dateCreated": "Fecha de creación",
    "text_account_supporttickets_dateUpdated": "Fecha de actualización",
    "text_account_supporttickets_status": "Estado",
    "text_account_supporttickets_viewDetails": "Ver detalles",
    "text_account_supporttickets_addSupportTicket": "Añadir vale de servicio de soporte",
    "text_account_supportTickets_page_currentPage": "Página {0} de {1}",
    "text_account_supportTickets_page_firstPage": "&laquo;",
    "text_account_supportTickets_page_lastPage": "&raquo;",
    "text_account_supportTickets_page_linkNextPage": "Página siguiente",
    "text_account_supportTickets_page_linkPreviousPage": "Página anterior",
    "text_account_supportTickets_page_showAllResults": "Mostrar todo",
    "text_account_supportTickets_page_showPageResults": "Mostrar con páginas",
    "text_account_supportTickets_page_sort_byDate": "Fecha de actualización",
    "text_account_supportTickets_page_sort_byTicketId": "ID de vale de servicio",
    "text_account_supportTickets_page_sort_LastChangeDateTime": "Fecha de actualización",
    "text_account_supportTickets_page_sort_ObjectID": "ID de vale de servicio",
    "text_account_supportTickets_page_sortTitle": "Ordenar por",
    "text_account_supportTickets_page_totalResults": "de {0} tickets",
    "text_account_supportTickets_page_totalResultsCurrPage": "{0} de {1} tickets",
    "text_account_supportTickets_page_totalResultsSinglePag": "{0} tickets",
    "text_account_supportTickets_page_totalResultsSingleOrder": "1 ticket",
    "supportticket_subject_invalid": "Indique el asunto.",
    "supportticket_subject_invalid_length": "El asunto debe tener 255 caracteres como máximo.",
    "supportticket_message_invalid": "Escriba un mensaje válido.",
    "supportticket_message_invalid_length": "El mensaje no debe tener más de 5000 caracteres.",
    "text_account_supporttickets_messages": "Mensajes",
    "text_account_supporttickets_createTicket_heading": "Solicitar soporte de cliente",
    "text_account_supporttickets_createTicket_subject": "Asunto",
    "text_account_supporttickets_createTicket_subject_desc": "Indique el asunto de su solicitud.",
    "text_account_supporttickets_createTicket_message": "Mensaje",
    "text_account_supporttickets_createTicket_message_history": "Historial de mensajes",
    "text_account_supporttickets_createTicket_message_desc": "Escriba un mensaje. Proporcione toda la información que pueda.",
    "text_account_supporttickets_attachment_block_listed": "El anexo de fichero tiene una extensión no admitida. Solo se permiten {0}.",
    "text_account_supporttickets_createTicket_associatedTo": "Asociado a",
    "text_account_supporttickets_createTicket_associatedTo_option1": "Seleccionar opcionalmente...",
    "text_account_supporttickets_createTicket_ticketCategory": "Categoría",
    "text_account_supporttickets_createTicket_ticketCategory_ENQUIRY": "Consulta",
    "text_account_supporttickets_createTicket_ticketCategory_COMPLAINT": "Queja",
    "text_account_supporttickets_createTicket_ticketCategory_PROBLEM": "Problema",
    "text_account_supporttickets_createTicket_updated": "Actualizado",
    "text_account_supporttickets_createTicket_selectFile": "Seleccione un fichero",
    "text_account_supporttickets_createTicket_chooseFile": "Elija fichero",
    "text_account_supporttickets_fileMaxSizeExceeded": "El fichero es demasiado grande.",
    "text_account_supporttickets_file_is_large_than": "El fichero es demasiado grande (>{0})",
    "text_account_supporttickets_createTicket_noFileChosen": "Sin archivo elegido",
    "text_account_supporttickets_createTicket_Cart": "Carro",
    "text_account_supporttickets_createTicket_SavedCart": "Carros guardados",
    "text_account_supporttickets_createTicket_Order": "Pedido",
    "text_account_supporttickets_createTicket_submit": "Enviar",
    "text_account_supporttickets_createTicket_back": "Atrás",
    "text_account_supporttickets_history_addedBy_customerService": "Atención al cliente",
    "text_account_supporttickets_updateSupportTicket": "Actualizar vale de servicio de soporte",
    "text_account_supportTicket_updateTicket_heading": "Actualizar vale de servicio de soporte",
    "text_account_supportTicket_updateTicket_status": "Estado",
    "text_account_supporttickets_updateTicket_message_desc": "Actualiza un mensaje. Por favor, proporcione tanta información como sea posible.",
    "text_account_supporttickets_currentStatus": "estado actual",
    "text_account_supporttickets_tryLater": "Lo sentimos, hubo un problema. Vuelve a intentarlo más tarde.",
    "text_account_supporttickets_updateTicket_addMessage": "Añadir mensaje",
    "text_account_supporttickets_updateTicket_on": "sobre",
    "text_account_supporttickets_cancel": "Cancelar",
    "ticketstatus_OPEN": "Abrir",
    "ticketstatus_INPROCESS": "En curso",
    "ticketstatus_COMPLETED": "Completado",
    "ticketstatus_CLOSED": "Cerrado",
    "ticketstatus_REOPEN": "Se volvió a abrir",
    "ticketstatus_box_COMPLETED": "Completar",
    "ticketstatus_box_INPROCESS": "Volver a abrir",
    "ticketstatus_box_CLOSED": "Cerrado",
    "text_supporttickets_reset": "Reiniciar",
    "text_supporttickets_search": "Buscar",
    "text_supporttickets_search_from_date": "Billete Fecha De",
    "text_supporttickets_search_to_date": "Billete Fecha A",
    "text_account_supporttickets_createTicket_message_mandatory": "Mensaje*",
    "text_account_supporttickets_content1": "no Archivo seleccionado",
    "text_account_supporttickets_content2": "(Máximo: 9 Megabyte)",
    "text_account_supporttickets_content3": "Ver / Agregar",
    "text_account_supporttickets_createTicket_subject_mandatory": "Sujeto*",
    "supportticket_tickettype_invalid": "Por favor ingrese un válid Billete tipo.",
    "supportticket_category_invalid": "Por favor ingrese un válido categoría.",
    "supportticket_associatedTo_invalid": "Por favor ingrese un válido Asociado a.",
    "text_account_supporttickets_createTicket_category_option1": "por favor seleccione categoría",
    "text_account_supporttickets_createTicket_associatedTo_option2": "por favor seleccione Asociado a",
    "text_account_supporttickets_statusList": "por favor seleccione El estado",
    "text_account_supporttickets_tickettypeList": "por favor seleccione Tipo de entrada",
    "text_account_supporttickets_createTicket_status_NEW": "Nuevo",
    "text_account_supporttickets_createTicket_status_OPEN": "Abierto",
    "text_account_supporttickets_createTicket_status_INPROGRESS": "En curso",
    "text_account_supporttickets_createTicket_status_COMPLETED": "Terminado",
    "text_account_supporttickets_createTicket_status_CLOSED": "Cerrado",
    "text_account_supporttickets_createTicket_tickettype_WEB": "Creado por el usuario",
    "document_library_text_document_type": "Tipo de documento",
    "document_library_text_language": "Idioma",
    "text_account_supporttickets_createTicket_tickettype_MANUAL": "Creado por Servicio al cliente",
    "text_account_supporttickets_customerID": "Cliente ID",
    "text_account_supporttickets_createTicket_ticketID": "Id de entradas",
    "text_company_manageUser_registration_zeroResults": "0 Nuevas solicitudes encontradas",
    "account_adb_breadcrumbs": "Visite mi pagina",
    "text_account_supporttickets_updateTicket_c4cMessage1": "Este ticket se deriva a Atención al cliente",
    "text_documentLibrary_search_firstName": "Primer nombre",
    "text_documentLibrary_search_lastName": "Apellido",
    "document_download_kb_text": "Descargue un documento de Knorr-Bremse",
    "download_agree_disclaimer_text": "Estoy de acuerdo con el descargo de responsabilidad",
    "download_start_download_button_text": "Comienza a descargar ",
    "text_account_supporttickets_updateTicket_c4cMessage2": "haga clic aquí ",
    "text_account_supporttickets_updateTicket_c4cMessage3": "para actualizar el ticket",
    "text_account_supportTicket_confirmation_ticket_added": "Gracias por enviar su solicitud de ticket de soporte. Su mensaje ha sido enviado a nuestro equipo de Atención al Cliente, quien responderá a su solicitud.",
    "text_account_supporttickets_content": "Por favor, adjunte un máximo de 9,00 mb",
    "text_software_request_form_tebs_info": "<div style=",
    "airdiscBrake_text_numberof_vahicles": "Número de vehículos",
    "airdiscBrake_drum_summary_paragraph1": "Obtenga más información sobre Bendix® air disc brakes para tractores y remolques. Póngase en contacto con su gestor de cuentas Bendix, llame al 1-800-AIR-BRAKE (1-800-247-2725) o visite Bendix.com hoy mismo.",
    "airdiscBrake_drum_summary_paragraph2": "La(s) Calculadora(s) de Valor Bendix está(n) pensada(s) únicamente como referencia; la calculadora ayuda a orientar a los usuarios interesados en",
    "airdiscBrake_drum_summary_paragraph3": "entender el retorno potencial de la inversión (ROI) de varios productos comparándolos con otros sistemas/productos. Los resultados de la calculadora se consideran únicamente estimaciones. Los datos reales de desgaste, la vida útil de los componentes, los calendarios/ciclos de sustitución, los costes del ciclo de vida, los datos de ahorro/evitación, el rendimiento y las especificaciones de los productos pueden variar en función (aunque no exclusivamente) de las configuraciones de los vehículos, las aplicaciones de los vehículos, el comportamiento del conductor, las prácticas de mantenimiento, los ciclos de trabajo, el funcionamiento del vehículo y otros factores.",
    "airdiscBrake_drum_summary_paragraph4": "En los casos en que el usuario no disponga de información específica, Bendix ha proporcionado cifras predeterminadas basadas en información general de encuestas, datos/información de flotas nacionales, etc., con el fin de facilitar el análisis.",
    "airdiscBrake_drum_summary_paragraph5": "EL CUMPLIMIENTO Y LA CERTIFICACIÓN DE TODAS LAS NORMATIVAS POR PARTE DEL VEHÍCULO SON RESPONSABILIDAD EXCLUSIVA DEL FABRICANTE DEL VEHÍCULO.",
    "airdiscBrake_drum_summary_paragraph6": "Bendix Commercial Vehicle Systems LLC, miembro del Grupo Knorr-Bremse. Todos los derechos reservados.\n\n",
    "endurasure_summary_paragraph1": "Obtenga más información sobre Bendix® EnduraSure® -Pro para tractores y remolques. Póngase en contacto con su gestor de cuentas Bendix, llame al 1-800-AIR-BRAKE (1-800-247-2725) o visite Bendix.com hoy mismo.",
    "endurasure_summary_paragraph2": "La(s) Calculadora(s) de Valor Bendix está(n) pensada(s) únicamente como referencia; la calculadora ayuda a orientar a los usuarios interesados en",
    "endurasure_summary_paragraph3": "entender el retorno potencial de la inversión (ROI) de varios productos comparándolos con otros sistemas/productos. Los resultados de la calculadora se consideran únicamente estimaciones. Los datos reales de desgaste, la vida útil de los componentes, los calendarios/ciclos de sustitución, los costes del ciclo de vida, los datos de ahorro/evitación, el rendimiento y las especificaciones de los productos pueden variar en función (aunque no exclusivamente) de las configuraciones de los vehículos, las aplicaciones de los vehículos, el comportamiento del conductor, las prácticas de mantenimiento, los ciclos de trabajo, el funcionamiento del vehículo y otros factores.",
    "endurasure_summary_paragraph4": "En los casos en que el usuario no disponga de información específica, Bendix ha proporcionado cifras predeterminadas basadas en información general de encuestas, datos/información de flotas nacionales, etc., con el fin de facilitar el análisis.",
    "endurasure_summary_paragraph5": "EL CUMPLIMIENTO Y LA CERTIFICACIÓN DE TODAS LAS NORMATIVAS POR PARTE DEL VEHÍCULO SON RESPONSABILIDAD EXCLUSIVA DEL FABRICANTE DEL VEHÍCULO.",
    "endurasure_summary_paragraph6": "Bendix Commercial Vehicle Systems LLC, miembro del Grupo Knorr-Bremse. Todos los derechos reservados.",
    "warranty_eligibility_check": "Warranty Eligibility Check",
    "warranty_terms": "Warranty Terms",
    "warranty_quick_coverage_guide": "Quick Coverage Guide",
    "warranty_documents": "Warranty Documents",
    "warranty_shipping_packaging": "Shipping/Packaging",
    "basket_page_totalWeight": "Peso TOTAL",
    "basket_page_weightPerKg": "Peso (KG)",
    "notifications_available": " Nueva(s) notificacion(es)",
    "notifications_not_available": "No hay notificaciones nuevas",
    "text_compare_show_difference_only": "Mostrar sólo diferencias",
    "text_demo_bendix_center": "Bendix Demo Center",
    "text_demo_bendix_form": "Demo Registration",
    "register_success": "Se ha inscrito correctamente en la demostración. Recibirá un correo electrónico de confirmación con su renuncia aceptada.",
    "text_core_submission_invoiceNumber": "Número de factura",
    "text_core_new_invoiceNumber": "Agregar otro",
    "Enter_your_part_number_using_the_magnifying_glass_below": "Ingrese su número de pieza usando la lupa a continuación.",
    "description_text": "Descripción"
  },
  "registrationDemoLandingPage": {
    "bendix_demo_center": "Centro de demostración de Bendix",
    "title1": "Invierta inteligentemente en seguridad",
    "p1": "Disponer de la tecnología adecuada en sus camiones y remolques puede ayudarle a aumentar la seguridad y la retención de los conductores... por no mencionar la reducción de su coste total de propiedad.",
    "p2": "Ahí es donde podemos ayudarle. Descubra lo que el conjunto de tecnologías de seguridad de Bendix puede significar para su flota.",
    "resgister": "¡inscríbase",
    "today": " hoy mismo!",
    "image-text": "Más formación a su disposición",
    "title2": "Tecnologías destacadas",
    "p3": "Experiencia de primera mano desde el asiento del pasajero",
    "p4": "Sienta la potencia de estas soluciones de seguridad integradas de Bendix",
    "list_title1": "Bendix® Fusion™",
    "list_desc1": "- incluye funciones mejoradas como advertencia de salida de la carretera y frenado, AEB multicarril y más.",
    "list_title2": "Bendix® ADB22X®",
    "list_desc2": "- prácticamente sin desvanecimiento de los frenos y mayor vida útil con un diseño optimizado del par de fricción.",
    "list_title3": "ESP® Full Stability",
    "list_desc3": "- reduce los vuelcos y las situaciones de pérdida de control.",
    "list_title4": "TABS con TRSP® ",
    "list_desc4": "- ayuda a mantener el control y reduce el riesgo de vuelco del remolque.",
    "launch_video": "vídeo de lanzamiento",
    "register_here": "S'inscrire ici",
    "Currently_no_demos": "Actualmente no hay demos disponibles.",
    "Bendix_in_action": "Haz clic aquí para ver la experiencia de demostración de Bendix en acción"
  },
  "registrationDemoForm": {
    "l1": "Si desea participar en nuestra demostración, rellene el formulario de inscripción a la demostración.",
    "l2": "Si tiene preguntas, envíe un correo electrónico al ",
    "demo_team": "equipo de la demo.",
    "l3": "Para cualquier otra pregunta, por favor contacte con su Gestor de Cuenta Bendix.  Muchas gracias.",
    "date_and_times": "FECHA / HORA",
    "Locations": "UBICACIÓN",
    "Wavier": "RENUNCIA / INSCRIPCIÓN"
  },
  "WarrentyParagraph": {
    "p1": "Para presentar un reclamo de garantía de Bendix, complete el siguiente formulario en línea. La información requerida está marcada con un asterisco (*).",
    "p2": "Si tiene alguna pregunta adicional, descargue",
    "hyperlinkText": "Cómo presentar un reclamo de garantía",
    "p3": "Gracias, Su equipo de soporte de garantía de Bendix"
  },
  "coreReport": {
    "page_Title": "Bienvenido al Centro de Cores Bendix",
    "p1": "Bienvenido al Centro de Cores Bendix",
    "p2": "Como cliente, podrá enviar devoluciones de cores y acceder a informes de cores. ",
    "p3": "Debe iniciar sesión en su cuenta para acceder a los siguientes enlaces:",
    "link1": "Enviar devoluciones de cores",
    "link2": "Buscar devoluciones de cores",
    "link3": "Devoluciones de cores Bendix"
  },
  "SelectAllVehicalPopup": {
    "p1": "Tipos de vehículos:",
    "p2": "Cada función del sector estará limitada a un único tipo de vehículo, excepto en el caso de los clientes de flotas.  Los clientes de flotas podrán seleccionar varios tipos de vehículos.",
    "p3": "El tipo de vehículo seleccionado determinará el programa de demostración disponible."
  },
  "waiver_popup_content": {
    "title": "ACUERDO DE LIBERACIÓN Y ASUNCIÓN DE RIESGOS",
    "p1": "En consideración a la oportunidad que me ha concedido Bendix Commercial Vehicle Systems LLC («BENDIX») de participar como pasajero, conductor o espectador en una demostración automovilística llevada a cabo por BENDIX en la que se muestren las características de un producto BENDIX y/o el funcionamiento de un vehículo con tecnologías de seguridad activa y de apoyo de Bendix, Por la presente -en mi nombre y en el de mis herederos, albaceas, administradores, sucesores y cesionarios- libero y descargo completa e incondicionalmente a BENDIX y a cada uno de sus funcionarios, directores, accionistas, miembros, abogados, concesionarios, distribuidores, proveedores, aseguradores, indemnizadores, agentes, servidores, representantes pasados, presentes y futuros, empleados, sociedades matrices y filiales, afiliados, socios, predecesores, sucesores y cesionarios (colectivamente «los Exonerados»), de todas y cada una de las reclamaciones, demandas, obligaciones, acciones, causas de acción, reclamaciones por homicidio culposo, derechos, daños y perjuicios, costes, pérdida de servicios, pérdida de comodidad y sociedad, gastos e indemnizaciones pasadas, presentes y futuras de cualquier naturaleza, incluidas todas las reclamaciones por daños compensatorios, ejemplares o punitivos, contribución o indemnización, ya se basen en negligencia, contrato, incumplimiento de garantía, responsabilidad objetiva o cualquier otra teoría legal o equitativa, que haya tenido, tenga ahora o que pueda acumular o adquirir de otro modo en el futuro y que surjan de o estén relacionadas con: (a) la demostración del producto, su entorno y ubicación, (b) cualquier defecto o condición asociados con los productos demostrados o los vehículos utilizados durante dicha demostración, (c) cualquier condición física asociada con el Sitio, (d) mi participación u observación de la demostración del producto, y/o (e) montar en, conducir o estar presente cerca de cualquier vehículo de motor en el Sitio durante dicha demostración del producto (colectivamente «Los Riesgos Voluntariamente Asumidos y Liberados»).",
    "p2": "Este Acuerdo de Exoneración y Asunción de Riesgos incluye específicamente todas y cada una de las reclamaciones o causas de acción conocidas o desconocidas contra BENDIX y los Exonerados por pérdidas económicas, lesiones personales, enfermedad, muerte o daños a la propiedad causados a o por mí o sufridos por mí, ya sea que ocurran o se acumulen antes, a partir de, o después de la fecha de este Acuerdo, y también incluye todas las consecuencias de cualquier pérdida económica, lesión personal, enfermedad, muerte o daño a la propiedad (ya sea esperado, anticipado, inesperado o imprevisto), que resulten o puedan resultar en el futuro de uno o más de Los Riesgos Voluntariamente Asumidos y Liberados.",
    "p3": "Yo, consciente y voluntariamente, reconozco y personalmente asumo todos los riesgos relacionados con (a) la demostración del producto, su entorno y ubicación, (b) cualquier defecto o condición asociada con los productos demostrados o vehículos utilizados durante dicha demostración, (c) cualquier condición física asociada con el Sitio, (d) mi participación u observación de la demostración del producto, y/o (e) montar en, conducir o estar presente cerca de cualquier vehículo de motor en el Sitio durante dicha demostración del producto. Asimismo, garantizo y declaro a BENDIX que no conozco ningún defecto físico o mental, afección médica, enfermedad física o limitaciones o restricciones físicas que me impidan, dificulten o me hagan susceptible de sufrir lesiones mientras participo u observo la demostración del producto o mientras monto, conduzco o estoy presente cerca de cualquier vehículo de motor en el Sitio durante la demostración del producto.",
    "p4": "Reconozco y permito voluntariamente a BENDIX y a sus agentes o cesionarios debidamente autorizados el uso, con carácter no exclusivo, de mi nombre, imagen, sonidos y/o actuación grabados, fotografiados, grabados en vídeo o conservados de otro modo, digitalmente o de otro modo, mientras participo u observo dicha demostración de producto, y por la presente cedo a BENDIX a perpetuidad todos los derechos sobre los mismos para dichos fines.",
    "p5": "EN FE DE LO CUAL, suscribo el presente Acuerdo de Exoneración y Asunción de Riesgos como mi acto y escritura voluntarios, el día de hoy: ",
    "p6": "Exención de responsabilidad Demo - 06-29-26 BCVS",
    "accept": "De acuerdo"
  },
  "dataExtractionRquest": {
    "dataExtractionRquestTitle": "Solicitud de extracción de datos de",
    "dataExtractionOverview": "Resumen de la extracción de datos  ",
    "customerVehicleOwner": "Cliente/propietario del vehículo",
    "requestor": "Solicitante",
    "reportECURecipient": "Destinatario del informe/ECU",
    "vehicleInformation": "Información del vehículo",
    "eCUInformation": "Información de la ECU",
    "incidentInformation": "Información del incidente",
    "returnShippingInformation": "Información sobre el envío de devolución",
    "Next": "Siguiente",
    "back": "Volver",
    "error_message": "Introduzca un valor válido."
  },
  "dataExtractionOverviewPage": {
    "p1": "Utilice este formulario para solicitar y liberar la extracción de datos de la unidad de control electrónico (ECU) de Bendix® y para realizar un seguimiento de la custodia de cualquier componente retirado de su vehículo y enviado a Bendix Commercial Vehicle Systems (Bendix).",
    "Note": "NOTA: SE APLICA UNA TARIFA DE EXTRACCIÓN DE DATOS DE 1000,00 USD.",
    "p2": "Tras la retirada del vehículo, envíe los componentes, este formulario cumplimentado y un cheque por valor de 1000,00 USD a nombre de Bendix Commercial Vehicle Systems a:",
    "address1": "Bendix Commercial Vehicle Systems",
    "address2": "Event Log Reporting",
    "address3": "35500 Chester Road",
    "address4": "Avon, Ohio 44011",
    "p3_1": "Los componentes, el formulario cumplimentado y el cheque por valor de 1000,00 USD deben recibirse antes de que Bendix comience la extracción.Si tiene alguna pregunta, envíe un correo electrónico a",
    "p3_2": "o póngase en contacto directamente con su gestor de cuentas de Bendix. Gracias.",
    "p4_1": "Acepto el aviso legal sobre",
    "p4_2": "extracción de datos de Bendix."
  },
  "bendix_data_extraction_disclaimer_popup": {
    "title": "Descargo de responsabilidad sobre la extracción de datos de Bendix",
    "p1": "Exclusión de daños incidentales, consecuentes y otros daños específicos:",
    "p2": "En la medida en que lo permita la legislación aplicable, en ningún caso Bendix, sus filiales, empresas asociadas, proveedores o proveedores de servicios autorizados serán responsables de ningún daño especial, incidental, indirecto o consecuente que se derive o esté relacionado de alguna manera con la pérdida de la ECU, el uso o la imposibilidad de utilizar la extracción de datos, el suministro o la falta de suministro de informes de eventos, o de cualquier otra forma en virtud de o en relación con cualquier disposición del presente acuerdo.",
    "attention": "ATENCIÓN:",
    "p3": "Dependiendo del tipo y la versión del producto, las unidades de control electrónico (ECU) de Bendix® pueden almacenar datos relacionados con la resolución de problemas, el diagnóstico, las necesidades de servicio, el estado de funcionamiento del sistema del vehículo y las entradas del operador del vehículo. No se registran datos de identificación personal (por ejemplo, nombre, sexo o edad). Bendix no accederá a los datos almacenados en la ECU ni los compartirá con terceros, salvo con el consentimiento del propietario del vehículo; en respuesta a una solicitud oficial de las fuerzas del orden u otra agencia gubernamental; como parte de la defensa de Bendix en un litigio; o cuando lo exija la ley. Los datos que recibe Bendix también pueden utilizarse con fines de investigación o ponerse a disposición de terceros con fines de investigación, cuando se demuestre la necesidad y los datos no estén vinculados a un vehículo o propietario específico.",
    "p4": "Las unidades de control electrónico (ECU) de la marca Bendix® no están diseñadas para almacenar datos con fines de reconstrucción de accidentes, y el software de diagnóstico Bendix® ACom® no está destinado a recuperar datos con fines de reconstrucción de accidentes. Bendix no garantiza la exactitud de los datos recuperados e interpretados de las ECU con fines de reconstrucción de accidentes. Bendix no ofrece servicios de reconstrucción de accidentes ni interpretación de datos almacenados. Las ECU de Bendix no están protegidas contra incendios, cortes de energía, daños por impacto u otras condiciones que puedan producirse en una situación de colisión y que puedan hacer que los datos no estén disponibles o sean irrecuperables.",
    "p5_1": "Cuando se solicita la extracción de datos de la ECU de los componentes de Bendix, se puede utilizar un único formulario para enviar varios componentes para su extracción.",
    "p5_2": "Es esencial que se rellene completamente.",
    "p5_3": "INDIQUE EL NÚMERO DE SERIE",
    "p5_4": "de cada componente que envíe. También se recomienda encarecidamente enviar una foto clara de la etiqueta de cada componente.",
    "p6": "Tenga en cuenta las siguientes excepciones:",
    "p7": "ECU del sistema de frenos antibloqueo (ABS) Bendix®: ",
    "p7_1": "No es necesario enviar la ECU del freno si solicita un informe del registrador de datos Bendix (BDR). Para que Bendix pueda generar el informe BDR, es necesario el informe del código de diagnóstico de averías (DTC) del ABS en formato HTML (para Bendix® ACom® Legacy) o en un archivo ZIP (para el software de diagnóstico Bendix® ACom® PRO™/AE™). Bendix recomienda enviar el informe DTC en una memoria USB/pendrive junto con los elementos necesarios que se indican en la SECCIÓN 1: DESCRIPCIÓN GENERAL de este documento. Los materiales incompletos o que falten provocarán retrasos en el procesamiento.",
    "p8": "Bendix™ FLR-21™, FLR-25™ (radar de visión frontal):",
    "p8_1": "Los únicos datos disponibles son el informe DTC del radar.",
    "p8_2": "No envíe ninguno de estos radares,",
    "p8_3": "ya que no se extraerá ningún dato.",
    "note": "NOTA: Las ECU AutoVue® / SafetyDirect® deben enviarse a Rand McNally®.",
    "p9": "©Bendix Commercial Vehicle Systems LLC, miembro del grupo Knorr-Bremse. Todos los derechos reservados.",
    "accept": "De acuerdo"
  },
  "customerVehicleOwnerForm": {
    "companyName": "Nombre de la empresa*",
    "contactName": "Nombre de la persona de contacto*",
    "contactEmail": "Correo electrónico de contacto*",
    "contactPhoneNumber": "Número de teléfono de contacto*",
    "companyAddresswithStreetNumber": "Dirección de la empresa con número de calle*",
    "address2": "Dirección 2 (por ejemplo, unidad, piso, nombre de la casa)",
    "city": "Ciudad*",
    "state": "Estado*",
    "zipPostalCode": "Código postal*",
    "country": "País* ",
    "company_name_popup_title": "Nombre de la empresa",
    "company_name_popup_content": "La empresa propietaria del vehículo.",
    "contact_name_popup_title": "Nombre de contacto",
    "contact_name_popup_content": "La persona propietaria del vehículo."
  },
  "requestorForm": {
    "checkbox_label": "Igual que la información del cliente/propietario del vehículo.",
    "companyName": "Nombre de la empresa solicitante*",
    "contactName": "Nombre de la persona de contacto solicitante*",
    "contactEmail": "Correo electrónico de la persona de contacto solicitante*",
    "contactPhoneNumber": "Número de teléfono de la persona de contacto solicitante*",
    "companyAddresswithStreetNumber": "Dirección de la empresa solicitante con número de calle*",
    "address2": "Dirección 2 (por ejemplo, unidad, piso, nombre de la casa)",
    "city": "Ciudad*",
    "state": "Estado*",
    "zipPostalCode": "Código postal*",
    "country": "País*",
    "company_name_popup_title": "Nombre de la empresa solicitante",
    "company_name_popup_content": "La empresa que solicita la extracción de datos (si no es el propietario del vehículo).",
    "contact_name_popup_title": "Nombre del solicitante",
    "contact_name_popup_content": "La persona que solicita la extracción de datos (si no es el propietario del vehículo)."
  },
  "reportECURecipientForm": {
    "checkbox_label": "Igual que la información del solicitante",
    "companyName": "Nombre de la empresa destinataria*",
    "contactName": "Nombre de la persona de contacto de la empresa destinataria*",
    "contactEmail": "Correo electrónico de la persona de contacto de la empresa destinataria*",
    "contactPhoneNumber": "Número de teléfono de la persona de contacto de la empresa destinataria*",
    "companyAddresswithStreetNumber": "Dirección de la empresa solicitante con número de calle*",
    "address2": "Dirección 2 (por ejemplo, unidad, piso, nombre de la casa)",
    "city": "Ciudad*",
    "state": "Estado*",
    "zipPostalCode": "Código postal*",
    "country": "País*",
    "customer_reference_number": "Número de referencia del cliente",
    "company_name_popup_title": "Nombre de la empresa destinataria del informe",
    "company_name_popup_content": "La empresa a la que Bendix devolverá los informes y las ECU.",
    "contact_name_popup_title": "Nombre del destinatario del informe",
    "contact_name_popup_content": "La persona a la que Bendix devolverá los informes y las ECU."
  },
  "vehicleInformation": {
    "vehicleIdentificationNumber": "Número de identificación del vehículo (VIN)*",
    "vehicleYear": "Año del vehículo*",
    "vehicleMake": "Marca del vehículo*",
    "vehicleModel": "Vehicle Model*",
    "vehicleTruckNumber": "Número de camión del vehículo*",
    "vehicleMileage": "Millas del vehículo",
    "mileageUnit": "Millas"
  },
  "IncidentForm": {
    "label_Is_this_Request_the_Result_of_an_Accident": "¿Esta solicitud es consecuencia de un accidente?*",
    "Yes": "Sí",
    "No": "No",
    "Date_of_Incident": "Fecha del incidente*",
    "Select_Date": "Seleccionar fecha",
    "Time_of_Incident": "Hora del incidente*",
    "City_of_Incident": "Ciudad del incidente*",
    "State_of_Incident": "Estado del incidente*",
    "Select_Your_State": "Seleccionar su estado",
    "Country_of_Incident": "País del incidente*",
    "Select_Your_Country": "Seleccionar su país"
  },
  "returnShippingInformation": {
    "return_shipping_type": "Tipo de envío de devolución:",
    "domestic": "Nacional",
    "international": "Internacional",
    "carrier": "Transportista*",
    "account_number": "Número de cuenta*",
    "account_postal_code": "Código postal de la cuenta*",
    "account_country_code": "Código de país de la cuenta*",
    "e-signature": "Firma electrónica",
    "i_am_not_robot": "No soy un robot",
    "domestic_shipping_label": "Solo para envíos internacionales:",
    "domestic_not_required": "No es necesario",
    "domestic_shipping_desc": "si el envío de devolución  se realiza dentro de Estados Unidos.",
    "international_shipping_label": "Se requiere toda la información de envío internaciona",
    "international_required": "para la devolución de la ECU al cliente.",
    "international_shipping_desc": "Cualquier impuesto o tasa asociada a este envío se cargará a su cuenta de Bendix."
  },
  "ECUForm": {
    "dtc_report_text": "Informe de códigos de diagnóstico de averías (DTC)*",
    "ecu_removed": "ECU(s) retiradas: marque todas las que correspondan*",
    "ecu_serial_no": "ECU Serial Number*",
    "ecu_photo": "ECU Photo*",
    "ecu_serial_popup": "ECU Serial Number",
    "ecu_serial_popup_title": "Display Instructions on how to find each ECU serial number – work with Keving Kinley (this will vary by product)",
    "ecu_photo_popup": "ECU Photo",
    "ecu_photo_popup_title": "Photo of the ECU being sent to Bendix for data extraction (for traceability).",
    "dtc_report_text_popup": "Informe de códigos de diagnóstico de averías (DTC)",
    "dtc_report_text_popup_title": "Adjunte el informe de códigos de diagnóstico de averías (DTC) del sistema de frenos antibloqueo (ABS) Bendix® en formato HTML para Bendix® ACom® Legacy y como archivo ZIP o XML para el software de diagnóstico Bendix® ACom® PRO™/ AE™.",
    "text_ecu_select_file_wish": "Seleccione el archivo que desea cargar y haga clic en el botón \"Cargar\". Cada archivo cargado se añadirá a la solicitud.",
    "text_ecu_select_file_type_upload": "Note: only html, xml, or zip files are permitted.",
    "text_ecu_select_file_type_upload_1": "Note: Only image file formats are permitted.",
    "bendix_ABS_text": "Bendix® ABS ECU",
    "bendix_EBS_Text": "Bendix® EBS-90™ ECU",
    "bendix_FLC_text": "Bendix® Cámara FLC-20™ (negra)",
    "bendix_intellipark_text":"Bendix® Intellipark® Dash ECU (DECU)",
    "sdp_text": "Procesador SafetyDirect® (SDP)",
    "ecu_text": "Unidad de control electrónico (ECU) AutoVue®",
    "camera_text": "Cámara AutoVue® 3G (gris)",
    "flr_text": "Bendix® FLR-21™, FLR-25™ (radar de visión frontal)",
    "not_send_bendix_text": "<u>No</u> enviar a Bendix.  Enviar a Rand McNally para su procesamiento.",
    "not_send_ecu_text": "<u>No</u> enviar a Bendix.  Esta ECU <u>no</u> se procesará.",
    "record_text": "registros"
  },
  "DTC_PAGE": {
    "dtc_Form_title": "Búsqueda de códigos de diagnóstico",
    "product_type": "Tipo de producto",
    "dtc_type": "Tipo de código*",
    "search": "Buscar",
    "search_string": "Cadena de búsqueda*",
    "internalCodesOptional": "Códigos internos (opcional)",
    "internalCode1": "Código interno 1:",
    "internalCode2": "Código interno 2:",
    "downloadDocument": "Descargar documentos",
    "troubleshootingSteps": "Pasos para solucionar problemas",
    "reset": "Restablece",
    "dtc_popup_title": "Tipo de código:",
    "spn_text": "<b>SPN</b> es el <b>número de parámetro sospechoso</b>, que identifica el producto o sistema específico en el que se detecta un problema.",
    "fmi_text": "<b>FMI</b> es el <b>identificador del modo de fallo</b>,que indica el tipo de problema o fallo.",
    "hex_code_text": "Los <b>códigos hexadecimales</b> son toda la información combinada sobre fallos, incluidos todos los metadatos de diagnóstico almacenados en formato hexadecimal.",
    "blink_codes_text": "Los <b>códigos de parpadeo</b> son un método para mostrar los códigos de avería, utilizando una luz indicadora (como la luz del ABS) para hacer parpadear una serie de destellos que representan un código numérico.",
    "faultCodeSpnSidDecPreferred": "Código de fallo SPN/SID (DEC) Preferido",
    "fmi": "FMI",
    "hexCode": "Código hexadecimal",
    "internalCode1Path": "Código interno 1 (Ruta)",
    "internalCode2Type": "Código interno 2 (Tipo)",
    "blinkCode1": "Código de parpadeo 1",
    "blinkCode2": "Código de parpadeo 2",
    "publiclySharableFaultDescription": "Descripción del fallo que se puede compartir públicamente",
    "public": "Público",
    "repairTabInfoSection": "Información de la pestaña «Reparación» / Sección",
    "serviceActionCodeList": "Acción de servicio (tabla de fallos de la hoja SD) Lista de códigos.",
    "ecuPinLocations": "Ubicación de los pasadores de la ECU",
    "overview": "Descripción general",
    "possibleCauses": "Posibles causas",
    "sdSheetFaultCodeTableSection": "Hoja SD Sección de la tabla de códigos de avería",
    "schematics": "Esquemas",
    "disclaimer": "Descargo de responsabilidad",
    "beforeYouBegin": "Antes de comenzar",
    "afterRepairsHaveBeenMade": "Una vez realizadas las reparaciones",
    "sortBy": "Ordenar por",
    "dtcTypeAscending": "Tipo de DTC: ascendente",
    "dtcTypeDescending": "Tipo de DTC: descendente",
    "productTypeAscending": "Tipo de producto: ascendente",
    "productTypeDescending": "Tipo de producto: descendente",
    "defaultSort": "Tipo de DTC: ascendente",
    "back_button": "Atrás"
  }
}